import * as i0 from '@angular/core';
import { InjectionToken, NgModule, PLATFORM_ID, Injectable, Inject, Component, ChangeDetectionStrategy, Injector, Input, ViewChild, EventEmitter, Output, ReflectiveInjector, ElementRef, Directive, Optional, ContentChild, forwardRef, Pipe } from '@angular/core';
import * as i1$3 from '@angular/common';
import { isPlatformBrowser, isPlatformServer, APP_BASE_HREF, CommonModule } from '@angular/common';
import { BehaviorSubject, of, throwError, ReplaySubject, Subject, EMPTY, Subscription, merge, fromEvent } from 'rxjs';
import * as i2 from '@angular/router';
import { RouterModule, NavigationEnd } from '@angular/router';
import * as i1$2 from '@ngrx/effects';
import { createEffect, ofType } from '@ngrx/effects';
import { map, catchError, tap, filter as filter$1, switchMap, flatMap, first, take, mergeMap, takeUntil, distinctUntilChanged, startWith } from 'rxjs/operators';
import * as i1 from '@ngrx/store';
import { createAction, props, createReducer, on, createFeatureSelector, createSelector, select } from '@ngrx/store';
import { get } from 'lodash';
import * as i1$1 from '@angular/common/http';
import { filter } from 'rxjs/internal/operators/filter';
import * as i1$4 from '@angular/material/dialog';
import { MAT_DIALOG_DATA, MatDialogModule, MatDialog } from '@angular/material/dialog';
import { trigger, transition, animate, keyframes, style, state } from '@angular/animations';
import * as i5 from '@angular/material/button';
import { MatButtonModule } from '@angular/material/button';
import * as i3 from 'ngx-toastr';
import { switchMap as switchMap$1 } from 'rxjs/internal/operators/switchMap';
import * as i6 from '@angular/forms';
import { Validators, FormControl, UntypedFormControl, FormsModule, ReactiveFormsModule } from '@angular/forms';
import * as i2$1 from 'ngx-cookie-service';
import * as i1$5 from '@angular/platform-browser';
import * as i2$4 from '@angular/material/icon';
import { MatIconModule } from '@angular/material/icon';
import * as i9 from '@angular/flex-layout';
import { FlexModule, FlexLayoutModule } from '@angular/flex-layout';
import * as i6$1 from 'ngx-mask';
import { NgxMaskModule } from 'ngx-mask';
import * as i11 from 'ckeditor4-angular';
import { CKEditorModule } from 'ckeditor4-angular';
import * as i2$3 from '@angular/material/form-field';
import { MatFormFieldModule } from '@angular/material/form-field';
import * as i3$1 from '@angular/material/input';
import { MatInputModule } from '@angular/material/input';
import * as i1$6 from '@angular/material/slide-toggle';
import { MatSlideToggleModule } from '@angular/material/slide-toggle';
import * as i4 from '@angular/material/select';
import { MatSelectModule } from '@angular/material/select';
import * as i2$5 from '@angular/material/tooltip';
import { MatTooltipModule } from '@angular/material/tooltip';
import * as i7$1 from '@angular/material/chips';
import { MatChipsModule } from '@angular/material/chips';
import * as i8 from '@angular/material/autocomplete';
import { MatAutocompleteModule } from '@angular/material/autocomplete';
import * as i2$2 from '@angular/material/progress-spinner';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import * as i5$1 from '@angular/material/core';
import * as i7 from 'ngx-mat-select-search';
import { NgxMatSelectSearchModule } from 'ngx-mat-select-search';
import { isObject } from 'rxjs/internal-compatibility';
import * as i3$2 from '@angular/cdk/drag-drop';
import { moveItemInArray, DragDropModule } from '@angular/cdk/drag-drop';
import * as i6$2 from 'ng2-file-upload';
import { FileUploader, FileUploadModule } from 'ng2-file-upload';
import * as i5$2 from '@angular/material/progress-bar';
import { MatProgressBarModule } from '@angular/material/progress-bar';
import { ENTER, COMMA } from '@angular/cdk/keycodes';
import { driver } from 'driver.js';
import { NgrxFormsModule } from 'ngrx-forms';
import { MatTableModule } from '@angular/material/table';
import * as i6$3 from '@angular/material/paginator';
import { MatPaginator, MatPaginatorModule } from '@angular/material/paginator';
import * as i22 from '@angular/material/tabs';
import { MatTabsModule } from '@angular/material/tabs';
import { MatSort } from '@angular/material/sort';
import * as i2$6 from '@angular/material/menu';
import { MatMenuModule } from '@angular/material/menu';
import { MatLegacyChipsModule } from '@angular/material/legacy-chips';
import * as i1$7 from '@angular/cdk/platform';
import moment from 'moment';

const CORE_CONFIG = new InjectionToken('SHARED_CORE_CONFIG');
// export const AUTH_SERVICE_CONFIG: InjectionToken<SocialAuthServiceConfig> = new InjectionToken<SocialAuthServiceConfig>('AUTH_SERVICE_CONFIG');

class WtFrontSharedModule {
    static forApp(appConfig) {
        return {
            ngModule: WtFrontSharedModule,
            providers: [
                { provide: CORE_CONFIG, useValue: appConfig }
            ]
        };
    }
}
WtFrontSharedModule.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "15.2.9", ngImport: i0, type: WtFrontSharedModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule });
WtFrontSharedModule.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "15.2.9", ngImport: i0, type: WtFrontSharedModule });
WtFrontSharedModule.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "15.2.9", ngImport: i0, type: WtFrontSharedModule });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "15.2.9", ngImport: i0, type: WtFrontSharedModule, decorators: [{
            type: NgModule,
            args: [{
                    declarations: [],
                    imports: [],
                    exports: []
                }]
        }] });

const STORAGE_KEY = {
    currentUser: 'WT_CURRENT_USER',
    token: 'WT_TOKEN',
    tokenExp: 'WT_TOKEN_EXP',
    refreshToken: 'WT_REFRESH_TOKEN'
};
class AuthenticationService {
    constructor(platformId, route
    /*@Inject('LOCALSTORAGE') private localStorage: any*/
    ) {
        this.platformId = platformId;
        this.route = route;
        this.haveLocalStorage = false;
        if (isPlatformBrowser(this.platformId)) {
            this.haveLocalStorage = true;
            this.currentUserSubject = new BehaviorSubject(JSON.parse(localStorage.getItem(STORAGE_KEY.currentUser)));
        }
        if (isPlatformServer(this.platformId)) {
            this.haveLocalStorage = false;
            this.currentUserSubject = new BehaviorSubject({ id: '' });
        }
        this.currentUser = this.currentUserSubject.asObservable();
    }
    get isGuest() {
        const user = this.currentUserValue;
        console.info('[ auth ]', user);
        return !!(!user || !user.id);
    }
    get currentUserValue() {
        return this.currentUserSubject.value;
    }
    loadAuthDataFromLocalStore() {
        if (isPlatformBrowser(this.platformId)) {
            const user = JSON.parse(localStorage.getItem(STORAGE_KEY.currentUser));
            const token = localStorage.getItem(STORAGE_KEY.token);
            const tokenExp = +localStorage.getItem(STORAGE_KEY.tokenExp);
            const refreshToken = localStorage.getItem(STORAGE_KEY.refreshToken);
            return { ...user, token, tokenExp, refreshToken };
        }
        return { id: '', user: {}, token: '', tokenExp: null, refreshToken: '' };
    }
    saveAuthInfo(user, remember = false) {
        if (this.haveLocalStorage) {
            // store user details and jwt token in local storage to keep user logged in between page refreshes
            localStorage.setItem(STORAGE_KEY.currentUser, JSON.stringify({
                id: user.id,
                name: user.name,
                email: user.email,
                lastName: user.lastName,
                role: user.role,
                avatar: user.avatar,
                sex: user.sex,
                rights: user.rights
            }));
            localStorage.setItem(STORAGE_KEY.token, user.token);
            localStorage.setItem(STORAGE_KEY.tokenExp, user.tokenExp.toString());
            localStorage.setItem(STORAGE_KEY.refreshToken, user.refreshToken);
            this.currentUserSubject.next(user);
        }
    }
    saveRefreshToken(token, tokenExp, refreshToken) {
        if (this.haveLocalStorage) {
            localStorage.setItem(STORAGE_KEY.token, token);
            localStorage.setItem(STORAGE_KEY.tokenExp, tokenExp.toString());
            localStorage.setItem(STORAGE_KEY.refreshToken, refreshToken);
        }
    }
    clearData() {
        if (this.haveLocalStorage) {
            localStorage.removeItem(STORAGE_KEY.currentUser);
            localStorage.removeItem(STORAGE_KEY.token);
            localStorage.removeItem(STORAGE_KEY.tokenExp);
            localStorage.removeItem(STORAGE_KEY.refreshToken);
            this.currentUserSubject.next(null);
        }
    }
    getRedirectToUrl() {
        if (this.route.snapshot.queryParams && this.route.snapshot.queryParams.redirectTo) {
            return this.route.snapshot.queryParams.redirectTo;
        }
        return undefined;
    }
}
AuthenticationService.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "15.2.9", ngImport: i0, type: AuthenticationService, deps: [{ token: PLATFORM_ID }, { token: i2.ActivatedRoute }], target: i0.ɵɵFactoryTarget.Injectable });
AuthenticationService.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "15.2.9", ngImport: i0, type: AuthenticationService, providedIn: 'root' });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "15.2.9", ngImport: i0, type: AuthenticationService, decorators: [{
            type: Injectable,
            args: [{ providedIn: 'root' }]
        }], ctorParameters: function () { return [{ type: undefined, decorators: [{
                    type: Inject,
                    args: [PLATFORM_ID]
                }] }, { type: i2.ActivatedRoute }]; } });

var AsyncValidatorsMessages;
(function (AsyncValidatorsMessages) {
    AsyncValidatorsMessages["FirmUniqEmailInValidMessage"] = "\u0423\u043A\u0430\u0437\u0430\u043D\u043D\u044B\u0439 Email \u0443\u0436\u0435 \u0437\u0430\u0440\u0435\u0433\u0438\u0441\u0442\u0440\u0438\u0440\u043E\u0432\u0430\u043D \u0432 \u0441\u0438\u0441\u0442\u0435\u043C\u0435";
    AsyncValidatorsMessages["FirmUniqEmailValidMessage"] = "\u0423\u043A\u0430\u0437\u0430\u043D\u043D\u044B\u0439 Email \u043F\u043E\u0434\u0445\u043E\u0434\u0438\u0442";
    AsyncValidatorsMessages["FirmUniqPhoneInValidMessage"] = "\u0423\u043A\u0430\u0437\u0430\u043D\u043D\u044B\u0439 \u0442\u0435\u043B\u0435\u0444\u043E\u043D \u0443\u0436\u0435 \u0437\u0430\u0440\u0435\u0433\u0438\u0441\u0442\u0440\u0438\u0440\u043E\u0432\u0430\u043D \u0432 \u0441\u0438\u0441\u0442\u0435\u043C\u0435";
    AsyncValidatorsMessages["FirmUniqPhoneValidMessage"] = "\u0423\u043A\u0430\u0437\u0430\u043D\u043D\u044B\u0439 \u0442\u0435\u043B\u0435\u0444\u043E\u043D \u043F\u043E\u0434\u0445\u043E\u0434\u0438\u0442";
    AsyncValidatorsMessages["FirmUniqNameInValidMessage"] = "\u0423\u043A\u0430\u0437\u0430\u043D\u043D\u043E\u0435 \u043D\u0430\u0437\u0432\u0430\u043D\u0438\u0435 \u0444\u0438\u0440\u043C\u044B \u0443\u0436\u0435 \u0437\u0430\u0440\u0435\u0433\u0438\u0441\u0442\u0440\u0438\u0440\u043E\u0432\u0430\u043D \u0432 \u0441\u0438\u0441\u0442\u0435\u043C\u0435";
    AsyncValidatorsMessages["ItemUniqValueMessage"] = "\u0423\u043A\u0430\u0437\u0430\u043D\u043D\u043E\u0435 \":field\" \u0443\u0436\u0435 \u0437\u0430\u0440\u0435\u0433\u0438\u0441\u0442\u0440\u0438\u0440\u043E\u0432\u0430\u043D\u043E \u0432 \u0441\u0438\u0441\u0442\u0435\u043C\u0435 \u043F\u043E\u043B\u0435";
    AsyncValidatorsMessages["FirmUniqNameValidMessage"] = "\u0423\u043A\u0430\u0437\u0430\u043D\u043D\u044B\u0439 \u043D\u0430\u0437\u0432\u0430\u043D\u0438\u0435 \u0444\u0438\u0440\u043C\u044B \u043F\u043E\u0434\u0445\u043E\u0434\u0438\u0442";
    AsyncValidatorsMessages["FirmUniqLegalNameInValidMessage"] = "\u0423\u043A\u0430\u0437\u0430\u043D\u043D\u043E\u0435 \u044E\u0440\u0438\u0434\u0438\u0447\u0435\u0441\u043A\u043E\u0435 \u043D\u0430\u0437\u0432\u0430\u043D\u0438\u0435 \u0443\u0436\u0435 \u0437\u0430\u0440\u0435\u0433\u0438\u0441\u0442\u0440\u0438\u0440\u043E\u0432\u0430\u043D \u0432 \u0441\u0438\u0441\u0442\u0435\u043C\u0435";
    AsyncValidatorsMessages["FirmUniqLegalNameValidMessage"] = "\u0423\u043A\u0430\u0437\u0430\u043D\u043D\u043E\u0435 \u044E\u0440\u0438\u0434\u0438\u0447\u0435\u0441\u043A\u043E\u0435 \u043D\u0430\u0437\u0432\u0430\u043D\u0438\u0435 \u043F\u043E\u0434\u0445\u043E\u0434\u0438\u0442";
    AsyncValidatorsMessages["itemUniqValue"] = "\u0423\u043A\u0430\u0437\u0430\u043D\u043D\u043E\u0435 \":field\" \u0443\u0436\u0435 \u0437\u0430\u0440\u0435\u0433\u0438\u0441\u0442\u0440\u0438\u0440\u043E\u0432\u0430\u043D\u043E \u0432 \u0441\u0438\u0441\u0442\u0435\u043C\u0435 \u043F\u043E\u043B\u0435";
})(AsyncValidatorsMessages || (AsyncValidatorsMessages = {}));

var AsyncValidators;
(function (AsyncValidators) {
    AsyncValidators["ItemUniqValue"] = "item-uniq-value";
})(AsyncValidators || (AsyncValidators = {}));
var AsyncValidatorsType;
(function (AsyncValidatorsType) {
    AsyncValidatorsType["FirmUniqEmail"] = "firm-uniq-email";
    AsyncValidatorsType["FirmUniqPhone"] = "firm-uniq-phone";
    AsyncValidatorsType["FirmUniqName"] = "firm-uniq-name";
    AsyncValidatorsType["FirmUniqLegalName"] = "firm-uniq-legal-name";
    AsyncValidatorsType["CommonUniqItem"] = "common-uniq-item";
})(AsyncValidatorsType || (AsyncValidatorsType = {}));

const BaseErrors = {
    ERROR_FILE_SIZE_LIMIT: 'Размер файла слишком большой',
    ERROR_FILE_TYPE: 'Не подходящий тип файла',
    COMMON_ERROR_UPLOAD_FILE: 'Ошибка загрузки файл. Попробуйте заново',
    PERMISSION_ERROR: 'Ошибка доступа',
    FILE_UPLOAD_ERROR: 'Ошибка загрузки файла',
    INCORRECT_RELATION_VALUES: 'Указанны не верные данные',
    INCORRECT_RELATION_VALUES_FULL: 'Для поля :field указанны не верные данные. Поправьте или обратитесь в тех. поддержку',
};

const NOTIFICATION_TIMEOUT = 1000;
const NOTIFICATION_LONG_TIMEOUT = 2000;
const PasswordRules = {
    pattern: /^[A-Za-z0-9!@#$%^&*_=+-]{6,}$/
    // pattern: /^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[!@#$%^&*_=+-]).{6,12}$/
};

const SharedFormErrors = {
    REQUIRE: 'Поле :field является обязательным',
    FORM_SAVE_ERROR: "Произошла ошибка при сохранении формы, проверьте все еще. Если ошибка повторяется напишите в службу поддержки <a href=\"mailto:support@world-travel.uz\">support@world-travel.uz</a>",
    PATTERN: "Не коректное значение",
};

const GlobalErrorMessages = {
    ...SharedFormErrors,
    ...AsyncValidatorsMessages,
    ...BaseErrors
};

const MainConst = {
    responseStatus: {
        tokenNotFound: 'token-not-found'
    }
};

const PublishErrors = {
    FIELD_MUST_FILLED: {
        title: 'Вам нужно заполнить поле "{field}"',
        description: 'Чтобы был лучше эффект нужно заполнить поле "{field}".'
    },
    FILES_LENGTH_RECOM_5: {
        title: 'Мы рекомендуем Вам загрузить 5 файлов',
        description: 'Для лучшего эффекта мы рекомендуем загрузить 5 файлов.Д'
    },
    FIELD_MIN_LENGTH_ERROR_150: {
        title: 'Вам нужно улучшить описание для поля "{field}"',
        description: 'Чтобы привлечь клиентов нужно заполнить поле "{field}" как минимум на 150 символов.'
    },
    FIELD_MIN_LENGTH_ERROR_250: {
        title: 'Вам нужно улучшить описание для поля "{field}"',
        description: 'Чтобы привлечь клиентов нужно заполнить поле "{field}" как минимум на 250 символов.'
    },
    FIELD_MIN_LENGTH_ERROR_500: {
        title: 'Вам нужно улучшить описание для поля "{field}"',
        description: 'Чтобы привлечь клиентов нужно заполнить поле "{field}" как минимум на 500 символов.'
    },
    FIELD_MIN_LENGTH_ERROR_1000: {
        title: 'Вам нужно улучшить описание для поля "{field}"',
        description: 'Чтобы привлечь клиентов нужно заполнить поле "{field}" как минимум на 1000 символов.'
    },
    FIELD_LENGTH_RECOM_1500: {
        title: 'Мы рекомендуем вам улучшить описание для поля "{field}"',
        description: 'Чтобы привлечь много клиентов нужно заполнить поле "{field}" как минимум на 1500 символов.'
    },
    FILES_LENGTH_MIN_ERROR_3: {
        title: 'Вам нужно загрузить минимум 3 картинки',
        description: 'Чтобы был лучше эффект нужно загрузить 3 картинки, а Вы загрузили только {countDownloadedFiles}'
    },
    FILES_LENGTH_RECOMM_5: {
        title: 'Мы рекомендуем вам загрузить как минимум 5 фотографий',
        description: 'Мы рекомендуем вам загрузить как минимум 5 фотографий, а сейчас {countDownloadedFiles}'
    }
};

var ValidatorsType;
(function (ValidatorsType) {
    ValidatorsType["Required"] = "required";
    ValidatorsType["RequiredTrue"] = "requiredTrue";
    ValidatorsType["MinLength"] = "minLength";
    ValidatorsType["Pattern"] = "pattern";
    ValidatorsType["Custom"] = "custom";
})(ValidatorsType || (ValidatorsType = {}));

const LoadUsers = createAction('[Users] Load Users');
const LoadUsersSuccess = createAction('[Users] Load Users Success');
const LoadUsersFail = createAction('[Users] Load Users Error');
const LoginSend = createAction('[Users] Auth Send', props());
const LoginSendSuccess = createAction('[Users] Auth Send Success', props());
const LoginSendFail = createAction('[Users] Auth Send Error', props());
const RefreshToken = createAction('[Users] Refresh Token', props());
const RefreshTokenSuccess = createAction('[Users] Refresh Token Success', props());
const RefreshTokenFail = createAction('[Users] Refresh Token Error', props());
/**
 *
 */
const SetLoaded = createAction('[Users] Set Loaded');

const LoadCore = createAction('[Core] Load Core', props());
const CoreLoaded = createAction('[Core] Load Loaded');
const CoreLoadError = createAction('[Core] Core Load Error');
const GlobalEvent = createAction('[Core] Global Event', props());
/*
import { Action } from '@ngrx/store';

export enum CoreActionTypes {
  LoadCore = '[Core] Load Core',
  CoreLoaded = '[Core] Core Loaded',
  CoreLoadError = '[Core] Core Load Error'
}

export class LoadCore implements Action {
  readonly type = CoreActionTypes.LoadCore;
}

export class CoreLoadError implements Action {
  readonly type = CoreActionTypes.CoreLoadError;
  constructor(public payload: any, error, correlation) {}
}

export class CoreLoaded implements Action {
  readonly type = CoreActionTypes.CoreLoaded;
  constructor(public payload: Entity[]) {}
}

export type CoreAction = LoadCore | CoreLoaded | CoreLoadError;

export const fromCoreActions = {
  LoadCore,
  CoreLoaded,
  CoreLoadError
};
*/

const EntityUpdate = createAction('[UpdateEntities] Entity Part Update', props());

var NotificationShowingType;
(function (NotificationShowingType) {
    NotificationShowingType["TOASTER"] = "toaster";
    NotificationShowingType["POPUP"] = "popup";
})(NotificationShowingType || (NotificationShowingType = {}));
;
const NotificationAdd = createAction('[Notification] Add', props());
const NotificationAddFail = createAction('[Notification] Add Error');

var ActionsEndpointTypes;
(function (ActionsEndpointTypes) {
    ActionsEndpointTypes["SEND_ACTION"] = "send-action";
})(ActionsEndpointTypes || (ActionsEndpointTypes = {}));

class Request {
    constructor(domain) {
        this.domain = domain;
    }
    addAuthHeaders(headers) {
        if (!!headers && !!headers.token && !!headers.uid) {
            return {
                'Authorization': `JWT ${headers.token}`
            };
        }
        else {
            return null;
        }
    }
    cleanTextParams(text) {
        if (!text)
            return;
        return text.replace(/"/, '\"');
    }
    cleanParams(obj) {
        return Object.keys(obj).reduce((acc, key) => {
            const _acc = acc;
            if (obj[key] !== undefined && obj[key] !== '' && obj[key] !== null) {
                const isObject = typeof obj[key] === 'object';
                if (obj[key] instanceof File) {
                    _acc[key] = obj[key];
                }
                else {
                    const value = isObject && !Array.isArray(obj[key]) ? this.cleanParams(obj[key]) : obj[key];
                    if (!isObject || Object.keys(value).length > 0) {
                        _acc[key] = value;
                    }
                }
            }
            return _acc;
        }, {});
    }
    makeFormData(data) {
        const formData = new FormData();
        this.appendDataIntoFormDataRecursion(formData, '', data);
        return formData;
    }
    appendDataIntoFormDataRecursion(formData, key, data) {
        if (data) {
            if (Array.isArray(data)) {
                data.forEach((item, index) => {
                    this.appendDataIntoFormDataRecursion(formData, this.getKey(key, index), data[index]);
                });
            }
            else if (typeof data === 'object') {
                if (data && 'origin' in data) {
                    if (data.origin !== '[object Object]') {
                        formData.append(key, data.origin);
                    }
                    return;
                }
                if (data instanceof File) {
                    formData.append(key, data);
                    return;
                }
                Object.keys(data).forEach(field => {
                    this.appendDataIntoFormDataRecursion(formData, this.getKey(key, field), data[field]);
                });
            }
            else {
                formData.append(key, data);
            }
        }
    }
    getKey(allKey, newKey) {
        if (allKey) {
            return `${allKey}[${newKey}]`;
        }
        else {
            return `${newKey}`;
        }
    }
    convertFieldsToString(fieldData = {}, level = 0) {
        if (level === 6 || !fieldData || typeof fieldData !== 'object') {
            return;
        }
        let url = '';
        if (fieldData.fields && Array.isArray(fieldData.fields)) {
            url = fieldData.fields.join(',');
        }
        Object.keys(fieldData).forEach(field => {
            if (field !== 'fields') {
                if (url) {
                    url += ',';
                }
                if (typeof fieldData[field] === 'object') {
                    url += `${field}(${this.convertFieldsToString(fieldData[field], level + 1)})`;
                }
            }
        });
        return `${level === 0 && url ? 'fields=' : ''}${url}`;
    }
    convertPagingToString(paging) {
        let res = '';
        if (paging) {
            if (paging?.page) {
                res = `page=${paging.page}`;
            }
            if (paging?.perPage) {
                res += `${res ? '&' : ''}per_page=${paging.perPage}`;
            }
        }
        return res;
    }
}

var RequestMethod;
(function (RequestMethod) {
    RequestMethod["GET"] = "get";
    RequestMethod["POST"] = "post";
    RequestMethod["PUT"] = "put";
    RequestMethod["DELETE"] = "delete";
    RequestMethod["PATCH"] = "patch";
})(RequestMethod || (RequestMethod = {}));

class GetRequest extends Request {
    constructor() {
        super(...arguments);
        this.httpMethod = RequestMethod.GET;
    }
    convertWHereToString(obj = {}) {
        let whereString = '';
        Object.keys(obj).forEach((key) => {
            if (whereString) {
                whereString += ',';
            }
            whereString += `${key}=${obj[key]}`;
        });
        if (whereString) {
            whereString = `where=(${whereString})`;
        }
        return whereString;
    }
    convertEmbedsToString(obj = []) {
        const embeds = [];
        obj.forEach(item => {
            embeds.push(this.embedToString(item));
        });
        return embeds.length ? `&embed=${embeds.join(',')}` : '';
    }
    embedToString(obj) {
        const embedParams = [];
        if (obj.fields && obj.fields.length) {
            embedParams.push(`fields=${obj.fields.join(',')}`);
        }
        if (obj.page) {
            embedParams.push(`page=${obj.page}`);
        }
        if (obj.perPage) {
            embedParams.push(`perPage=${obj.fields.join(',')}`);
        }
        if (obj.count) {
            embedParams.push(`count=${obj.count}`);
        }
        return `${obj.name}(${embedParams.join(',')})`;
    }
}

class PutRequest extends Request {
    constructor() {
        super(...arguments);
        this.httpMethod = RequestMethod.PUT;
    }
}

class PatchRequest extends Request {
    constructor() {
        super(...arguments);
        this.httpMethod = RequestMethod.PATCH;
    }
}

class PostRequest extends Request {
    constructor() {
        super(...arguments);
        this.httpMethod = RequestMethod.POST;
    }
}

class DeleteRequest extends Request {
    constructor() {
        super(...arguments);
        this.httpMethod = RequestMethod.DELETE;
    }
}

var ResponseStatus;
(function (ResponseStatus) {
    ResponseStatus[ResponseStatus["STATUS_200"] = 200] = "STATUS_200";
    ResponseStatus[ResponseStatus["STATUS_201"] = 201] = "STATUS_201";
    ResponseStatus[ResponseStatus["STATUS_204"] = 204] = "STATUS_204";
    ResponseStatus[ResponseStatus["STATUS_400"] = 400] = "STATUS_400";
    ResponseStatus[ResponseStatus["STATUS_401"] = 401] = "STATUS_401";
    ResponseStatus[ResponseStatus["STATUS_403"] = 403] = "STATUS_403";
    ResponseStatus[ResponseStatus["STATUS_404"] = 404] = "STATUS_404";
    ResponseStatus[ResponseStatus["STATUS_422"] = 422] = "STATUS_422";
    ResponseStatus[ResponseStatus["STATUS_500"] = 500] = "STATUS_500";
})(ResponseStatus || (ResponseStatus = {}));

class ActionsSendRequest extends PostRequest {
    constructor(domain, config) {
        super(domain);
        this.domain = domain;
        this.config = config;
    }
    get url() {
        const { action } = this.config;
        return `${this.domain}/api/actions/${action}`;
    }
    get headers() {
        return this.addAuthHeaders(this.config.headers);
    }
    get params() {
        return null;
    }
    get body() {
        const { action, actionId, data } = this.config;
        return {
            action,
            actionId,
            data
        };
    }
}

var AuthEndpointTypes;
(function (AuthEndpointTypes) {
    AuthEndpointTypes["LOGIN_SEND"] = "login-send";
    AuthEndpointTypes["REFRESH_TOKEN"] = "refresh-token";
})(AuthEndpointTypes || (AuthEndpointTypes = {}));

class LoginSendCreateRequest extends PostRequest {
    constructor(domain, config) {
        super(domain);
        this.domain = domain;
        this.config = config;
    }
    get url() {
        return `${this.domain}/api/auth`;
    }
    get headers() {
        return null; // this.addAuthHeaders(this.config.headers);
    }
    get params() {
        return null;
    }
    get body() {
        const { email, password, formId } = this.config;
        return {
            email,
            password,
            formId
        };
    }
}

class LoginSendCreateResponseFactory {
    static createResponse(httpResponse) {
        let response;
        switch (httpResponse?.status) {
            case ResponseStatus.STATUS_201:
                const response201 = {
                    status: ResponseStatus.STATUS_201,
                    body: { ...httpResponse.body }
                };
                response = response201;
                break;
            case ResponseStatus.STATUS_422:
            case ResponseStatus.STATUS_400:
            case ResponseStatus.STATUS_404:
                response = {
                    status: httpResponse.status,
                    body: httpResponse.error
                };
                break;
            default:
                response = null;
                break;
        }
        return response;
    }
}

class BaseResponseFactory {
    /**
     * Create Response
     */
    static createResponse(httpResponse) {
        let response;
        switch (httpResponse?.status) {
            case ResponseStatus.STATUS_201:
                const response200 = {
                    status: ResponseStatus.STATUS_201,
                    body: { ...httpResponse.body }
                };
                response = response200;
                break;
            case ResponseStatus.STATUS_422:
            case ResponseStatus.STATUS_400:
            case ResponseStatus.STATUS_404:
                response = {
                    status: httpResponse.status,
                    body: httpResponse.error
                };
                break;
            default:
                response = null;
                break;
        }
        return response;
    }
}

var CacheDataEndpointTypes;
(function (CacheDataEndpointTypes) {
    CacheDataEndpointTypes["GET_CACHE_DATA"] = "get-cache-data";
})(CacheDataEndpointTypes || (CacheDataEndpointTypes = {}));

class GetCacheDataRequest extends GetRequest {
    constructor(domain, config) {
        super(domain);
        this.domain = domain;
        this.config = config;
    }
    get url() {
        const { type } = this.config;
        return `${this.domain}/api/cache-data/${type}`;
    }
    get headers() {
        return this.addAuthHeaders(this.config.headers);
    }
    get params() {
        return null;
    }
    get body() {
        return null;
    }
}

var FilesEndpointTypes;
(function (FilesEndpointTypes) {
    FilesEndpointTypes["UPDATE"] = "update";
    FilesEndpointTypes["DELETE"] = "delete";
    FilesEndpointTypes["SORT"] = "sort";
    FilesEndpointTypes["LOAD"] = "load";
})(FilesEndpointTypes || (FilesEndpointTypes = {}));

class FilesUpdateRequest extends PutRequest {
    constructor(domain, config) {
        super(domain);
        this.domain = domain;
        this.config = config;
    }
    get url() {
        return `${this.domain}/api/files/${this.config.id}`;
    }
    get headers() {
        return this.addAuthHeaders(this.config.headers);
    }
    get params() {
        return null;
    }
    get body() {
        const { id, title, main, sort, section, itemId } = this.config;
        const comment = {
            id,
            title,
            main,
            sort,
            section,
            item_id: itemId
        };
        return { ...this.cleanParams(comment) };
    }
}

class FilesUpdateResponseFactory {
    static createResponse(httpResponse) {
        let response;
        switch (httpResponse.status) {
            case ResponseStatus.STATUS_200:
                const response201 = {
                    status: ResponseStatus.STATUS_200,
                    body: { ...httpResponse.body }
                };
                response = response201;
                break;
            case ResponseStatus.STATUS_422:
            case ResponseStatus.STATUS_400:
            case ResponseStatus.STATUS_404:
                response = {
                    status: httpResponse.status,
                    body: httpResponse.error
                };
                break;
            default:
                response = null;
                break;
        }
        return response;
    }
}

class FilesDeleteRequest extends DeleteRequest {
    constructor(domain, config) {
        super(domain);
        this.domain = domain;
        this.config = config;
    }
    get url() {
        return `${this.domain}/api/files/${this.config.id}`;
    }
    get headers() {
        return this.addAuthHeaders(this.config.headers);
    }
    get params() {
        return null;
    }
    get body() {
        return null;
    }
}

class FilesDeleteResponseFactory {
    static createResponse(httpResponse) {
        let response;
        switch (httpResponse.status) {
            case ResponseStatus.STATUS_200:
                const response201 = {
                    status: ResponseStatus.STATUS_200,
                    body: { ...httpResponse.body }
                };
                response = response201;
                break;
            case ResponseStatus.STATUS_422:
            case ResponseStatus.STATUS_400:
            case ResponseStatus.STATUS_404:
                response = {
                    status: httpResponse.status,
                    body: httpResponse.error
                };
                break;
            default:
                response = null;
                break;
        }
        return response;
    }
}

class FilesSortRequest extends PostRequest {
    constructor(domain, config) {
        super(domain);
        this.domain = domain;
        this.config = config;
    }
    get url() {
        return `${this.domain}/api/files/sort`;
    }
    get headers() {
        return this.addAuthHeaders(this.config.headers);
    }
    get params() {
        return null;
    }
    get body() {
        const { files } = this.config;
        const data = {
            files
        };
        return { ...this.cleanParams(data) };
    }
}

class FilesSortResponseFactory {
    static createResponse(httpResponse) {
        let response;
        switch (httpResponse.status) {
            case ResponseStatus.STATUS_200:
                const response201 = {
                    status: ResponseStatus.STATUS_200,
                    body: { ...httpResponse.body }
                };
                response = response201;
                break;
            case ResponseStatus.STATUS_422:
            case ResponseStatus.STATUS_400:
            case ResponseStatus.STATUS_404:
                response = {
                    status: httpResponse.status,
                    body: httpResponse.error
                };
                break;
            default:
                response = null;
                break;
        }
        return response;
    }
}

class FilesLoadRequest extends GetRequest {
    constructor(domain, config) {
        super(domain);
        this.domain = domain;
        this.config = config;
    }
    get url() {
        const fields = this.convertFieldsToString(this.config.fields);
        return `${this.domain}/api/files/${this.config.section}/${this.config.itemId}?${fields}`;
    }
    get headers() {
        return this.addAuthHeaders(this.config.headers);
    }
    get params() {
        return null;
    }
    get body() {
        return null;
    }
}

class FilesLoadResponseFactory {
    static createResponse(httpResponse) {
        let response;
        switch (httpResponse.status) {
            case ResponseStatus.STATUS_200:
                const response201 = {
                    status: ResponseStatus.STATUS_200,
                    body: { ...httpResponse.body }
                };
                response = response201;
                break;
            case ResponseStatus.STATUS_422:
            case ResponseStatus.STATUS_400:
            case ResponseStatus.STATUS_404:
                response = {
                    status: httpResponse.status,
                    body: httpResponse.error
                };
                break;
            default:
                response = null;
                break;
        }
        return response;
    }
}

var FormDeleteFileBaseEndpointTypes;
(function (FormDeleteFileBaseEndpointTypes) {
    FormDeleteFileBaseEndpointTypes["DELETE"] = "delete";
})(FormDeleteFileBaseEndpointTypes || (FormDeleteFileBaseEndpointTypes = {}));

class FormDeleteFileRequest extends PutRequest {
    constructor(domain, config) {
        super(domain);
        this.domain = domain;
        this.config = config;
    }
    get url() {
        return `${this.domain}/api/form-delete-file`;
    }
    get headers() {
        return null;
    }
    get params() {
        return null;
    }
    get body() {
        const { entity, entityId, field } = this.config;
        const comment = {
            entity,
            entityId,
            field
        };
        return { ...this.cleanParams(comment) };
    }
}

var FormValidationEndpointTypes;
(function (FormValidationEndpointTypes) {
    FormValidationEndpointTypes["CHECK"] = "check";
})(FormValidationEndpointTypes || (FormValidationEndpointTypes = {}));

class FormValidationCheckRequest extends GetRequest {
    constructor(domain, config) {
        super(domain);
        this.domain = domain;
        this.config = config;
    }
    get url() {
        const { type, value, itemId, entity, entityField } = this.config;
        let requestUrl = `${this.domain}/api/form-validation/${type}/${value}/${itemId || '0'}`;
        if (entity) {
            requestUrl += `/${entity}`;
        }
        if (entityField) {
            requestUrl += `/${entityField}`;
        }
        return requestUrl;
    }
    get headers() {
        return null;
    }
    get params() {
        return null;
    }
    get body() {
        return null;
    }
}

var PublishEndpointTypes;
(function (PublishEndpointTypes) {
    PublishEndpointTypes["POST"] = "post";
    PublishEndpointTypes["UN_POST"] = "UN_POST";
})(PublishEndpointTypes || (PublishEndpointTypes = {}));

class PublishPostRequest extends PostRequest {
    constructor(domain, config) {
        super(domain);
        this.domain = domain;
        this.config = config;
    }
    get url() {
        return `${this.domain}/api/publish/${this.config.entity.toLowerCase()}/${this.config.itemId}${this.config.subEntity ? '/' + this.config.subEntity.toLowerCase() : ''}`;
    }
    get headers() {
        return null;
    }
    get params() {
        return null;
    }
    get body() {
        return null;
    }
}

class UnPublishPostRequest extends DeleteRequest {
    constructor(domain, config) {
        super(domain);
        this.domain = domain;
        this.config = config;
    }
    get url() {
        return `${this.domain}/api/publish/${this.config.entity.toLowerCase()}/${this.config.itemId}${this.config.subEntity ? '/' + this.config.subEntity.toLowerCase() : ''}`;
    }
    get headers() {
        return null;
    }
    get params() {
        return null;
    }
    get body() {
        return null;
    }
}

var ReportsEndpointTypes;
(function (ReportsEndpointTypes) {
    ReportsEndpointTypes["ENTITIES_REPORT"] = "entities-report";
    ReportsEndpointTypes["USER_BEHAVIOR_REPORT"] = "user-behavior-report";
})(ReportsEndpointTypes || (ReportsEndpointTypes = {}));

class EntitiesReportsRequest extends GetRequest {
    constructor(domain, config) {
        super(domain);
        this.domain = domain;
        this.config = config;
    }
    get url() {
        return `${this.domain}/api/reports/entities`;
    }
    get headers() {
        return this.addAuthHeaders(this.config.headers);
    }
    get params() {
        return null;
    }
    get body() {
        return null;
    }
}

var StaticDataEndpointTypes;
(function (StaticDataEndpointTypes) {
    StaticDataEndpointTypes["CREATE"] = "create";
    StaticDataEndpointTypes["DELETE"] = "delete";
    StaticDataEndpointTypes["LOAD_REVISION"] = "loadRevision";
    StaticDataEndpointTypes["GET_LIST"] = "getList";
    StaticDataEndpointTypes["GET_SUB_ROUTING"] = "getSubRouting";
    StaticDataEndpointTypes["GET_LIST_CATEGORIES"] = "getListCategories";
    StaticDataEndpointTypes["GET"] = "get";
    StaticDataEndpointTypes["UPDATE"] = "update";
    StaticDataEndpointTypes["PATCH_UPDATE"] = "patchUpdate";
})(StaticDataEndpointTypes || (StaticDataEndpointTypes = {}));

class StaticDataCreateRequest extends PostRequest {
    constructor(domain, config) {
        super(domain);
        this.domain = domain;
        this.config = config;
    }
    get url() {
        return `${this.domain}/api/static-data/${this.config.publicApi ? 'public/' : ''}${this.config.contentType}`;
    }
    get headers() {
        return this.addAuthHeaders(this.config.headers);
    }
    get params() {
        return null;
    }
    get body() {
        const { data, formId, contentType } = this.config;
        const comment = {
            data,
            meta: {
                formId,
                contentType
            }
        };
        return this.makeFormData({ ...this.cleanParams(comment) });
    }
}

class StaticDataUpdateRequest extends PutRequest {
    constructor(domain, config) {
        super(domain);
        this.domain = domain;
        this.config = config;
    }
    get url() {
        return `${this.domain}/api/static-data/${this.config.contentType}/${this.config.itemId}`;
    }
    get headers() {
        return this.addAuthHeaders(this.config.headers);
    }
    get params() {
        return null;
    }
    get body() {
        const { data, formId, contentType, itemId } = this.config;
        const comment = {
            data,
            meta: {
                formId,
                contentType,
                itemId
            }
        };
        return this.makeFormData({ ...this.cleanParams(comment) });
    }
}

class StaticDataDeleteRequest extends DeleteRequest {
    constructor(domain, config) {
        super(domain);
        this.domain = domain;
        this.config = config;
    }
    get url() {
        return `${this.domain}/api/static-data/${this.config.contentType}/${this.config.itemId}`;
    }
    get headers() {
        return this.addAuthHeaders(this.config.headers);
    }
    get params() {
        return null;
    }
    get body() {
        return null;
    }
}

class StaticDataGetListRequest extends GetRequest {
    constructor(domain, config) {
        super(domain);
        this.domain = domain;
        this.config = config;
    }
    get url() {
        const where = this.convertWHereToString(this.config.where);
        const fields = this.convertFieldsToString(this.config.fields);
        const paging = this.convertPagingToString(this.config.paging);
        let url = where;
        if (fields) {
            url += `${url ? '&' : ''}${fields}`;
        }
        if (paging) {
            url += `${url ? '&' : ''}${paging}`;
        }
        if (this.config.sort) {
            url += `${url ? '&' : ''}sort=${this.config.sort}`;
        }
        if (this.config.tagId) {
            url += `${url ? '&' : ''}tag_id=${this.config.tagId}`;
        }
        if (this.config.search) {
            url += `${url ? '&' : ''}search=${this.config.search}`;
        }
        if (this.config.revision) {
            url += `${url ? '&' : ''}revision=${this.config.revision}`;
        }
        return `${this.domain}/api/static-data/${this.config.contentType}/${this.config.subSection || 'list'}/${url ? '?' : ''}${url}`;
    }
    get headers() {
        return this.addAuthHeaders(this.config.headers);
    }
    get params() {
        return null;
    }
    get body() {
        return null;
    }
}

class StaticDataGetListCategoriesRequest extends GetRequest {
    constructor(domain, config) {
        super(domain);
        this.domain = domain;
        this.config = config;
    }
    get url() {
        const contentTypes = this.config.contentTypes;
        const revisions = this.config.revisions;
        return `${this.domain}/api/static-data/list/?types=${contentTypes.join(',')}${revisions ? '&revisions=' + revisions.join(':') : ''}`;
    }
    get headers() {
        return null;
    }
    get params() {
        return null;
    }
    get body() {
        return null;
    }
}

class StaticDataGetRequest extends GetRequest {
    constructor(domain, config) {
        super(domain);
        this.domain = domain;
        this.config = config;
    }
    get url() {
        const page = this.convertWHereToString(this.config.paging.page);
        const where = this.convertWHereToString(this.config.where);
        const fields = this.convertFieldsToString(this.config.fields);
        let url = `${this.domain}/api/static-data$/${this.config.contentType}/${this.config.itemId}/`; // ?${where}${where ? '&' : ''}${fields}`;
        if (page || page || fields) {
            let dopUrl = '';
            if (page) {
                dopUrl += `${dopUrl ? '&' : ''}page=${page}`;
            }
            if (where) {
                dopUrl += `${dopUrl ? '&' : ''}where=${where}`;
            }
            if (fields) {
                dopUrl += `${fields ? '&' : ''}fields=${fields}`;
            }
            if (dopUrl) {
                url += dopUrl;
            }
        }
        return url;
    }
    get headers() {
        return this.addAuthHeaders(this.config.headers);
    }
    get params() {
        return null;
    }
    get body() {
        return null;
    }
}

class StaticDataSubRoutingGetRequest extends GetRequest {
    constructor(domain, config) {
        super(domain);
        this.domain = domain;
        this.config = config;
    }
    get url() {
        let queryString = '';
        if (this.config.data) {
            queryString = '?' + Object.keys(this.config.data)
                .map(field => `${field}=${this.config.data[field]}`)
                .join('&');
        }
        return `${this.domain}/api/static-data/${this.config.contentType}/r/${this.config.routing}/${queryString}`;
    }
    get headers() {
        return this.addAuthHeaders(this.config.headers);
    }
    get params() {
        return null;
    }
    get body() {
        return null;
    }
}

var TagsEndpointTypes;
(function (TagsEndpointTypes) {
    TagsEndpointTypes["CREATE"] = "create";
    TagsEndpointTypes["DELETE"] = "delete";
    TagsEndpointTypes["LOAD"] = "load";
    TagsEndpointTypes["ENTITIES"] = "entities";
    TagsEndpointTypes["GET"] = "get";
    TagsEndpointTypes["UPDATE"] = "update";
})(TagsEndpointTypes || (TagsEndpointTypes = {}));

class TagsLoadRequest extends GetRequest {
    constructor(domain, config) {
        super(domain);
        this.domain = domain;
        this.config = config;
    }
    get url() {
        const entity = this.config.entity;
        const paging = this.config.paging;
        let dopUrl = '';
        if (paging) {
            dopUrl += `${dopUrl ? '&' : '?'}${paging}`;
        }
        return `${this.domain}/api/tags/entity/${entity}${dopUrl}`;
    }
    get headers() {
        return this.addAuthHeaders(this.config.headers);
    }
    get params() {
        return null;
    }
    get body() {
        return null;
    }
}

class TagsLoadResponseFactory {
    static createResponse(httpResponse) {
        let response;
        switch (httpResponse.status) {
            case ResponseStatus.STATUS_200:
                const response201 = {
                    status: ResponseStatus.STATUS_200,
                    body: { ...httpResponse.body }
                };
                response = response201;
                break;
            case ResponseStatus.STATUS_422:
            case ResponseStatus.STATUS_400:
            case ResponseStatus.STATUS_404:
                response = {
                    status: httpResponse.status,
                    body: httpResponse.error
                };
                break;
            default:
                response = null;
                break;
        }
        return response;
    }
}

class TagEntitiesRequest extends GetRequest {
    constructor(domain, config) {
        super(domain);
        this.domain = domain;
        this.config = config;
    }
    get url() {
        const tag = this.config.tag;
        return `${this.domain}/api/tags/entities/${tag}`;
    }
    get headers() {
        return null;
    }
    get params() {
        return null;
    }
    get body() {
        return null;
    }
}

var EntityType;
(function (EntityType) {
    EntityType["LESSON"] = "lesson";
    EntityType["STANDALONE_LESSON"] = "standalone_lesson";
    EntityType["COURSE"] = "course";
    EntityType["TOOL"] = "tool";
})(EntityType || (EntityType = {}));

var EntityQueryFieldNames;
(function (EntityQueryFieldNames) {
    EntityQueryFieldNames["COMMENTS_COUNT"] = "comments_count";
    EntityQueryFieldNames["STATE"] = "state";
    EntityQueryFieldNames["VIEWS_COUNT"] = "views_count";
    EntityQueryFieldNames["TITLE"] = "title";
    EntityQueryFieldNames["DESCRIPTION"] = "description";
    EntityQueryFieldNames["SHORT_DESCRIPTION"] = "short_description";
    EntityQueryFieldNames["SLUG"] = "slug";
    EntityQueryFieldNames["FREE_VIDEO_ID"] = "free_video_id";
    EntityQueryFieldNames["CHINESE_FREE_VIDEO_ID"] = "chinese_free_video_id";
    EntityQueryFieldNames["SKILL_LEVEL"] = "skill_level";
    EntityQueryFieldNames["COMMUNITY_TOPIC_ID"] = "community_topic_id";
    EntityQueryFieldNames["COMMUNITY_TOPIC"] = "community_topic";
    EntityQueryFieldNames["LESSON_TYPE"] = "lesson_type";
    EntityQueryFieldNames["PRODUCT"] = "product";
    EntityQueryFieldNames["UPVOTES_COUNT"] = "upvotes_count";
    EntityQueryFieldNames["DOWNVOTES_COUNT"] = "downvotes_count";
    EntityQueryFieldNames["COVER_IMAGE"] = "cover_image";
    EntityQueryFieldNames["COURSE"] = "course";
    EntityQueryFieldNames["CREATED_AT"] = "created_at";
})(EntityQueryFieldNames || (EntityQueryFieldNames = {}));

var EntitySortType;
(function (EntitySortType) {
    EntitySortType["LATEST"] = "published_at";
    EntitySortType["POPULAR"] = "popularity";
    EntitySortType["RELEVANCE"] = "relevance";
    EntitySortType["LATEST_CREATED"] = "created_at";
})(EntitySortType || (EntitySortType = {}));

class Entity {
}

// @ts-ignore
function identity(val) {
    return val;
}
function always(val) {
    return true;
}
function mappet(schema, options = {}) {
    const { strict, name = 'Mapper', greedy, include } = options;
    return (source) => Object.keys(schema)
        .reduce((result, key) => {
        // @ts-ignore
        const schemaEntry = schema[key];
        const _include = typeof schemaEntry === 'string' ? include || always : schemaEntry.include || include || always;
        const path = typeof schemaEntry === 'string' ? schemaEntry : schemaEntry.path;
        const value = get(source, path);
        if (!_include(value, source)) {
            return result;
        }
        const modifier = typeof schemaEntry === 'string' ? identity : schemaEntry.modifier || identity;
        if (strict && value === undefined) {
            throw new Error(`${name}: ${path} not found`);
        }
        return ({ ...result, [key]: modifier(value, source) });
    }, greedy ? { ...source } : {});
}

class MapperRegistry {
    constructor(cache) {
        this._registry = null;
        if (!cache) {
            this._registry = { cache: new Map() };
        }
        else {
            this._registry = cache;
        }
    }
    register(type, schema, opt) {
        if (!type && !schema) {
            throw new Error('type paramater is required when register a mapping');
        }
        else if (this.exists(type)) {
            throw new Error(`A mapper for ${type.name} has already been registered`);
        }
        // @ts-ignore
        const mapper = mappet(schema, opt);
        this._registry.cache.set(type, mapper);
    }
    map(type, data) {
        if (!this.exists(type)) {
            throw new Error(`A mapper for ${type.name} not found. Please register mapper or use mappet function`);
        }
        const mapper = this.getMapper(type);
        // @ts-ignore
        return mapper(data);
    }
    getMapper(type) {
        return this._registry.cache.get(type);
    }
    setMapper(type, schema, opt) {
        if (!schema) {
            throw new Error(`The schema must be an Object. Found ${schema}`);
        }
        else if (!this.exists(type)) {
            throw new Error(`The type ${type.name} is not registered. Register it using \`Mophism.register(${type.name}, schema)\``);
        }
        else {
            const fn = mappet(schema, opt);
            this._registry.cache.set(type, fn);
            return fn;
        }
    }
    deleteMapper(type) {
        return this._registry.cache.delete(type);
    }
    exists(type) {
        return this._registry.cache.has(type);
    }
    get mappers() {
        return this._registry.cache;
    }
}
const mapperRegistry = new MapperRegistry();
const mapperMixin = mappet;
mapperMixin.register = (t, s, opt) => mapperRegistry.register(t, s, opt);
mapperMixin.map = (t, d) => mapperRegistry.map(t, d);
mapperMixin.getMapper = (t) => mapperRegistry.getMapper(t);
mapperMixin.setMapper = (t, s, opt) => mapperRegistry.setMapper(t, s, opt);
mapperMixin.deleteMapper = (t) => mapperRegistry.deleteMapper(t);
mapperMixin.mappers = mapperRegistry.mappers;
const MapperUtil = mapperMixin;

class FileUpdateModel {
}
class FileModel {
}

class UserModel {
}

var UserRole;
(function (UserRole) {
    UserRole["GUEST"] = "guest";
    UserRole["ADMIN"] = "admin";
    UserRole["INSTRUCTOR"] = "instructor";
    UserRole["MODERATOR"] = "moderator";
    UserRole["STUDENT"] = "student";
})(UserRole || (UserRole = {}));

var UserFieldNames;
(function (UserFieldNames) {
    UserFieldNames["TOKEN"] = "token";
    UserFieldNames["TOKENEXP"] = "token_exp";
    UserFieldNames["REFRESHTOKEN"] = "refresh_token";
    UserFieldNames["EMAIL"] = "email";
    UserFieldNames["NAME"] = "name";
    UserFieldNames["LASTNAME"] = "last_name";
    UserFieldNames["AVATAR"] = "avatar";
    UserFieldNames["SEX"] = "sex";
    UserFieldNames["RIGHTS"] = "rights";
    UserFieldNames["ROLE"] = "role";
})(UserFieldNames || (UserFieldNames = {}));

class UserSectionRightModel {
}

const entityScheme = {
    id: 'id'
};

const userScheme = {
    ...entityScheme,
    email: 'email',
    token: UserFieldNames.TOKEN,
    tokenExp: UserFieldNames.TOKENEXP,
    refreshToken: UserFieldNames.REFRESHTOKEN,
    role: UserFieldNames.ROLE,
    lastName: UserFieldNames.LASTNAME,
    name: UserFieldNames.NAME,
    avatar: UserFieldNames.AVATAR,
    sex: UserFieldNames.SEX,
    rights: UserFieldNames.RIGHTS
};
const userMapper = mappet(userScheme);

class VersionsModel {
}

var FileFieldNames;
(function (FileFieldNames) {
    FileFieldNames["FILE"] = "file";
    FileFieldNames["FOLDER"] = "folder";
    FileFieldNames["TITLE"] = "title";
    FileFieldNames["MAIN"] = "main";
    FileFieldNames["ORDER"] = "order";
    FileFieldNames["SECTION"] = "section";
    FileFieldNames["VERSION"] = "versions";
    FileFieldNames["ITEM_ID"] = "item_id";
    FileFieldNames["TYPE"] = "type";
})(FileFieldNames || (FileFieldNames = {}));

const fileScheme = {
    ...entityScheme,
    file: FileFieldNames.FILE,
    folder: FileFieldNames.FOLDER,
    order: FileFieldNames.ORDER,
    main: FileFieldNames.MAIN,
    title: FileFieldNames.TITLE,
    itemId: FileFieldNames.ITEM_ID,
    section: FileFieldNames.SECTION,
    type: FileFieldNames.TYPE,
    versions: {
        path: FileFieldNames.VERSION,
        modifier: versions => ({
            1: versions['1'],
            2: versions['2'],
            3: versions['3']
        })
    }
};
const fileMapper = mappet(fileScheme);

class TagEntityModel {
}

var TagFieldNames;
(function (TagFieldNames) {
    TagFieldNames["ID"] = "id";
    TagFieldNames["NAME"] = "name";
    TagFieldNames["SLUG"] = "slug";
    TagFieldNames["ENTITY"] = "entity";
    TagFieldNames["COUNT"] = "count";
})(TagFieldNames || (TagFieldNames = {}));

const tagEntityScheme = {
    ...entityScheme,
    id: TagFieldNames.ID,
    name: TagFieldNames.NAME,
    slug: TagFieldNames.SLUG,
};
const tagEntityMapper = mappet(tagEntityScheme);

var PublicationMessageFieldNames;
(function (PublicationMessageFieldNames) {
    PublicationMessageFieldNames["ID"] = "id";
    PublicationMessageFieldNames["ITEM_ID"] = "itemId";
    PublicationMessageFieldNames["ENTITY"] = "entity";
    PublicationMessageFieldNames["IS_ERROR"] = "isError";
    PublicationMessageFieldNames["MESSAGE"] = "message";
    PublicationMessageFieldNames["FIELD"] = "field";
    PublicationMessageFieldNames["CREATED_AT"] = "createdAt";
    PublicationMessageFieldNames["UPDATED_AT"] = "updatedAt";
})(PublicationMessageFieldNames || (PublicationMessageFieldNames = {}));

const publicationMessageScheme = {
    ...entityScheme,
    isError: PublicationMessageFieldNames.IS_ERROR,
    message: PublicationMessageFieldNames.MESSAGE,
    field: PublicationMessageFieldNames.FIELD,
    entity: PublicationMessageFieldNames.ENTITY,
    itemId: PublicationMessageFieldNames.ITEM_ID,
};
const publicationMessageMapper = mappet(publicationMessageScheme);

class FormErrorModel {
}
class PublishResultModel {
}
class PublishDataModel {
}

const tagScheme = {
    ...entityScheme,
    id: TagFieldNames.ID,
    name: TagFieldNames.NAME,
    slug: TagFieldNames.SLUG,
    count: TagFieldNames.COUNT,
    entity: TagFieldNames.ENTITY
};
const tagMapper = mappet(tagScheme);

class TagModel {
}

const includeFn = (value, source) => {
    return value !== undefined;
};
// @dynamic
class BaseModelAdapter {
    constructor() {
        MapperUtil.register(UserModel, userScheme, { include: includeFn });
        MapperUtil.register(FileModel, fileScheme, { include: includeFn });
        // MapperUtil.register(TourFullModel, tourScheme, {include: includeFn});
        MapperUtil.register(TagEntityModel, tagEntityScheme, { include: includeFn });
        // MapperUtil.register(CategoryModel, categoryScheme, {include: includeFn});
        MapperUtil.register(FormErrorModel, publicationMessageScheme, { include: includeFn });
        MapperUtil.register(TagModel, tagScheme, { include: includeFn });
    }
    convertItem(type, item) {
        return MapperUtil.map(type, item);
    }
    convertItems(type, items) {
        if (Array.isArray(items) && items.length) {
            return items.map(item => this.convertItem(type, item));
        }
        return [];
    }
    static createInstance() {
        if (!this._modelAdapter) {
            this._modelAdapter = new BaseModelAdapter();
        }
        return this._modelAdapter;
    }
}

class QueryFieldsAdapter {
    generateQueryFieldsString(fields) {
        const result = this.getFieldsString(fields);
        return result;
    }
    getFieldsString(fields) {
        const result = [];
        for (const key in fields) {
            if (key === 'fields') {
                if (fields[key] && fields[key].length)
                    result.push([...fields[key]].join(','));
            }
            else {
                result.push(`${key}(${this.getFieldsString(fields[key])})`);
            }
        }
        return result.join(',');
    }
}

var UiUnitIds;
(function (UiUnitIds) {
    UiUnitIds["FIRMS"] = "firmsUiUnit";
    UiUnitIds["FIRMS_CATEGORIES"] = "firmsCategoriesUiUnit";
    UiUnitIds["FIRM_FORM"] = "firm_form";
    UiUnitIds["TOURS"] = "toursUiUnit";
    UiUnitIds["TOURS_CATEGORIES"] = "toursCategoriesUiUnit";
})(UiUnitIds || (UiUnitIds = {}));

class ActionsModel {
}

class CacheDataModel {
}

class NotificationModel {
}

class StaticDataModel {
}

var RequestStatus;
(function (RequestStatus) {
    RequestStatus["LOADING"] = "loading";
    RequestStatus["LOADED"] = "loaded";
})(RequestStatus || (RequestStatus = {}));
var RequestMethods;
(function (RequestMethods) {
    RequestMethods["GET"] = "get";
    RequestMethods["POST"] = "post";
    RequestMethods["PUT"] = "put";
    RequestMethods["DELETE"] = "delete";
})(RequestMethods || (RequestMethods = {}));

class MetaModel {
}

class ReportsModel {
}

class PagingModel {
}

class Behavior {
    constructor(action) {
        this.action = action;
        this.modelAdapter = BaseModelAdapter.createInstance();
        // constructor(protected action: AggregatableAction) {
    }
    generateSetLastRequestResult(actionType, requestResultInfo
    //correlationParams: CorrelationParams
    ) {
        const lastRequestResult = {
            actionType,
            ...requestResultInfo
        };
        /*    const setLastRequestResultPayload: SetLastRequestResultPayload = {
              lastRequestResult
            };
            return new SetLastRequestResult(
              setLastRequestResultPayload
              // correlationParams
            );*/
    }
}

;
class LoginSendBehavior extends Behavior {
    constructor(action, result) {
        super(action);
        this.action = action;
        this.result = result;
    }
    resolve() {
        const status = this.result.data.status;
        let returnedActions;
        switch (status) {
            case ResponseStatus.STATUS_200: {
                const response = this.result.data;
                const { user } = response.body;
                const userData = this.modelAdapter.convertItem(UserModel, user);
                returnedActions = [
                    LoginSendSuccess({ payload: { user: userData } })
                ];
                break;
            }
            case ResponseStatus.STATUS_400:
            case ResponseStatus.STATUS_404:
            case ResponseStatus.STATUS_422:
            case ResponseStatus.STATUS_401:
                const errorResponse = this.result.data;
                const error = errorResponse.body.errors[0].title;
                returnedActions = [
                    LoginSendFail({ payload: { error } })
                ];
                break;
            default: {
                returnedActions = [
                    LoginSendFail({ payload: { error: 'Unhandled error' } })
                ];
            }
        }
        return [...returnedActions];
    }
}

class RefreshTokenBehavior extends Behavior {
    constructor(action, result) {
        super(action);
        this.action = action;
        this.result = result;
    }
    resolve() {
        const status = this.result.data.status;
        let returnedActions;
        switch (status) {
            case ResponseStatus.STATUS_200: {
                const response = this.result.data;
                const { user } = response.body;
                const userData = this.modelAdapter.convertItem(UserModel, user);
                returnedActions = [
                    RefreshTokenSuccess({
                        payload: {
                            token: userData.token,
                            refreshToken: userData.refreshToken,
                            tokenExp: userData.tokenExp
                        }
                    })
                ];
                break;
            }
            case ResponseStatus.STATUS_400:
            case ResponseStatus.STATUS_404:
            case ResponseStatus.STATUS_422:
            case ResponseStatus.STATUS_401:
                const errorResponse = this.result.data;
                const error = errorResponse.body.errors[0].title;
                returnedActions = [
                    RefreshTokenFail({ payload: { error } })
                ];
                break;
            default: {
                returnedActions = [
                    RefreshTokenFail({ payload: { error: 'Unhandled error' } })
                ];
            }
        }
        return [...returnedActions];
    }
}

class BaseAPI {
    constructor(domain) {
        this.domain = domain;
    }
}

// @ts-ignore
var HttpErrorMessages;
(function (HttpErrorMessages) {
    HttpErrorMessages[HttpErrorMessages["Unprocessable Entity"] = 422] = "Unprocessable Entity";
})(HttpErrorMessages || (HttpErrorMessages = {}));
class BaseAPIService {
    constructor(httpClient, requestsFacade, formsFacade) {
        this.httpClient = httpClient;
        this.requestsFacade = requestsFacade;
        this.formsFacade = formsFacade;
        this.apiKey = 'api';
        this.statuses = {
            LOADING: 'loading',
            LOADED: 'loaded'
        };
    }
    /*  public doUpload(paramsConfig, endPoint: string): Observable<HttpClientResult<BaseResponse>> {
        const request = this.api.createRequest(paramsConfig, endPoint) as PutRequest;
        const headers = new HttpHeaders({...request.headers});
        const req = new HttpRequest(request.httpMethod, request.url, request.body, {
          headers,
          reportProgress: true
        });
        return this.httpClient
          .request(req)
          .pipe(
            switchMap((response) => {
              return of(this.handleResponse(response, endPoint));
            }),
            catchError(response => {
              const errorResult: HttpClientResult<any> = this.handleResponse(response, endPoint);
              if (!errorResult.info.isValid) {
                return throwError(errorResult);
              } else {
                return of(errorResult);
              }
            })
          );
      }*/
    doRequest(paramsConfig, endPoint) {
        const itemId = paramsConfig?.id || paramsConfig?.itemId || paramsConfig?.where?.slug;
        const formId = paramsConfig?.formId;
        const request = this.api.createRequest(paramsConfig, endPoint);
        const requestUrl = request.url;
        const { endPointUrl, secondEndPointUrl } = this.getEndPointUrls(requestUrl);
        const params = this.prepareRequestParams(request);
        if (endPointUrl) {
            this.requestsFacade.updateRequestData(endPointUrl, params.httpMethod, itemId, this.statuses.LOADING, secondEndPointUrl);
        }
        if (formId) {
            this.formsFacade.updateForm({
                formId,
                loading: true,
                isComplete: false
            });
        }
        return this.httpClient
            .request(params.httpMethod, params.url, params.options)
            .pipe(map((response) => {
            if (formId && response?.body?.data) {
                const { id } = response?.body?.data;
                this.formsFacade.updateForm({
                    formId,
                    loading: false,
                    isComplete: true,
                    data: {
                        itemId: id || null
                    }
                });
            }
            this.requestsFacade.updateRequestData(endPointUrl, params.httpMethod, itemId, this.statuses.LOADED, secondEndPointUrl, null, response?.body?.data);
            return this.handleResponse(response, endPoint);
        }), catchError((error) => {
            console.error('[ base-api-service ][ httpClient ][ request ]', error);
            /*        @TODO Moved in interceptor
                      if (formId) {
                        this.formsFacade.updateForm({
                          formId,
                          loading: false,
                          hasError: true,
                          isComplete: true
                        });
                      }*/
            const errorResult = this.handleResponse(error, endPoint);
            return of(errorResult);
        }));
    }
    /*  // @ts-ignore
      async _doRequest(paramsConfig, endPoint: string): Promise<HttpClientResult<BaseResponse>> {
        const request = this.api.createRequest(paramsConfig, endPoint);
        const params = this.prepareRequestParams(request);
        const result: HttpClientResult<Response> = await this.httpClient
          .request(params.httpMethod, params.url, params.options)
          .pipe(
            map((response: any) => {
              return this.handleResponse(response, endPoint);
            }),
            catchError(response => {
              const errorResult: HttpClientResult<any> = this.handleResponse(response, endPoint);
              if (!errorResult.info.isValid) {
                return throwError(errorResult);
              } else {
                return of(errorResult);
              }
            })
          ).toPromise();
        return result;
      }*/
    prepareRequestParams(request) {
        const httpMethod = request.httpMethod.toString();
        const { url, headers, params } = request;
        const options = {
            body: undefined,
            headers: { ...headers },
            params: { ...params },
            observe: 'response',
            responseType: 'json'
        };
        if (request instanceof PostRequest || request instanceof PutRequest || request instanceof PatchRequest) {
            if (request.body instanceof FormData) {
                options.body = request.body;
            }
            else {
                options.body = { ...request.body };
            }
        }
        return { httpMethod, url, options };
    }
    handleResponse(response, endPoint) {
        const apiResponse = this.api.handleResponse(response, endPoint);
        let clientResult;
        if (apiResponse) {
            clientResult = {
                info: {
                    isValid: true,
                    message: BaseAPIService.OK
                },
                data: apiResponse
            };
        }
        else {
            clientResult = {
                info: {
                    isValid: false,
                    message: BaseAPIService.ERROR
                },
                data: response
            };
        }
        return clientResult;
    }
    getEndPointUrls(url) {
        const params = url.split('/');
        let endPointUrl = '';
        let secondEndPointUrl = '';
        params.forEach((item, index) => {
            if (item === this.apiKey) {
                endPointUrl = params[index + 1];
                if (params[index + 2] && !+params[index + 2]) {
                    secondEndPointUrl = params[index + 2];
                }
            }
        });
        return { endPointUrl, secondEndPointUrl };
    }
    /**
     * Collect and get action with static data from response
     * @param modelAdapter ModelAdapter
     * @param responseData response data
     * @return Array<Action>
     */
    static getActionsWithStaticDataFromResponse(modelAdapter, responseData, staticDataFields) {
        let returnedActions = [];
        let staticData;
        /*
            @TODO
            if (Array.isArray(responseData)) {
              staticData = StaticDataHelperServices.collectListStaticDataFromResponseListData(staticDataFields, responseData);
            } else {
              staticData = StaticDataHelperServices.collectStaticDataFromResponseData(staticDataFields, responseData);
            }*/
        /*    Object.keys(staticData)
              .forEach((dataType: string) => {
                const paramsItems = staticData[dataType] as ObjectWithAnyParams[];
                if (paramsItems?.length) {
                  const params: LoadDataSuccessSuccessPayload = {
                    type: (dataType as any),
                    items: paramsItems as StaticDataModel[]
                  };
                  returnedActions.push(LoadDataSuccess({payload: params}));
                }
              });*/
        return returnedActions;
    }
    /**
     * Get collections of related data from the response for a list items
     * @param modelAdapter ModelAdapter
     * @param responseData[]
     * @return ObjectWithAnyParams
     */
    static getRelatedDataFromResponseForListItem(modelAdapter, responseData) {
        const returnedData = {};
        const relatedData = [
            { field: 'files', model: FileModel },
            // @TODO {field: 'categories', model: TourCategoryModel},
            { field: 'publicationMessages', model: FormErrorModel },
            // {field: 'firmId', model: FirmModel}
        ];
        responseData.forEach(item => {
            relatedData.forEach(relatedItem => {
                const itemField = relatedItem.field;
                const itemModel = new relatedItem.model();
                if (item[itemField]?.id || item[itemField].length) {
                    if (!returnedData[itemField]) {
                        returnedData[itemField] = [];
                    }
                    let newItemsWithoutDuplicates;
                    if (Array.isArray(item[itemField])) {
                        newItemsWithoutDuplicates = item[itemField].filter(filterItem => !returnedData[itemField].find(findItem => filterItem.id === findItem.id));
                    }
                    else {
                        const isDuplicate = item[itemField].find(filterItem => filterItem.id === item[itemField].id);
                        if (!isDuplicate) {
                            newItemsWithoutDuplicates = [item[itemField]];
                        }
                    }
                    if (newItemsWithoutDuplicates) {
                        const newItems = modelAdapter.convertItems(relatedItem.model, newItemsWithoutDuplicates);
                        returnedData[itemField] = [...returnedData[itemField], ...newItems];
                    }
                }
            });
        });
        return returnedData;
    }
}
BaseAPIService.OK = 'OK';
BaseAPIService.ERROR = 'ERROR';

class RefreshTokenRequest extends GetRequest {
    constructor(domain, config) {
        super(domain);
        this.domain = domain;
        this.config = config;
    }
    get url() {
        return `${this.domain}/api/auth/refresh-token/${this.config.refreshToken}`;
    }
    get headers() {
        return null; // this.addAuthHeaders(this.config.headers);
    }
    get params() {
        return null;
    }
    get body() {
        return null;
    }
}

class RefreshTokenResponseFactory {
    static createResponse(httpResponse) {
        let response;
        switch (httpResponse.status) {
            case ResponseStatus.STATUS_201:
                const response201 = {
                    status: ResponseStatus.STATUS_201,
                    body: { ...httpResponse.body }
                };
                response = response201;
                break;
            case ResponseStatus.STATUS_422:
            case ResponseStatus.STATUS_400:
            case ResponseStatus.STATUS_404:
                response = {
                    status: httpResponse.status,
                    body: httpResponse.error
                };
                break;
            default:
                response = null;
                break;
        }
        return response;
    }
}

class UsersApi extends BaseAPI {
    constructor(domain) {
        super(domain);
        this.domain = domain;
    }
    createRequest(paramsConfig, endPointType) {
        let request;
        switch (endPointType) {
            case AuthEndpointTypes.LOGIN_SEND:
                request = new LoginSendCreateRequest(this.domain, paramsConfig);
                break;
            case AuthEndpointTypes.REFRESH_TOKEN:
                request = new RefreshTokenRequest(this.domain, paramsConfig);
                break;
            default:
                throw new Error(`Request for ${endPointType} is undefined `);
        }
        return request;
    }
    handleResponse(response, endPointType) {
        let courseResponse;
        switch (endPointType) {
            case AuthEndpointTypes.LOGIN_SEND:
                courseResponse = LoginSendCreateResponseFactory.createResponse(response);
                break;
            case AuthEndpointTypes.REFRESH_TOKEN:
                courseResponse = RefreshTokenResponseFactory.createResponse(response);
                break;
            default:
                throw new Error(`Response for ${endPointType} is undefined `);
        }
        return courseResponse;
    }
}

const CreateRequestListener = createAction('[Requests] Create Request waiter', props());
const DeleteRequestWaiter = createAction('[Requests] Delete Request Waiter', props());
const UpdateRequestData = createAction('[Requests] Update Request data', props());

class ReducerService {
    static clearAll(initState) {
    }
    static upsertOne(state, item, id) {
        const newState = { list: [...state['list']], ids: [...state['ids']] };
        const itemId = id ? id : item.id;
        const foundIndex = this.findItemIndex(state, itemId);
        if (foundIndex || foundIndex === 0) {
            // @ts-ignore
            newState.list[foundIndex] = { ...newState.list[foundIndex], ...item };
        }
        else {
            if (Array.isArray(newState.list)) {
                // @ts-ignore
                newState.list.push(item);
            }
            else {
                // @ts-ignore
                newState.list = [item];
            }
            newState.ids.push(itemId);
        }
        return newState;
    }
    static upsertMeny(state, items) {
        let newState = { ...state };
        if (items && items.length) {
            items.forEach((item) => {
                newState = this.upsertOne(newState, item);
            });
        }
        return newState;
    }
    static findItemIndex(state, itemId) {
        const itemIdChecked = itemId;
        let foundIndex = null;
        if (state.ids.indexOf(itemIdChecked) !== -1) {
            state.list.forEach((item, index) => {
                if (item.id === itemIdChecked) {
                    foundIndex = index;
                }
            });
        }
        return foundIndex;
    }
    static deleteOne(state, itemId) {
        if (state.ids.includes(+itemId)) {
            state = this.deleteItemsByField(state, 'id', itemId);
        }
        return state;
    }
    static deleteItemsByField(state, field, value) {
        const newState = { ids: [], list: [] };
        newState.list = state.list.filter((item) => +item[field] !== +value);
        newState.ids = state.ids.filter((item) => +item[field] !== +value);
        return newState;
    }
}

const REQUESTS_FEATURE_KEY = 'requests';
const initialState$f = {
    list: [],
    ids: []
};
const _requestsStateReducer = createReducer(initialState$f, on(CreateRequestListener, (state, action) => {
    const { endPointUrl, itemId, method, secondEndPointUrl } = action.payload;
    const { id } = getRequestId(endPointUrl, action.payload?.itemId, method);
    return {
        ...ReducerService.upsertOne(state, {
            id,
            endPointUrl,
            itemId,
            secondEndPointUrl
        })
    };
}), on(DeleteRequestWaiter, (state, action) => {
    const { endPointUrl, secondEndPointUrl, method } = action.payload;
    const ids = getRequestIdVariants(endPointUrl, action.payload?.itemId, method, secondEndPointUrl);
    let existsId = getExistId(state.ids, ids);
    if (existsId) {
        return {
            ...ReducerService.deleteOne(state, existsId)
        };
    }
}), on(UpdateRequestData, (state, action) => {
    const { endPointUrl, secondEndPointUrl, status, error, itemId, method, data } = action.payload;
    const ids = getRequestIdVariants(endPointUrl, action.payload?.itemId, method, secondEndPointUrl);
    let existsId = getExistId(state.ids, ids);
    if (existsId) {
        return {
            ...ReducerService.upsertOne(state, {
                id: existsId,
                endPointUrl,
                secondEndPointUrl,
                itemId,
                status,
                error,
                data: { ...data }
            })
        };
    }
    return state;
}));
function requestsReducer(state, action) {
    return _requestsStateReducer(state, action);
}
function getRequestId(endPoint, itemIdIn, method) {
    const itemId = itemIdIn || '*';
    return { id: `${endPoint}_${method}_${itemId}` };
}
function getRequestIdVariants(endPoint, itemIdIn, method, secondEndPointUrl) {
    const itemId = itemIdIn || '*';
    const resultList = [];
    resultList.push(`${endPoint}_${method}_${itemId}`);
    resultList.push(`${endPoint}_*_${itemId}`);
    resultList.push(`${endPoint}${secondEndPointUrl ? '/' + secondEndPointUrl : ''}_${method}_${itemId}`);
    resultList.push(`${endPoint}${secondEndPointUrl ? '/' + secondEndPointUrl : ''}_*_${itemId}`);
    return resultList;
}
function getExistId(ids, checkIds) {
    return ids.find(id => checkIds.includes(id));
}

const getRequestsState = createFeatureSelector(REQUESTS_FEATURE_KEY);
const getRequestInfo = (endpointUrl, method, itemId, secondEndPointUrl) => createSelector(getRequestsState, (state) => {
    return state?.list?.find(item => {
        return item.endPointUrl === endpointUrl
            && (!itemId || item.itemId === itemId)
            && (!secondEndPointUrl || item.secondEndPointUrl === secondEndPointUrl);
    });
});
const requestsQuery = {
    getRequestInfo
};

const SequelizeUniqueConstraintError = 'SequelizeUniqueConstraintError';
class RequestsFacade {
    constructor(store) {
        this.store = store;
    }
    /**
     *
     * @param endPointUrl
     * @param method
     * @param itemId
     * @param secondEndPointUrl
     * @example
     * this.requestsFacade.createRequestListener('files', 'post');
     * this.requestsFacade.createRequestListener('files', 'post', 5);
     * this.requestsFacade.createRequestListener('files', 'post', null, 'sort');
     */
    createRequestListener(endPointUrl, method, itemId, secondEndPointUrl) {
        this.store.dispatch(CreateRequestListener({ payload: { endPointUrl, method, itemId, secondEndPointUrl } }));
    }
    updateRequestData(endPointUrl, method, itemId, status, secondEndPointUrl, error, responseData) {
        this.store.dispatch(UpdateRequestData({ payload: { endPointUrl, secondEndPointUrl, method, itemId, status, error, data: responseData } }));
    }
    deleteRequestWaiter(endPointUrl, method, itemId, secondEndPointUrl) {
        this.store.dispatch(DeleteRequestWaiter({ payload: { endPointUrl, secondEndPointUrl, method, itemId } }));
    }
    getRequestUpdates(endPointUrl, method, itemId, secondEndpointUrl) {
        return this.store.pipe(select(requestsQuery.getRequestInfo(endPointUrl, method, itemId, secondEndpointUrl)), filter(data => !!data && !!data.status));
    }
}
RequestsFacade.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "15.2.9", ngImport: i0, type: RequestsFacade, deps: [{ token: i1.Store }], target: i0.ɵɵFactoryTarget.Injectable });
RequestsFacade.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "15.2.9", ngImport: i0, type: RequestsFacade, providedIn: "root" });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "15.2.9", ngImport: i0, type: RequestsFacade, decorators: [{
            type: Injectable,
            args: [{ providedIn: "root" }]
        }], ctorParameters: function () { return [{ type: i1.Store }]; } });

/**
 *
 */
const InitForm = createAction('[Forms] Init form', props());
const DeleteForm = createAction('[Forms] Delete Form', props());
const UpdateForm = createAction('[Forms] Update Form', props());
const FormCompleted = createAction('[Forms] Form completed', props());

const FORMS_FEATURE_KEY = 'forms';
const initialState$e = {
    list: [],
    ids: []
};
const _formReducer = createReducer(initialState$e, on(InitForm, UpdateForm, (state, action) => {
    const { formId, loading, hasError, isComplete, data, error, code } = action.payload;
    const id = formId;
    return {
        ...ReducerService.upsertOne(state, {
            id,
            formId,
            hasError,
            loading,
            isComplete: isComplete || false,
            error,
            code,
            data
        })
    };
}), on(DeleteForm, (state, action) => {
    const { formId } = action.payload;
    return {
        ...ReducerService.deleteOne(state, formId)
    };
}), on(FormCompleted, (state, action) => {
    const { formId } = action.payload;
    return {
        ...ReducerService.upsertOne(state, {
            id: formId,
            isComplete: true,
        })
    };
}));
function formReducer(state, action) {
    return _formReducer(state, action);
}

const getFormsState = createFeatureSelector(FORMS_FEATURE_KEY);
const getForm = (formId) => createSelector(getFormsState, (state) => {
    if (state) {
        return state.list.find(item => item.formId === formId);
    }
    return null;
});
const getAllForms = () => createSelector(getFormsState, (state) => {
    if (state) {
        return state.list;
    }
    return null;
});
const formsQuery = {
    getForm,
    getAllForms
};

class FormsFacade {
    constructor(store) {
        this.store = store;
    }
    initForm(form) {
        this.store.dispatch(InitForm({ payload: form }));
    }
    updateForm(form) {
        this.store.dispatch(UpdateForm({ payload: form }));
    }
    getForm(formId) {
        return this.store.pipe(select(formsQuery.getForm(formId)));
    }
    getAllForms() {
        return this.store.pipe(select(formsQuery.getAllForms()));
    }
    removeForm(formId) {
        this.store.dispatch(DeleteForm({ payload: { formId } }));
    }
}
FormsFacade.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "15.2.9", ngImport: i0, type: FormsFacade, deps: [{ token: i1.Store }], target: i0.ɵɵFactoryTarget.Injectable });
FormsFacade.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "15.2.9", ngImport: i0, type: FormsFacade, providedIn: 'root' });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "15.2.9", ngImport: i0, type: FormsFacade, decorators: [{
            type: Injectable,
            args: [{ providedIn: 'root' }]
        }], ctorParameters: function () { return [{ type: i1.Store }]; } });

class UsersService extends BaseAPIService {
    constructor(httpClient, config, requestsFacade, formsFacade) {
        super(httpClient, requestsFacade, formsFacade);
        this.httpClient = httpClient;
        this.config = config;
        this.requestsFacade = requestsFacade;
        this.formsFacade = formsFacade;
        this.api = new UsersApi(this.config.apiUrl);
    }
    loginSend(config) {
        return this.doRequest(config, AuthEndpointTypes.LOGIN_SEND);
    }
    refreshToken(config) {
        return this.doRequest(config, AuthEndpointTypes.REFRESH_TOKEN);
    }
}
UsersService.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "15.2.9", ngImport: i0, type: UsersService, deps: [{ token: i1$1.HttpClient }, { token: CORE_CONFIG }, { token: RequestsFacade }, { token: FormsFacade }], target: i0.ɵɵFactoryTarget.Injectable });
UsersService.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "15.2.9", ngImport: i0, type: UsersService, providedIn: 'root' });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "15.2.9", ngImport: i0, type: UsersService, decorators: [{
            type: Injectable,
            args: [{
                    providedIn: 'root'
                }]
        }], ctorParameters: function () { return [{ type: i1$1.HttpClient }, { type: undefined, decorators: [{
                    type: Inject,
                    args: [CORE_CONFIG]
                }] }, { type: RequestsFacade }, { type: FormsFacade }]; } });

class CustomSerializer {
    serialize(routerState) {
        let route = routerState.root;
        let path;
        while (route.firstChild) {
            route = route.firstChild;
            path = route.routeConfig.path;
        }
        const { url, root: { queryParams }, } = routerState;
        const { params } = route;
        return { url, params, queryParams, path };
    }
}

const ROUTER_FEATURE_KEY = 'notifications';
// @ts-ignore
const initialState$d = { root: null, url: '' };
/*
const _outerReducer = createReducer(
  initialState,
  on(ROUTER_ERROR,
    ROUTER_CANCEL,
    ROUTER_NAVIGATION,
    (state, action) => {
      return {
        ...state,
        ...action.type
      };
    }
  )
);

export function routerReducer(state, action) {
  return _outerReducer(state, action);
}
*/

const getRouterState = createFeatureSelector(ROUTER_FEATURE_KEY);
const getRouterUrl = createSelector(getRouterState, (state) => {
    return state && state['router'].url;
});
const getRouterRoot = createSelector(getRouterState, (state) => {
    return state && state['router'].root;
});
const getRouterQueryParams = createSelector(getRouterState, (state) => {
    return state && state['router'].root.queryParams;
});
const getRouterLastRoute = createSelector(getRouterState, (state) => {
    if (state) {
        let route = state['router'].root;
        while (route.firstChild) {
            route = route.firstChild;
        }
        return route.url.length ? route.url[0].path : '';
    }
    return '';
});
const getRouterLastRouteParams = createSelector(getRouterState, (state) => {
    if (state) {
        let route = state['router'].root;
        while (route.firstChild) {
            route = route.firstChild;
        }
        return route.params;
    }
    return '';
});

const Go = createAction('[Router] Go', props());
const GoFail = createAction('[Router] Go Error');
const SetRouterQueryParams = createAction('[Router] Set Router Query Params', props());
const Back = createAction('[Router] Back');
const Forward = createAction('[Router] Forward');

class RouterEffects {
    /*  @Effect({ dispatch: false })
      setRouterQueryParams$ = this.effect(RouterActionTypes.SetRouterQueryParams, {
        operatorFunctions: (action: SetRouterQueryParams) => [
          switchMap(() => this.applySelector(getRouterUrl)),
          tap((url: string) => {
            const payload: SetRouterQueryParamsPayload = action.payload;
            const extras: NavigationExtras = payload.extras;
            const path = [this.location.path().split('?')[0]];
            this.router.navigate(path, extras);
          })
        ],
        onError: (action: Go, error) => new GoFail({}, error, action.correlationParams)
      });*/
    constructor(actions$, store, router, location) {
        this.actions$ = actions$;
        this.store = store;
        this.router = router;
        this.location = location;
        this.go$ = createEffect(() => this.actions$.pipe(ofType(Go), tap((action) => {
            const payload = action.payload;
            const path = this.preparePath(payload.path);
            let extras;
            if (payload.extras) {
                extras = {};
                if (!!payload.extras.queryParams) {
                    extras.queryParams = payload.extras.queryParams;
                }
                if (!!payload.extras.fragment) {
                    extras.fragment = payload.extras.fragment;
                }
            }
            this.router.navigate(path, extras)
                .then(data => {
                console.info('[ router ][ navigate ]', path);
            })
                .catch(error => {
                console.error('[ router ][ error ]', error);
            });
        })), { dispatch: false });
    }
    preparePath(params) {
        const path = [];
        let i = 0;
        while (params.length > i) {
            const p = params[i];
            if (typeof p === 'object') {
                for (const key in p) {
                    if (p.hasOwnProperty(key)) {
                        path.push(p[key]);
                    }
                }
            }
            else {
                path.push(p);
            }
            i++;
        }
        return path;
    }
}
RouterEffects.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "15.2.9", ngImport: i0, type: RouterEffects, deps: [{ token: i1$2.Actions }, { token: i1.Store }, { token: i2.Router }, { token: i1$3.Location }], target: i0.ɵɵFactoryTarget.Injectable });
RouterEffects.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "15.2.9", ngImport: i0, type: RouterEffects });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "15.2.9", ngImport: i0, type: RouterEffects, decorators: [{
            type: Injectable
        }], ctorParameters: function () { return [{ type: i1$2.Actions }, { type: i1.Store }, { type: i2.Router }, { type: i1$3.Location }]; } });

class RouterService {
    constructor(store) {
        this.store = store;
    }
    goTo(src, extras) {
        console.info('[ router.service.navigation ]', src, extras);
        this.store.dispatch(Go({ payload: { path: [src], extras } }));
    }
}
RouterService.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "15.2.9", ngImport: i0, type: RouterService, deps: [{ token: i1.Store }], target: i0.ɵɵFactoryTarget.Injectable });
RouterService.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "15.2.9", ngImport: i0, type: RouterService, providedIn: 'root' });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "15.2.9", ngImport: i0, type: RouterService, decorators: [{
            type: Injectable,
            args: [{ providedIn: 'root' }]
        }], ctorParameters: function () { return [{ type: i1.Store }]; } });

class ActionsApi extends BaseAPI {
    constructor(domain) {
        super(domain);
        this.domain = domain;
    }
    createRequest(paramsConfig, endPointType) {
        let request;
        switch (endPointType) {
            case ActionsEndpointTypes.SEND_ACTION:
                request = new ActionsSendRequest(this.domain, paramsConfig);
                break;
            default:
                throw new Error(`Request for ${endPointType} is undefined `);
        }
        return request;
    }
    handleResponse(response, endPointType) {
        return BaseResponseFactory.createResponse(response);
    }
}

class ActionsService extends BaseAPIService {
    constructor(httpClient, config, requestsFacade, formsFacade) {
        super(httpClient, requestsFacade, formsFacade);
        this.httpClient = httpClient;
        this.config = config;
        this.requestsFacade = requestsFacade;
        this.formsFacade = formsFacade;
        this.api = new ActionsApi(this.config.apiUrl);
    }
    sendAction(config) {
        return this.doRequest(config, ActionsEndpointTypes.SEND_ACTION);
    }
}
ActionsService.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "15.2.9", ngImport: i0, type: ActionsService, deps: [{ token: i1$1.HttpClient }, { token: CORE_CONFIG }, { token: RequestsFacade }, { token: FormsFacade }], target: i0.ɵɵFactoryTarget.Injectable });
ActionsService.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "15.2.9", ngImport: i0, type: ActionsService, providedIn: "root" });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "15.2.9", ngImport: i0, type: ActionsService, decorators: [{
            type: Injectable,
            args: [{
                    providedIn: "root"
                }]
        }], ctorParameters: function () { return [{ type: i1$1.HttpClient }, { type: undefined, decorators: [{
                    type: Inject,
                    args: [CORE_CONFIG]
                }] }, { type: RequestsFacade }, { type: FormsFacade }]; } });

class NotificationsFacade {
    constructor(store) {
        this.store = store;
        this.forbiddenError = {
            text: 'У вас нет доступа для этого действия',
            title: 'Внимание'
        };
    }
    addNotifications(params) {
        this.store.dispatch(NotificationAdd({ payload: { ...params } }));
    }
    showForbiddenError() {
        const rand = Math.random();
        const payload = {
            id: `forbidden${rand}`,
            type: 'error',
            text: this.forbiddenError.text,
            title: this.forbiddenError.title,
            showingType: NotificationShowingType.POPUP
        };
        this.store.dispatch(NotificationAdd({ payload }));
    }
}
NotificationsFacade.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "15.2.9", ngImport: i0, type: NotificationsFacade, deps: [{ token: i1.Store }], target: i0.ɵɵFactoryTarget.Injectable });
NotificationsFacade.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "15.2.9", ngImport: i0, type: NotificationsFacade, providedIn: "root" });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "15.2.9", ngImport: i0, type: NotificationsFacade, decorators: [{
            type: Injectable,
            args: [{ providedIn: "root" }]
        }], ctorParameters: function () { return [{ type: i1.Store }]; } });

const NOTIFICATIONS_FEATURE_KEY = 'notifications';
const initialState$c = {
    list: [],
    ids: []
};
const _notificationsReducer = createReducer(initialState$c, on(NotificationAdd, (state, action) => {
    const { text, title, type, id, showingType } = action.payload;
    const data = {
        text,
        id,
        title,
        type,
        showingType
    };
    return {
        ...ReducerService.upsertOne(state, data)
    };
}));
function notificationsReducer(state, action) {
    return _notificationsReducer(state, action);
}

const getNotificationsState = createFeatureSelector(NOTIFICATIONS_FEATURE_KEY);
const getAll = (id) => createSelector(getNotificationsState, (state) => {
    return state.list;
});
const notificationQuery = {
    getAll
};

class UsersEffects {
    constructor(actions$, store, usersService, authenticationService, routerService, actionsService, notificationsFacade) {
        this.actions$ = actions$;
        this.store = store;
        this.usersService = usersService;
        this.authenticationService = authenticationService;
        this.routerService = routerService;
        this.actionsService = actionsService;
        this.notificationsFacade = notificationsFacade;
        this.GlobalEvent$ = createEffect(() => this.actions$.pipe(ofType(GlobalEvent), filter$1(action => action.payload.action === 'generation-new-password-send-user'), switchMap((actionIn) => {
            const { action, formValue } = actionIn.payload;
            const config = {
                action,
                actionId: Math.ceil(Math.random() * 100),
                data: {
                    userId: formValue['id'],
                    salt: formValue['salt'],
                }
            };
            return this.actionsService.sendAction(config)
                .pipe(tap((r) => {
                const newPassword = r?.data?.body?.data?.newPassword || '';
                if (newPassword) {
                    // Update form
                    const field = actionIn.payload.fieldData?.field || '';
                    const entity = actionIn.payload?.entity || '';
                    const entityId = actionIn.payload?.entityId || '';
                    if (field && entity && entityId) {
                        this.store.dispatch(EntityUpdate({
                            payload: {
                                entity: `StaticData`,
                                subeEntity: entity,
                                entityId,
                                updates: { [field]: newPassword }
                            }
                        }));
                    }
                    // Send a notification
                    const payload = {
                        id: config.actionId,
                        type: 'success',
                        text: 'Новый пароль успешно сохранен и выслан на почту',
                        timeout: NOTIFICATION_LONG_TIMEOUT,
                        showingType: NotificationShowingType.TOASTER
                    };
                    this.notificationsFacade.addNotifications(payload);
                }
                else {
                    const payload = {
                        id: config.actionId,
                        type: 'error',
                        text: 'Не удалось сгенерировать и отправить новый пароль, попробуйте еще раз',
                        timeout: NOTIFICATION_LONG_TIMEOUT,
                        showingType: NotificationShowingType.TOASTER
                    };
                    this.notificationsFacade.addNotifications(payload);
                }
            }));
        })), { dispatch: false });
        this.GlobalEvent2$ = createEffect(() => this.actions$.pipe(ofType(GlobalEvent), filter$1(action => action.payload.action === 'generation-new-password'), switchMap((actionIn) => {
            const { action, formValue } = actionIn.payload;
            const config = {
                action,
                actionId: Math.ceil(Math.random() * 100),
                data: {
                    newPassword: formValue['password'],
                    salt: formValue['salt'],
                }
            };
            return this.actionsService.sendAction(config)
                .pipe(tap((r) => {
                const newPassword = r?.data?.body?.data?.newPassword || '';
                if (newPassword) {
                    // Update form
                    const field = actionIn.payload.fieldData.field || '';
                    const entity = actionIn.payload?.entity || '';
                    const entityId = actionIn.payload?.entityId || '';
                    if (field && entity && entityId) {
                        this.store.dispatch(EntityUpdate({
                            payload: {
                                entity: `StaticData`,
                                subeEntity: entity,
                                entityId,
                                updates: { [field]: newPassword }
                            }
                        }));
                    }
                    // Send a notification
                    const payload = {
                        id: config.actionId,
                        type: 'success',
                        text: 'Новый пароль успешно сгенерирован. Сохраните форму',
                        timeout: NOTIFICATION_LONG_TIMEOUT,
                        showingType: NotificationShowingType.TOASTER
                    };
                    this.notificationsFacade.addNotifications(payload);
                }
                else {
                    const payload = {
                        id: config.actionId,
                        type: 'error',
                        text: 'Не удалось сгенерировать новый пароль, попробуйте еще раз',
                        timeout: NOTIFICATION_LONG_TIMEOUT,
                        showingType: NotificationShowingType.TOASTER
                    };
                    this.notificationsFacade.addNotifications(payload);
                }
            }));
        })), { dispatch: false });
        this.loginSend$ = createEffect(() => this.actions$.pipe(ofType(LoginSend), switchMap((action) => {
            const { email, password, formId } = action.payload;
            const config = {
                email,
                password,
                formId
            };
            return this.usersService.loginSend(config)
                .pipe(flatMap((r) => new LoginSendBehavior(action, r).resolve()));
        }), catchError(error => of(LoginSendFail(error)))));
        this.loginSendSuccess$ = createEffect(() => this.actions$.pipe(ofType(LoginSendSuccess), tap((action) => {
            const { user } = action.payload;
            this.authenticationService.saveAuthInfo(user);
            const redirectUrl = this.authenticationService.getRedirectToUrl();
            this.routerService.goTo(redirectUrl ? [redirectUrl] : '/');
        })), { dispatch: false });
        this.refreshToken$ = createEffect(() => this.actions$.pipe(ofType(RefreshToken), switchMap((action) => {
            const { refreshToken } = action.payload;
            const config = { refreshToken };
            return this.usersService.refreshToken(config)
                .pipe(flatMap((r) => new RefreshTokenBehavior(action, r).resolve()));
        }), catchError(error => of(RefreshTokenFail(error)))));
        this.refreshTokenSuccess$ = createEffect(() => this.actions$.pipe(ofType(RefreshTokenSuccess), tap(action => {
            const { token, refreshToken, tokenExp } = action.payload;
            this.authenticationService.saveRefreshToken(token, tokenExp, refreshToken);
        })));
    }
}
UsersEffects.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "15.2.9", ngImport: i0, type: UsersEffects, deps: [{ token: i1$2.Actions }, { token: i1.Store }, { token: UsersService }, { token: AuthenticationService }, { token: RouterService }, { token: ActionsService }, { token: NotificationsFacade }], target: i0.ɵɵFactoryTarget.Injectable });
UsersEffects.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "15.2.9", ngImport: i0, type: UsersEffects, providedIn: "root" });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "15.2.9", ngImport: i0, type: UsersEffects, decorators: [{
            type: Injectable,
            args: [{ providedIn: "root" }]
        }], ctorParameters: function () { return [{ type: i1$2.Actions }, { type: i1.Store }, { type: UsersService }, { type: AuthenticationService }, { type: RouterService }, { type: ActionsService }, { type: NotificationsFacade }]; } });

const USERS_FEATURE_KEY = 'users';
const initialState$b = {
    loaded: false
};
const _userReducer = createReducer(initialState$b, on(LoadUsersSuccess, (state, action) => {
    return {
        ...state,
        loaded: true
    };
}), on(RefreshToken, SetLoaded, (state, action) => {
    return {
        ...state,
        loaded: false
    };
}), on(RefreshTokenSuccess, (state, action) => {
    console.info('[ refreshTokenSuccess ]');
    const { token, refreshToken, tokenExp } = action.payload;
    return {
        ...state,
        // data: { ...state.data, token, refreshToken, tokenExp },
        token,
        refreshToken,
        tokenExp,
        loaded: true
    };
}));
function userReducer(state, action) {
    return _userReducer(state, action);
}

const getUsersState = createFeatureSelector(USERS_FEATURE_KEY);
const getLoaded$3 = createSelector(getUsersState, (state) => state.loaded);
const getError$4 = createSelector(getUsersState, (state) => {
    return state;
});
const getUser = createSelector(getUsersState, (state) => {
    return state.token ? state : null;
});
const getUserAuthData = createSelector(getUsersState, (userSate) => {
    return userSate && { token: userSate.token, uid: userSate.id };
});
const usersQuery = {
    getLoaded: getLoaded$3,
    getError: getError$4,
    getUser,
};

class UsersFacade {
    constructor(store) {
        this.store = store;
        this.loaded$ = this.store.pipe(select(usersQuery.getLoaded));
        this.getUser$ = this.store.pipe(select(usersQuery.getUser));
    }
    testMethod() {
    }
    loadAll() {
        this.store.dispatch(LoadUsers());
    }
    sendLogin({ email, password, remember, formId }) {
        const params = {
            email, password, remember, formId
        };
        this.store.dispatch(LoginSend({ payload: params }));
    }
    logOut() {
        console.info('logOut');
    }
    refreshToken(refreshToken) {
        console.info('refreshToken');
        this.store.dispatch(RefreshToken({ payload: { refreshToken } }));
    }
    setLoaded() {
        this.store.dispatch(SetLoaded());
    }
}
UsersFacade.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "15.2.9", ngImport: i0, type: UsersFacade, deps: [{ token: i1.Store }], target: i0.ɵɵFactoryTarget.Injectable });
UsersFacade.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "15.2.9", ngImport: i0, type: UsersFacade, providedIn: "root" });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "15.2.9", ngImport: i0, type: UsersFacade, decorators: [{
            type: Injectable,
            args: [{
                    providedIn: "root"
                }]
        }], ctorParameters: function () { return [{ type: i1.Store }]; } });

const appearFromRightWithDelay = trigger('appearFromRightWithDelay', [
    transition(':enter', [
        animate('500ms 3ms', keyframes([
            style({ opacity: 0, transform: 'translateX(50px)', offset: 0 }),
            style({ opacity: .7, transform: 'translateX(-30px)', offset: 0.7 }),
            style({ opacity: 1, transform: 'none', offset: 1 })
        ]))
    ]),
    transition(':leave', [
        animate('300ms', keyframes([
            style({ opacity: 1, transform: 'none', offset: 0 }),
            style({ opacity: .3, transform: 'translateX(-20px)', offset: 0.3 }),
            style({ opacity: 0, transform: 'translateX(50px)', offset: 1 })
        ]))
    ])
]);

class CommonDialogComponent {
    constructor(dialogRef, data) {
        this.dialogRef = dialogRef;
        this.data = data;
        this.sizeValues = {
            big: 'big',
            middle: 'middle',
            small: 'small'
        };
        this.typesValues = {
            success: 'success',
            error: 'error',
            info: 'info'
        };
        this.showButton = true;
    }
    onNoClick() {
        this.dialogRef.close(false);
    }
    onYesClick() {
        this.dialogRef.close(true);
    }
}
CommonDialogComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "15.2.9", ngImport: i0, type: CommonDialogComponent, deps: [{ token: i1$4.MatDialogRef }, { token: MAT_DIALOG_DATA }], target: i0.ɵɵFactoryTarget.Component });
CommonDialogComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "15.2.9", type: CommonDialogComponent, selector: "app-common-dialog", ngImport: i0, template: "<div class=\"text-center position-relative p-10\"\n     @appearFromRightWithDelay\n     [class.size-big]=\"data.size === sizeValues.big\"\n     [class.size-middle]=\"data.size === sizeValues.middle\"\n     [class.size-small]=\"data.size === sizeValues.small\"\n     [class.style-success]=\"data.messageType === typesValues.success\"\n     [class.style-error]=\"data.messageType === typesValues.error\"\n     [class.style-info]=\"data.messageType === typesValues.info\">\n  <div [class.display-none]=\"!data.hideButton\"\n       class=\"close-button\"\n       (click)=\"onNoClick()\">\n    x\n  </div>\n\n  <h1 class=\"mat-dialog-title\" [class.display-none]=\"!data.title\">{{data.title}}</h1>\n  <div mat-dialog-content>\n    <p [innerHTML]=\"data.message\"></p>\n  </div>\n  <div [class.display-none]=\"data.hideButton\" mat-dialog-actions class=\"text-align-center mt-20\">\n    <button mat-button (click)=\"onNoClick()\"\n            class=\"mat-raised-button mr-10\"\n            cdkFocusInitial>{{data.falseButtonTitle || '\u041D\u0435\u0442' }}</button>\n    <button mat-button\n            [class.display-none]=\"data.hideTrueButton\"\n            (click)=\"onYesClick()\"\n            class=\"mat-raised-button mat-warn\">{{data.trueButtonTitle || '\u0414\u0430' }}</button>\n  </div>\n</div>\n", styles: [".size-big{width:800px}.size-middle{width:600px}.size-small{width:300px}.style-success,.style-error,.style-info{padding:24px}.style-success{border-left:5px solid #4caf50;background:linear-gradient(15deg,rgba(109,207,113,.7882352941),#f0f8f0)}.style-info{border-left:5px solid #fcb202;background:linear-gradient(15deg,rgba(252,178,2,.5294117647),rgba(252,178,2,.031372549))}.style-error{border-left:5px solid #f44336;background:linear-gradient(15deg,rgba(242,104,100,.5803921569),#f7e6e4)}.close-button{right:0;margin:-9px 10px 0 0;position:absolute;cursor:pointer;font-size:16px;font-weight:700}.display-none{display:none}\n"], dependencies: [{ kind: "directive", type: i1$4.MatDialogContent, selector: "[mat-dialog-content], mat-dialog-content, [matDialogContent]" }, { kind: "directive", type: i1$4.MatDialogActions, selector: "[mat-dialog-actions], mat-dialog-actions, [matDialogActions]", inputs: ["align"] }, { kind: "component", type: i5.MatButton, selector: "    button[mat-button], button[mat-raised-button], button[mat-flat-button],    button[mat-stroked-button]  ", inputs: ["disabled", "disableRipple", "color"], exportAs: ["matButton"] }], animations: [appearFromRightWithDelay], changeDetection: i0.ChangeDetectionStrategy.OnPush });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "15.2.9", ngImport: i0, type: CommonDialogComponent, decorators: [{
            type: Component,
            args: [{ selector: 'app-common-dialog', animations: [appearFromRightWithDelay], changeDetection: ChangeDetectionStrategy.OnPush, template: "<div class=\"text-center position-relative p-10\"\n     @appearFromRightWithDelay\n     [class.size-big]=\"data.size === sizeValues.big\"\n     [class.size-middle]=\"data.size === sizeValues.middle\"\n     [class.size-small]=\"data.size === sizeValues.small\"\n     [class.style-success]=\"data.messageType === typesValues.success\"\n     [class.style-error]=\"data.messageType === typesValues.error\"\n     [class.style-info]=\"data.messageType === typesValues.info\">\n  <div [class.display-none]=\"!data.hideButton\"\n       class=\"close-button\"\n       (click)=\"onNoClick()\">\n    x\n  </div>\n\n  <h1 class=\"mat-dialog-title\" [class.display-none]=\"!data.title\">{{data.title}}</h1>\n  <div mat-dialog-content>\n    <p [innerHTML]=\"data.message\"></p>\n  </div>\n  <div [class.display-none]=\"data.hideButton\" mat-dialog-actions class=\"text-align-center mt-20\">\n    <button mat-button (click)=\"onNoClick()\"\n            class=\"mat-raised-button mr-10\"\n            cdkFocusInitial>{{data.falseButtonTitle || '\u041D\u0435\u0442' }}</button>\n    <button mat-button\n            [class.display-none]=\"data.hideTrueButton\"\n            (click)=\"onYesClick()\"\n            class=\"mat-raised-button mat-warn\">{{data.trueButtonTitle || '\u0414\u0430' }}</button>\n  </div>\n</div>\n", styles: [".size-big{width:800px}.size-middle{width:600px}.size-small{width:300px}.style-success,.style-error,.style-info{padding:24px}.style-success{border-left:5px solid #4caf50;background:linear-gradient(15deg,rgba(109,207,113,.7882352941),#f0f8f0)}.style-info{border-left:5px solid #fcb202;background:linear-gradient(15deg,rgba(252,178,2,.5294117647),rgba(252,178,2,.031372549))}.style-error{border-left:5px solid #f44336;background:linear-gradient(15deg,rgba(242,104,100,.5803921569),#f7e6e4)}.close-button{right:0;margin:-9px 10px 0 0;position:absolute;cursor:pointer;font-size:16px;font-weight:700}.display-none{display:none}\n"] }]
        }], ctorParameters: function () { return [{ type: i1$4.MatDialogRef }, { type: undefined, decorators: [{
                    type: Inject,
                    args: [MAT_DIALOG_DATA]
                }] }]; } });

const FilesLoad = createAction('[Files] File Load', props());
const FilesLoadSuccess = createAction('[Files] File Load Success', props());
const FilesLoadFail = createAction('[Files] File Load Error', props());
const FileUpdates = createAction('[Files] File Updates', props());
const FileUpdate = createAction('[Files] File Update', props());
const FileUpdateSuccess = createAction('[Files] File Update Success', props());
const FileUpdateFail = createAction('[Files] File Update Error', props());
const FileDelete = createAction('[Files] File Delete', props());
const FileDeleteSuccess = createAction('[Files] File Delete Success', props());
const FileDeleteFail = createAction('[Files] File Delete Error', props());
const FilesSort = createAction('[Files] File Sort', props());
const FilesSortSuccess = createAction('[Files] File Sort Success', props());
const FilesSortFail = createAction('[Files] File Sort Error', props());

const FILES_FEATURE_KEY = 'files';
const initialState$a = {
    list: [],
    ids: [],
    loaded: true,
    error: '',
    selected: -1
};
const _filesReducer = createReducer(initialState$a, on(FilesLoadSuccess, (state, action) => {
    const files = action.payload.files;
    return {
        ...ReducerService.upsertMeny(state, files),
        loading: false
    };
}), on(FileDeleteSuccess, (state, action) => {
    return {
        ...ReducerService.deleteOne(state, action.payload.deleteId),
        loading: false
    };
}), on(FilesLoad, FileUpdate, FileDelete, FilesSort, (state) => {
    return {
        ...state,
        loading: true
    };
}), on(FileUpdates, (state, action) => {
    const files = action.payload;
    return {
        ...ReducerService.upsertMeny(state, files),
        loading: false
    };
}), on(FileUpdateSuccess, (state, action) => {
    const files = action.payload.files;
    return {
        ...ReducerService.upsertMeny(state, files),
        loading: false
    };
}), on(FilesSortSuccess, (state, action) => {
    const files = action.payload.files;
    return {
        ...ReducerService.upsertMeny(state, files),
        loading: true
    };
}));
function filesReducer(state, action) {
    return _filesReducer(state, action);
}

// Lookup the 'Files' feature state managed by NgRx
const getFilesState = createFeatureSelector(FILES_FEATURE_KEY);
const getLoading = createSelector(getFilesState, (state) => {
    return !state.loaded;
});
const getError$3 = createSelector(getFilesState, (state) => state.error);
const geSelected$1 = createSelector(getFilesState, (state) => state.selected);
const getFiles = createSelector(getFilesState, getLoading, (state, isLoading) => {
    return !isLoading ? state.list : null;
});
const getFiles2 = createSelector(getFilesState, getLoading, (state, isLoading) => {
    return state.list;
});
const getFile = (id) => createSelector(getFiles, (list) => {
    if (list && list.length) {
        return list.find((item) => item.id === id);
    }
    return {};
});
const getFilteredFiles = (itemId, section, type) => createSelector(getFiles2, (list) => {
    if (list && list.length) {
        const result = list
            .filter((item) => item.itemId === +itemId && item.section === section)
            .filter((item) => {
            return item.type === type || (!item.type && !type);
        });
        if (result && result.length) {
            return result;
        }
    }
    return [];
});
const filesQuery = {
    getLoading,
    getError: getError$3,
    getFiles,
    geSelected: geSelected$1,
    getFile,
    getFilteredFiles
};

class FilesFacade {
    constructor(store) {
        this.store = store;
    }
    filesDelete(itemId) {
        this.store.dispatch(FileDelete({ payload: { id: itemId } }));
    }
    filesUpdates(updates) {
        this.store.dispatch(FileUpdates({ payload: updates }));
    }
    filesLoadSuccess(files) {
        this.store.dispatch(FilesLoadSuccess({ payload: { files: files } }));
    }
    filesUpdate(data) {
        const params = { ...data };
        this.store.dispatch(FileUpdate({ payload: params }));
    }
    getFiles(data) {
        return this.store.pipe(select(filesQuery.getFilteredFiles(data.itemId, data.section, data.type)));
    }
    filesSort(files) {
        this.store.dispatch(FilesSort({ payload: { files } }));
    }
    loadFiles(data) {
        const params = {
            ...data,
            fields: {
                fields: [],
                versions: {}
            }
        };
        return this.store.dispatch(FilesLoad({ payload: params }));
    }
}
FilesFacade.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "15.2.9", ngImport: i0, type: FilesFacade, deps: [{ token: i1.Store }], target: i0.ɵɵFactoryTarget.Injectable });
FilesFacade.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "15.2.9", ngImport: i0, type: FilesFacade, providedIn: "root" });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "15.2.9", ngImport: i0, type: FilesFacade, decorators: [{
            type: Injectable,
            args: [{ providedIn: "root" }]
        }], ctorParameters: function () { return [{ type: i1.Store }]; } });

class FilesLoadBehavior extends Behavior {
    constructor(action, result) {
        super(action);
        this.action = action;
        this.result = result;
    }
    resolve() {
        const status = this.result.data.status;
        let returnedActions;
        switch (status) {
            case ResponseStatus.STATUS_200: {
                const response = this.result.data;
                const { data } = response.body;
                const fileData = this.modelAdapter.convertItems(FileModel, data);
                returnedActions = [
                    FilesLoadSuccess({ payload: { files: fileData } })
                ];
                break;
            }
            case ResponseStatus.STATUS_400:
            case ResponseStatus.STATUS_404:
            case ResponseStatus.STATUS_422:
            case ResponseStatus.STATUS_401:
                const errorResponse = this.result.data;
                const error = errorResponse.body.errors ? errorResponse.body.errors[0].title : 'Unknown error';
                returnedActions = [
                    FilesLoadFail({ payload: { error } })
                ];
                break;
            default: {
                returnedActions = [
                    FilesLoadFail({ payload: { error: 'Unhandled error' } })
                ];
            }
        }
        return [...returnedActions];
    }
}

class FileUpdateBehavior extends Behavior {
    constructor(action, result) {
        super(action);
        this.action = action;
        this.result = result;
    }
    resolve() {
        const status = this.result.data.status;
        let returnedActions;
        switch (status) {
            case ResponseStatus.STATUS_200: {
                const response = this.result.data;
                const { data } = response.body;
                const fileData = this.modelAdapter.convertItems(FileModel, data);
                returnedActions = [
                    FileUpdateSuccess({ payload: { files: fileData } })
                ];
                break;
            }
            case ResponseStatus.STATUS_400:
            case ResponseStatus.STATUS_404:
            case ResponseStatus.STATUS_422:
            case ResponseStatus.STATUS_401:
                const errorResponse = this.result.data;
                const error = errorResponse.body.errors[0].title;
                returnedActions = [
                    FileUpdateFail({ payload: { error } })
                ];
                break;
            default: {
                returnedActions = [
                    FileUpdateFail({ payload: { error: 'Unhandled error' } })
                ];
            }
        }
        return [...returnedActions];
    }
}

class FileDeleteBehavior extends Behavior {
    constructor(action, result) {
        super(action);
        this.action = action;
        this.result = result;
    }
    resolve() {
        const status = this.result.data.status;
        let returnedActions;
        switch (status) {
            case ResponseStatus.STATUS_200: {
                const response = this.result.data;
                const { data } = response.body;
                returnedActions = [
                    FileDeleteSuccess({ payload: { deleteId: data.delete_id } })
                ];
                break;
            }
            case ResponseStatus.STATUS_400:
            case ResponseStatus.STATUS_404:
            case ResponseStatus.STATUS_422:
            case ResponseStatus.STATUS_401:
                const errorResponse = this.result.data;
                const error = errorResponse.body.errors[0].title;
                returnedActions = [
                    FileDeleteFail({ payload: { error } })
                ];
                break;
            default: {
                returnedActions = [
                    FileDeleteFail({ payload: { error: 'Unhandled error' } })
                ];
            }
        }
        return [...returnedActions];
    }
}

class FilesSortBehavior extends Behavior {
    constructor(action, result) {
        super(action);
        this.action = action;
        this.result = result;
    }
    resolve() {
        const status = this.result.data.status;
        let returnedActions;
        switch (status) {
            case ResponseStatus.STATUS_200: {
                const response = this.result.data;
                const { data } = response.body;
                const fileData = this.modelAdapter.convertItems(FileModel, data);
                returnedActions = [
                    FilesSortSuccess({ payload: { files: fileData } })
                ];
                break;
            }
            case ResponseStatus.STATUS_400:
            case ResponseStatus.STATUS_404:
            case ResponseStatus.STATUS_422:
            case ResponseStatus.STATUS_401:
                const errorResponse = this.result.data;
                const error = errorResponse.body.errors[0].title;
                returnedActions = [
                    FilesSortFail({ payload: { error } })
                ];
                break;
            default: {
                returnedActions = [
                    FilesSortFail({ payload: { error: 'Unhandled error' } })
                ];
            }
        }
        return [...returnedActions];
    }
}

class FilesApi extends BaseAPI {
    constructor(domain) {
        super(domain);
        this.domain = domain;
    }
    createRequest(paramsConfig, endPointType) {
        let request;
        switch (endPointType) {
            case FilesEndpointTypes.UPDATE:
                request = new FilesUpdateRequest(this.domain, paramsConfig);
                break;
            case FilesEndpointTypes.DELETE:
                request = new FilesDeleteRequest(this.domain, paramsConfig);
                break;
            case FilesEndpointTypes.SORT:
                request = new FilesSortRequest(this.domain, paramsConfig);
                break;
            case FilesEndpointTypes.LOAD:
                request = new FilesLoadRequest(this.domain, paramsConfig);
                break;
            default:
                throw new Error(`Request for ${endPointType} is undefined `);
        }
        return request;
    }
    handleResponse(response, endPointType) {
        let courseResponse;
        switch (endPointType) {
            case FilesEndpointTypes.UPDATE:
                courseResponse = FilesUpdateResponseFactory.createResponse(response);
                break;
            case FilesEndpointTypes.DELETE:
                courseResponse = FilesDeleteResponseFactory.createResponse(response);
                break;
            case FilesEndpointTypes.SORT:
                courseResponse = FilesSortResponseFactory.createResponse(response);
                break;
            case FilesEndpointTypes.LOAD:
                courseResponse = FilesSortResponseFactory.createResponse(response);
                break;
            default:
                throw new Error(`Response for ${endPointType} is undefined `);
        }
        return courseResponse;
    }
}

class FilesService extends BaseAPIService {
    constructor(httpClient, config, requestsFacade, formsFacade) {
        super(httpClient, requestsFacade, formsFacade);
        this.httpClient = httpClient;
        this.config = config;
        this.requestsFacade = requestsFacade;
        this.formsFacade = formsFacade;
        this.api = new FilesApi(this.config.apiUrl);
    }
    filesLoad(config) {
        return this.doRequest(config, FilesEndpointTypes.LOAD);
    }
    fileUpdate(config) {
        return this.doRequest(config, FilesEndpointTypes.UPDATE);
    }
    fileDelete(config) {
        return this.doRequest(config, FilesEndpointTypes.DELETE);
    }
    filesSort(config) {
        return this.doRequest(config, FilesEndpointTypes.SORT);
    }
}
FilesService.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "15.2.9", ngImport: i0, type: FilesService, deps: [{ token: i1$1.HttpClient }, { token: CORE_CONFIG }, { token: RequestsFacade }, { token: FormsFacade }], target: i0.ɵɵFactoryTarget.Injectable });
FilesService.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "15.2.9", ngImport: i0, type: FilesService, providedIn: 'root' });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "15.2.9", ngImport: i0, type: FilesService, decorators: [{
            type: Injectable,
            args: [{
                    providedIn: 'root'
                }]
        }], ctorParameters: function () { return [{ type: i1$1.HttpClient }, { type: undefined, decorators: [{
                    type: Inject,
                    args: [CORE_CONFIG]
                }] }, { type: RequestsFacade }, { type: FormsFacade }]; } });

const UiUnitsSet = createAction('[UiUnits] UiUnitsSet', props());

const UIUNITS_FEATURE_KEY = 'uiUnits';
const initialState$9 = {
    list: [],
    ids: []
};
const _uiUnitsReducer = createReducer(initialState$9, on(UiUnitsSet, (state, action) => {
    return {
        ...ReducerService.upsertOne(state, {
            data: action.payload.data,
            id: action.payload.id
        })
    };
}));
function uiUnitsReducer(state, action) {
    return _uiUnitsReducer(state, action);
}

const getAllUiUnits = createFeatureSelector(UIUNITS_FEATURE_KEY);
const getUIUnit = (id) => createSelector(getAllUiUnits, (state) => {
    const item = state.list.find((item) => item.id === id);
    return item ? item.data : null;
});
const getUiUnitDataById = (id) => createSelector(getAllUiUnits, (state) => {
    const item = state.list.find((item) => item.id === id);
    return item ? item.data : null;
});
/*export const filterUiUnitIdsByType = (type: string) =>
  createSelector(
    getAllUiUnits,
    (state: UiUnitsState) => {
      return state.list
        .filter((item) => item.type === type)
        .map(item => item.id);
    }
  );

export const getUiUnitEntitiesByType = (type: string) =>
  createSelector(
    getAllUiUnits,
    (state: UiUnitsState) => {
      return state.list
        .filter((item) => item.type === type)
        .map(item => item.id);
    }
  );*/
const uiUnitsQuery = {
    getUIUnit
};

class UiUnitsFacade {
    constructor(store) {
        this.store = store;
    }
    setUIUnits(id, data) {
        this.store.dispatch(UiUnitsSet({ payload: { id, data } }));
    }
    getUIUnits(id) {
        return this.store.pipe(select(getUIUnit(id)));
    }
}
UiUnitsFacade.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "15.2.9", ngImport: i0, type: UiUnitsFacade, deps: [{ token: i1.Store }], target: i0.ɵɵFactoryTarget.Injectable });
UiUnitsFacade.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "15.2.9", ngImport: i0, type: UiUnitsFacade, providedIn: "root" });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "15.2.9", ngImport: i0, type: UiUnitsFacade, decorators: [{
            type: Injectable,
            args: [{ providedIn: "root" }]
        }], ctorParameters: function () { return [{ type: i1.Store }]; } });

class FilesEffects {
    constructor(actions$, store, filesService, uiUnitsFacade, authenticationService) {
        this.actions$ = actions$;
        this.store = store;
        this.filesService = filesService;
        this.uiUnitsFacade = uiUnitsFacade;
        this.authenticationService = authenticationService;
        this.fileDelete$ = createEffect(() => this.actions$.pipe(ofType(FileDelete), switchMap((action) => {
            const headers = this.authenticationService.loadAuthDataFromLocalStore();
            const id = action.payload.id;
            const config = {
                headers: { token: headers.token, uid: headers.id },
                id
            };
            return this.filesService.fileDelete(config)
                .pipe(flatMap((r) => new FileDeleteBehavior(action, r).resolve()));
        }), catchError(error => of(FileDeleteFail(error)))));
        this.fileUpdate2$ = createEffect(() => this.actions$.pipe(ofType(FileUpdate), switchMap((action) => {
            const headers = this.authenticationService.loadAuthDataFromLocalStore();
            const { id, main, order, title, section, itemId } = action.payload;
            const config = {
                id,
                headers: { token: headers.token, uid: headers.id },
                section,
                itemId
            };
            if (main)
                config['main'] = main;
            if (order)
                config['order'] = order;
            if (title)
                config['title'] = title;
            return this.filesService.fileUpdate(config)
                .pipe(flatMap((r) => new FileUpdateBehavior(action, r).resolve()));
        }), catchError(error => of(FileUpdateFail(error)))));
        this.filesSort$ = createEffect(() => this.actions$.pipe(ofType(FilesSort), switchMap((action) => {
            const headers = this.authenticationService.loadAuthDataFromLocalStore();
            const { files } = action.payload;
            const config = {
                headers: { token: headers.token, uid: headers.id },
                files
            };
            return this.filesService.filesSort(config)
                .pipe(flatMap((r) => new FilesSortBehavior(action, r).resolve()));
        }), catchError(error => of(FilesSortFail(error)))));
        this.filesLoad$ = createEffect(() => this.actions$.pipe(ofType(FilesLoad), switchMap((action) => {
            const headers = this.authenticationService.loadAuthDataFromLocalStore();
            const { section, itemId, fields } = action.payload;
            const config = {
                headers: { token: headers.token, uid: headers.id },
                section,
                itemId,
                fields
            };
            return this.filesService.filesLoad(config)
                .pipe(flatMap((r) => new FilesLoadBehavior(action, r).resolve()));
        }), catchError(error => of(FilesLoadFail(error)))));
    }
}
FilesEffects.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "15.2.9", ngImport: i0, type: FilesEffects, deps: [{ token: i1$2.Actions }, { token: i1.Store }, { token: FilesService }, { token: UiUnitsFacade }, { token: AuthenticationService }], target: i0.ɵɵFactoryTarget.Injectable });
FilesEffects.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "15.2.9", ngImport: i0, type: FilesEffects });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "15.2.9", ngImport: i0, type: FilesEffects, decorators: [{
            type: Injectable
        }], ctorParameters: function () { return [{ type: i1$2.Actions }, { type: i1.Store }, { type: FilesService }, { type: UiUnitsFacade }, { type: AuthenticationService }]; } });

class NotificationsEffects {
    constructor(actions$, store, toastrService, notificationsFacade, dialog) {
        this.actions$ = actions$;
        this.store = store;
        this.toastrService = toastrService;
        this.notificationsFacade = notificationsFacade;
        this.dialog = dialog;
        this.notificationAdd$ = createEffect(() => this.actions$.pipe(ofType(NotificationAdd), tap((action) => {
            const { text, title, type, timeout, showingType } = action.payload;
            if (!showingType || showingType === NotificationShowingType.TOASTER) {
                if (type === 'success') {
                    this.toastrService.success(text, title, { timeOut: timeout, closeButton: true, progressAnimation: 'increasing' });
                }
                else {
                    this.toastrService.error(text, title, { timeOut: timeout, closeButton: true, progressAnimation: 'increasing' });
                }
            }
            else {
                this.dialog.open(CommonDialogComponent, {
                    panelClass: 'dialog-without-margin',
                    data: {
                        title: title,
                        message: text,
                        hideButton: true,
                        messageType: type,
                        size: 'middle'
                    }
                }).afterClosed();
            }
        })), { dispatch: false });
        this.fileDeleteSuccess$ = createEffect(() => this.actions$.pipe(ofType(FileDeleteSuccess), tap((action) => {
            const notification = {
                id: 5,
                type: 'success',
                text: 'Файл успешно удален',
                timeout: 2000
            };
            this.notificationsFacade.addNotifications(notification);
        }), catchError(error => of(FileDeleteFail(error)))), { dispatch: false });
        this.fileUpdateSuccess$ = createEffect(() => this.actions$.pipe(ofType(FileUpdateSuccess), tap(() => {
            const notification = {
                id: 5,
                type: 'success',
                text: 'Файл успешно обновлен',
                timeout: 2000
            };
            this.notificationsFacade.addNotifications(notification);
        }), catchError(error => of(FileUpdateFail(error)))), { dispatch: false });
        this.filesSortSuccess$ = createEffect(() => this.actions$.pipe(ofType(FilesSortSuccess), tap(() => {
            const notification = {
                id: 5,
                type: 'success',
                text: 'Сортировка картинок успешно сохранена',
                timeout: 2000
            };
            this.notificationsFacade.addNotifications(notification);
        }), catchError(error => of(FilesSortFail(error)))), { dispatch: false });
    }
}
NotificationsEffects.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "15.2.9", ngImport: i0, type: NotificationsEffects, deps: [{ token: i1$2.Actions }, { token: i1.Store }, { token: i3.ToastrService }, { token: NotificationsFacade }, { token: i1$4.MatDialog }], target: i0.ɵɵFactoryTarget.Injectable });
NotificationsEffects.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "15.2.9", ngImport: i0, type: NotificationsEffects });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "15.2.9", ngImport: i0, type: NotificationsEffects, decorators: [{
            type: Injectable
        }], ctorParameters: function () { return [{ type: i1$2.Actions }, { type: i1.Store }, { type: i3.ToastrService }, { type: NotificationsFacade }, { type: i1$4.MatDialog }]; } });

const TagsLoad = createAction('[Tags] Tags Load', props());
const TagsLoadSuccess = createAction('[Tags] Tags Load Success', props());
const TagsLoadFail = createAction('[Tags] Tags Load Error', props());
const TagEntitiesLoad = createAction('[Tags] Tag entities Load', props());
const TagEntitiesLoadSuccess = createAction('[Tags] Tag entities Load Success', props());
const TagEntitiesLoadFail = createAction('[Tags] Tags entities Load Error', props());

class TagsLoadBehavior extends Behavior {
    constructor(action, result) {
        super(action);
        this.action = action;
        this.result = result;
    }
    resolve() {
        const status = this.result.data.status;
        let returnedActions;
        switch (status) {
            case ResponseStatus.STATUS_200: {
                const response = this.result.data;
                const { data, meta } = response.body;
                let tagsData = this.modelAdapter.convertItems(TagModel, data);
                returnedActions = [
                    TagsLoadSuccess({ payload: { tags: tagsData, meta } })
                ];
                break;
            }
            case ResponseStatus.STATUS_400:
            case ResponseStatus.STATUS_404:
            case ResponseStatus.STATUS_422:
            case ResponseStatus.STATUS_401:
                const errorResponse = this.result.data;
                const error = errorResponse.body.errors ? errorResponse.body.errors[0].title : '';
                returnedActions = [
                    TagsLoadFail({ payload: { error } })
                ];
                break;
            default: {
                returnedActions = [
                    TagsLoadFail({ payload: { error: 'Unhandled error' } })
                ];
            }
        }
        return [...returnedActions];
    }
}

class TagEntitiesLoadBehavior extends Behavior {
    constructor(action, result) {
        super(action);
        this.action = action;
        this.result = result;
    }
    resolve() {
        const status = this.result.data.status;
        let returnedActions;
        switch (status) {
            case ResponseStatus.STATUS_200: {
                const response = this.result.data;
                returnedActions = [];
                const { data, meta } = response.body;
                let resultEntities = [];
                if (data) {
                    Object.keys(data)
                        .forEach(entity => {
                        let tagEntity = this.modelAdapter.convertItems(TagEntityModel, data[entity]);
                        if (tagEntity?.length) {
                            const tagEntitiesFull = tagEntity.map(item => {
                                return {
                                    ...item,
                                    tagId: meta.tag.id,
                                    tagSlug: meta.tag.slug,
                                    entity
                                };
                            });
                            resultEntities = [...resultEntities, ...tagEntitiesFull];
                        }
                    });
                }
                if (meta.tag) {
                    returnedActions.push(TagsLoadSuccess({ payload: { tags: [{ ...meta.tag }] } }));
                }
                if (resultEntities?.length) {
                    returnedActions.push(TagEntitiesLoadSuccess({ payload: { entities: resultEntities } }));
                }
                break;
            }
            case ResponseStatus.STATUS_400:
            case ResponseStatus.STATUS_404:
            case ResponseStatus.STATUS_422:
            case ResponseStatus.STATUS_401:
                const errorResponse = this.result.data;
                const error = errorResponse.body.errors ? errorResponse.body.errors[0].title : '';
                returnedActions = [
                    TagEntitiesLoadFail({ payload: { error } })
                ];
                break;
            default: {
                returnedActions = [
                    TagEntitiesLoadFail({ payload: { error: 'Unhandled error' } })
                ];
            }
        }
        return [...returnedActions];
    }
}

class TagsApi extends BaseAPI {
    constructor(domain) {
        super(domain);
        this.domain = domain;
    }
    createRequest(paramsConfig, endPointType) {
        let request;
        switch (endPointType) {
            case TagsEndpointTypes.LOAD:
                request = new TagsLoadRequest(this.domain, paramsConfig);
                break;
            case TagsEndpointTypes.ENTITIES:
                request = new TagEntitiesRequest(this.domain, paramsConfig);
                break;
            default:
                throw new Error(`Request for ${endPointType} is undefined `);
        }
        return request;
    }
    handleResponse(response, endPointType) {
        return BaseResponseFactory.createResponse(response);
    }
}

class TagsService extends BaseAPIService {
    constructor(httpClient, config, requestsFacade, formsFacade) {
        super(httpClient, requestsFacade, formsFacade);
        this.httpClient = httpClient;
        this.config = config;
        this.requestsFacade = requestsFacade;
        this.formsFacade = formsFacade;
        this.api = new TagsApi(this.config.apiUrl);
    }
    tagsLoad(config) {
        return this.doRequest(config, TagsEndpointTypes.LOAD);
    }
    tagEntitiesLoad(config) {
        return this.doRequest(config, TagsEndpointTypes.ENTITIES);
    }
}
TagsService.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "15.2.9", ngImport: i0, type: TagsService, deps: [{ token: i1$1.HttpClient }, { token: CORE_CONFIG }, { token: RequestsFacade }, { token: FormsFacade }], target: i0.ɵɵFactoryTarget.Injectable });
TagsService.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "15.2.9", ngImport: i0, type: TagsService, providedIn: "root" });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "15.2.9", ngImport: i0, type: TagsService, decorators: [{
            type: Injectable,
            args: [{
                    providedIn: "root"
                }]
        }], ctorParameters: function () { return [{ type: i1$1.HttpClient }, { type: undefined, decorators: [{
                    type: Inject,
                    args: [CORE_CONFIG]
                }] }, { type: RequestsFacade }, { type: FormsFacade }]; } });

class TagsEffects {
    constructor(actions$, store, tagsService, authenticationService) {
        this.actions$ = actions$;
        this.store = store;
        this.tagsService = tagsService;
        this.authenticationService = authenticationService;
        this.tagsLoad$ = createEffect(() => this.actions$.pipe(ofType(TagsLoad), switchMap((action) => {
            const { entity } = action.payload;
            const headers = this.authenticationService.loadAuthDataFromLocalStore();
            return this.tagsService.tagsLoad({
                entity,
                headers: { token: headers.token, uid: headers.id }
            })
                .pipe(flatMap((r) => new TagsLoadBehavior(action, r).resolve()));
        }), catchError(error => of(TagsLoadFail(error)))));
        this.tagEntitiesLoadLoad$ = createEffect(() => this.actions$.pipe(ofType(TagEntitiesLoad), switchMap((action) => {
            const { tag } = action.payload;
            return this.tagsService.tagEntitiesLoad({
                tag
            })
                .pipe(flatMap((r) => new TagEntitiesLoadBehavior(action, r).resolve()));
        }), catchError(error => of(TagsLoadFail(error)))));
    }
}
TagsEffects.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "15.2.9", ngImport: i0, type: TagsEffects, deps: [{ token: i1$2.Actions }, { token: i1.Store }, { token: TagsService }, { token: AuthenticationService }], target: i0.ɵɵFactoryTarget.Injectable });
TagsEffects.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "15.2.9", ngImport: i0, type: TagsEffects });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "15.2.9", ngImport: i0, type: TagsEffects, decorators: [{
            type: Injectable
        }], ctorParameters: function () { return [{ type: i1$2.Actions }, { type: i1.Store }, { type: TagsService }, { type: AuthenticationService }]; } });

class UiUnitsEffects {
    /*  @Effect({dispatch: false})
      ImagesLoadSuccess$ = this.effect(ImagesActionTypes.ImagesLoadSuccess, {
        operatorFunctions: (action: ImagesLoadSuccess) => [
          tap(() => {
            this.uiUnitsFacade.setUIUnits(UiUnitIds.FIRMS, action.payload.meta);
          })
        ],
        onError: (action: ImagesLoad, error) => {
          return new ImagesLoadFail({}, error, action.correlationParams);
        }
      });*/
    constructor(actions$, store, uiUnitsFacade) {
        this.actions$ = actions$;
        this.store = store;
        this.uiUnitsFacade = uiUnitsFacade;
    }
}
UiUnitsEffects.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "15.2.9", ngImport: i0, type: UiUnitsEffects, deps: [{ token: i1$2.Actions }, { token: i1.Store }, { token: UiUnitsFacade }], target: i0.ɵɵFactoryTarget.Injectable });
UiUnitsEffects.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "15.2.9", ngImport: i0, type: UiUnitsEffects });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "15.2.9", ngImport: i0, type: UiUnitsEffects, decorators: [{
            type: Injectable
        }], ctorParameters: function () { return [{ type: i1$2.Actions }, { type: i1.Store }, { type: UiUnitsFacade }]; } });

class MainEffects {
    constructor(actions$, store, config) {
        this.actions$ = actions$;
        this.store = store;
        this.config = config;
        this.notificationAdd$ = createEffect(() => this.actions$.pipe(tap((action) => {
            if (this.config.env === 'develop') {
                console.info('[ action ]', action.type);
            }
        })), { dispatch: false });
    }
}
MainEffects.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "15.2.9", ngImport: i0, type: MainEffects, deps: [{ token: i1$2.Actions }, { token: i1.Store }, { token: CORE_CONFIG }], target: i0.ɵɵFactoryTarget.Injectable });
MainEffects.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "15.2.9", ngImport: i0, type: MainEffects });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "15.2.9", ngImport: i0, type: MainEffects, decorators: [{
            type: Injectable
        }], ctorParameters: function () { return [{ type: i1$2.Actions }, { type: i1.Store }, { type: undefined, decorators: [{
                    type: Inject,
                    args: [CORE_CONFIG]
                }] }]; } });

const TAGS_FEATURE_KEY = 'tags';
const initialState$8 = {
    list: [],
    entities: [],
    ids: [],
    selected: null,
    loaded: false
};
const _tagsReducer = createReducer(initialState$8, on(TagsLoadSuccess, (state, action) => {
    const { tags } = action.payload;
    const newState = {
        ...ReducerService.upsertMeny(state, tags)
    };
    if (state.entities?.length) {
        newState['entities'] = state.entities;
    }
    return newState;
}), on(TagEntitiesLoadSuccess, (state, action) => {
    const { entities } = action.payload;
    return {
        ...state,
        entities: [...entities]
    };
}));
function tagsReducer(state, action) {
    return _tagsReducer(state, action);
}

// Lookup the 'Tags' feature state managed by NgRx
const getTagsState = createFeatureSelector(TAGS_FEATURE_KEY);
const getLoaded$2 = createSelector(getTagsState, (state) => {
    return state.loaded;
});
const getError$2 = createSelector(getTagsState, (state) => state.error);
const geSelected = createSelector(getTagsState, (state) => state.selected);
const getTags = createSelector(getTagsState, (state) => {
    return state.list || [];
});
const getTagsByEntity = (entity) => createSelector(getTags, (list) => {
    if (entity) {
        if (list && list.length) {
            return list.filter((item) => item.entity === entity);
        }
    }
    return list;
});
const getTagEntities = (tagSlug) => createSelector(getTagsState, (state) => {
    if (state.entities?.length) {
        return state.entities.filter((item) => item.tagSlug === tagSlug);
    }
});
const getTag = (slugOrId) => createSelector(getTags, (list) => {
    if (list && list.length) {
        return list.find((item) => item.id === slugOrId || item.slug === slugOrId);
    }
});
const tagsQuery = {
    getLoaded: getLoaded$2,
    getError: getError$2,
    getTags,
    geSelected,
    getTag,
    getTagsByEntity,
    getTagEntities
};

class TagsFacade {
    constructor(store) {
        this.store = store;
        this.loaded$ = this.store.pipe(select(tagsQuery.getLoaded));
    }
    loadEntities(tag) {
        this.store.dispatch(TagEntitiesLoad({ payload: { tag } }));
    }
    loadTags(entity, perPage) {
        this.store.dispatch(TagsLoad({ payload: { entity, perPage } }));
    }
    getTags(entity) {
        return this.store.pipe(select(tagsQuery.getTagsByEntity(entity)));
    }
    getTag(idOrSlug) {
        return this.store.pipe(select(tagsQuery.getTag(idOrSlug)));
    }
    getTagEntities(tagSlug) {
        return this.store.pipe(select(tagsQuery.getTagEntities(tagSlug)));
    }
    waitLoading() {
        return this.store.pipe(select(tagsQuery.getLoaded), filter$1((item) => !!item));
    }
}
TagsFacade.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "15.2.9", ngImport: i0, type: TagsFacade, deps: [{ token: i1.Store }], target: i0.ɵɵFactoryTarget.Injectable });
TagsFacade.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "15.2.9", ngImport: i0, type: TagsFacade, providedIn: "root" });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "15.2.9", ngImport: i0, type: TagsFacade, decorators: [{
            type: Injectable,
            args: [{ providedIn: "root" }]
        }], ctorParameters: function () { return [{ type: i1.Store }]; } });

/**
 *
 */
const UpdateMetaData = createAction('[MetaData] Update MetaData', props());
const UpdateMetaDataSuccess = createAction('[MetaData] Update MetaData Success');
const UpdateMetaDataFail = createAction('[MetaData] Update MetaData Error');

const MAIN_FEATURE_KEY = 'main';
const initialState$7 = {
    metaData: {}
};
const _mainReducer = createReducer(initialState$7, on(UpdateMetaData, (state, action) => {
    const metaData = action.payload;
    return {
        ...state,
        metaData
    };
}));
function mainReducer(state, action) {
    return _mainReducer(state, action);
}

const getState = createFeatureSelector(MAIN_FEATURE_KEY);
const getMetaData = createSelector(getState, (state) => {
    return state.metaData;
});
const mainQuery = {
    getMetaData
};

class MainFacade {
    constructor(store) {
        this.store = store;
    }
    getMetadata() {
        return this.store.pipe(select(mainQuery.getMetaData));
    }
}
MainFacade.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "15.2.9", ngImport: i0, type: MainFacade, deps: [{ token: i1.Store }], target: i0.ɵɵFactoryTarget.Injectable });
MainFacade.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "15.2.9", ngImport: i0, type: MainFacade, providedIn: "root" });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "15.2.9", ngImport: i0, type: MainFacade, decorators: [{
            type: Injectable,
            args: [{ providedIn: "root" }]
        }], ctorParameters: function () { return [{ type: i1.Store }]; } });

const CheckValidation = createAction('[FormValidation] Check Validation', props());
const CheckValidationSuccess = createAction('[FormValidation] Check Validation Success', props());
const CheckValidationFail = createAction('[FormValidation] Check Validation Error', props());

class FormValidationCheckBehavior extends Behavior {
    constructor(action, result) {
        super(action);
        this.action = action;
        this.result = result;
    }
    resolve() {
        const status = this.result.data.status;
        let returnedActions;
        const { type, value, itemId } = this.action.payload;
        switch (status) {
            case ResponseStatus.STATUS_200: {
                const response = this.result.data;
                const { isValid } = response.body.data;
                returnedActions = [
                    CheckValidationSuccess({ payload: { type, value, itemId, isValid } })
                ];
                break;
            }
            case ResponseStatus.STATUS_400:
            case ResponseStatus.STATUS_404:
            case ResponseStatus.STATUS_422:
            case ResponseStatus.STATUS_401:
                const errorResponse = this.result.data;
                const error = errorResponse.body.errors[0].title;
                returnedActions = [
                    CheckValidationFail({ payload: { error } })
                ];
                break;
            default: {
                returnedActions = [
                    CheckValidationFail({ payload: { error: 'Unhandled error' } })
                ];
            }
        }
        return [...returnedActions];
    }
}

class FormValidationApi extends BaseAPI {
    constructor(domain) {
        super(domain);
        this.domain = domain;
    }
    createRequest(paramsConfig, endPointType) {
        let request;
        switch (endPointType) {
            case FormValidationEndpointTypes.CHECK:
                request = new FormValidationCheckRequest(this.domain, paramsConfig);
                break;
            default:
                throw new Error(`Request for ${endPointType} is undefined `);
        }
        return request;
    }
    handleResponse(response, endPointType) {
        let resResponse;
        switch (endPointType) {
            case FormValidationEndpointTypes.CHECK:
                resResponse = BaseResponseFactory.createResponse(response);
                break;
            default:
                throw new Error(`Response for ${endPointType} is undefined `);
        }
        return resResponse;
    }
}

class FormValidationService extends BaseAPIService {
    constructor(httpClient, config, requestsFacade, formsFacade) {
        super(httpClient, requestsFacade, formsFacade);
        this.httpClient = httpClient;
        this.config = config;
        this.requestsFacade = requestsFacade;
        this.formsFacade = formsFacade;
        this.api = new FormValidationApi(this.config.apiUrl);
    }
    formValidationCheck(config) {
        return this.doRequest(config, FormValidationEndpointTypes.CHECK);
    }
}
FormValidationService.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "15.2.9", ngImport: i0, type: FormValidationService, deps: [{ token: i1$1.HttpClient }, { token: CORE_CONFIG }, { token: RequestsFacade }, { token: FormsFacade }], target: i0.ɵɵFactoryTarget.Injectable });
FormValidationService.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "15.2.9", ngImport: i0, type: FormValidationService, providedIn: 'root' });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "15.2.9", ngImport: i0, type: FormValidationService, decorators: [{
            type: Injectable,
            args: [{
                    providedIn: 'root'
                }]
        }], ctorParameters: function () { return [{ type: i1$1.HttpClient }, { type: undefined, decorators: [{
                    type: Inject,
                    args: [CORE_CONFIG]
                }] }, { type: RequestsFacade }, { type: FormsFacade }]; } });

class FormValidationEffects {
    constructor(actions$, store, formValidationService, authenticationService) {
        this.actions$ = actions$;
        this.store = store;
        this.formValidationService = formValidationService;
        this.authenticationService = authenticationService;
        this.checkValidation$ = createEffect(() => this.actions$.pipe(ofType(CheckValidation), switchMap((action) => {
            const { type, value, itemId, options } = action.payload;
            return this.formValidationService.formValidationCheck({
                type,
                value,
                itemId,
                entity: options?.entity,
                entityField: options?.entityField
            })
                .pipe(flatMap((r) => new FormValidationCheckBehavior(action, r).resolve()));
        }), catchError(error => of(CheckValidationFail(error)))));
    }
}
FormValidationEffects.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "15.2.9", ngImport: i0, type: FormValidationEffects, deps: [{ token: i1$2.Actions }, { token: i1.Store }, { token: FormValidationService }, { token: AuthenticationService }], target: i0.ɵɵFactoryTarget.Injectable });
FormValidationEffects.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "15.2.9", ngImport: i0, type: FormValidationEffects });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "15.2.9", ngImport: i0, type: FormValidationEffects, decorators: [{
            type: Injectable
        }], ctorParameters: function () { return [{ type: i1$2.Actions }, { type: i1.Store }, { type: FormValidationService }, { type: AuthenticationService }]; } });

const FORM_VALIDATION_FEATURE_KEY = 'formValidation';
const initialState$6 = {
    list: [],
    ids: []
};
const _formValidationReducer = createReducer(initialState$6, on(CheckValidation, (state, action) => {
    const { type, value, itemId } = action.payload;
    const id = `${type}${value}`;
    return {
        ...ReducerService.upsertOne(state, {
            id,
            type,
            value,
            itemId,
            loaded: false
        })
    };
}), on(CheckValidationSuccess, (state, action) => {
    const { type, value, isValid, itemId } = action.payload;
    const id = `${type}${value}`;
    return {
        ...ReducerService.upsertOne(state, {
            id,
            type,
            value,
            isValid,
            itemId,
            loaded: true
        })
    };
}));
function formValidationReducer(state, action) {
    return _formValidationReducer(state, action);
}

const getFormValidationState = createFeatureSelector(FORM_VALIDATION_FEATURE_KEY);
const getFormValidation = (type, value) => createSelector(getFormValidationState, (state) => {
    return state.list.find(item => item.type === type && item.value === value);
});
const formValidationQuery = {
    getFormValidation
};

class FormValidationFacade {
    constructor(store) {
        this.store = store;
    }
    sendValidation(type, value, itemId, options) {
        this.store.dispatch(CheckValidation({ payload: { type, value, itemId, options } }));
    }
    getValidation(type, value) {
        return this.store.pipe(select(formValidationQuery.getFormValidation(type, value)));
    }
}
FormValidationFacade.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "15.2.9", ngImport: i0, type: FormValidationFacade, deps: [{ token: i1.Store }], target: i0.ɵɵFactoryTarget.Injectable });
FormValidationFacade.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "15.2.9", ngImport: i0, type: FormValidationFacade, providedIn: "root" });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "15.2.9", ngImport: i0, type: FormValidationFacade, decorators: [{
            type: Injectable,
            args: [{ providedIn: "root" }]
        }], ctorParameters: function () { return [{ type: i1.Store }]; } });

class FormErrorsEffects {
    /*  @Effect()
      checkValidation$ = this.effect(FormErrorsActionTypes.CheckValidation, {
        operatorFunctions: (action: CheckValidation) => [
          switchMap(() => {
            const { type, value, itemId } = action.payload;
            const headers = this.authenticationService.loadAuthDataFromLocalStore();
            return this.formErrorsService.formErrorsCheck({
              type,
              value,
              itemId
            });
          }),
          flatMap((r: HttpClientResult<BaseResponse>) => new FormErrorsCheckBehavior(action, r).resolve())
        ],
        onError: (action: CheckValidation, error) => {
          return new CheckValidationFail({
            type: action.payload.type,
            value: action.payload.value
          }, error, action.correlationParams);
        }
      });*/
    constructor(actions$, store) {
        this.actions$ = actions$;
        this.store = store;
        // super(actions$, store);
    }
}
FormErrorsEffects.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "15.2.9", ngImport: i0, type: FormErrorsEffects, deps: [{ token: i1$2.Actions }, { token: i1.Store }], target: i0.ɵɵFactoryTarget.Injectable });
FormErrorsEffects.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "15.2.9", ngImport: i0, type: FormErrorsEffects });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "15.2.9", ngImport: i0, type: FormErrorsEffects, decorators: [{
            type: Injectable
        }], ctorParameters: function () { return [{ type: i1$2.Actions }, { type: i1.Store }]; } });

/**
 *
 */
const FormErrorsAdd = createAction('[FormErrors] Add Error', props());
const FormErrorsDelete = createAction('[FormErrors] Delete Error', props());
const FormErrorsClear = createAction('[FormErrorsClearPayload] Clear Form', props());

const FORM_ERRORS_FEATURE_KEY = 'formErrors';
const initialState$5 = {
    list: [],
    ids: []
};
const _formErrorsReducer = createReducer(initialState$5, on(FormErrorsAdd, (state, action) => {
    const { code, field, formId, message, params } = action.payload;
    const id = `${formId}${field}`;
    return {
        ...ReducerService.upsertOne(state, {
            id,
            code,
            field,
            formId,
            message,
            params
        })
    };
}), on(FormErrorsDelete, (state, action) => {
    const { formId, field } = action.payload;
    const id = `${formId}${field}`;
    return {
        ...ReducerService.deleteOne(state, id)
    };
}), on(FormErrorsClear, (state, action) => {
    const { formId } = action.payload;
    return {
        ...ReducerService.deleteItemsByField(state, 'formId', formId)
    };
}));
function formErrorsReducer(state, action) {
    return _formErrorsReducer(state, action);
}

const getFormErrorsState = createFeatureSelector(FORM_ERRORS_FEATURE_KEY);
const getFormErrors = (formId) => createSelector(getFormErrorsState, (state) => {
    return state.list.filter(item => item.formId === formId);
});
const getFormError = (formId, field) => createSelector(getFormErrorsState, (state) => {
    return state.list.find(item => item.formId === formId && field === field);
});
const formErrorsQuery = {
    getFormErrors,
    getFormError
};

class FormErrorsFacade {
    constructor(store) {
        this.store = store;
    }
    saveError(error) {
        this.store.dispatch(FormErrorsAdd({ payload: error }));
    }
    getFormErrors(formId) {
        return this.store.pipe(select(formErrorsQuery.getFormErrors(formId)));
    }
    clearFormErrors(formId) {
        this.store.dispatch(FormErrorsClear({ payload: { formId } }));
    }
}
FormErrorsFacade.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "15.2.9", ngImport: i0, type: FormErrorsFacade, deps: [{ token: i1.Store }], target: i0.ɵɵFactoryTarget.Injectable });
FormErrorsFacade.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "15.2.9", ngImport: i0, type: FormErrorsFacade, providedIn: "root" });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "15.2.9", ngImport: i0, type: FormErrorsFacade, decorators: [{
            type: Injectable,
            args: [{ providedIn: "root" }]
        }], ctorParameters: function () { return [{ type: i1.Store }]; } });

const FORM_UPDATE_ERROR = {
    title: 'Внимание',
    text: 'При сохранении формы возникла ошибка. Проверьте пожалуйста'
};
class FormsEffects {
    constructor(actions$, store, notificationsFacade) {
        this.actions$ = actions$;
        this.store = store;
        this.notificationsFacade = notificationsFacade;
        this.fileDelete$ = createEffect(() => this.actions$.pipe(ofType(UpdateForm), tap((action) => {
            const { formId, hasError, error } = action.payload;
            if (hasError) {
                this.notificationsFacade.addNotifications({
                    id: `form-error-${formId}`,
                    type: 'error',
                    text: error || FORM_UPDATE_ERROR.text,
                    title: FORM_UPDATE_ERROR.title,
                    timeout: NOTIFICATION_LONG_TIMEOUT
                });
            }
        })), { dispatch: false });
    }
}
FormsEffects.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "15.2.9", ngImport: i0, type: FormsEffects, deps: [{ token: i1$2.Actions }, { token: i1.Store }, { token: NotificationsFacade }], target: i0.ɵɵFactoryTarget.Injectable });
FormsEffects.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "15.2.9", ngImport: i0, type: FormsEffects });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "15.2.9", ngImport: i0, type: FormsEffects, decorators: [{
            type: Injectable
        }], ctorParameters: function () { return [{ type: i1$2.Actions }, { type: i1.Store }, { type: NotificationsFacade }]; } });

const FormDeleteFile = createAction('[FormDeleteFile] Delete File', props());
const FormDeleteFileSuccess = createAction('[FormDeleteFile] Delete File Success', props());
const FormDeleteFileFail = createAction('[FormDeleteFile] Delete File Error', props());

class FormDeleteFileBehavior extends Behavior {
    constructor(action, result) {
        super(action);
        this.action = action;
        this.result = result;
    }
    resolve() {
        const status = this.result.data.status;
        let returnedActions;
        switch (status) {
            case ResponseStatus.STATUS_200: {
                const response = this.result.data;
                const { field, entity, entityId } = response.body.data;
                returnedActions = [
                    FormDeleteFileSuccess({
                        payload: {
                            field,
                            entity,
                            entityId
                        }
                    })
                ];
                break;
            }
            case ResponseStatus.STATUS_400:
            case ResponseStatus.STATUS_404:
            case ResponseStatus.STATUS_422:
            case ResponseStatus.STATUS_401:
                const errorResponse = this.result.data;
                const error = errorResponse.body.errors[0].title;
                returnedActions = [
                    FormDeleteFileFail({ payload: { error } })
                ];
                break;
            default: {
                returnedActions = [
                    FormDeleteFileFail({ payload: { error: 'Unhandled error' } })
                ];
            }
        }
        return [...returnedActions];
    }
}

class FormDeleteFileApi extends BaseAPI {
    constructor(domain) {
        super(domain);
        this.domain = domain;
    }
    createRequest(paramsConfig, endPointType) {
        let request;
        switch (endPointType) {
            case FormDeleteFileBaseEndpointTypes.DELETE:
                request = new FormDeleteFileRequest(this.domain, paramsConfig);
                break;
            default:
                throw new Error(`Request for ${endPointType} is undefined `);
        }
        return request;
    }
    handleResponse(response, endPointType) {
        let resResponse;
        switch (endPointType) {
            case FormDeleteFileBaseEndpointTypes.DELETE:
                resResponse = BaseResponseFactory.createResponse(response);
                break;
            default:
                throw new Error(`Response for ${endPointType} is undefined `);
        }
        return resResponse;
    }
}

class FormDeleteFileService extends BaseAPIService {
    constructor(httpClient, config, requestsFacade, formsFacade) {
        super(httpClient, requestsFacade, formsFacade);
        this.httpClient = httpClient;
        this.config = config;
        this.requestsFacade = requestsFacade;
        this.formsFacade = formsFacade;
        this.api = new FormDeleteFileApi(this.config.apiUrl);
    }
    formDeleteFile(config) {
        return this.doRequest(config, FormDeleteFileBaseEndpointTypes.DELETE);
    }
}
FormDeleteFileService.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "15.2.9", ngImport: i0, type: FormDeleteFileService, deps: [{ token: i1$1.HttpClient }, { token: CORE_CONFIG }, { token: RequestsFacade }, { token: FormsFacade }], target: i0.ɵɵFactoryTarget.Injectable });
FormDeleteFileService.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "15.2.9", ngImport: i0, type: FormDeleteFileService, providedIn: 'root' });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "15.2.9", ngImport: i0, type: FormDeleteFileService, decorators: [{
            type: Injectable,
            args: [{
                    providedIn: 'root'
                }]
        }], ctorParameters: function () { return [{ type: i1$1.HttpClient }, { type: undefined, decorators: [{
                    type: Inject,
                    args: [CORE_CONFIG]
                }] }, { type: RequestsFacade }, { type: FormsFacade }]; } });

class FormDeleteFileEffects {
    constructor(actions$, store, formDeleteFileService, authenticationService) {
        this.actions$ = actions$;
        this.store = store;
        this.formDeleteFileService = formDeleteFileService;
        this.authenticationService = authenticationService;
        this.formDeleteFile$ = createEffect(() => this.actions$.pipe(ofType(FormDeleteFile), switchMap((action) => {
            const { field, entity, entityId } = action.payload;
            const headers = this.authenticationService.loadAuthDataFromLocalStore();
            return this.formDeleteFileService.formDeleteFile({
                field,
                entity,
                entityId,
                headers: { token: headers.token, uid: headers.id }
            })
                .pipe(flatMap((r) => new FormDeleteFileBehavior(action, r).resolve()));
        }), catchError(error => of(FormDeleteFileFail(error)))));
        this.deleteFileSuccess$ = createEffect(() => this.actions$.pipe(ofType(FormDeleteFileSuccess), map((action) => {
            const { field, entity, entityId } = action.payload;
            return EntityUpdate({ payload: {
                    updates: { [field]: '' },
                    entity,
                    entityId,
                }
            });
        }), catchError(error => of(FormDeleteFileFail(error)))));
    }
}
FormDeleteFileEffects.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "15.2.9", ngImport: i0, type: FormDeleteFileEffects, deps: [{ token: i1$2.Actions }, { token: i1.Store }, { token: FormDeleteFileService }, { token: AuthenticationService }], target: i0.ɵɵFactoryTarget.Injectable });
FormDeleteFileEffects.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "15.2.9", ngImport: i0, type: FormDeleteFileEffects });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "15.2.9", ngImport: i0, type: FormDeleteFileEffects, decorators: [{
            type: Injectable
        }], ctorParameters: function () { return [{ type: i1$2.Actions }, { type: i1.Store }, { type: FormDeleteFileService }, { type: AuthenticationService }]; } });

const PublishPost = createAction('[PublishError] Publish Post', props());
const PublishPostSuccess = createAction('[PublishError] Publish Post Success', props());
const PublishPostFail = createAction('[PublishError] Publish Post Fail', props());
const PublishPostDelete = createAction('[PublishError] Publish Post Delete', props());
const UnPublishPost = createAction('[PublishError] Un Publish Post', props());
const UnPublishPostSuccess = createAction('[PublishError] Un Publish Post Success', props());
const UnPublishPostFail = createAction('[PublishError] Un Publish Post Error', props());
const AddPublishErrors = createAction('[PublishError] Add publish errors', props());
const DeletePublishErrors = createAction('[PublishError] Delete publish errors', props());

class PublicationErrorsPostBehavior extends Behavior {
    constructor(action, result) {
        super(action);
        this.action = action;
        this.result = result;
    }
    resolve() {
        const status = this.result.data.status;
        let returnedActions = [];
        switch (status) {
            case ResponseStatus.STATUS_200: {
                const { publicationResult } = this.result.data?.body?.data;
                const meta = this.result.data?.body?.meta;
                const { entity, itemId, publishFinishedAt, publishedAt, status } = publicationResult.result;
                const updates = {
                    publishedAt,
                    publishFinishedAt,
                    status
                };
                returnedActions = [
                    EntityUpdate({ payload: { entity, entityId: itemId, updates } })
                ];
                const dopActions = this.checkPublishErrors(publicationResult, meta);
                returnedActions.push(...dopActions);
                if (!publicationResult?.errors?.length) {
                    returnedActions.push(PublishPostSuccess({ payload: {} }));
                }
                break;
            }
        }
        return [...returnedActions];
    }
    checkPublishErrors(publishData, meta) {
        const actions = [];
        const { errors, result, warnings } = publishData;
        const entity = meta?.staticDataType;
        const subStaticDataType = meta?.subStaticDataType;
        if (errors?.length) {
            const { itemId } = errors[0];
            actions.push(PublishPostDelete({ payload: { entity, itemId } }));
            actions.push(AddPublishErrors({ payload: { messages: errors } }));
        }
        if (warnings?.length) {
            actions.push(AddPublishErrors({ payload: { messages: warnings } }));
        }
        if (result) {
            const { itemId, publishedAt, publishFinishedAt, status } = result;
            if (entity && +itemId) {
                const updates = {
                    publishedAt,
                    publishFinishedAt,
                    status
                };
                actions.push(EntityUpdate({
                    payload: {
                        entity,
                        entityId: itemId,
                        updates,
                        subeEntity: subStaticDataType
                    }
                }));
            }
        }
        return actions;
    }
}

class UnPublicationPostBehavior extends Behavior {
    constructor(action, result) {
        super(action);
        this.action = action;
        this.result = result;
    }
    resolve() {
        const status = this.result.data.status;
        let returnedActions;
        switch (status) {
            case ResponseStatus.STATUS_200: {
                const response = this.result.data;
                const { itemId, publishFinishedAt, publishedAt, status } = response.body.data;
                const meta = response.body.meta;
                const updates = {
                    publishedAt,
                    publishFinishedAt,
                    status
                };
                const entity = meta?.staticDataType;
                const subStaticDataType = meta?.subStaticDataType;
                returnedActions = [
                    EntityUpdate({
                        payload: {
                            entity,
                            entityId: itemId,
                            updates,
                            subeEntity: subStaticDataType
                        }
                    }),
                    UnPublishPostSuccess({ payload: {} })
                ];
                break;
            }
            default: {
                returnedActions = [UnPublishPostFail({ payload: { error: '' } })];
            }
        }
        return [...returnedActions];
    }
}

class PublishApi extends BaseAPI {
    constructor(domain) {
        super(domain);
        this.domain = domain;
    }
    createRequest(paramsConfig, endPointType) {
        let request;
        switch (endPointType) {
            case PublishEndpointTypes.POST:
                request = new PublishPostRequest(this.domain, paramsConfig);
                break;
            case PublishEndpointTypes.UN_POST:
                request = new UnPublishPostRequest(this.domain, paramsConfig);
                break;
            default:
                throw new Error(`Request for ${endPointType} is undefined `);
        }
        return request;
    }
    handleResponse(response, endPointType) {
        let courseResponse;
        switch (endPointType) {
            case PublishEndpointTypes.POST:
                courseResponse = BaseResponseFactory.createResponse(response);
                break;
            case PublishEndpointTypes.UN_POST:
                courseResponse = BaseResponseFactory.createResponse(response);
                break;
            default:
                throw new Error(`Response for ${endPointType} is undefined `);
        }
        return courseResponse;
    }
}

class PublishService extends BaseAPIService {
    constructor(httpClient, config, requestsFacade, formsFacade) {
        super(httpClient, requestsFacade, formsFacade);
        this.httpClient = httpClient;
        this.config = config;
        this.requestsFacade = requestsFacade;
        this.formsFacade = formsFacade;
        this.api = new PublishApi(this.config.apiUrl);
    }
    publishPost(config) {
        return this.doRequest(config, PublishEndpointTypes.POST);
    }
    unPublishPost(config) {
        return this.doRequest(config, PublishEndpointTypes.UN_POST);
    }
}
PublishService.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "15.2.9", ngImport: i0, type: PublishService, deps: [{ token: i1$1.HttpClient }, { token: CORE_CONFIG }, { token: RequestsFacade }, { token: FormsFacade }], target: i0.ɵɵFactoryTarget.Injectable });
PublishService.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "15.2.9", ngImport: i0, type: PublishService, providedIn: 'root' });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "15.2.9", ngImport: i0, type: PublishService, decorators: [{
            type: Injectable,
            args: [{
                    providedIn: 'root'
                }]
        }], ctorParameters: function () { return [{ type: i1$1.HttpClient }, { type: undefined, decorators: [{
                    type: Inject,
                    args: [CORE_CONFIG]
                }] }, { type: RequestsFacade }, { type: FormsFacade }]; } });

class PublicationMessagesEffects {
    constructor(actions$, store, publishService, notificationsFacade) {
        this.actions$ = actions$;
        this.store = store;
        this.publishService = publishService;
        this.notificationsFacade = notificationsFacade;
        this.publishPost$ = createEffect(() => this.actions$.pipe(ofType(PublishPost), switchMap((action) => {
            const { itemId, entity, subEntity } = action.payload;
            return this.publishService.publishPost({ itemId, entity, subEntity })
                .pipe(flatMap((r) => new PublicationErrorsPostBehavior(action, r).resolve()));
        }), catchError(errors => {
            throw errors;
        })));
        this.publishPostSuccess$ = createEffect(() => this.actions$.pipe(ofType(PublishPostSuccess), tap(() => {
            const notification = {
                id: `publish-${Math.random()}`,
                type: 'success',
                text: 'Публикация успешно завершена',
                showingType: NotificationShowingType.POPUP
            };
            this.notificationsFacade.addNotifications(notification);
        })), { dispatch: false });
        this.PublishPostFail$ = createEffect(() => this.actions$.pipe(ofType(PublishPostFail), tap(() => {
            const notification = {
                id: `publish-${Math.random()}`,
                type: 'error',
                title: 'Внимание',
                text: 'Для публикации необходимо исправить корректировки',
                showingType: NotificationShowingType.POPUP
            };
            return this.notificationsFacade.addNotifications(notification);
        })), { dispatch: false });
        this.unPublishPost$ = createEffect(() => this.actions$.pipe(ofType(UnPublishPost), switchMap((action) => {
            const { itemId, entity, subEntity } = action.payload;
            return this.publishService.unPublishPost({ itemId, entity, subEntity })
                .pipe(flatMap((r) => new UnPublicationPostBehavior(action, r).resolve()));
        }), catchError(errors => {
            throw errors;
        })));
        this.unPublishPostFail$ = createEffect(() => this.actions$.pipe(ofType(UnPublishPostFail), tap(() => {
            const notification = {
                id: `publish-${Math.random()}`,
                type: 'error',
                title: 'Ошибка снятия с публикации',
                text: 'Обновите страницу и попробуйте заново',
                showingType: NotificationShowingType.POPUP
            };
            return this.notificationsFacade.addNotifications(notification);
        })), { dispatch: false });
        this.unPublishPostSuccess$ = createEffect(() => this.actions$.pipe(ofType(UnPublishPostSuccess), tap(() => {
            const notification = {
                id: `publish-${Math.random()}`,
                type: 'success',
                text: 'Запись снята с публикации',
                showingType: NotificationShowingType.POPUP
            };
            this.notificationsFacade.addNotifications(notification);
        })), { dispatch: false });
    }
}
PublicationMessagesEffects.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "15.2.9", ngImport: i0, type: PublicationMessagesEffects, deps: [{ token: i1$2.Actions }, { token: i1.Store }, { token: PublishService }, { token: NotificationsFacade }], target: i0.ɵɵFactoryTarget.Injectable });
PublicationMessagesEffects.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "15.2.9", ngImport: i0, type: PublicationMessagesEffects });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "15.2.9", ngImport: i0, type: PublicationMessagesEffects, decorators: [{
            type: Injectable
        }], ctorParameters: function () { return [{ type: i1$2.Actions }, { type: i1.Store }, { type: PublishService }, { type: NotificationsFacade }]; } });

// @TODO need to rename in all place for PUBLICATION
const PUBLISH_MESSAGES_FEATURE_KEY = 'publicationMessages';
const initialState$4 = {
    messages: []
};
const _staticDataReducer$3 = createReducer(initialState$4, on(PublishPostDelete, (state, action) => {
    if (action.payload) {
        const { itemId, entity } = action.payload;
        return {
            messages: [
                ...state.messages.filter((item) => item.itemId !== itemId && item.entity !== entity),
            ]
        };
    }
    return state;
}), on(AddPublishErrors, (state, action) => {
    if (action.payload) {
        const { messages } = action.payload;
        return {
            messages: [
                ...state.messages,
                ...messages
            ]
        };
    }
    return state;
}), on(DeletePublishErrors, (state, action) => {
    if (action.payload) {
        const { itemId, entity } = action.payload;
        return {
            messages: [
                ...state.messages.filter((item) => item.itemId !== itemId && item.entity !== entity),
            ]
        };
    }
    return state;
}));
function publicationMessagesReducer(state, action) {
    return _staticDataReducer$3(state, action);
}

const getStaticDataState$1 = createFeatureSelector(PUBLISH_MESSAGES_FEATURE_KEY);
const getPublicationMessage = (entity, itemId) => createSelector(getStaticDataState$1, (state) => {
    return state.messages.filter(message => message.entity === entity.toLowerCase() && message.itemId === +itemId);
});
const publicationMessagesQuery = {
    getPublicationMessage
};

class PublicationMessagesFacade {
    constructor(store) {
        this.store = store;
    }
    publishPost(entity, itemId, subEntity) {
        this.store.dispatch(PublishPost({ payload: { entity, itemId, subEntity } }));
    }
    unPublishPost(entity, itemId, subEntity) {
        this.store.dispatch(UnPublishPost({ payload: { entity, itemId, subEntity } }));
    }
    getPublicationMessage(entityType, itemId) {
        return this.store.pipe(select(publicationMessagesQuery.getPublicationMessage(entityType, itemId)));
    }
    deletePublicationMessages(entity, itemId) {
        this.store.dispatch(PublishPostDelete({ payload: { entity, itemId } }));
    }
    savePublicationMessages(messages) {
        this.store.dispatch(AddPublishErrors({ payload: { messages } }));
    }
    publishPostFail() {
        this.store.dispatch(PublishPostFail({ payload: {} }));
    }
}
PublicationMessagesFacade.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "15.2.9", ngImport: i0, type: PublicationMessagesFacade, deps: [{ token: i1.Store }], target: i0.ɵɵFactoryTarget.Injectable });
PublicationMessagesFacade.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "15.2.9", ngImport: i0, type: PublicationMessagesFacade, providedIn: "root" });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "15.2.9", ngImport: i0, type: PublicationMessagesFacade, decorators: [{
            type: Injectable,
            args: [{ providedIn: "root" }]
        }], ctorParameters: function () { return [{ type: i1.Store }]; } });

class UpdateEntitiesEffects {
    constructor(actions$, store) {
        this.actions$ = actions$;
        this.store = store;
        this.entityUpdate = createEffect(() => this.actions$.pipe(ofType(EntityUpdate), map((action) => {
            const { entity, entityId, subeEntity, updates } = action.payload;
            const payload = {
                id: entityId,
                subeEntity,
                updates
            };
            const entityUpdatePartAction = createAction(`[${entity}] ${entity} Update Part`, props());
            return entityUpdatePartAction({ payload });
        })));
    }
}
UpdateEntitiesEffects.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "15.2.9", ngImport: i0, type: UpdateEntitiesEffects, deps: [{ token: i1$2.Actions }, { token: i1.Store }], target: i0.ɵɵFactoryTarget.Injectable });
UpdateEntitiesEffects.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "15.2.9", ngImport: i0, type: UpdateEntitiesEffects });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "15.2.9", ngImport: i0, type: UpdateEntitiesEffects, decorators: [{
            type: Injectable
        }], ctorParameters: function () { return [{ type: i1$2.Actions }, { type: i1.Store }]; } });

class BaseEffects {
    constructor(actions$, store) {
        this.actions$ = actions$;
        this.store = store;
    }
    applySelector(selector) {
        return this.store.pipe(select(selector), first());
    }
    applySelectorWithPrevious(prevResult, selector) {
        return this.store.pipe(select(selector), first(), map(selectorResult => {
            if (Array.isArray(prevResult)) {
                return [...prevResult, selectorResult];
            }
            else {
                return [prevResult, selectorResult];
            }
        }));
    }
}

const StaticDataCreate = createAction('[StaticData] StaticData Create', props());
const StaticDataCreateSuccess = createAction('[StaticData] StaticData Create Success', props());
const StaticDataCreateFail = createAction('[StaticData] StaticData Create Error', props());
const StaticDataDelete = createAction('[StaticData] StaticData Delete', props());
const StaticDataDeleteSuccess = createAction('[StaticData] StaticData Delete Success', props());
const StaticDataDeleteFail = createAction('[StaticData] StaticData Delete Error', props());
const StaticDataUpdate = createAction('[StaticData] StaticData Update', props());
const StaticDataUpdateSuccess = createAction('[StaticData] StaticData Update Success', props());
const StaticDataUpdateFail = createAction('[StaticData] StaticData Update Fail', props());
const StaticDataPatchUpdate = createAction('[StaticData] StaticData Patch Update', props());
const StaticDataPatchUpdateSuccess = createAction('[StaticData] StaticData Patch Update Success', props());
const StaticDataPatchUpdateFail = createAction('[StaticData] StaticData Patch Update Fail', props());
const StaticDataGet = createAction('[StaticData] FGet StaticData', props());
const StaticDataGetSuccess = createAction('[StaticData] Get StaticData Success', props());
const StaticDataGetFail = createAction('[StaticData] Get StaticData Fail', props());
const StaticDataPartUpdate = createAction('[static-data] static-data Update Part', props());
const StaticDataGetList = createAction('[StaticData] StaticData Load', props());
const StaticDataGetListSuccess = createAction('[StaticData] StaticData Load Success', props());
const StaticDataGetListFail = createAction('[StaticData] StaticData Load Fail', props());
const StaticDataGetListCategories = createAction('[StaticData] StaticData Get List Categories', props());
const StaticDataGetListCategoriesSuccess = createAction('[StaticData] StaticData Get List Categories Success', props());
const StaticDataGetListCategoriesFail = createAction('[StaticData] StaticData Get List Categories Fail', props());
const ClearStaticData = createAction('[StaticData] Clear StaticData', props());
const StaticDataGetSubRouting = createAction('[StaticData] StaticData Get Sub routing', props());
const StaticDataGetSubRoutingSuccess = createAction('[StaticData] StaticData Get Sub routing Success', props());
const StaticDataGetSubRoutingFail = createAction('[StaticData] StaticData Get Sub routing Fail', props());
const StaticDataNewRevisions = createAction('[StaticData] StaticDataNewRevisions', props());
const StaticDataLoadRevisions = createAction('[StaticData] StaticDataLoadRevisions', props());

class StaticDataGetListBehavior extends Behavior {
    constructor(action, result) {
        super(action);
        this.action = action;
        this.result = result;
    }
    resolve() {
        const status = this.result.data?.status;
        let returnedActions = [];
        switch (status) {
            case ResponseStatus.STATUS_200: {
                const response = this.result.data;
                const { data, meta } = response.body;
                const actionPayload = this.action['payload'];
                if (data) {
                    returnedActions = [
                        StaticDataGetListSuccess({
                            payload: { data, meta, keepState: actionPayload?.keepState }
                        })
                    ];
                }
                break;
            }
            case ResponseStatus.STATUS_400:
            case ResponseStatus.STATUS_404:
            case ResponseStatus.STATUS_422:
            case ResponseStatus.STATUS_401:
                const errorResponse = this.result.data;
                const error = errorResponse.body.errors ? errorResponse.body.errors[0].title : '';
                returnedActions = [
                    StaticDataGetListFail({ payload: { error, contentType: errorResponse.body.errors.contentType } })
                ];
                break;
            default: {
                const errorResponse = this.result.data;
                returnedActions = [
                    StaticDataGetListFail({
                        payload: {
                            error: 'Unhandled error',
                            contentType: errorResponse?.body?.errors?.contentType || null
                        }
                    })
                ];
            }
        }
        return [...returnedActions];
    }
}

class StaticDataDeleteBehavior extends Behavior {
    constructor(action, result) {
        super(action);
        this.action = action;
        this.result = result;
    }
    resolve() {
        const status = this.result.data.status;
        let returnedActions;
        switch (status) {
            case ResponseStatus.STATUS_200: {
                const response = this.result.data;
                const { contentType, itemId } = response.body.data;
                returnedActions = [
                    StaticDataDeleteSuccess({ payload: { contentType: contentType, itemId } })
                ];
                break;
            }
            case ResponseStatus.STATUS_400:
            case ResponseStatus.STATUS_404:
            case ResponseStatus.STATUS_422:
            case ResponseStatus.STATUS_401:
                const errorResponse = this.result.data;
                const error = errorResponse.body.errors[0].title;
                const { contentType, itemId } = this.result.data.body.data;
                returnedActions = [
                    StaticDataDeleteFail({ payload: { contentType: contentType, itemId, error } })
                ];
                break;
            default: {
                if (this.result.data?.body?.data) {
                    const { contentType, itemId } = this.result.data?.body?.data;
                    returnedActions = [
                        StaticDataDeleteFail({ payload: { contentType: contentType, itemId, error: 'Unhandled error' } })
                    ];
                }
                else {
                    returnedActions = [
                        StaticDataDeleteFail({ payload: { contentType: undefined, itemId: undefined, error: 'Unhandled error' } })
                    ];
                }
            }
        }
        return [...returnedActions];
    }
}

class StaticDataCreateBehavior extends Behavior {
    constructor(action, result) {
        super(action);
        this.action = action;
        this.result = result;
    }
    resolve() {
        const status = this.result.data.status;
        const error = this.result.data?.body?.error;
        let returnedActions;
        const response = this.result.data;
        switch (status) {
            case ResponseStatus.STATUS_200: {
                const { data, meta } = response.body;
                returnedActions = [
                    StaticDataCreateSuccess({ payload: { data, contentType: meta.staticDataType, itemId: data.id } }),
                ];
                break;
            }
            default: {
                returnedActions = [];
            }
        }
        return [...returnedActions];
    }
}

class StaticDataUpdateBehavior extends Behavior {
    constructor(action, result) {
        super(action);
        this.action = action;
        this.result = result;
    }
    resolve() {
        const status = this.result.data?.status;
        let returnedActions;
        const error = this.result.data.body?.error;
        switch (status) {
            case ResponseStatus.STATUS_200:
            case ResponseStatus.STATUS_201: {
                const response = this.result.data;
                const { data, meta } = response.body;
                returnedActions = [
                    StaticDataUpdateSuccess({ payload: { data, contentType: meta?.staticDataType, itemId: data.id } })
                ];
                break;
            }
            default: {
                returnedActions = [
                    StaticDataUpdateFail({
                        payload: {
                            error,
                            contentType: error?.payload?.contentType,
                            itemId: error?.payload?.itemId
                        }
                    })
                ];
            }
        }
        return [...returnedActions];
    }
}

class StaticDataGetListCategoriesBehavior extends Behavior {
    constructor(action, result) {
        super(action);
        this.action = action;
        this.result = result;
    }
    resolve() {
        const status = this.result.data.status;
        let returnedActions = [];
        switch (status) {
            case ResponseStatus.STATUS_200: {
                const response = this.result.data;
                const { data, meta } = response.body;
                if (data) {
                    returnedActions = [
                        StaticDataGetListCategoriesSuccess({
                            payload: { data }
                        })
                    ];
                }
                break;
            }
        }
        return [...returnedActions];
    }
}

class StaticDataPatchUpdateBehavior extends Behavior {
    constructor(action, result) {
        super(action);
        this.action = action;
        this.result = result;
    }
    resolve() {
        const status = this.result.data?.status;
        let returnedActions;
        const error = this.result.data.body?.error;
        switch (status) {
            case ResponseStatus.STATUS_200:
            case ResponseStatus.STATUS_201: {
                const response = this.result.data;
                const { data, meta } = response.body;
                returnedActions = [
                    StaticDataPatchUpdateSuccess({ payload: { data, contentType: meta?.staticDataType, itemId: data.id } })
                ];
                break;
            }
            default: {
                returnedActions = [
                    StaticDataPatchUpdateFail({
                        payload: {
                            error,
                            contentType: error?.payload?.contentType,
                            itemId: error?.payload?.itemId
                        }
                    })
                ];
            }
        }
        return [...returnedActions];
    }
}

var IFormFieldFormat;
(function (IFormFieldFormat) {
    IFormFieldFormat["Date"] = "date";
    IFormFieldFormat["Email"] = "email";
    IFormFieldFormat["Phone"] = "phone";
    IFormFieldFormat["Number"] = "number";
    IFormFieldFormat["Password"] = "password";
})(IFormFieldFormat || (IFormFieldFormat = {}));

class BaseAutoFormService {
    getPreparedFields(fields) {
        const result = {};
        fields.forEach((item) => {
            let validators = [];
            let asyncValidators = [];
            if (item.validators && item.validators.length) {
                validators = this.getValidators(item.validators, item.options);
            }
            if (item.options?.format) {
                const validator = this.getValidatorByFormat(item.options.format);
                if (validator) {
                    validators.push(validator);
                }
            }
            if (item.asyncValidators && item.asyncValidators.length) {
                asyncValidators = this.getAsyncValidators(item.asyncValidators, item.options);
            }
            result[item.field] = [null, validators, asyncValidators];
        });
        return result;
    }
    getValidators(validators, options) {
        return [];
    }
    getAsyncValidators(validators, options) {
        return [];
    }
    getValidatorByFormat(format) {
        let validator;
        if (format === IFormFieldFormat.Email) {
            validator = Validators.email;
        }
        if (format === IFormFieldFormat.Phone) {
            validator = Validators.pattern(/[\+0-9]/);
        }
        if (format === IFormFieldFormat.Number) {
            validator = Validators.pattern(/[0-9]$/);
        }
        if (format === IFormFieldFormat.Date) {
            validator = Validators.pattern(/[0-9\-]/);
        }
        return validator;
    }
    prepareFieldError(error, fieldsValue) {
        let newText = error;
        Object.keys(fieldsValue).forEach(key => {
            const value = fieldsValue[key];
            newText = newText.replace(`:${key}`, value);
        });
        return newText;
    }
}
BaseAutoFormService.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "15.2.9", ngImport: i0, type: BaseAutoFormService, deps: [], target: i0.ɵɵFactoryTarget.Injectable });
BaseAutoFormService.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "15.2.9", ngImport: i0, type: BaseAutoFormService, providedIn: 'root' });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "15.2.9", ngImport: i0, type: BaseAutoFormService, decorators: [{
            type: Injectable,
            args: [{ providedIn: 'root' }]
        }] });

class AutoFormService extends BaseAutoFormService {
    constructor(formValidationFacade, notificationsFacade) {
        super();
        this.formValidationFacade = formValidationFacade;
        this.notificationsFacade = notificationsFacade;
        this.validatorsData = {};
    }
    getAsyncValidators(validators, options) {
        const resultValidators = [];
        validators.forEach(validator => {
            switch (validator) {
                case AsyncValidators.ItemUniqValue:
                    resultValidators.push(this.itemUniqValueValidator.bind(this, { ...options }));
                    break;
            }
        });
        return resultValidators;
    }
    getValidators(validators, options) {
        const resultValidators = [];
        validators.forEach(validator => {
            switch (validator) {
                case ValidatorsType.Required:
                    resultValidators.push(Validators.required.bind(this));
                    break;
                case ValidatorsType.RequiredTrue:
                    resultValidators.push(Validators.requiredTrue.bind(this));
                    break;
                case ValidatorsType.MinLength:
                    const length = options.validations[ValidatorsType.MinLength].length;
                    resultValidators.push(Validators.minLength(length));
                    break;
                case ValidatorsType.Pattern:
                    const pattern = options.validations[ValidatorsType.Pattern].pattern;
                    resultValidators.push(Validators.pattern(pattern));
                    break;
                case ValidatorsType.Custom:
                    const validationFunction = options.validations[ValidatorsType.Custom].validationFunction;
                    resultValidators.push(validationFunction);
                    break;
            }
        });
        return resultValidators;
    }
    itemUniqValueValidator(controlIn, optionsIn) {
        const control = arguments[1];
        const options = arguments[0]?.validations.uniq;
        const value = control.value;
        const form = control.parent;
        let itemId;
        if (form && form.get('id')) {
            itemId = +form.get('id').value;
        }
        const type = options.type;
        // If the value for this type is checked before not need to do this checking again
        if (this.validatorsData[type] && this.validatorsData[type].value === value && this.validatorsData[type].valid) {
            return Promise.resolve();
        }
        this.validatorsData[type] = { value: value, valid: false };
        return new Promise(resolve => {
            if (value && value.length < 3) {
                resolve({ [options.errorKey]: true });
                return;
            }
            if (value && !control.pristine) {
                let validatorOption;
                if (options.entity && options.entityField) {
                    validatorOption = {
                        entity: options.entity,
                        entityField: options.entityField,
                    };
                }
                this.formValidationFacade.sendValidation(type, value, itemId, validatorOption);
                this.formValidationFacade.getValidation(type, value)
                    .pipe(take(2), filter$1((validationData) => validationData.loaded))
                    .subscribe((validationData) => {
                    if (validationData && !validationData.isValid) {
                        this.notificationsFacade.addNotifications({
                            id: `${options.errorKey}${value}`,
                            type: 'error',
                            text: options.errorText,
                            timeout: NOTIFICATION_LONG_TIMEOUT
                        });
                        resolve({ [options.errorKey]: true });
                    }
                    else {
                        this.validatorsData[type] = { value: value, valid: true };
                        resolve();
                    }
                });
            }
            else {
                control.status = 'VALID';
                resolve();
            }
        });
    }
    prepareFormFieldPublicationMessage(messages, publishErrorConstants, fields) {
        return messages.map(item => {
            const { field, message } = item;
            const foundField = fields?.find(fieldItem => fieldItem.field === field);
            let params = {
                'field': foundField?.title || field
            };
            const messageParam = message.split('-');
            const messageKey = messageParam[0];
            if (messageParam.length > 1) {
                params['countDownloadedFiles'] = messageParam[1];
            }
            if (publishErrorConstants[messageKey]) {
                const { title, description } = publishErrorConstants[messageKey];
                return {
                    title: this.prepareText(title, params),
                    description: this.prepareText(description, params),
                    field: foundField?.field || field
                };
            }
            return {
                title: field,
                description: message
            };
        });
    }
    prepareText(text, params) {
        let newText = text;
        Object.keys(params)
            .forEach(key => {
            newText = this.replaceAll(newText, '{' + key + '}', params[key]);
        });
        return newText;
    }
    replaceAll(str, a, b) {
        return str.replace(new RegExp(a, 'g'), b);
    }
}
AutoFormService.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "15.2.9", ngImport: i0, type: AutoFormService, deps: [{ token: FormValidationFacade }, { token: NotificationsFacade }], target: i0.ɵɵFactoryTarget.Injectable });
AutoFormService.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "15.2.9", ngImport: i0, type: AutoFormService, providedIn: "root" });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "15.2.9", ngImport: i0, type: AutoFormService, decorators: [{
            type: Injectable,
            args: [{ providedIn: "root" }]
        }], ctorParameters: function () { return [{ type: FormValidationFacade }, { type: NotificationsFacade }]; } });

class CacheDataApi extends BaseAPI {
    constructor(domain) {
        super(domain);
        this.domain = domain;
    }
    createRequest(paramsConfig, endPointType) {
        let request;
        switch (endPointType) {
            case CacheDataEndpointTypes.GET_CACHE_DATA:
                request = new GetCacheDataRequest(this.domain, paramsConfig);
                break;
            default:
                throw new Error(`Request for ${endPointType} is undefined `);
        }
        return request;
    }
    handleResponse(response, endPointType) {
        return BaseResponseFactory.createResponse(response);
    }
}

class CacheDataService extends BaseAPIService {
    constructor(httpClient, config, requestsFacade, formsFacade) {
        super(httpClient, requestsFacade, formsFacade);
        this.httpClient = httpClient;
        this.config = config;
        this.requestsFacade = requestsFacade;
        this.formsFacade = formsFacade;
        this.api = new CacheDataApi(this.config.apiUrl);
    }
    getCacheData(config) {
        return this.doRequest(config, CacheDataEndpointTypes.GET_CACHE_DATA);
    }
}
CacheDataService.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "15.2.9", ngImport: i0, type: CacheDataService, deps: [{ token: i1$1.HttpClient }, { token: CORE_CONFIG }, { token: RequestsFacade }, { token: FormsFacade }], target: i0.ɵɵFactoryTarget.Injectable });
CacheDataService.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "15.2.9", ngImport: i0, type: CacheDataService, providedIn: 'root' });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "15.2.9", ngImport: i0, type: CacheDataService, decorators: [{
            type: Injectable,
            args: [{
                    providedIn: 'root'
                }]
        }], ctorParameters: function () { return [{ type: i1$1.HttpClient }, { type: undefined, decorators: [{
                    type: Inject,
                    args: [CORE_CONFIG]
                }] }, { type: RequestsFacade }, { type: FormsFacade }]; } });

const COOKIES_OPTIONS = new InjectionToken('COOKIES_OPTIONS');

function isBlank(obj) {
    return obj === undefined || obj === null;
}
function isPresent(obj) {
    return obj !== undefined && obj !== null;
}
function isString(obj) {
    return typeof obj === 'string';
}
function mergeOptions(oldOptions, newOptions) {
    if (!newOptions) {
        return oldOptions;
    }
    return {
        path: isPresent(newOptions.path) ? newOptions.path : oldOptions.path,
        domain: isPresent(newOptions.domain) ? newOptions.domain : oldOptions.domain,
        expires: isPresent(newOptions.expires) ? newOptions.expires : oldOptions.expires,
        secure: isPresent(newOptions.secure) ? newOptions.secure : oldOptions.secure,
        httpOnly: isPresent(newOptions.httpOnly) ? newOptions.httpOnly : oldOptions.httpOnly
    };
}
function safeDecodeURIComponent(str) {
    try {
        return decodeURIComponent(str);
    }
    catch (e) {
        return str;
    }
}
function safeJsonParse(str) {
    try {
        return JSON.parse(str);
    }
    catch (e) {
        return str;
    }
}

class CookiesService {
    constructor(injector) {
        this.injector = injector;
        const cookiesOptions = this.injector.get(COOKIES_OPTIONS, {});
        this.defaultOptions = {
            path: this.injector.get(APP_BASE_HREF, '/'),
            domain: null,
            expires: null,
            secure: false
        };
        this.options = mergeOptions(this.defaultOptions, cookiesOptions);
    }
    setItem(key, value, options) {
        this.cookiesWriter()(key, value, options || this.options);
    }
    putObject(key, value, options) {
        this.setItem(key, JSON.stringify(value), options || this.options);
    }
    getItem(key) {
        return this.cookiesReader()[key];
    }
    getObject(key) {
        const value = this.getItem(key);
        return value ? safeJsonParse(value) : value;
    }
    getAll() {
        return this.cookiesReader();
    }
    removeItem(key, options) {
        this.cookiesWriter()(key, '', options);
    }
    clear() {
        const cookies = this.getAll();
        Object.keys(cookies).forEach(key => {
            this.removeItem(key);
        });
    }
    cookiesReader() {
        return {};
    }
    cookiesWriter() {
        return () => { };
    }
}
CookiesService.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "15.2.9", ngImport: i0, type: CookiesService, deps: [{ token: i0.Injector }], target: i0.ɵɵFactoryTarget.Injectable });
CookiesService.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "15.2.9", ngImport: i0, type: CookiesService });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "15.2.9", ngImport: i0, type: CookiesService, decorators: [{
            type: Injectable
        }], ctorParameters: function () { return [{ type: i0.Injector }]; } });

class UserBehaviorReportRequest extends GetRequest {
    constructor(domain, config) {
        super(domain);
        this.domain = domain;
        this.config = config;
    }
    get url() {
        return `${this.domain}/api/reports/user-behavior`;
    }
    get headers() {
        return this.addAuthHeaders(this.config.headers);
    }
    get params() {
        return null;
    }
    get body() {
        return null;
    }
}

class ReportsApi extends BaseAPI {
    constructor(domain) {
        super(domain);
        this.domain = domain;
    }
    createRequest(paramsConfig, endPointType) {
        let request;
        switch (endPointType) {
            case ReportsEndpointTypes.ENTITIES_REPORT:
                request = new EntitiesReportsRequest(this.domain, paramsConfig);
                break;
            case ReportsEndpointTypes.USER_BEHAVIOR_REPORT:
                request = new UserBehaviorReportRequest(this.domain, paramsConfig);
                break;
            default:
                throw new Error(`Request for ${endPointType} is undefined `);
        }
        return request;
    }
    handleResponse(response, endPointType) {
        return BaseResponseFactory.createResponse(response);
    }
}

class ReportsService extends BaseAPIService {
    constructor(httpClient, config, requestsFacade, formsFacade) {
        super(httpClient, requestsFacade, formsFacade);
        this.httpClient = httpClient;
        this.config = config;
        this.requestsFacade = requestsFacade;
        this.formsFacade = formsFacade;
        this.api = new ReportsApi(this.config.apiUrl);
    }
    getEntitiesReports(config) {
        return this.doRequest(config, ReportsEndpointTypes.ENTITIES_REPORT);
    }
    getUserBehaviorReport(config) {
        return this.doRequest(config, ReportsEndpointTypes.USER_BEHAVIOR_REPORT);
    }
}
ReportsService.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "15.2.9", ngImport: i0, type: ReportsService, deps: [{ token: i1$1.HttpClient }, { token: CORE_CONFIG }, { token: RequestsFacade }, { token: FormsFacade }], target: i0.ɵɵFactoryTarget.Injectable });
ReportsService.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "15.2.9", ngImport: i0, type: ReportsService, providedIn: 'root' });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "15.2.9", ngImport: i0, type: ReportsService, decorators: [{
            type: Injectable,
            args: [{
                    providedIn: 'root'
                }]
        }], ctorParameters: function () { return [{ type: i1$1.HttpClient }, { type: undefined, decorators: [{
                    type: Inject,
                    args: [CORE_CONFIG]
                }] }, { type: RequestsFacade }, { type: FormsFacade }]; } });

class SocialAuthService {
    constructor(platformId) {
        /*
          if (isPlatformBrowser(platformId) && config) {
              this.providers = config.providers;
              this.providers.forEach((provider: LoginProvider, key: string) => {
                  provider.initialize().then(() => {
                      const readyProviders = this._readyState.getValue();
                      readyProviders.push(key);
                      this._readyState.next(readyProviders);
                  }).catch((err) => {
                      // this._authState.next(null);
                  });
              });
          }*/
        this.platformId = platformId;
        // private providers: Map<string, LoginProvider>;
        this._readyState = new BehaviorSubject([]);
    }
    /*private getLoginStatus(): Observable<SocialUser> {
        const arr = [];


        this.providers.forEach((provider: LoginProvider, key: string) => {

            arr.push(from(provider.initialize()).pipe(
                switchMap(() => {
                    const readyProviders = this._readyState.getValue();
                    readyProviders.push(key);
                    this._readyState.next(readyProviders);
                    return from(provider.getLoginStatus());
                }),
                catchError(error => {
                    return throwError('getLoginStatus error: ' + error);
                })
            ))
        });

        return race(arr);
    }

    public signIn(providerId: string, opt?: LoginOptions): Observable<SocialUser> {
        const providerObject = this.providers.get(providerId);
        if (providerObject) {
            return from(providerObject.signIn(opt))
        } else {
            return throwError(SocialAuthService.ERR_LOGIN_PROVIDER_NOT_FOUND)
        }
    }
*/
    signOut(providerId) {
        /*        const providerObject = this.providers.get(providerId);
                if (providerObject) {
                    return from(providerObject.signOut())
                } else {
                    return throwError(SocialAuthService.ERR_LOGIN_PROVIDER_NOT_FOUND)
                }*/
        return throwError(SocialAuthService.ERR_LOGIN_PROVIDER_NOT_FOUND);
    }
}
SocialAuthService.ERR_LOGIN_PROVIDER_NOT_FOUND = 'Login provider not found';
SocialAuthService.ERR_NOT_LOGGED_IN = 'Not logged in';
SocialAuthService.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "15.2.9", ngImport: i0, type: SocialAuthService, deps: [{ token: PLATFORM_ID }], target: i0.ɵɵFactoryTarget.Injectable });
SocialAuthService.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "15.2.9", ngImport: i0, type: SocialAuthService });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "15.2.9", ngImport: i0, type: SocialAuthService, decorators: [{
            type: Injectable
        }], ctorParameters: function () { return [{ type: undefined, decorators: [{
                    type: Inject,
                    args: [PLATFORM_ID]
                }] }]; } });

class StaticDataPatchUpdateRequest extends PatchRequest {
    constructor(domain, config) {
        super(domain);
        this.domain = domain;
        this.config = config;
    }
    get url() {
        return `${this.domain}/api/static-data/${this.config.contentType}/${this.config.itemId}`;
    }
    get headers() {
        return this.addAuthHeaders(this.config.headers);
    }
    get params() {
        return null;
    }
    get body() {
        const { data, formId, contentType, itemId } = this.config;
        const comment = {
            data,
            meta: {
                formId,
                contentType,
                itemId
            }
        };
        return { ...this.cleanParams(comment) };
    }
}

class StaticDataLoadRevisionsRequest extends GetRequest {
    constructor(domain, config) {
        super(domain);
        this.domain = domain;
        this.config = config;
    }
    get url() {
        return `${this.domain}/api/static-data/revisions`;
    }
    get headers() {
        return this.addAuthHeaders(this.config.headers);
    }
    get params() {
        return null;
    }
    get body() {
        return null;
    }
}

class StaticDataApi extends BaseAPI {
    constructor(domain) {
        super(domain);
        this.domain = domain;
    }
    createRequest(paramsConfig, endPointType) {
        let request;
        switch (endPointType) {
            case StaticDataEndpointTypes.LOAD_REVISION:
                request = new StaticDataLoadRevisionsRequest(this.domain, paramsConfig);
                break;
            case StaticDataEndpointTypes.GET_LIST:
                request = new StaticDataGetListRequest(this.domain, paramsConfig);
                break;
            case StaticDataEndpointTypes.GET_LIST_CATEGORIES:
                request = new StaticDataGetListCategoriesRequest(this.domain, paramsConfig);
                break;
            case StaticDataEndpointTypes.DELETE:
                request = new StaticDataDeleteRequest(this.domain, paramsConfig);
                break;
            case StaticDataEndpointTypes.GET:
                request = new StaticDataGetRequest(this.domain, paramsConfig);
                break;
            case StaticDataEndpointTypes.UPDATE:
                request = new StaticDataUpdateRequest(this.domain, paramsConfig);
                break;
            case StaticDataEndpointTypes.PATCH_UPDATE:
                request = new StaticDataPatchUpdateRequest(this.domain, paramsConfig);
                break;
            case StaticDataEndpointTypes.CREATE:
                request = new StaticDataCreateRequest(this.domain, paramsConfig);
                break;
            case StaticDataEndpointTypes.GET_SUB_ROUTING:
                request = new StaticDataSubRoutingGetRequest(this.domain, paramsConfig);
                break;
            default:
                throw new Error(`Request for ${endPointType} is undefined `);
        }
        return request;
    }
    handleResponse(response, endPointType) {
        return BaseResponseFactory.createResponse(response);
    }
}

class StaticDataService extends BaseAPIService {
    constructor(httpClient, config, requestsFacade, formsFacade) {
        super(httpClient, requestsFacade, formsFacade);
        this.httpClient = httpClient;
        this.config = config;
        this.requestsFacade = requestsFacade;
        this.formsFacade = formsFacade;
        this.api = new StaticDataApi(this.config.apiUrl);
    }
    loadRevision(config) {
        return this.doRequest(config, StaticDataEndpointTypes.LOAD_REVISION);
    }
    getList(config) {
        return this.doRequest(config, StaticDataEndpointTypes.GET_LIST);
    }
    getSubRouting(config) {
        return this.doRequest(config, StaticDataEndpointTypes.GET_SUB_ROUTING);
    }
    getListCategories(config) {
        return this.doRequest(config, StaticDataEndpointTypes.GET_LIST_CATEGORIES);
    }
    getItem(config) {
        return this.doRequest(config, StaticDataEndpointTypes.GET);
    }
    delete(config) {
        return this.doRequest(config, StaticDataEndpointTypes.DELETE);
    }
    create(config) {
        return this.doRequest(config, StaticDataEndpointTypes.CREATE);
    }
    update(config) {
        return this.doRequest(config, StaticDataEndpointTypes.UPDATE);
    }
    patchUpdate(config) {
        return this.doRequest(config, StaticDataEndpointTypes.PATCH_UPDATE);
    }
}
StaticDataService.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "15.2.9", ngImport: i0, type: StaticDataService, deps: [{ token: i1$1.HttpClient }, { token: CORE_CONFIG }, { token: RequestsFacade }, { token: FormsFacade }], target: i0.ɵɵFactoryTarget.Injectable });
StaticDataService.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "15.2.9", ngImport: i0, type: StaticDataService, providedIn: 'root' });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "15.2.9", ngImport: i0, type: StaticDataService, decorators: [{
            type: Injectable,
            args: [{
                    providedIn: 'root'
                }]
        }], ctorParameters: function () { return [{ type: i1$1.HttpClient }, { type: undefined, decorators: [{
                    type: Inject,
                    args: [CORE_CONFIG]
                }] }, { type: RequestsFacade }, { type: FormsFacade }]; } });

class BrowserCookiesService extends CookiesService {
    get cookieString() {
        return document.cookie || '';
    }
    set cookieString(val) {
        document.cookie = val;
    }
    constructor(injector) {
        super(injector);
        this.injector = injector;
    }
    cookiesReader() {
        let lastCookies = {};
        let lastCookieString = '';
        let cookiesArray, cookie, i, index, name;
        const currentCookieString = this.cookieString;
        if (currentCookieString !== lastCookieString) {
            lastCookieString = currentCookieString;
            cookiesArray = lastCookieString.split('; ');
            lastCookies = {};
            for (i = 0; i < cookiesArray.length; i++) {
                cookie = cookiesArray[i];
                index = cookie.indexOf('=');
                if (index > 0) { // ignore nameless cookies
                    name = safeDecodeURIComponent(cookie.substring(0, index));
                    if (isBlank(lastCookies[name])) {
                        lastCookies[name] = safeDecodeURIComponent(cookie.substring(index + 1));
                    }
                }
            }
        }
        return lastCookies;
    }
    cookiesWriter() {
        return (name, value, options) => {
            this.cookieString = this.buildCookieString(name, value, options);
        };
    }
    buildCookieString(name, value, options) {
        const opts = mergeOptions(this.options, options);
        let expires = opts.expires;
        if (isBlank(expires)) {
            const now = new Date().getTime();
            expires = new Date(now + 2 * 30 * 24 * 60 * 60 * 1000);
        }
        if (isString(expires)) {
            expires = new Date(expires);
        }
        let str = encodeURIComponent(name) + '=' + encodeURIComponent(value);
        str += opts.path ? `;path=${opts.path}` : '';
        str += opts.domain ? `;domain=${opts.domain}` : '';
        str += expires ? `;expires=${expires.toUTCString()}` : '';
        str += opts.secure ? ';secure' : '';
        const cookiesLength = str.length + 1;
        if (cookiesLength > 4096) {
            console.info(`Cookie \'${name}\' possibly not set or overflowed because it was too
      large (${cookiesLength} > 4096 bytes)!`);
        }
        return str;
    }
}
BrowserCookiesService.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "15.2.9", ngImport: i0, type: BrowserCookiesService, deps: [{ token: i0.Injector }], target: i0.ɵɵFactoryTarget.Injectable });
BrowserCookiesService.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "15.2.9", ngImport: i0, type: BrowserCookiesService });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "15.2.9", ngImport: i0, type: BrowserCookiesService, decorators: [{
            type: Injectable
        }], ctorParameters: function () { return [{ type: i0.Injector }]; } });

// import { ServerCookiesService } from './server/server-cookies.service';
function cookiesProviderFactory(platformId, injector) {
    // if (isPlatformBrowser(platformId)) {
    return new BrowserCookiesService(injector);
    // }
    // return new ServerCookiesService(injector);
}
const CookiesProvider = {
    provide: CookiesService,
    deps: [PLATFORM_ID, Injector],
    useFactory: cookiesProviderFactory,
};

class StorageService {
    setItem(key, value, options) {
    }
    putObject(key, value) {
    }
    getItem(key) {
        return null;
    }
    getObject(key) {
        return '';
    }
    getAll() {
        return null;
    }
    removeItem(key) {
    }
    clear() {
    }
}
StorageService.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "15.2.9", ngImport: i0, type: StorageService, deps: [], target: i0.ɵɵFactoryTarget.Injectable });
StorageService.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "15.2.9", ngImport: i0, type: StorageService });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "15.2.9", ngImport: i0, type: StorageService, decorators: [{
            type: Injectable
        }] });
const StorageProvider = {
    provide: StorageService,
    deps: [PLATFORM_ID, Injector],
    useFactory: cookiesProviderFactory,
};

const STATIC_DATA_FEATURE_KEY$1 = 'staticData';
var StaticDataMetaStatus$1;
(function (StaticDataMetaStatus) {
    StaticDataMetaStatus["LOADING"] = "loading";
    StaticDataMetaStatus["LOADED"] = "loaded";
})(StaticDataMetaStatus$1 || (StaticDataMetaStatus$1 = {}));
const initialState$3 = {
    list: {},
    meta: {},
    revisions: null
};
const _staticDataReducer$2 = createReducer(initialState$3, on(StaticDataGetList, (state, action) => {
    const { contentType, subSection } = action.payload;
    if (contentType) {
        return {
            ...state,
            meta: {
                ...state.meta,
                [contentType]: {
                    ...state.meta?.[contentType],
                    [subSection]: {
                        ...state.meta?.[contentType]?.[subSection]
                    }
                }
            }
        };
    }
    return {
        ...state
    };
}), on(StaticDataGetListSuccess, (state, action) => {
    const { data, meta, keepState } = action.payload;
    const { staticDataType, subSection } = meta;
    const newsState = { list: {}, meta: {} };
    const storeSubSection = subSection || 'list';
    newsState['list'] = {};
    newsState['meta'] = { ...state.meta };
    if (staticDataType) {
        if (Object.keys(state.list)?.length) {
            Object.keys(state.list)
                .forEach(key => {
                if (!newsState['list'][key]) {
                    newsState['list'][key] = {};
                }
                if (state.list?.[key]) {
                    Object.keys(state.list[key])
                        .forEach(subSection => {
                        if (!newsState['list'][key][subSection]) {
                            newsState['list'][key][subSection] = {};
                        }
                        if ((key !== staticDataType || subSection !== storeSubSection) && state.list[key]?.[subSection]) {
                            if (Array.isArray(state.list[key][subSection])) {
                                newsState['list'][key][subSection] = [...state.list[key][subSection]];
                            }
                            else {
                                newsState['list'][key][subSection] = [{ ...state.list[key][subSection] }];
                            }
                        }
                    });
                }
            });
        }
        if (!newsState['list'][staticDataType]) {
            newsState['list'][staticDataType] = { [storeSubSection]: {} };
        }
        if (keepState && state.list[staticDataType]?.[storeSubSection]) {
            let currentList = [...state.list[staticDataType][storeSubSection]];
            const newIds = data.map(item => item.id);
            if (currentList?.length) {
                currentList = currentList.filter(listItem => !newIds.includes(listItem.id));
            }
            newsState['list'][staticDataType][storeSubSection] = Array.isArray(data) ? [...currentList, ...data] : [];
        }
        else {
            newsState['list'][staticDataType][storeSubSection] = Array.isArray(data) ? [...data] : [];
        }
        newsState['meta'][staticDataType] = {
            ...newsState['meta']?.[staticDataType],
            [storeSubSection]: {
                ...newsState['meta']?.[staticDataType]?.[storeSubSection],
                page: meta?.page,
                perPage: meta?.perPage,
                totalCount: meta?.totalCount,
                status: StaticDataMetaStatus$1.LOADED
            }
        };
        return {
            ...newsState,
            meta: {
                ...newsState['meta']
            }
        };
    }
    return {
        ...state
    };
}), on(StaticDataDeleteSuccess, (state, action) => {
    const { contentType, itemId } = action.payload;
    return {
        ...state,
        list: {
            ...state.list,
            [contentType]: {
                list: state.list[contentType].list.filter(item => item.id !== Number(itemId))
            }
        },
        meta: {
            ...state.meta,
            [contentType]: {
                ...state.meta[contentType],
                list: {
                    status: StaticDataMetaStatus$1.LOADED
                }
            }
        }
    };
}), on(StaticDataCreate, (state, action) => {
    const { contentType } = action.payload;
    const key = `${contentType}-new`;
    return {
        ...state,
        meta: {
            ...state.meta,
            [key]: {
                ...state.meta[key],
                list: {
                    status: StaticDataMetaStatus$1.LOADING
                }
            }
        }
    };
}), on(StaticDataPartUpdate, (state, action) => {
    const { subeEntity, id, updates } = action.payload;
    const newState = {
        ...state,
        list: {
            ...state.list,
            [subeEntity]: {
                ...state.list[subeEntity],
                list: [...state.list[subeEntity].list]
            }
        }
    };
    if (newState.list?.[subeEntity]?.list) {
        newState.list[subeEntity].list = newState.list[subeEntity].list.map(item => {
            const newItem = { ...item };
            if (newItem.id === id) {
                Object.keys(updates).forEach(field => {
                    newItem[field] = updates[field];
                });
            }
            return newItem;
        });
    }
    return newState;
}), on(StaticDataCreateFail, (state, action) => {
    const { contentType, error } = action.payload;
    const key = getFormKey$1(contentType);
    return {
        ...state,
        meta: {
            ...state.meta,
            [key]: {
                ...state.meta[key],
                list: {
                    status: StaticDataMetaStatus$1.LOADED, error
                }
            }
        }
    };
}), on(StaticDataCreateSuccess, (state, action) => {
    const { contentType, itemId, data } = action.payload;
    const keyOld = getFormKey$1(contentType);
    const key = getFormKey$1(contentType, itemId);
    return {
        ...state,
        list: {
            ...state.list,
            [contentType]: {
                list: [...(state.list?.[contentType]?.list || []), data]
            }
        },
        meta: {
            ...state.meta,
            [keyOld]: {
                ...state.meta[key],
                list: { status: StaticDataMetaStatus$1.LOADED }
            },
            [key]: {
                ...state.meta[key],
                list: { status: StaticDataMetaStatus$1.LOADED }
            }
        }
    };
}), on(StaticDataUpdate, (state, action) => {
    const { contentType, itemId } = action.payload;
    const key = getFormKey$1(contentType, itemId);
    return {
        ...state,
        meta: {
            ...state.meta,
            [key]: {
                ...state.meta[key],
                list: { status: StaticDataMetaStatus$1.LOADED }
            }
        }
    };
}), on(StaticDataUpdateFail, (state, action) => {
    const { contentType, itemId, error } = action.payload;
    const key = getFormKey$1(contentType, itemId);
    return {
        ...state,
        meta: {
            ...state.meta,
            [key]: {
                ...state.meta[key],
                list: { status: StaticDataMetaStatus$1.LOADED, error }
            }
        }
    };
}), on(StaticDataUpdateSuccess, (state, action) => {
    const { contentType, itemId, data } = action.payload;
    const key = getFormKey$1(contentType, itemId);
    const newList = state.list[contentType]?.list?.filter(item => item.id !== Number(itemId)) || [];
    return {
        ...state,
        list: {
            ...state.list,
            [contentType]: { list: [...newList, data] }
        },
        meta: {
            ...state.meta,
            [key]: {
                ...state.meta[key],
                list: { status: StaticDataMetaStatus$1.LOADED }
            }
        }
    };
}), on(StaticDataPatchUpdateSuccess, (state, action) => {
    const { contentType, itemId, data } = action.payload;
    const key = getFormKey$1(contentType, itemId);
    const newList = state.list[contentType]?.list?.map(item => {
        let newItem = { ...item };
        if (newItem.id === Number(itemId)) {
            newItem = { ...newItem, ...data };
        }
        return { ...newItem };
    }) || [];
    return {
        ...state,
        list: {
            ...state.list,
            [contentType]: { list: [...newList, data] }
        },
        meta: {
            ...state.meta,
            [key]: {
                ...state.meta[key],
                list: { status: StaticDataMetaStatus$1.LOADED }
            }
        }
    };
}), on(StaticDataGetListCategories, (state, action) => {
    const { contentTypes } = action.payload;
    const newState = {
        ...state,
        meta: {
            ...state.meta
        }
    };
    contentTypes.forEach(contentType => {
        const contentTypesParams = contentType.split('(');
        const clearContentType = contentTypesParams[0] || contentType;
        newState.meta[clearContentType] = {
            ...newState.meta[contentType],
            list: {
                ...newState.meta[contentType]?.['list'] || [],
                status: StaticDataMetaStatus$1.LOADING
            }
        };
    });
    return newState;
}), on(StaticDataGetListCategoriesFail, (state, action) => {
    const { contentTypes } = action.payload;
    const newState = {
        ...state,
        meta: {
            ...state.meta
        }
    };
    contentTypes.forEach(contentType => {
        newState.meta[contentType] = {
            ...newState[contentType],
            list: {
                ...newState[contentType].list,
                status: StaticDataMetaStatus$1.LOADED
            }
        };
    });
    return newState;
}), on(StaticDataGetListCategoriesSuccess, (state, action) => {
    const { data } = action.payload;
    let newState = {
        ...state,
        list: { ...state.list },
        meta: {
            ...state.meta
        }
    };
    Object.keys(data).forEach(contentType => {
        newState.list[contentType] = { list: [...data[contentType]] };
        newState.meta[contentType] = {
            ...newState.meta[contentType],
            list: {
                ...newState.meta[contentType]['list'],
                status: StaticDataMetaStatus$1.LOADED
            }
        };
    });
    return newState;
}), on(StaticDataNewRevisions, (state, action) => {
    const { data } = action.payload;
    const newState = {
        list: { ...state.list },
        meta: { ...state.meta }
    };
    const newDataKeys = data.map(item => item.staticDataKey);
    if (data?.length) {
        if (!newState.list?.revisions) {
            newState.list['revisions'] = { list: [] };
        }
        else {
            if (newState.list['revisions']?.list) {
                const newList = newState.list['revisions'].list
                    .filter(item => !newDataKeys.includes(item.staticDataKey));
                if (newList) {
                    newState.list['revisions'] = { list: [...newList] };
                }
            }
        }
        data.forEach(item => {
            const contentType = item.staticDataKey;
            newState.list['revisions'].list.push({
                slug: contentType,
                staticDataKey: contentType,
                revision: item.revision
            });
        });
    }
    return newState;
}));
function staticDataReducer(state, action) {
    return _staticDataReducer$2(state, action);
}
function getFormKey$1(contentType, itemId) {
    return `${contentType}-${itemId || '*'}`;
}

const getStaticDataState = createFeatureSelector(STATIC_DATA_FEATURE_KEY$1);
const getStatus$1 = (contentType, subSection) => createSelector(getStaticDataState, (state) => state?.meta?.[contentType]?.[subSection]?.status);
const getLoaded$1 = (contentType, subSection) => createSelector(getStaticDataState, (state) => state?.meta?.[contentType]?.[subSection]?.status === StaticDataMetaStatus$1.LOADED);
const getError$1 = (contentType) => createSelector(getStaticDataState, (state) => state?.meta?.[contentType]?.error);
const getStaticDataMeta = (contentType, subSection) => createSelector(getStaticDataState, (state) => {
    return state.meta?.[contentType]?.[subSection];
});
const getStaticDataRevisions = () => createSelector(getStaticDataState, (state) => {
    let result = [];
    if (state.list['revisions']?.['list']) {
        result = state.list['revisions']?.['list'];
    }
    return result;
});
const getStaticDataRevision = (contentType) => createSelector(getStaticDataState, (state) => {
    let result = null;
    if (state.list?.revisions?.list) {
        result = state.list?.revisions?.list.find(item => item.slug === contentType);
    }
    return result;
});
const getStaticDataRevisionsList = (contentTypes) => createSelector(getStaticDataState, (state) => {
    const preparedContentTypes = contentTypes.map(item => {
        const itemParameters = item.split('(');
        return itemParameters[0];
    });
    let result = null;
    if (state.list?.revisions?.list) {
        result = state.list?.revisions?.list.filter(item => preparedContentTypes.includes(item.slug));
    }
    return result;
});
const getStaticData = (contentType, subSection, where) => createSelector(getStaticDataState, getLoaded$1(contentType, subSection), (state, isLoaded) => {
    let list = isLoaded ? state.list[contentType]?.[subSection] : null;
    if (where && list?.length) {
        list = list.filter(item => {
            let result = true;
            Object.keys(where)
                .forEach(whereItem => {
                if (!Array.isArray(item[whereItem])) {
                    const fieldValue = item[whereItem];
                    if (!Array.isArray(where[whereItem])) {
                        result = fieldValue === where[whereItem];
                    }
                    else {
                        const whereValues = where[whereItem];
                        result = !!whereValues.includes(fieldValue);
                    }
                }
                else {
                    // item[whereItem] is Array
                    if (!Array.isArray(where[whereItem])) {
                        result = item[whereItem].includes(where[whereItem]);
                    }
                    else {
                        result = where[whereItem].some(subItem => item[whereItem].includes(subItem));
                    }
                }
            });
            return result;
        });
    }
    return list;
});
const getStaticDataForListContentTypes = (contentTypes) => createSelector(getStaticDataState, (state) => {
    let result = {};
    contentTypes.forEach(contentType => {
        result[contentType] = state.list[contentType]?.list || [];
    });
    return result;
});
const getStaticDataItem = (contentType, subSection, itemIdOrSlug) => createSelector(getStaticDataState, (state) => {
    const foundItem = state.list[contentType]?.[subSection]?.find(item => {
        return Number(item.id) === Number(itemIdOrSlug) || item?.slug === itemIdOrSlug || item?.slug + '.html' === itemIdOrSlug;
    }); //
    return foundItem || {};
});
const staticDataQuery = {
    getStatus: getStatus$1,
    getLoaded: getLoaded$1,
    getError: getError$1,
    getStaticData,
    getStaticDataItem,
    getStaticDataMeta,
    getStaticDataForListContentTypes,
    getStaticDataRevision,
    getStaticDataRevisions,
    getStaticDataRevisionsList
};

class StaticDataFacade {
    constructor(store) {
        this.store = store;
    }
    getStatus$(contentType, subSection = 'list') {
        return this.store.pipe(select(staticDataQuery.getStatus(contentType, subSection)));
    }
    getStaticDataMeta$(contentType, subSection = 'list') {
        return this.store.pipe(select(staticDataQuery.getStaticDataMeta(contentType, subSection)));
    }
    getStaticData$(contentType, subSection = 'list', options, where) {
        return this.store.pipe(select(staticDataQuery.getStaticData(contentType, subSection, where)));
    }
    getStaticDataForListContentTypes$(contentTypes) {
        return this.store.pipe(select(staticDataQuery.getStaticDataForListContentTypes(contentTypes)));
    }
    getStaticDataItem$(contentType, subSection = 'list', itemIdOrSlug) {
        return this.store.pipe(select(staticDataQuery.getStaticDataItem(contentType, subSection, itemIdOrSlug)));
    }
    getStaticDataRevision(contentType) {
        return new Promise((resolve, reject) => {
            if (!contentType) {
                return resolve(null);
            }
            this.store.pipe(select(staticDataQuery.getStaticDataRevision(contentType)))
                .pipe(take(1))
                .subscribe(revisionData => {
                resolve(revisionData?.revision || null);
            });
        });
    }
    getStaticDataRevisions(contentTypes) {
        return new Promise((resolve, reject) => {
            if (!contentTypes?.length) {
                return resolve(null);
            }
            this.store.pipe(select(staticDataQuery.getStaticDataRevisionsList(contentTypes)))
                .pipe(take(1))
                .subscribe(revisions => {
                if (revisions?.length) {
                    const revisionList = revisions.map(item => item.revision);
                    resolve(revisionList || null);
                }
                else {
                    resolve(null);
                }
            });
        });
    }
    loadStaticData(contentType, params, subSection = 'list') {
        const { where, fields, paging, sort, forPanel, search, keepState } = params;
        this.getStaticDataRevision(contentType)
            .then(revision => {
            this.store.dispatch(StaticDataGetList({
                payload: {
                    contentType,
                    subSection,
                    where,
                    fields,
                    paging,
                    sort,
                    forPanel,
                    search,
                    keepState,
                    revision
                }
            }));
        });
    }
    loadStaticDataSubRouting(contentType, routing, data) {
        this.store.dispatch(StaticDataGetSubRouting({
            payload: {
                contentType,
                routing,
                data
            }
        }));
    }
    loadStaticDataRevisions() {
        this.store.dispatch(StaticDataLoadRevisions({
            payload: null
        }));
    }
    clearStaticData(contentType) {
        return this.store.dispatch(ClearStaticData({ payload: { contentType } }));
    }
    delete(contentType, itemId) {
        this.store.dispatch(StaticDataDelete({
            payload: {
                contentType,
                itemId
            }
        }));
    }
    newRevisions(newRevisions) {
        this.store.dispatch(StaticDataNewRevisions({
            payload: { data: newRevisions }
        }));
    }
    create(formId, contentType, data, publicApi = false) {
        this.store.dispatch(StaticDataCreate({
            payload: {
                formId,
                contentType,
                data,
                publicApi
            }
        }));
    }
    update(formId, contentType, itemId, data, publicApi = false) {
        this.store.dispatch(StaticDataUpdate({
            payload: {
                formId,
                contentType,
                itemId,
                data,
                publicApi
            }
        }));
    }
    updateSuccess(contentType, itemId, data) {
        this.store.dispatch(StaticDataUpdateSuccess({
            payload: {
                contentType,
                itemId,
                data
            }
        }));
    }
    patchUpdate(formId, contentType, itemId, data, publicApi = false) {
        this.store.dispatch(StaticDataPatchUpdate({
            payload: {
                formId,
                contentType,
                itemId,
                data,
                publicApi
            }
        }));
    }
    staticDataLoadCategories(contentTypes) {
        this.getStaticDataRevisions(contentTypes)
            .then(revisions => {
            this.store.dispatch(StaticDataGetListCategories({
                payload: {
                    contentTypes,
                    revisions
                }
            }));
        });
    }
}
StaticDataFacade.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "15.2.9", ngImport: i0, type: StaticDataFacade, deps: [{ token: i1.Store }], target: i0.ɵɵFactoryTarget.Injectable });
StaticDataFacade.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "15.2.9", ngImport: i0, type: StaticDataFacade, providedIn: 'root' });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "15.2.9", ngImport: i0, type: StaticDataFacade, decorators: [{
            type: Injectable,
            args: [{ providedIn: 'root' }]
        }], ctorParameters: function () { return [{ type: i1.Store }]; } });

var WebsocketMessageTypes;
(function (WebsocketMessageTypes) {
    WebsocketMessageTypes["USER_ACTIVITY"] = "user-activity";
    WebsocketMessageTypes["ERRORS"] = "errors";
})(WebsocketMessageTypes || (WebsocketMessageTypes = {}));
var WebsocketMessageSubTypes;
(function (WebsocketMessageSubTypes) {
    WebsocketMessageSubTypes["CHANGE_PAGE"] = "change-page";
    WebsocketMessageSubTypes["OPEN_BOOKING_FORM"] = "open-booking-form";
    WebsocketMessageSubTypes["OPEN_FIRM_CONTACT"] = "open-firm-contact";
    WebsocketMessageSubTypes["SELECT_TOUR_CRITERIA"] = "select-tour-criteria";
    WebsocketMessageSubTypes["TOUR_VIEW"] = "tour-view";
    WebsocketMessageSubTypes["TOURS_VIEW"] = "tours-view";
    WebsocketMessageSubTypes["FIRM_VIEW"] = "firm-view";
    WebsocketMessageSubTypes["FIRMS_VIEW"] = "firms-view";
    WebsocketMessageSubTypes["INFO_VIEW"] = "info-view";
    WebsocketMessageSubTypes["INFOS_VIEW"] = "infos-view";
    WebsocketMessageSubTypes["DESTINATION_VIEW"] = "destination-view";
    WebsocketMessageSubTypes["DESTINATIONS_VIEW"] = "destinations-view";
    WebsocketMessageSubTypes["TAG_VIEW"] = "tag-view";
})(WebsocketMessageSubTypes || (WebsocketMessageSubTypes = {}));
;
class WebsocketService {
    constructor(config, 
    // @Inject(PLATFORM_ID) platformId: Object,
    staticDataFacade, cookieService) {
        this.config = config;
        this.staticDataFacade = staticDataFacade;
        this.cookieService = cookieService;
        this.wsIsLoaded = false;
        this.maxNumbersOfReloads = 10;
        this.numbersOfReloads = 0;
        this.messageQueue = [];
        this.storageKey = 'wt-user-key';
        // this.isBrowser = isPlatformBrowser(platformId);
        this.connectToWebSocket();
        this.sendMessageFromQueueTimer();
    }
    connectToWebSocket() {
        // if (this.isBrowser) {
        this.ws = new WebSocket(this.config.websocketUrl);
        const storageData = this.getUserKey();
        this.ws.onopen = () => {
            this.numbersOfReloads = 0;
            console.info('[ WS ][ Connection opened ]', this.sessionKey || '', this.config.websocketUrl);
        };
        this.ws.onmessage = (event) => {
            let message;
            try {
                message = JSON.parse(event.data);
            }
            catch (e) {
                console.error('[ WS ][ Incorrect message ]', { message: event.data, error: e });
            }
            if (message?.revisions) {
                console.info('[ WS ][ New revisions ]', message.revisions);
                this.staticDataFacade.newRevisions(message.revisions);
            }
            if (message && !this.sessionKey) {
                if (message?.sessionKey) {
                    this.sessionKey = storageData?.sessionKey || message.sessionKey;
                    this.cookieKey = storageData?.cookieKey || message.sessionKey;
                    if (!storageData?.sessionKey) {
                        this.setUserKey(this.sessionKey);
                    }
                }
                console.info('[ WS ][ First message received ]', this.sessionKey, message);
            }
        };
        this.ws.onclose = () => {
            console.info('[ WS ][ Connection closed ]');
            this.wsIsLoaded = false;
            setTimeout(() => {
                if (this.numbersOfReloads < this.maxNumbersOfReloads) {
                    this.numbersOfReloads++;
                    this.connectToWebSocket();
                }
            }, 10000);
        };
        //}
    }
    getUserKey() {
        const storageValue = this.cookieService.get(this.storageKey);
        if (storageValue) {
            const storageData = JSON.parse(storageValue);
            const newDate = new Date().toISOString();
            const nowDateString = newDate.substring(0, 10);
            const storageDateString = storageData.date.substring(0, 10);
            return {
                sessionKey: nowDateString === storageDateString ? storageData.sessionKey : null,
                cookieKey: storageData.cookieKey,
                date: storageData.date
            };
        }
        return null;
    }
    setUserKey(sessionKey) {
        const storageValue = this.cookieService.get(this.storageKey);
        const storageData = storageValue ? JSON.parse(storageValue) : {};
        this.cookieService.set(this.storageKey, JSON.stringify({
            sessionKey: sessionKey,
            cookieKey: storageData.cookieKey || sessionKey,
            date: new Date()
        }), 365);
    }
    sendMessageFromQueueTimer() {
        this.messageTimer = setInterval(() => {
            this.sendMessageFromQueue();
        }, 50);
    }
    sendMessageFromQueue() {
        if (this.sessionKey && this.cookieKey) {
            if (this.messageQueue?.length) {
                this.messageQueue.forEach((messageItem) => {
                    this.ws.send(JSON.stringify({ ...messageItem, sessionKey: this.sessionKey, cookieKey: this.cookieKey }));
                });
                this.messageQueue = [];
            }
            clearInterval(this.messageTimer);
        }
    }
    wsSentMessage(type, subType = null, message) {
        const messageObj = {
            type,
            subType,
            message,
            sessionKey: this.sessionKey,
            cookieKey: this.cookieKey
        };
        if (this.sessionKey && this.cookieKey) {
            this.ws.send(JSON.stringify(messageObj));
        }
        else {
            this.messageQueue.push(messageObj);
        }
    }
}
WebsocketService.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "15.2.9", ngImport: i0, type: WebsocketService, deps: [{ token: CORE_CONFIG }, { token: StaticDataFacade }, { token: i2$1.CookieService }], target: i0.ɵɵFactoryTarget.Injectable });
WebsocketService.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "15.2.9", ngImport: i0, type: WebsocketService, providedIn: 'root' });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "15.2.9", ngImport: i0, type: WebsocketService, decorators: [{
            type: Injectable,
            args: [{
                    providedIn: 'root'
                }]
        }], ctorParameters: function () { return [{ type: undefined, decorators: [{
                    type: Inject,
                    args: [CORE_CONFIG]
                }] }, { type: StaticDataFacade }, { type: i2$1.CookieService }]; } });

class SeoService {
    constructor(titleService, metaService) {
        this.titleService = titleService;
        this.metaService = metaService;
    }
    updateTitle(title) {
        this.titleService.setTitle(title);
    }
    updateDescription(description) {
        this.metaService.updateTag({ name: 'description', content: description });
    }
}
SeoService.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "15.2.9", ngImport: i0, type: SeoService, deps: [{ token: i1$5.Title }, { token: i1$5.Meta }], target: i0.ɵɵFactoryTarget.Injectable });
SeoService.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "15.2.9", ngImport: i0, type: SeoService, providedIn: 'root' });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "15.2.9", ngImport: i0, type: SeoService, decorators: [{
            type: Injectable,
            args: [{
                    providedIn: 'root'
                }]
        }], ctorParameters: function () { return [{ type: i1$5.Title }, { type: i1$5.Meta }]; } });

class RouterFacade {
    constructor(store) {
        this.store = store;
    }
    goTo(path, extras = null) {
        console.info('[ router.facade.navigation ]', path, extras);
        return this.store.dispatch(Go({ payload: { path, extras } }));
    }
}
RouterFacade.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "15.2.9", ngImport: i0, type: RouterFacade, deps: [{ token: i1.Store }], target: i0.ɵɵFactoryTarget.Injectable });
RouterFacade.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "15.2.9", ngImport: i0, type: RouterFacade, providedIn: "root" });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "15.2.9", ngImport: i0, type: RouterFacade, decorators: [{
            type: Injectable,
            args: [{ providedIn: "root" }]
        }], ctorParameters: function () { return [{ type: i1.Store }]; } });

class StaticDataEffects extends BaseEffects {
    constructor(actions$, store, authenticationService, staticDataService, routerService, notificationsFacade) {
        super(actions$, store);
        this.actions$ = actions$;
        this.store = store;
        this.authenticationService = authenticationService;
        this.staticDataService = staticDataService;
        this.routerService = routerService;
        this.notificationsFacade = notificationsFacade;
        this.staticDataLoadRevision$ = createEffect(() => this.actions$.pipe(ofType(StaticDataLoadRevisions), mergeMap((action) => {
            const headers = this.authenticationService.loadAuthDataFromLocalStore();
            const config = {
                headers: { token: headers.token, uid: headers.id },
            };
            return this.staticDataService.loadRevision(config)
                .pipe(flatMap((r) => new StaticDataGetListBehavior(action, r).resolve()));
        })));
        this.staticDataGetList$ = createEffect(() => this.actions$.pipe(ofType(StaticDataGetList), mergeMap((action) => {
            const headers = this.authenticationService.loadAuthDataFromLocalStore();
            const config = {
                ...action.payload,
                headers: { token: headers.token, uid: headers.id },
                contentType: action.payload.contentType,
            };
            return this.staticDataService.getList(config)
                .pipe(flatMap((r) => new StaticDataGetListBehavior(action, r).resolve()));
        })));
        this.staticDataGetSubRouting$ = createEffect(() => this.actions$.pipe(ofType(StaticDataGetSubRouting), mergeMap((action) => {
            const headers = this.authenticationService.loadAuthDataFromLocalStore();
            const config = {
                ...action.payload,
                headers: { token: headers.token, uid: headers.id },
                contentType: action.payload.contentType,
                routing: action.payload.routing,
            };
            return this.staticDataService.getSubRouting(config)
                .pipe(flatMap((r) => new StaticDataGetListBehavior(action, r).resolve()));
        })));
        this.staticDataDelete$ = createEffect(() => this.actions$.pipe(ofType(StaticDataDelete), switchMap$1((action) => {
            const headers = this.authenticationService.loadAuthDataFromLocalStore();
            const config = {
                ...action.payload,
                headers: { token: headers.token, uid: headers.id },
                contentType: action.payload.contentType,
                itemId: action.payload.itemId,
            };
            return this.staticDataService.delete(config)
                .pipe(flatMap((r) => new StaticDataDeleteBehavior(action, r).resolve()));
        })));
        /*  @Effect({dispatch: false})
          StaticDataDeleteSuccess$ = this.actions$.pipe(
            ofType(StaticDataDeleteSuccess),
            tap((action) => {
              const {contentType, itemId} = action.payload;
              this.routerService.goTo(['/static-data', contentType]);
              this.notificationsFacade.addNotifications({
                id: `form-message-delete-${contentType}-${itemId}`,
                type: 'success',
                text: MESSAGES.delete.text,
                title: MESSAGES.delete.title,
                timeout: NOTIFICATION_TIMEOUT
              });
            })
          );*/
        this.staticDataCreate$ = createEffect(() => this.actions$.pipe(ofType(StaticDataCreate), switchMap$1((action) => {
            const headers = this.authenticationService.loadAuthDataFromLocalStore();
            const config = {
                ...action.payload,
                headers: { token: headers.token, uid: headers.id },
                formId: action.payload.formId,
                contentType: action.payload.contentType,
                publicApi: action.payload.publicApi,
            };
            return this.staticDataService.create(config)
                .pipe(flatMap((r) => new StaticDataCreateBehavior(action, r).resolve()));
        })));
        /*  @Effect({dispatch: false})
          staticDataCreateSuccess$ = this.actions$.pipe(
            ofType(StaticDataCreateSuccess),
            tap((action) => {
              const {contentType, itemId} = action.payload;
              this.routerService.goTo(['/static-data', contentType, itemId]);
              this.notificationsFacade.addNotifications({
                id: `form-message-create-${contentType}-${itemId}`,
                type: 'success',
                text: MESSAGES.create.text,
                title: MESSAGES.create.title,
                timeout: NOTIFICATION_TIMEOUT
              });
            })
          );*/
        this.staticDataUpdate$ = createEffect(() => this.actions$.pipe(ofType(StaticDataUpdate), switchMap$1((action) => {
            const headers = this.authenticationService.loadAuthDataFromLocalStore();
            const config = {
                ...action.payload,
                headers: { token: headers.token, uid: headers.id },
                formId: action.payload.formId,
                contentType: action.payload.contentType,
                itemId: action.payload.itemId,
            };
            return this.staticDataService.update(config)
                .pipe(flatMap((r) => new StaticDataUpdateBehavior(action, r).resolve()));
        })));
        this.staticDataPatchUpdate$ = createEffect(() => this.actions$.pipe(ofType(StaticDataPatchUpdate), switchMap$1((action) => {
            const headers = this.authenticationService.loadAuthDataFromLocalStore();
            const config = {
                ...action.payload,
                headers: { token: headers.token, uid: headers.id },
                formId: action.payload.formId,
                contentType: action.payload.contentType,
                itemId: action.payload.itemId,
            };
            return this.staticDataService.patchUpdate(config)
                .pipe(flatMap((r) => new StaticDataPatchUpdateBehavior(action, r).resolve()));
        })));
        this.staticDataGetListCategories$ = createEffect(() => this.actions$.pipe(ofType(StaticDataGetListCategories), switchMap$1((action) => {
            const { contentTypes, revisions } = action.payload;
            const config = {
                contentTypes,
                revisions
            };
            return this.staticDataService.getListCategories(config)
                .pipe(flatMap((r) => new StaticDataGetListCategoriesBehavior(action, r).resolve()), catchError(error => of(StaticDataGetListCategoriesFail({
                payload: {
                    contentTypes: action.payload.contentTypes,
                }
            }))));
        })));
    }
}
StaticDataEffects.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "15.2.9", ngImport: i0, type: StaticDataEffects, deps: [{ token: i1$2.Actions }, { token: i1.Store }, { token: AuthenticationService }, { token: StaticDataService }, { token: RouterFacade }, { token: NotificationsFacade }], target: i0.ɵɵFactoryTarget.Injectable });
StaticDataEffects.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "15.2.9", ngImport: i0, type: StaticDataEffects });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "15.2.9", ngImport: i0, type: StaticDataEffects, decorators: [{
            type: Injectable
        }], ctorParameters: function () { return [{ type: i1$2.Actions }, { type: i1.Store }, { type: AuthenticationService }, { type: StaticDataService }, { type: RouterFacade }, { type: NotificationsFacade }]; } });

const ActionsSend = createAction('[Actions] Actions Create', props());
const ActionsSendSuccess = createAction('[Actions] Actions Create Success', props());
const ActionsSendFail = createAction('[Actions] Actions Create Error', props());

class ActionsSendBehavior extends Behavior {
    constructor(action, result) {
        super(action);
        this.action = action;
        this.result = result;
    }
    resolve() {
        const status = this.result.data.status;
        let returnedActions;
        const response = this.result.data;
        const { data } = response.body;
        switch (status) {
            case ResponseStatus.STATUS_200: {
                returnedActions = [
                    ActionsSendSuccess({ payload: { ...data } })
                ];
                break;
            }
            default: {
                returnedActions = [
                    ActionsSendFail({
                        payload: {
                            error: 'Unhandled error',
                            action: data.action,
                            actionId: data.actionId,
                        }
                    })
                ];
            }
        }
        return [...returnedActions];
    }
}

class ActionsEffects extends BaseEffects {
    /* @Effect({dispatch: false})
     actionsSendSuccess$ = this.actions$.pipe(
       ofType(ActionsSendSuccess),
       tap((action) => {
         // const {contentType, itemId} = action.payload;
         /!*      this.notificationsFacade.addNotifications({
                 id: `form-message-delete-${contentType}-${itemId}`,
                 type: 'success',
                 text: MESSAGES.delete.text,
                 title: MESSAGES.delete.title,
                 timeout: NOTIFICATION_TIMEOUT
               });*!/
       })
     );
   */
    constructor(actions$, store, authenticationService, actionsService) {
        super(actions$, store);
        this.actions$ = actions$;
        this.store = store;
        this.authenticationService = authenticationService;
        this.actionsService = actionsService;
        this.actionsSend$ = createEffect(() => this.actions$.pipe(ofType(ActionsSend), mergeMap((action) => {
            const headers = this.authenticationService.loadAuthDataFromLocalStore();
            const config = {
                ...action.payload,
                headers: { token: headers.token, uid: headers.id }
            };
            return this.actionsService.sendAction(config)
                .pipe(flatMap((r) => new ActionsSendBehavior(action, r).resolve()));
        })));
    }
}
ActionsEffects.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "15.2.9", ngImport: i0, type: ActionsEffects, deps: [{ token: i1$2.Actions }, { token: i1.Store }, { token: AuthenticationService }, { token: ActionsService }], target: i0.ɵɵFactoryTarget.Injectable });
ActionsEffects.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "15.2.9", ngImport: i0, type: ActionsEffects });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "15.2.9", ngImport: i0, type: ActionsEffects, decorators: [{
            type: Injectable
        }], ctorParameters: function () { return [{ type: i1$2.Actions }, { type: i1.Store }, { type: AuthenticationService }, { type: ActionsService }]; } });

var ActionsMetaStatus;
(function (ActionsMetaStatus) {
    ActionsMetaStatus["LOADING"] = "loading";
    ActionsMetaStatus["SUCCESS"] = "success";
    ActionsMetaStatus["FAIL"] = "fail";
})(ActionsMetaStatus || (ActionsMetaStatus = {}));

const STATIC_DATA_FEATURE_KEY = 'actions';
const initialState$2 = {
    list: {},
    meta: {}
};
const _actionsReducer = createReducer(initialState$2, on(ActionsSend, (state, actionIn) => {
    const { action, actionId, data } = actionIn.payload;
    const key = `${action}-${actionId}`;
    return {
        ...state,
        list: {
            ...state.list,
            [key]: { action, actionId, data },
        },
        meta: {
            ...state.meta,
            [key]: {
                ...state.meta[key],
                status: ActionsMetaStatus.LOADING
            }
        }
    };
}), on(ActionsSendFail, (state, actionIn) => {
    const { action, actionId, error } = actionIn.payload;
    const key = `${action}-${actionId}`;
    return {
        ...state,
        meta: {
            ...state.meta,
            [key]: {
                ...state.meta[key],
                status: ActionsMetaStatus.FAIL,
                error
            }
        }
    };
}), on(ActionsSendSuccess, (state, actionIn) => {
    const { action, actionId, data } = actionIn.payload;
    const key = `${action}-${actionId}`;
    return {
        ...state,
        meta: {
            ...state.meta,
            [key]: {
                ...state.meta[key],
                status: ActionsMetaStatus.SUCCESS
            }
        }
    };
}));
function actionsReducer(state, action) {
    return _actionsReducer(state, action);
}
function getFormKey(contentType, itemId) {
    return `${contentType}-${itemId || '*'}`;
}

const CacheDataGet = createAction('[CacheData] Get CacheData', props());
const CacheDataGetSuccess = createAction('[CacheData] Get CacheData Success', props());
const CacheDataGetFail = createAction('[CacheData] Get CacheData Fail', props());

class CacheDataGetBehavior extends Behavior {
    constructor(action, result) {
        super(action);
        this.action = action;
        this.result = result;
    }
    resolve() {
        const status = this.result.data.status;
        let returnedActions;
        switch (status) {
            case ResponseStatus.STATUS_200: {
                const response = this.result.data;
                const { data, meta } = response.body;
                returnedActions = [
                    CacheDataGetSuccess({ payload: { data, type: meta.contentType } })
                ];
                break;
            }
            case ResponseStatus.STATUS_400:
            case ResponseStatus.STATUS_404:
            case ResponseStatus.STATUS_422:
            case ResponseStatus.STATUS_401:
                const errorResponse = this.result.data;
                const error = errorResponse.body.errors[0].title;
                returnedActions = [
                    CacheDataGetFail({ payload: { error } })
                ];
                break;
            default: {
                returnedActions = [
                    CacheDataGetFail({ payload: { error: 'Unhandled error' } })
                ];
            }
        }
        return [...returnedActions];
    }
}

class CacheDataEffects extends BaseEffects {
    constructor(actions$, store, authenticationService, cacheDataService) {
        super(actions$, store);
        this.actions$ = actions$;
        this.store = store;
        this.authenticationService = authenticationService;
        this.cacheDataService = cacheDataService;
        this.cacheDataGet$ = createEffect(() => this.actions$.pipe(ofType(CacheDataGet), mergeMap((action) => {
            const headers = this.authenticationService.loadAuthDataFromLocalStore();
            const config = {
                ...action.payload,
                headers: { token: headers.token, uid: headers.id },
                type: action.payload.type,
            };
            return this.cacheDataService.getCacheData(config)
                .pipe(flatMap((r) => new CacheDataGetBehavior(action, r).resolve()));
        })));
    }
}
CacheDataEffects.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "15.2.9", ngImport: i0, type: CacheDataEffects, deps: [{ token: i1$2.Actions }, { token: i1.Store }, { token: AuthenticationService }, { token: CacheDataService }], target: i0.ɵɵFactoryTarget.Injectable });
CacheDataEffects.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "15.2.9", ngImport: i0, type: CacheDataEffects });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "15.2.9", ngImport: i0, type: CacheDataEffects, decorators: [{
            type: Injectable
        }], ctorParameters: function () { return [{ type: i1$2.Actions }, { type: i1.Store }, { type: AuthenticationService }, { type: CacheDataService }]; } });

const CACHE_DATA_FEATURE_KEY = 'cacheData';
const initialState$1 = {};
const _staticDataReducer$1 = createReducer(initialState$1, on(CacheDataGetSuccess, (state, action) => {
    const { type, data } = action.payload;
    if (type) {
        return {
            ...state,
            [type]: {
                ...data
            }
        };
    }
    else {
        return { ...state };
    }
}));
function cacheDataReducer(state, action) {
    return _staticDataReducer$1(state, action);
}

const ReportsEntitiesGet = createAction('[Reports] Get Reports Entities', props());
const ReportsEntitiesGetSuccess = createAction('[Reports] Get Reports Entities Success', props());
const ReportsEntitiesGetFail = createAction('[Reports] Get Reports Entities Fail', props());
const UserBehaviorReportGet = createAction('[Reports] Get User Behaviors Entities', props());
const UserBehaviorReportSuccess = createAction('[Reports] Get User Behaviors Entities Success', props());
const UserBehaviorReportFail = createAction('[Reports] Get User Behaviors Entities Fail', props());

const REPORTS_FEATURE_KEY = 'reports';
const initialState = {};
const _staticDataReducer = createReducer(initialState, on(ReportsEntitiesGetSuccess, (state, action) => {
    const { type, data } = action.payload;
    if (type) {
        return {
            ...state,
            [type]: {
                ...data
            }
        };
    }
    else {
        return { ...state };
    }
}), on(UserBehaviorReportSuccess, (state, action) => {
    const { type, data } = action.payload;
    if (type) {
        return {
            ...state,
            [type]: {
                ...data
            }
        };
    }
    else {
        return { ...state };
    }
}));
function reportsReducer(state, action) {
    return _staticDataReducer(state, action);
}

class ReportsEntitiesDataBehavior extends Behavior {
    constructor(action, result) {
        super(action);
        this.action = action;
        this.result = result;
    }
    resolve() {
        const status = this.result.data.status;
        let returnedActions;
        switch (status) {
            case ResponseStatus.STATUS_200: {
                const response = this.result.data;
                const { data } = response.body;
                returnedActions = [
                    ReportsEntitiesGetSuccess({
                        payload: {
                            data: data.result,
                            type: data.type
                        }
                    })
                ];
                break;
            }
            case ResponseStatus.STATUS_400:
            case ResponseStatus.STATUS_404:
            case ResponseStatus.STATUS_422:
            case ResponseStatus.STATUS_401:
                const errorResponse = this.result.data;
                const error = errorResponse.body.errors[0].title;
                returnedActions = [
                    ReportsEntitiesGetFail({ payload: { error } })
                ];
                break;
            default: {
                returnedActions = [
                    ReportsEntitiesGetFail({ payload: { error: 'Unhandled error' } })
                ];
            }
        }
        return [...returnedActions];
    }
}

class UserBehaviorGetBehavior extends Behavior {
    constructor(action, result) {
        super(action);
        this.action = action;
        this.result = result;
    }
    resolve() {
        const status = this.result.data.status;
        let returnedActions;
        switch (status) {
            case ResponseStatus.STATUS_200: {
                const response = this.result.data;
                const { data } = response.body;
                returnedActions = [
                    UserBehaviorReportSuccess({
                        payload: {
                            data: data.result,
                            type: data.type
                        }
                    })
                ];
                break;
            }
            case ResponseStatus.STATUS_400:
            case ResponseStatus.STATUS_404:
            case ResponseStatus.STATUS_422:
            case ResponseStatus.STATUS_401:
                const errorResponse = this.result.data;
                const error = errorResponse.body.errors[0].title;
                returnedActions = [
                    UserBehaviorReportFail({ payload: { error } })
                ];
                break;
            default: {
                returnedActions = [
                    UserBehaviorReportFail({ payload: { error: 'Unhandled error' } })
                ];
            }
        }
        return [...returnedActions];
    }
}

class ReportsEffects extends BaseEffects {
    constructor(actions$, store, authenticationService, reportsService) {
        super(actions$, store);
        this.actions$ = actions$;
        this.store = store;
        this.authenticationService = authenticationService;
        this.reportsService = reportsService;
        this.reportsEntitiesGet$ = createEffect(() => this.actions$.pipe(ofType(ReportsEntitiesGet), mergeMap((action) => {
            const headers = this.authenticationService.loadAuthDataFromLocalStore();
            const config = {
                headers: { token: headers.token, uid: headers.id }
            };
            return this.reportsService.getEntitiesReports({})
                .pipe(flatMap((r) => new ReportsEntitiesDataBehavior(action, r).resolve()));
        })));
        this.userBehaviorReportGet$ = createEffect(() => this.actions$.pipe(ofType(UserBehaviorReportGet), mergeMap((action) => {
            const headers = this.authenticationService.loadAuthDataFromLocalStore();
            const config = {
                headers: { token: headers.token, uid: headers.id }
            };
            return this.reportsService.getUserBehaviorReport(config)
                .pipe(flatMap((r) => new UserBehaviorGetBehavior(action, r).resolve()));
        })));
    }
}
ReportsEffects.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "15.2.9", ngImport: i0, type: ReportsEffects, deps: [{ token: i1$2.Actions }, { token: i1.Store }, { token: AuthenticationService }, { token: ReportsService }], target: i0.ɵɵFactoryTarget.Injectable });
ReportsEffects.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "15.2.9", ngImport: i0, type: ReportsEffects });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "15.2.9", ngImport: i0, type: ReportsEffects, decorators: [{
            type: Injectable
        }], ctorParameters: function () { return [{ type: i1$2.Actions }, { type: i1.Store }, { type: AuthenticationService }, { type: ReportsService }]; } });

const getActionsState = createFeatureSelector(STATIC_DATA_FEATURE_KEY);
const getStatus = (action, actionId) => createSelector(getActionsState, (state) => state?.meta?.[`${action}-${actionId}`]?.status);
const getLoaded = (action, actionId) => createSelector(getActionsState, (state) => state?.meta?.[`${action}-${actionId}`]?.status);
const getError = (action) => createSelector(getActionsState, (state) => state?.meta?.[action]?.error);
const getActionMeta = (action, actionId) => createSelector(getActionsState, (state) => state.meta?.[`${action}-${actionId}`]);
const getActionItem = (action, actionId) => createSelector(getActionsState, (state) => {
    return state.list[`${action}-${actionId}`] || {};
});
const actionsQuery = {
    getStatus,
    getLoaded,
    getError,
    getActionItem,
    getActionMeta
};

class ActionsFacade {
    constructor(store) {
        this.store = store;
    }
    getActionMeta$(action, actionId) {
        return this.store.pipe(select(actionsQuery.getActionMeta(action, actionId)));
    }
    getAction$(action, actionId) {
        return this.store.pipe(select(actionsQuery.getActionItem(action, actionId)));
    }
    sendAction(action, actionId, data) {
        this.store.dispatch(ActionsSend({
            payload: {
                action,
                actionId,
                data
            }
        }));
    }
}
ActionsFacade.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "15.2.9", ngImport: i0, type: ActionsFacade, deps: [{ token: i1.Store }], target: i0.ɵɵFactoryTarget.Injectable });
ActionsFacade.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "15.2.9", ngImport: i0, type: ActionsFacade, providedIn: "root" });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "15.2.9", ngImport: i0, type: ActionsFacade, decorators: [{
            type: Injectable,
            args: [{ providedIn: "root" }]
        }], ctorParameters: function () { return [{ type: i1.Store }]; } });

const getCacheDataState = createFeatureSelector(CACHE_DATA_FEATURE_KEY);
const getCacheData = (type) => createSelector(getCacheDataState, (state) => {
    return state[type] || null;
});
const cacheDataQuery = {
    getCacheData,
};

class CacheDataFacade {
    constructor(store) {
        this.store = store;
    }
    getCacheData$(type) {
        return this.store.pipe(select(cacheDataQuery.getCacheData(type)));
    }
    loadCacheData(type) {
        this.store.dispatch(CacheDataGet({
            payload: {
                type,
            }
        }));
    }
}
CacheDataFacade.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "15.2.9", ngImport: i0, type: CacheDataFacade, deps: [{ token: i1.Store }], target: i0.ɵɵFactoryTarget.Injectable });
CacheDataFacade.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "15.2.9", ngImport: i0, type: CacheDataFacade, providedIn: "root" });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "15.2.9", ngImport: i0, type: CacheDataFacade, decorators: [{
            type: Injectable,
            args: [{ providedIn: "root" }]
        }], ctorParameters: function () { return [{ type: i1.Store }]; } });

const getReportsState = createFeatureSelector(REPORTS_FEATURE_KEY);
const getReportsEntities = createSelector(getReportsState, (state) => {
    const type = 'entities';
    return state[type] || null;
});
const getRUserBehaviorEntities = createSelector(getReportsState, (state) => {
    const type = 'user-behavior';
    return state[type] || null;
});
/*const getReportsEntities = (type: string) =>
  createSelector(
    getReportsState,
    (state: ReportsState) => {
      return state[type] || null
    }
  );*/
const reportsQuery = {
    getReportsEntities,
    getRUserBehaviorEntities
};

class ReportsFacade {
    constructor(store) {
        this.store = store;
    }
    getReportEntities$() {
        return this.store.pipe(select(reportsQuery.getReportsEntities));
    }
    getUserBehaviorEntities$() {
        return this.store.pipe(select(reportsQuery.getRUserBehaviorEntities));
    }
    loadReportEntities() {
        this.store.dispatch(ReportsEntitiesGet({
            payload: {}
        }));
    }
    loadUserBehaviorReport() {
        this.store.dispatch(UserBehaviorReportGet({
            payload: {}
        }));
    }
}
ReportsFacade.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "15.2.9", ngImport: i0, type: ReportsFacade, deps: [{ token: i1.Store }], target: i0.ɵɵFactoryTarget.Injectable });
ReportsFacade.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "15.2.9", ngImport: i0, type: ReportsFacade, providedIn: "root" });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "15.2.9", ngImport: i0, type: ReportsFacade, decorators: [{
            type: Injectable,
            args: [{ providedIn: "root" }]
        }], ctorParameters: function () { return [{ type: i1.Store }]; } });

const getStore = (storeKey) => {
    let rootStore = storeKey;
    let nestedStore = '';
    if (storeKey.includes('.')) {
        const params = storeKey.split('.');
        rootStore = params[0];
        nestedStore = params[1] !== 'list' ? params[1] : params[2];
    }
    const getCoreState = createFeatureSelector(rootStore);
    return createSelector(getCoreState, (state) => {
        if (state.list) {
            if (nestedStore) {
                return state.list[nestedStore];
            }
            return state.list;
        }
        return state;
    });
};
const coreQuery = {
    getStore
};

class CoreFacade {
    constructor(store) {
        this.store = store;
    }
    sendGlobalEvent(action, entity, entityId, fieldData, formValue) {
        this.store.dispatch(GlobalEvent({
            payload: {
                action,
                entity,
                entityId,
                fieldData,
                formValue
            }
        }));
    }
    getStoreByName(storeKey) {
        return this.store.pipe(select(coreQuery.getStore(storeKey)));
    }
}
CoreFacade.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "15.2.9", ngImport: i0, type: CoreFacade, deps: [{ token: i1.Store }], target: i0.ɵɵFactoryTarget.Injectable });
CoreFacade.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "15.2.9", ngImport: i0, type: CoreFacade, providedIn: "root" });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "15.2.9", ngImport: i0, type: CoreFacade, decorators: [{
            type: Injectable,
            args: [{ providedIn: "root" }]
        }], ctorParameters: function () { return [{ type: i1.Store }]; } });

class FormDeleteFileFacade {
    constructor(store) {
        this.store = store;
    }
    formDeleteFile(entity, entityId, field) {
        this.store.dispatch(FormDeleteFile({ payload: { entity, entityId, field } }));
    }
}
FormDeleteFileFacade.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "15.2.9", ngImport: i0, type: FormDeleteFileFacade, deps: [{ token: i1.Store }], target: i0.ɵɵFactoryTarget.Injectable });
FormDeleteFileFacade.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "15.2.9", ngImport: i0, type: FormDeleteFileFacade, providedIn: "root" });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "15.2.9", ngImport: i0, type: FormDeleteFileFacade, decorators: [{
            type: Injectable,
            args: [{ providedIn: "root" }]
        }], ctorParameters: function () { return [{ type: i1.Store }]; } });

const sharedEffects = [
    UsersEffects,
    RouterEffects,
    NotificationsEffects,
    FilesEffects,
    UiUnitsEffects,
    TagsEffects,
    MainEffects,
    StaticDataEffects,
    FormsEffects,
    FormValidationEffects,
    FormErrorsEffects,
    FormDeleteFileEffects,
    PublicationMessagesEffects,
    UpdateEntitiesEffects,
    ActionsEffects,
    CacheDataEffects,
    ReportsEffects
];
const sharedFacades = [
    CoreFacade,
    UsersFacade,
    UiUnitsFacade,
    NotificationsFacade,
    RouterFacade,
    FilesFacade,
    FormsFacade,
    TagsFacade,
    MainFacade,
    StaticDataFacade,
    FormsFacade,
    FormValidationFacade,
    FormErrorsFacade,
    FormDeleteFileFacade,
    RequestsFacade,
    PublicationMessagesFacade,
    ActionsFacade,
    CacheDataFacade,
    ReportsFacade
];
const SharedReducer = {
    requests: requestsReducer,
    files: filesReducer,
    formErrors: formErrorsReducer,
    formValidation: formValidationReducer,
    forms: formReducer,
    tags: tagsReducer,
    main: mainReducer,
    notifications: notificationsReducer,
    staticData: staticDataReducer,
    uiUnits: uiUnitsReducer,
    users: userReducer,
    publicationMessages: publicationMessagesReducer,
    actions: actionsReducer,
    cacheData: cacheDataReducer,
    reports: reportsReducer,
};

class RequestsEffects {
    /*    @Effect()
        checkValidation$ = this.actions$.pipe(
          ofType(UpdateRequest),
          switchMap((action) => {
            const {endPointUrl, itemId, method, } = action.payload;
            return of([]);
          }),
        );*/
    constructor(actions$, store
    // protected formValidationService: FormValidationService,
    // protected authenticationService: AuthenticationService
    ) {
        this.actions$ = actions$;
        this.store = store;
    }
}
RequestsEffects.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "15.2.9", ngImport: i0, type: RequestsEffects, deps: [{ token: i1$2.Actions }, { token: i1.Store }], target: i0.ɵɵFactoryTarget.Injectable });
RequestsEffects.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "15.2.9", ngImport: i0, type: RequestsEffects });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "15.2.9", ngImport: i0, type: RequestsEffects, decorators: [{
            type: Injectable
        }], ctorParameters: function () { return [{ type: i1$2.Actions }, { type: i1.Store }]; } });

var StaticDataMetaStatus;
(function (StaticDataMetaStatus) {
    StaticDataMetaStatus["LOADING"] = "loading";
    StaticDataMetaStatus["LOADED"] = "loaded";
})(StaticDataMetaStatus || (StaticDataMetaStatus = {}));

function guid() {
    return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
        // tslint:disable-next-line:no-bitwise
        const r = (Math.random() * 16) | 0, 
        // tslint:disable-next-line:no-bitwise
        v = c === 'x' ? r : (r & 0x3) | 0x8;
        return v.toString(16);
    });
}

function componentDestroyed(component) {
    if (component.__componentDestroyed$) {
        return component.__componentDestroyed$;
    }
    const oldNgOnDestroy = component.ngOnDestroy;
    const stop$ = new ReplaySubject();
    component.ngOnDestroy = function () {
        if (oldNgOnDestroy) {
            oldNgOnDestroy.apply(component);
        }
        stop$.next(true);
        stop$.complete();
    };
    return component.__componentDestroyed$ = stop$.asObservable();
}
function untilComponentDestroyed(component) {
    return (source) => source.pipe(takeUntil(componentDestroyed(component)));
}

function trackById(index, item) {
    return item ? item.id : undefined;
}

class DeleteComponent {
    constructor(dialogRef, data) {
        this.dialogRef = dialogRef;
        this.data = data;
    }
    onNoClick() {
        this.dialogRef.close(false);
    }
    onYesClick() {
        this.dialogRef.close(true);
    }
    ngOnInit() {
    }
}
DeleteComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "15.2.9", ngImport: i0, type: DeleteComponent, deps: [{ token: i1$4.MatDialogRef }, { token: MAT_DIALOG_DATA }], target: i0.ɵɵFactoryTarget.Component });
DeleteComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "15.2.9", type: DeleteComponent, selector: "app-delete", ngImport: i0, template: "<div class=\"text-center m-2\">\n  <h1 class=\"mat-dialog-title\">\u0423\u0434\u0430\u043B\u0435\u043D\u0438\u0435</h1>\n  <div mat-dialog-content>\n    <p>\u0412\u044B \u0434\u0435\u0439\u0441\u0442\u0432\u0438\u0442\u0435\u043B\u044C\u043D\u043E \u0445\u043E\u0442\u0438\u0442\u0435 \u0443\u0434\u0430\u043B\u0438\u0442\u044C{{data.name ? ' \"'+data.name+'\"' : ''}}?</p>\n  </div>\n  <div mat-dialog-actions class=\"text-align-center\">\n    <button mat-button (click)=\"onNoClick()\" class=\"mat-flat-button mr-1\" cdkFocusInitial>\u041D\u0435\u0442</button>\n    <button mat-button (click)=\"onYesClick()\" class=\"mat-raised-button mat-warn\">\u0414\u0430</button>\n  </div>\n</div>\n", styles: [""], dependencies: [{ kind: "directive", type: i1$4.MatDialogContent, selector: "[mat-dialog-content], mat-dialog-content, [matDialogContent]" }, { kind: "directive", type: i1$4.MatDialogActions, selector: "[mat-dialog-actions], mat-dialog-actions, [matDialogActions]", inputs: ["align"] }, { kind: "component", type: i5.MatButton, selector: "    button[mat-button], button[mat-raised-button], button[mat-flat-button],    button[mat-stroked-button]  ", inputs: ["disabled", "disableRipple", "color"], exportAs: ["matButton"] }], changeDetection: i0.ChangeDetectionStrategy.OnPush });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "15.2.9", ngImport: i0, type: DeleteComponent, decorators: [{
            type: Component,
            args: [{ selector: 'app-delete', changeDetection: ChangeDetectionStrategy.OnPush, template: "<div class=\"text-center m-2\">\n  <h1 class=\"mat-dialog-title\">\u0423\u0434\u0430\u043B\u0435\u043D\u0438\u0435</h1>\n  <div mat-dialog-content>\n    <p>\u0412\u044B \u0434\u0435\u0439\u0441\u0442\u0432\u0438\u0442\u0435\u043B\u044C\u043D\u043E \u0445\u043E\u0442\u0438\u0442\u0435 \u0443\u0434\u0430\u043B\u0438\u0442\u044C{{data.name ? ' \"'+data.name+'\"' : ''}}?</p>\n  </div>\n  <div mat-dialog-actions class=\"text-align-center\">\n    <button mat-button (click)=\"onNoClick()\" class=\"mat-flat-button mr-1\" cdkFocusInitial>\u041D\u0435\u0442</button>\n    <button mat-button (click)=\"onYesClick()\" class=\"mat-raised-button mat-warn\">\u0414\u0430</button>\n  </div>\n</div>\n" }]
        }], ctorParameters: function () { return [{ type: i1$4.MatDialogRef }, { type: undefined, decorators: [{
                    type: Inject,
                    args: [MAT_DIALOG_DATA]
                }] }]; } });

class DialogService {
    constructor(dialog) {
        this.dialog = dialog;
    }
    openDeleteDialog() {
        const dialogRef = this.dialog.open(DeleteComponent, {
            width: '250px',
            data: { name: 'картинку' }
        });
        /*    dialogRef.afterClosed().subscribe(result => {
              this.animal = result;
            });*/
        return dialogRef.afterClosed();
    }
}
DialogService.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "15.2.9", ngImport: i0, type: DialogService, deps: [{ token: i1$4.MatDialog }], target: i0.ɵɵFactoryTarget.Injectable });
DialogService.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "15.2.9", ngImport: i0, type: DialogService });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "15.2.9", ngImport: i0, type: DialogService, decorators: [{
            type: Injectable
        }], ctorParameters: function () { return [{ type: i1$4.MatDialog }]; } });

class DialogsModule {
}
DialogsModule.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "15.2.9", ngImport: i0, type: DialogsModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule });
DialogsModule.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "15.2.9", ngImport: i0, type: DialogsModule, declarations: [DeleteComponent, CommonDialogComponent], imports: [CommonModule,
        MatDialogModule,
        MatButtonModule,
        MatIconModule] });
DialogsModule.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "15.2.9", ngImport: i0, type: DialogsModule, providers: [DialogService, MatDialog], imports: [CommonModule,
        MatDialogModule,
        MatButtonModule,
        MatIconModule] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "15.2.9", ngImport: i0, type: DialogsModule, decorators: [{
            type: NgModule,
            args: [{
                    imports: [
                        CommonModule,
                        MatDialogModule,
                        MatButtonModule,
                        MatIconModule,
                    ],
                    declarations: [DeleteComponent, CommonDialogComponent],
                    providers: [DialogService, MatDialog]
                }]
        }] });

const appearFromLeft = trigger('appearFromLeft', [
    transition(':enter', [
        animate('500ms', keyframes([
            style({ opacity: 0, height: '0', transform: 'translateX(-50px)', offset: 0 }),
            style({ opacity: .7, height: '*', transform: 'translateX(30px)', offset: 0.7 }),
            style({ opacity: 1, transform: 'none', offset: 1, position: 'static' })
        ]))
    ]),
    transition(':leave', [
        animate('300ms', keyframes([
            style({ opacity: 1, height: '*', transform: 'none', offset: 0, position: 'absolute' }),
            style({ opacity: .3, transform: 'translateY(10px)', offset: 0.3 }),
            style({ opacity: 0, height: '0', transform: 'translateY(-20px)', offset: 1 })
        ]))
    ])
]);

const appearFromRight = trigger('appearFromRight', [
    transition(':enter', [
        animate('500ms', keyframes([
            style({ opacity: 0, transform: 'translateX(50px)', offset: 0 }),
            style({ opacity: .7, transform: 'translateX(-30px)', offset: 0.7 }),
            style({ opacity: 1, transform: 'none', offset: 1 })
        ]))
    ]),
    transition(':leave', [
        animate('300ms', keyframes([
            style({ opacity: 1, transform: 'none', offset: 0 }),
            style({ opacity: .3, transform: 'translateX(-20px)', offset: 0.3 }),
            style({ opacity: 0, transform: 'translateX(50px)', offset: 1 })
        ]))
    ])
]);

const appearFromLeftHideToRight = trigger('appearFromLeftHideToRight', [
    transition(':enter', [
        animate('500ms', keyframes([
            style({ opacity: 0, transform: 'translateX(-50px)', offset: 0 }),
            // style({ opacity: .7, height: '*', transform: 'translateX(30px)', offset: 0.7 }),
            style({ opacity: 1, transform: 'none', offset: 1 })
        ]))
    ]),
    transition(':leave', [
        animate('300ms', keyframes([
            style({ opacity: 1, transform: 'none', offset: 0 }),
            // style({ opacity: .3, transform: 'translateY(10px)', offset: 0.3 }),
            style({ opacity: 0, transform: 'translateX(-50px)', offset: 1 })
        ]))
    ])
]);

const appearFromLeftWithDelay = trigger('appearFromLeftWithDelay', [
    transition(':enter', [
        animate('500ms 3ms', keyframes([
            style({ opacity: 0, transform: 'translateX(-50px)', offset: 0 }),
            style({ opacity: .7, transform: 'translateX(30px)', offset: 0.7 }),
            style({ opacity: 1, transform: 'none', offset: 1 })
        ]))
    ]),
    transition(':leave', [
        animate('300ms', keyframes([
            style({ opacity: 1, transform: 'none', offset: 0 }),
            style({ opacity: .3, transform: 'translateX(20px)', offset: 0.3 }),
            style({ opacity: 0, transform: 'translateX(-50px)', offset: 1 })
        ]))
    ])
]);

const appearOpacity = trigger('appearOpacity', [
    transition(':enter', [
        animate('500ms 3ms', keyframes([
            style({ opacity: 0, offset: 0 }),
            style({ opacity: 1, offset: 0.5 }),
            style({ opacity: .7, offset: 0.7 }),
            style({ opacity: 1, transform: 'none', offset: 1 })
        ]))
    ]),
    transition(':leave', [
        animate('300ms', keyframes([
            style({ opacity: 1, offset: 0 }),
            style({ opacity: 0, offset: 1 })
        ]))
    ])
]);

const appearOpacity2 = trigger('appearOpacity2', [
    transition(':enter', [
        animate('500ms 3ms', keyframes([
            style({ opacity: 0, offset: 0 }),
            style({ opacity: 1, transform: 'none', offset: 1 })
        ]))
    ]),
    transition(':leave', [
        animate('300ms', keyframes([
            style({ opacity: 1, offset: 0 }),
            style({ opacity: 0, offset: 1 })
        ]))
    ])
]);

const expandCollapse = trigger('expandCollapse', [
    transition(':enter', [
        animate('500ms', keyframes([
            style({ opacity: 0, height: '0', offset: 0 }),
            style({ opacity: 1, height: '*', offset: 0.6 }),
            style({ opacity: 0.6, offset: 0.8 }),
            style({ opacity: 1, offset: 1 })
        ]))
    ]),
    transition(':leave', [
        animate('300ms', keyframes([
            style({ opacity: 1, height: '*', offset: 0 }),
            style({ opacity: 0, height: '0', offset: 1 })
        ]))
    ])
]);

const hideToTopOpacity = trigger('hideToTopOpacity', [
    transition(':leave', [
        animate('500ms', keyframes([
            style({ opacity: 1, transform: 'scale(1, 1)  translate(0, 0)', offset: 0 }),
            style({ opacity: 0.5, transform: 'scale(1, 1) translate(0, 50px)', offset: 0.3 }),
            style({ opacity: 0, transform: 'scale(0, 0) translate(0, -450px)', offset: 1 })
        ]))
    ])
]);

class AccessDeniedComponent {
}
AccessDeniedComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "15.2.9", ngImport: i0, type: AccessDeniedComponent, deps: [], target: i0.ɵɵFactoryTarget.Component });
AccessDeniedComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "15.2.9", type: AccessDeniedComponent, selector: "shared-access-denied", ngImport: i0, template: "<div class=\"text-center mt-30\">\n  \u041A \u0441\u043E\u0436\u0430\u043B\u0435\u043D\u0438\u044E, \u0443 \u0412\u0430\u0441 \u043D\u0435\u0442 \u0434\u043E\u0441\u0442\u0443\u043F\u0430 \u0434\u043B\u044F \u043F\u0440\u043E\u0441\u043C\u043E\u0442\u0440\u0430 \u044D\u0442\u043E\u0439 \u0441\u0442\u0440\u0430\u043D\u0438\u0446\u044B<br/>\n  <div class=\"mt-20\">\n    \u0415\u0441\u043B\u0438 \u0443 \u0432\u0430\u0441 \u0435\u0441\u0442\u044C \u0432\u043E\u043F\u0440\u043E\u0441\u044B \u043F\u043E \u044D\u0442\u043E\u043C\u0443 \u043F\u043E\u0432\u043E\u0434\u0443, \u043F\u043E\u0436\u0430\u043B\u0443\u0439\u0441\u0442\u0430 \u043D\u0430\u043F\u0438\u0448\u0438\u0442\u0435 \u0432 <a href=\"mailto:support@world-travel.uz\">support@world-travel.uz</a>\n  </div>\n</div>\n", styles: [""], changeDetection: i0.ChangeDetectionStrategy.OnPush });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "15.2.9", ngImport: i0, type: AccessDeniedComponent, decorators: [{
            type: Component,
            args: [{ selector: 'shared-access-denied', changeDetection: ChangeDetectionStrategy.OnPush, template: "<div class=\"text-center mt-30\">\n  \u041A \u0441\u043E\u0436\u0430\u043B\u0435\u043D\u0438\u044E, \u0443 \u0412\u0430\u0441 \u043D\u0435\u0442 \u0434\u043E\u0441\u0442\u0443\u043F\u0430 \u0434\u043B\u044F \u043F\u0440\u043E\u0441\u043C\u043E\u0442\u0440\u0430 \u044D\u0442\u043E\u0439 \u0441\u0442\u0440\u0430\u043D\u0438\u0446\u044B<br/>\n  <div class=\"mt-20\">\n    \u0415\u0441\u043B\u0438 \u0443 \u0432\u0430\u0441 \u0435\u0441\u0442\u044C \u0432\u043E\u043F\u0440\u043E\u0441\u044B \u043F\u043E \u044D\u0442\u043E\u043C\u0443 \u043F\u043E\u0432\u043E\u0434\u0443, \u043F\u043E\u0436\u0430\u043B\u0443\u0439\u0441\u0442\u0430 \u043D\u0430\u043F\u0438\u0448\u0438\u0442\u0435 \u0432 <a href=\"mailto:support@world-travel.uz\">support@world-travel.uz</a>\n  </div>\n</div>\n" }]
        }] });

class AccessDeniedModule {
}
AccessDeniedModule.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "15.2.9", ngImport: i0, type: AccessDeniedModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule });
AccessDeniedModule.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "15.2.9", ngImport: i0, type: AccessDeniedModule, declarations: [AccessDeniedComponent], exports: [AccessDeniedComponent] });
AccessDeniedModule.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "15.2.9", ngImport: i0, type: AccessDeniedModule });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "15.2.9", ngImport: i0, type: AccessDeniedModule, decorators: [{
            type: NgModule,
            args: [{
                    imports: [],
                    declarations: [AccessDeniedComponent],
                    exports: [AccessDeniedComponent]
                }]
        }] });

class SpinnerComponent {
    constructor() {
        this.overlay = false;
        this.diameter = 30;
        this.color = 'blue';
        this.position = 'left';
    }
    ngOnInit() {
    }
}
SpinnerComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "15.2.9", ngImport: i0, type: SpinnerComponent, deps: [], target: i0.ɵɵFactoryTarget.Component });
SpinnerComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "15.2.9", type: SpinnerComponent, selector: "shared-spinner", inputs: { overlay: "overlay", diameter: "diameter", color: "color", position: "position" }, ngImport: i0, template: "<div [ngClass]=\"{\n  overlay: overlay,\n  'grey-color': color === 'grey',\n  'align-center': position === 'center',\n  'align-right': position === 'right'\n  }\">\n  <mat-progress-spinner\n    class=\"example-margin\"\n    color=\"accent\"\n    [diameter]=\"diameter\"\n    mode=\"indeterminate\">\n  </mat-progress-spinner>\n</div>\n", styles: [".overlay{position:absolute;inset:0;background:rgba(30,33,41,.68);z-index:100;display:flex;justify-content:center;align-items:center}.align-center{display:flex;justify-content:center}.align-right{display:flex;justify-content:right}\n"], dependencies: [{ kind: "directive", type: i1$3.NgClass, selector: "[ngClass]", inputs: ["class", "ngClass"] }, { kind: "component", type: i2$2.MatProgressSpinner, selector: "mat-progress-spinner, mat-spinner", inputs: ["color", "mode", "value", "diameter", "strokeWidth"], exportAs: ["matProgressSpinner"] }], changeDetection: i0.ChangeDetectionStrategy.OnPush });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "15.2.9", ngImport: i0, type: SpinnerComponent, decorators: [{
            type: Component,
            args: [{ selector: 'shared-spinner', changeDetection: ChangeDetectionStrategy.OnPush, template: "<div [ngClass]=\"{\n  overlay: overlay,\n  'grey-color': color === 'grey',\n  'align-center': position === 'center',\n  'align-right': position === 'right'\n  }\">\n  <mat-progress-spinner\n    class=\"example-margin\"\n    color=\"accent\"\n    [diameter]=\"diameter\"\n    mode=\"indeterminate\">\n  </mat-progress-spinner>\n</div>\n", styles: [".overlay{position:absolute;inset:0;background:rgba(30,33,41,.68);z-index:100;display:flex;justify-content:center;align-items:center}.align-center{display:flex;justify-content:center}.align-right{display:flex;justify-content:right}\n"] }]
        }], ctorParameters: function () { return []; }, propDecorators: { overlay: [{
                type: Input
            }], diameter: [{
                type: Input
            }], color: [{
                type: Input
            }], position: [{
                type: Input
            }] } });

class FormFieldSpinnerComponent {
}
FormFieldSpinnerComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "15.2.9", ngImport: i0, type: FormFieldSpinnerComponent, deps: [], target: i0.ɵɵFactoryTarget.Component });
FormFieldSpinnerComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "15.2.9", type: FormFieldSpinnerComponent, selector: "shared-form-field-spinner", ngImport: i0, template: "<div class=\"spinner-overlay\">\n  <shared-spinner [color]=\"'grey'\" [diameter]=\"30\" [overlay]=\"true\"></shared-spinner>\n</div>\n", styles: [".spinner-overlay{position:absolute;width:100%;height:61px;top:0;margin-top:3px;border-radius:6px;overflow:hidden;opacity:.5}\n"], dependencies: [{ kind: "component", type: SpinnerComponent, selector: "shared-spinner", inputs: ["overlay", "diameter", "color", "position"] }], changeDetection: i0.ChangeDetectionStrategy.OnPush });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "15.2.9", ngImport: i0, type: FormFieldSpinnerComponent, decorators: [{
            type: Component,
            args: [{ selector: 'shared-form-field-spinner', changeDetection: ChangeDetectionStrategy.OnPush, template: "<div class=\"spinner-overlay\">\n  <shared-spinner [color]=\"'grey'\" [diameter]=\"30\" [overlay]=\"true\"></shared-spinner>\n</div>\n", styles: [".spinner-overlay{position:absolute;width:100%;height:61px;top:0;margin-top:3px;border-radius:6px;overflow:hidden;opacity:.5}\n"] }]
        }] });

class FormFieldSelectComponent {
    constructor(store, cd) {
        this.store = store;
        this.cd = cd;
        this.searchCtrl = new FormControl();
        this.loaded = false;
        this.options = [];
        this.allOptions = [];
        this.tempOptions = [];
        this.placeholder = '';
        this.unSubscribeSubject$ = new Subject();
    }
    ngOnInit() {
        if (this.fieldData.options.subscribeToFormChanges) {
            this.subscribeToFormChanges();
            this.placeholder = this.fieldData.options.subscribeToFormChanges.emptyTitle;
        }
        if (this.autoCompleteFields) {
            const findField = this.autoCompleteFields.find(item => item.field === this.fieldData.field);
            if (findField?.field) {
                this.form.get(findField.field).setValue(findField.value);
                this.form.get(findField.field).disable();
            }
        }
        this.subscribeToSearchChange();
    }
    ngOnDestroy() {
        this.unSubscribeSubject$.next();
        this.unSubscribeSubject$.complete();
    }
    ngOnChanges(changes) {
        if (changes.fieldData && changes.fieldData.currentValue) {
            const { loadOptionFromStore, selectOptions } = changes.fieldData.currentValue.options;
            if (selectOptions && selectOptions.length) {
                this.options = selectOptions;
            }
            if (loadOptionFromStore) {
                this.loadOptionsFromStore(loadOptionFromStore);
            }
            else {
                this.loaded = true;
            }
        }
    }
    subscribeToSearchChange() {
        if (this.searchCtrl) {
            this.searchCtrl.valueChanges
                .pipe(untilComponentDestroyed(this))
                .subscribe((searchValue) => {
                if (searchValue) {
                    if (!this.tempOptions.length) {
                        this.tempOptions = [...this.options];
                    }
                    this.options = this.options.filter(item => {
                        return item.name.toLowerCase().indexOf(searchValue.toLowerCase()) !== -1;
                    });
                }
                else {
                    if (this.tempOptions.length) {
                        this.options = [...this.tempOptions];
                        this.tempOptions = [];
                    }
                }
            });
        }
    }
    /**
     * Subscribe to the form changes for field with the property 'subscribeToFormChanges'
     */
    subscribeToFormChanges() {
        this.form.valueChanges
            .pipe(takeUntil(this.unSubscribeSubject$))
            .subscribe(changes => {
            this.filterOptionsByRelatedFieldValue(changes);
            this.cd.markForCheck();
        });
    }
    loadOptionsFromStore(loadOptionFromStore) {
        const listKeys = loadOptionFromStore.split('.');
        this.store.select(state => {
            let selectedStore = state;
            listKeys.forEach(key => {
                selectedStore = selectedStore[key];
            });
            return selectedStore;
        })
            .pipe(filter((listItems) => !!listItems), takeUntil(this.unSubscribeSubject$))
            .subscribe((listItems) => {
            let newOptions = [];
            if (listItems && listItems?.items) {
                newOptions = listItems.items;
            }
            else if (listItems.list?.length) {
                newOptions = listItems.list;
            }
            else if (Array.isArray(listItems)) {
                newOptions = listItems;
            }
            newOptions = this.sortOptionItemsByName(newOptions);
            if (this.fieldData.options.nestedByField) {
                newOptions = this.groupItemsByNestedField(newOptions);
            }
            this.allOptions = newOptions;
            if (!this.fieldData.options.subscribeToFormChanges) {
                this.options = newOptions?.length ? newOptions.map(item => ({ id: item.id, name: item.name })) : [];
            }
            else {
                this.filterOptionsByRelatedFieldValue(this.form.value);
            }
            this.cd.markForCheck();
            this.fieldData.options.loading = false;
        });
    }
    /**
     * Filter option by the 'subscribeToFormChanges' property
     * @param data
     */
    filterOptionsByRelatedFieldValue(data) {
        const { relatedField, currentFieldProperty } = this.fieldData.options.subscribeToFormChanges;
        const relatedFieldValue = data[relatedField];
        let newOptions = [];
        if (Array.isArray(relatedFieldValue)) {
            if (relatedFieldValue?.length) {
                newOptions = this.allOptions.filter(item => relatedFieldValue.includes(item[currentFieldProperty]));
            }
        }
        else {
            newOptions = this.allOptions.filter(item => item[currentFieldProperty] === relatedFieldValue);
        }
        this.options = newOptions.map(item => ({ id: item.id, name: item.name }));
    }
    groupItemsByNestedField(items) {
        let newItems = [];
        items.filter(item => !item[this.fieldData.options.nestedByField])
            .forEach(item => {
            const newItem = { ...item };
            const subItems = this.groupItemsByNestedFieldRecursion(items, item.id);
            newItems.push(newItem);
            if (subItems?.length) {
                newItems = [...newItems, ...subItems];
            }
        });
        return newItems;
    }
    groupItemsByNestedFieldRecursion(items, parentId, prefix = '---') {
        const nestedByFieldName = this.fieldData.options.nestedByField;
        const findItems = items.filter(item => item[nestedByFieldName] === parentId);
        if (findItems?.length) {
            let newItems = [];
            findItems.forEach(item => {
                newItems.push({ ...item, name: `${prefix} ${item.name}` });
                const subItems = this.groupItemsByNestedFieldRecursion(items, item.id, prefix + '---');
                if (subItems?.length) {
                    newItems = [...newItems, ...subItems];
                }
            });
            return newItems;
        }
        return null;
    }
    sortOptionItemsByName(items) {
        return [...items].sort((a, b) => {
            const field = a.name ? 'name' : 'title';
            if (a[field] > b[field])
                return 1;
            if (a[field] < b[field])
                return -1;
            return 0;
        });
    }
}
FormFieldSelectComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "15.2.9", ngImport: i0, type: FormFieldSelectComponent, deps: [{ token: i1.Store }, { token: i0.ChangeDetectorRef }], target: i0.ɵɵFactoryTarget.Component });
FormFieldSelectComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "15.2.9", type: FormFieldSelectComponent, selector: "shared-form-field-select", inputs: { fieldData: "fieldData", form: "form", autoCompleteFields: "autoCompleteFields" }, usesOnChanges: true, ngImport: i0, template: "<div [formGroup]=\"form\">\n  <mat-form-field appearance=\"outline\"\n                  class=\"width100\">\n    <mat-label>{{fieldData.title}}</mat-label>\n    <mat-select [required]=\"fieldData.validators?.includes('required')\"\n                [multiple]=\"fieldData.options.multiple\"\n                [formControlName]=\"fieldData.field\">\n      <mat-option *ngIf=\"fieldData.options.innerSearch\">\n        <ngx-mat-select-search\n          placeholderLabel=\"\u041F\u043E\u0438\u0441\u043A...\"\n          [formControl]=\"searchCtrl\"></ngx-mat-select-search>\n      </mat-option>\n      <mat-option *ngIf=\"!fieldData.validators?.includes('required')\" value=\"0\">\n        -----\n      </mat-option>\n      <ng-container *ngIf=\"!fieldData.options.loading\">\n        <ng-container *ngIf=\"options.length\">\n          <mat-option *ngFor=\"let item of options\" [value]=\"item.id\">\n            {{item.name || item['title']}}\n          </mat-option>\n        </ng-container>\n        <ng-container *ngIf=\"!options.length\">\n          <mat-option>\n            \u0421\u043F\u0438\u0441\u043E\u043A \u043F\u0443\u0441\u0442\n          </mat-option>\n        </ng-container>\n      </ng-container>\n      <ng-container *ngIf=\"fieldData.options.loading\">\n        <mat-option>\u0417\u0430\u0433\u0440\u0443\u0437\u043A\u0430....</mat-option>\n      </ng-container>\n    </mat-select>\n    <ng-container *ngIf=\"!options.length && placeholder\">\n      <div @appearOpacity class=\"form-select-placeholder\">{{placeholder}}</div>\n    </ng-container>\n  </mat-form-field>\n</div>\n", styles: [".form-select-placeholder{position:absolute;margin-left:81px;margin-top:-3px;opacity:.8}\n"], dependencies: [{ kind: "directive", type: i1$3.NgForOf, selector: "[ngFor][ngForOf]", inputs: ["ngForOf", "ngForTrackBy", "ngForTemplate"] }, { kind: "directive", type: i1$3.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "component", type: i2$3.MatFormField, selector: "mat-form-field", inputs: ["hideRequiredMarker", "color", "floatLabel", "appearance", "subscriptSizing", "hintLabel"], exportAs: ["matFormField"] }, { kind: "directive", type: i2$3.MatLabel, selector: "mat-label" }, { kind: "component", type: i4.MatSelect, selector: "mat-select", inputs: ["disabled", "disableRipple", "tabIndex", "hideSingleSelectionIndicator"], exportAs: ["matSelect"] }, { kind: "component", type: i5$1.MatOption, selector: "mat-option", exportAs: ["matOption"] }, { kind: "directive", type: i6.NgControlStatus, selector: "[formControlName],[ngModel],[formControl]" }, { kind: "directive", type: i6.NgControlStatusGroup, selector: "[formGroupName],[formArrayName],[ngModelGroup],[formGroup],form:not([ngNoForm]),[ngForm]" }, { kind: "directive", type: i6.RequiredValidator, selector: ":not([type=checkbox])[required][formControlName],:not([type=checkbox])[required][formControl],:not([type=checkbox])[required][ngModel]", inputs: ["required"] }, { kind: "directive", type: i6.FormControlDirective, selector: "[formControl]", inputs: ["formControl", "disabled", "ngModel"], outputs: ["ngModelChange"], exportAs: ["ngForm"] }, { kind: "directive", type: i6.FormGroupDirective, selector: "[formGroup]", inputs: ["formGroup"], outputs: ["ngSubmit"], exportAs: ["ngForm"] }, { kind: "directive", type: i6.FormControlName, selector: "[formControlName]", inputs: ["formControlName", "disabled", "ngModel"], outputs: ["ngModelChange"] }, { kind: "component", type: i7.MatSelectSearchComponent, selector: "ngx-mat-select-search", inputs: ["placeholderLabel", "type", "closeIcon", "closeSvgIcon", "noEntriesFoundLabel", "clearSearchInput", "searching", "disableInitialFocus", "enableClearOnEscapePressed", "preventHomeEndKeyPropagation", "disableScrollToActiveOnOptionsChanged", "ariaLabel", "showToggleAllCheckbox", "toggleAllCheckboxChecked", "toggleAllCheckboxIndeterminate", "toggleAllCheckboxTooltipMessage", "toggleAllCheckboxTooltipPosition", "hideClearSearchButton", "alwaysRestoreSelectedOptionsMulti"], outputs: ["toggleAll"] }], animations: [appearOpacity], changeDetection: i0.ChangeDetectionStrategy.OnPush });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "15.2.9", ngImport: i0, type: FormFieldSelectComponent, decorators: [{
            type: Component,
            args: [{ selector: 'shared-form-field-select', changeDetection: ChangeDetectionStrategy.OnPush, animations: [appearOpacity], template: "<div [formGroup]=\"form\">\n  <mat-form-field appearance=\"outline\"\n                  class=\"width100\">\n    <mat-label>{{fieldData.title}}</mat-label>\n    <mat-select [required]=\"fieldData.validators?.includes('required')\"\n                [multiple]=\"fieldData.options.multiple\"\n                [formControlName]=\"fieldData.field\">\n      <mat-option *ngIf=\"fieldData.options.innerSearch\">\n        <ngx-mat-select-search\n          placeholderLabel=\"\u041F\u043E\u0438\u0441\u043A...\"\n          [formControl]=\"searchCtrl\"></ngx-mat-select-search>\n      </mat-option>\n      <mat-option *ngIf=\"!fieldData.validators?.includes('required')\" value=\"0\">\n        -----\n      </mat-option>\n      <ng-container *ngIf=\"!fieldData.options.loading\">\n        <ng-container *ngIf=\"options.length\">\n          <mat-option *ngFor=\"let item of options\" [value]=\"item.id\">\n            {{item.name || item['title']}}\n          </mat-option>\n        </ng-container>\n        <ng-container *ngIf=\"!options.length\">\n          <mat-option>\n            \u0421\u043F\u0438\u0441\u043E\u043A \u043F\u0443\u0441\u0442\n          </mat-option>\n        </ng-container>\n      </ng-container>\n      <ng-container *ngIf=\"fieldData.options.loading\">\n        <mat-option>\u0417\u0430\u0433\u0440\u0443\u0437\u043A\u0430....</mat-option>\n      </ng-container>\n    </mat-select>\n    <ng-container *ngIf=\"!options.length && placeholder\">\n      <div @appearOpacity class=\"form-select-placeholder\">{{placeholder}}</div>\n    </ng-container>\n  </mat-form-field>\n</div>\n", styles: [".form-select-placeholder{position:absolute;margin-left:81px;margin-top:-3px;opacity:.8}\n"] }]
        }], ctorParameters: function () { return [{ type: i1.Store }, { type: i0.ChangeDetectorRef }]; }, propDecorators: { fieldData: [{
                type: Input
            }], form: [{
                type: Input
            }], autoCompleteFields: [{
                type: Input
            }] } });

class FormFieldSlideToggleComponent {
}
FormFieldSlideToggleComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "15.2.9", ngImport: i0, type: FormFieldSlideToggleComponent, deps: [], target: i0.ɵɵFactoryTarget.Component });
FormFieldSlideToggleComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "15.2.9", type: FormFieldSlideToggleComponent, selector: "shared-form-field-slide-toggle", inputs: { fieldData: "fieldData", form: "form" }, ngImport: i0, template: "<div [formGroup]=\"form\">\n  <mat-slide-toggle\n    [color]=\"'warn'\"\n    [formControlName]=\"fieldData.field\">\n    {{fieldData.title}}{{fieldData.validators && fieldData.validators.includes('required') ? ' *' : ''}}\n  </mat-slide-toggle>\n</div>\n", styles: [""], dependencies: [{ kind: "component", type: i1$6.MatSlideToggle, selector: "mat-slide-toggle", inputs: ["disabled", "disableRipple", "color", "tabIndex"], exportAs: ["matSlideToggle"] }, { kind: "directive", type: i6.NgControlStatus, selector: "[formControlName],[ngModel],[formControl]" }, { kind: "directive", type: i6.NgControlStatusGroup, selector: "[formGroupName],[formArrayName],[ngModelGroup],[formGroup],form:not([ngNoForm]),[ngForm]" }, { kind: "directive", type: i6.FormGroupDirective, selector: "[formGroup]", inputs: ["formGroup"], outputs: ["ngSubmit"], exportAs: ["ngForm"] }, { kind: "directive", type: i6.FormControlName, selector: "[formControlName]", inputs: ["formControlName", "disabled", "ngModel"], outputs: ["ngModelChange"] }], changeDetection: i0.ChangeDetectionStrategy.OnPush });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "15.2.9", ngImport: i0, type: FormFieldSlideToggleComponent, decorators: [{
            type: Component,
            args: [{ selector: 'shared-form-field-slide-toggle', changeDetection: ChangeDetectionStrategy.OnPush, template: "<div [formGroup]=\"form\">\n  <mat-slide-toggle\n    [color]=\"'warn'\"\n    [formControlName]=\"fieldData.field\">\n    {{fieldData.title}}{{fieldData.validators && fieldData.validators.includes('required') ? ' *' : ''}}\n  </mat-slide-toggle>\n</div>\n" }]
        }], propDecorators: { fieldData: [{
                type: Input
            }], form: [{
                type: Input
            }] } });

class SmartProgressBarComponent {
    constructor() {
        this.showValue = true;
    }
}
SmartProgressBarComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "15.2.9", ngImport: i0, type: SmartProgressBarComponent, deps: [], target: i0.ɵɵFactoryTarget.Component });
SmartProgressBarComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "15.2.9", type: SmartProgressBarComponent, selector: "shared-smart-progress-bar", inputs: { value: "value", title: "title", showValue: "showValue" }, ngImport: i0, template: "<div class=\"progress\">\n  <div class=\"progress-bar\"\n       role=\"progressbar\"\n       [title]=\"title\"\n       [style]=\"{width: value + '%'}\"\n       aria-valuemin=\"0\"\n       aria-valuemax=\"100\"\n       [class.bg-0]=\"value <= 30\"\n       [class.bg-1]=\"value > 30 && value <= 40\"\n       [class.bg-2]=\"value > 40 && value <= 50\"\n       [class.bg-3]=\"value > 50 && value <= 60\"\n       [class.bg-4]=\"value > 60 && value <= 70\"\n       [class.bg-5]=\"value > 70 && value <= 85\"\n       [class.bg-6]=\"value > 85\">\n    <ng-container *ngIf=\"value\">\u0424\u043E\u0440\u043C\u0430 \u0437\u0430\u043F\u043E\u043B\u043D\u0435\u043D\u0430 \u043D\u0430 {{value}}%</ng-container>\n  </div>\n</div>\n\n", styles: [".progress{display:flex;height:13px;overflow:hidden;font-size:.75rem;background-color:#e9ecef;border-radius:.25rem;margin-bottom:10px}.progress .progress-bar{font-size:12px;display:flex;flex-direction:column;justify-content:center;color:#fff;text-align:center;background-color:transparent!important;transition:all .6s ease}.progress .progress-bar.bg-0{background-color:#e72235!important}.progress .progress-bar.bg-1{background-color:#dc4835!important}.progress .progress-bar.bg-2{background-color:#c09841!important}.progress .progress-bar.bg-3{background-color:#b6962b!important}.progress .progress-bar.bg-4{background-color:#9cad04!important}.progress .progress-bar.bg-5{background-color:#548804!important}.progress .progress-bar.bg-6{background-color:#28a745!important}\n"], dependencies: [{ kind: "directive", type: i1$3.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }], changeDetection: i0.ChangeDetectionStrategy.OnPush });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "15.2.9", ngImport: i0, type: SmartProgressBarComponent, decorators: [{
            type: Component,
            args: [{ selector: 'shared-smart-progress-bar', changeDetection: ChangeDetectionStrategy.OnPush, template: "<div class=\"progress\">\n  <div class=\"progress-bar\"\n       role=\"progressbar\"\n       [title]=\"title\"\n       [style]=\"{width: value + '%'}\"\n       aria-valuemin=\"0\"\n       aria-valuemax=\"100\"\n       [class.bg-0]=\"value <= 30\"\n       [class.bg-1]=\"value > 30 && value <= 40\"\n       [class.bg-2]=\"value > 40 && value <= 50\"\n       [class.bg-3]=\"value > 50 && value <= 60\"\n       [class.bg-4]=\"value > 60 && value <= 70\"\n       [class.bg-5]=\"value > 70 && value <= 85\"\n       [class.bg-6]=\"value > 85\">\n    <ng-container *ngIf=\"value\">\u0424\u043E\u0440\u043C\u0430 \u0437\u0430\u043F\u043E\u043B\u043D\u0435\u043D\u0430 \u043D\u0430 {{value}}%</ng-container>\n  </div>\n</div>\n\n", styles: [".progress{display:flex;height:13px;overflow:hidden;font-size:.75rem;background-color:#e9ecef;border-radius:.25rem;margin-bottom:10px}.progress .progress-bar{font-size:12px;display:flex;flex-direction:column;justify-content:center;color:#fff;text-align:center;background-color:transparent!important;transition:all .6s ease}.progress .progress-bar.bg-0{background-color:#e72235!important}.progress .progress-bar.bg-1{background-color:#dc4835!important}.progress .progress-bar.bg-2{background-color:#c09841!important}.progress .progress-bar.bg-3{background-color:#b6962b!important}.progress .progress-bar.bg-4{background-color:#9cad04!important}.progress .progress-bar.bg-5{background-color:#548804!important}.progress .progress-bar.bg-6{background-color:#28a745!important}\n"] }]
        }], propDecorators: { value: [{
                type: Input
            }], title: [{
                type: Input
            }], showValue: [{
                type: Input
            }] } });

var FieldType;
(function (FieldType) {
    FieldType["FieldTypeInput"] = "input";
    FieldType["FieldTypeSelect"] = "select";
    FieldType["FieldTypeSelectMultiple"] = "select-multiple";
    FieldType["FieldTypeSlideToggle"] = "slide-toggle";
    FieldType["FieldTypeTextarea"] = "textarea-editor";
    FieldType["FieldTypeTextareaEditor"] = "textarea";
    FieldType["FieldTypeFile"] = "file";
    FieldType["FieldTypeFiles"] = "files";
    FieldType["FieldTypeRating"] = "rating";
    FieldType["FieldTypeTags"] = "tags";
})(FieldType || (FieldType = {}));

/*
    message1 - для вывода инлайн ошибок в форме
    message2 - для вывода списка ошибок в нижнем блоке ошибок

    :field - подменяется на название поля
 */
const ERRORS = {
    required: {
        message1: 'Поле обязательно для заполнения',
        message2: 'Заполните поле ":field"'
    },
    email: {
        message1: 'Не верный формат Email',
        message2: 'Введите корректное значение для поля ":field"'
    },
    mask: {
        message1: 'Не верный формат',
        message2: 'Введите корректное значение для поля ":field"'
    },
    minlength: {
        message1: 'Значение должно быть не меньше :requiredLength -ех/и символов',
        message2: 'Введите корректное значение для поля ":field"'
    },
    pattern: {
        message1: 'Значение должно быть',
        message2: 'Введите корректное значение для поля ":field"'
    }
};
/*
field,
valueLength,
requiredLength,
value
*/

class FormFieldErrorComponent {
    constructor(baseAutoFormService) {
        this.baseAutoFormService = baseAutoFormService;
        this.unSubscribeSubject$ = new Subject();
    }
    ngOnInit() {
        this.getError();
        this.statusChanges();
    }
    ngOnDestroy() {
        this.unSubscribeSubject$.next();
        this.unSubscribeSubject$.complete();
    }
    statusChanges() {
        this.form.get(this.fieldData.field).statusChanges
            .pipe(takeUntil(this.unSubscribeSubject$))
            .subscribe(() => {
            this.getError();
        });
    }
    getError() {
        const control = this.form.get(this.fieldData.field);
        const controlValue = control.value;
        if (control && control.errors) {
            Object
                .keys(control.errors)
                .map(errorKey => {
                const fieldValidationErrorTest = this.fieldData.options?.validations?.[errorKey]?.errorText;
                let error;
                switch (errorKey) {
                    case 'required':
                        error = fieldValidationErrorTest || ERRORS['required'].message1;
                        break;
                    case 'email':
                        error = fieldValidationErrorTest || ERRORS['email'].message1;
                        break;
                    case 'mask':
                        error = fieldValidationErrorTest || ERRORS['mask'].message1;
                        break;
                    case 'minlength':
                        error = fieldValidationErrorTest || ERRORS['minlength'].message1;
                        break;
                    case 'pattern':
                        error = fieldValidationErrorTest || ERRORS['pattern'].message1;
                        break;
                    case 'customValidation':
                        error = fieldValidationErrorTest || control.errors['customValidation'];
                        break;
                    default:
                        error = this.errorMessageTexts && this.errorMessageTexts[errorKey] ? this.errorMessageTexts[errorKey] : errorKey;
                        break;
                }
                this.error = this.baseAutoFormService.prepareFieldError(error, {
                    ['field']: this.fieldData.title,
                    ['valueLength']: controlValue?.length || 0,
                    ['requiredLength']: control.errors?.minlength?.requiredLength || 0,
                    ['value']: controlValue,
                });
            });
        }
    }
}
FormFieldErrorComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "15.2.9", ngImport: i0, type: FormFieldErrorComponent, deps: [{ token: BaseAutoFormService }], target: i0.ɵɵFactoryTarget.Component });
FormFieldErrorComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "15.2.9", type: FormFieldErrorComponent, selector: "shared-form-field-error", inputs: { fieldData: "fieldData", form: "form", errorMessageTexts: "errorMessageTexts" }, ngImport: i0, template: "<mat-error class=\"field-error\">\n  {{error}}\n</mat-error>\n", styles: [""], dependencies: [{ kind: "directive", type: i2$3.MatError, selector: "mat-error, [matError]", inputs: ["id"] }], changeDetection: i0.ChangeDetectionStrategy.OnPush });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "15.2.9", ngImport: i0, type: FormFieldErrorComponent, decorators: [{
            type: Component,
            args: [{ selector: 'shared-form-field-error', changeDetection: ChangeDetectionStrategy.OnPush, template: "<mat-error class=\"field-error\">\n  {{error}}\n</mat-error>\n" }]
        }], ctorParameters: function () { return [{ type: BaseAutoFormService }]; }, propDecorators: { fieldData: [{
                type: Input
            }], form: [{
                type: Input
            }], errorMessageTexts: [{
                type: Input
            }] } });

class FormFieldPublishErrorComponent {
    constructor(autoFormService, publicationMessagesFacade) {
        this.autoFormService = autoFormService;
        this.publicationMessagesFacade = publicationMessagesFacade;
        this.unSubscribeSubject$ = new Subject();
    }
    ngOnInit() {
        this.subscribeToPublishErError();
    }
    ngOnDestroy() {
        this.unSubscribeSubject$.next();
        this.unSubscribeSubject$.complete();
    }
    subscribeToPublishErError() {
        const field = this.fieldData.field;
        const itemId = this.form.get("id")?.value;
        if (itemId) {
            this.messages$ = this.publicationMessagesFacade.getPublicationMessage(this.entity, itemId)
                .pipe(map((items) => items.filter(item => item.field === field)), map((items) => ({
                errors: items.filter(item => item.isError),
                recommendations: items.filter(item => !item.isError)
            })), map((items) => ({
                errors: this.autoFormService.prepareFormFieldPublicationMessage(items.errors, PublishErrors, [this.fieldData]),
                recommendations: this.autoFormService.prepareFormFieldPublicationMessage(items.recommendations, PublishErrors, [this.fieldData])
            })));
        }
        else {
            this.messages$ = EMPTY;
        }
    }
}
FormFieldPublishErrorComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "15.2.9", ngImport: i0, type: FormFieldPublishErrorComponent, deps: [{ token: AutoFormService }, { token: PublicationMessagesFacade }], target: i0.ɵɵFactoryTarget.Component });
FormFieldPublishErrorComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "15.2.9", type: FormFieldPublishErrorComponent, selector: "shared-form-field-publish-error", inputs: { fieldData: "fieldData", form: "form", entity: "entity", errorMessageTexts: "errorMessageTexts" }, ngImport: i0, template: "<ng-container *ngIf=\"messages$ | async as messages\">\n  <ng-container *ngFor=\"let messageObj of messages.errors\">\n    <div @appearFromLeft class=\"color-red\">\n      {{messageObj.description}}\n    </div>\n  </ng-container>\n  <ng-container *ngFor=\"let messageObj of messages.recommendations\">\n    <div @appearFromLeft class=\"color-orange\">\n      {{messageObj.description}}\n    </div>\n  </ng-container>\n</ng-container>\n\n", styles: [""], dependencies: [{ kind: "directive", type: i1$3.NgForOf, selector: "[ngFor][ngForOf]", inputs: ["ngForOf", "ngForTrackBy", "ngForTemplate"] }, { kind: "directive", type: i1$3.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "pipe", type: i1$3.AsyncPipe, name: "async" }], animations: [appearFromLeft], changeDetection: i0.ChangeDetectionStrategy.OnPush });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "15.2.9", ngImport: i0, type: FormFieldPublishErrorComponent, decorators: [{
            type: Component,
            args: [{ selector: "shared-form-field-publish-error", changeDetection: ChangeDetectionStrategy.OnPush, animations: [appearFromLeft], template: "<ng-container *ngIf=\"messages$ | async as messages\">\n  <ng-container *ngFor=\"let messageObj of messages.errors\">\n    <div @appearFromLeft class=\"color-red\">\n      {{messageObj.description}}\n    </div>\n  </ng-container>\n  <ng-container *ngFor=\"let messageObj of messages.recommendations\">\n    <div @appearFromLeft class=\"color-orange\">\n      {{messageObj.description}}\n    </div>\n  </ng-container>\n</ng-container>\n\n" }]
        }], ctorParameters: function () { return [{ type: AutoFormService }, { type: PublicationMessagesFacade }]; }, propDecorators: { fieldData: [{
                type: Input
            }], form: [{
                type: Input
            }], entity: [{
                type: Input
            }], errorMessageTexts: [{
                type: Input
            }] } });

var InputType;
(function (InputType) {
    InputType["Text"] = "text";
    InputType["Email"] = "email";
    InputType["Tel"] = "tel";
    InputType["Number"] = "number";
    InputType["Password"] = "password";
    InputType["Url"] = "url";
    InputType["Range"] = "range";
})(InputType || (InputType = {}));

class FormFieldInputComponent {
    constructor(cd) {
        this.cd = cd;
        this.pendingStatus = 'PENDING';
        this.inputType = InputType.Text;
        this.inputMask = null;
        this.placeholder = '';
    }
    ngOnInit() {
        this.checkInputType();
        this.checkInputMask();
        this.subscribeToFieldStatus();
    }
    ngOnDestroy() {
    }
    subscribeToFieldStatus() {
        this.form.get(this.fieldData.field).statusChanges
            .pipe(untilComponentDestroyed(this))
            .subscribe((data) => {
            this.cd.markForCheck();
        });
    }
    checkInputType() {
        switch (this.fieldData.options.format) {
            case IFormFieldFormat.Email:
                this.inputType = InputType.Email;
                break;
            case IFormFieldFormat.Phone:
                this.inputType = InputType.Tel;
                break;
            case IFormFieldFormat.Number:
                this.inputType = InputType.Number;
                break;
            case IFormFieldFormat.Password:
                this.inputType = InputType.Password;
                break;
            default:
                this.inputType = InputType.Text;
        }
    }
    checkInputMask() {
        this.placeholder = this.fieldData.options.placeholder;
        switch (this.fieldData.options.format) {
            case IFormFieldFormat.Phone:
                this.inputMask = '+0(0000)000-00-00';
                this.placeholder = '+0(0000)000-00-00';
                break;
        }
    }
}
FormFieldInputComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "15.2.9", ngImport: i0, type: FormFieldInputComponent, deps: [{ token: i0.ChangeDetectorRef }], target: i0.ɵɵFactoryTarget.Component });
FormFieldInputComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "15.2.9", type: FormFieldInputComponent, selector: "shared-form-field-input", inputs: { fieldData: "fieldData", form: "form" }, viewQueries: [{ propertyName: "input", first: true, predicate: ["input"], descendants: true }], ngImport: i0, template: "<ng-container *ngIf=\"form.get(fieldData.field) as field\">\n  <div [formGroup]=\"form\">\n    <mat-form-field appearance=\"outline\"\n                    class=\"width100\">\n      <mat-label>{{fieldData.title}}{{fieldData.validators && fieldData.validators.includes('required') ? ' *' : ''}}</mat-label>\n      <div class=\"display-flex align-baseline \">\n        <ng-container *ngIf=\"inputMask\">\n          <input matInput\n                 #input\n                 [type]=\"inputType\"\n                 [placeholder]=\"placeholder\"\n                 [mask]=\"inputMask\"\n                 [formControlName]=\"fieldData.field\">\n        </ng-container>\n        <ng-container *ngIf=\"!inputMask\">\n          <input matInput\n                 #input\n                 [type]=\"inputType\"\n                 [placeholder]=\"placeholder\"\n                 [formControlName]=\"fieldData.field\">\n        </ng-container>\n        <div class=\"form-field-suffix\"\n             [ngClass]=\"{'input-field-icon-red': !field.valid}\"\n             *ngIf=\"fieldData.asyncValidators && fieldData.asyncValidators.length\">\n          <mat-icon *ngIf=\"field.status !== pendingStatus\"\n                    class=\"secondary-text mat-icon notranslate material-icons mat-icon-no-color\"\n                    role=\"img\" aria-hidden=\"true\">\n            {{field.valid ? 'done' : field.errors['itemUniqValue'] ? 'assignment_late' : ''}}\n          </mat-icon>\n          <shared-spinner *ngIf=\"field.status === pendingStatus\"\n                          [diameter]=\"24\"></shared-spinner>\n        </div>\n      </div>\n    </mat-form-field>\n  </div>\n</ng-container>\n", styles: [".form-field-suffix{width:17px;height:17px}.form-field-suffix mat-icon{color:#4caf50;font-size:17px;height:17px!important;width:17px!important;min-width:17px;min-height:17px;font-weight:700!important}.form-field-suffix.input-field-icon-red mat-icon{color:#f44336}\n"], dependencies: [{ kind: "directive", type: i1$3.NgClass, selector: "[ngClass]", inputs: ["class", "ngClass"] }, { kind: "directive", type: i1$3.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "component", type: i2$3.MatFormField, selector: "mat-form-field", inputs: ["hideRequiredMarker", "color", "floatLabel", "appearance", "subscriptSizing", "hintLabel"], exportAs: ["matFormField"] }, { kind: "directive", type: i2$3.MatLabel, selector: "mat-label" }, { kind: "directive", type: i3$1.MatInput, selector: "input[matInput], textarea[matInput], select[matNativeControl],      input[matNativeControl], textarea[matNativeControl]", inputs: ["disabled", "id", "placeholder", "name", "required", "type", "errorStateMatcher", "aria-describedby", "value", "readonly"], exportAs: ["matInput"] }, { kind: "directive", type: i6.DefaultValueAccessor, selector: "input:not([type=checkbox])[formControlName],textarea[formControlName],input:not([type=checkbox])[formControl],textarea[formControl],input:not([type=checkbox])[ngModel],textarea[ngModel],[ngDefaultControl]" }, { kind: "directive", type: i6.NgControlStatus, selector: "[formControlName],[ngModel],[formControl]" }, { kind: "directive", type: i6.NgControlStatusGroup, selector: "[formGroupName],[formArrayName],[ngModelGroup],[formGroup],form:not([ngNoForm]),[ngForm]" }, { kind: "component", type: SpinnerComponent, selector: "shared-spinner", inputs: ["overlay", "diameter", "color", "position"] }, { kind: "directive", type: i6.FormGroupDirective, selector: "[formGroup]", inputs: ["formGroup"], outputs: ["ngSubmit"], exportAs: ["ngForm"] }, { kind: "directive", type: i6.FormControlName, selector: "[formControlName]", inputs: ["formControlName", "disabled", "ngModel"], outputs: ["ngModelChange"] }, { kind: "directive", type: i6$1.MaskDirective, selector: "input[mask], textarea[mask]", inputs: ["mask", "specialCharacters", "patterns", "prefix", "suffix", "thousandSeparator", "decimalMarker", "dropSpecialCharacters", "hiddenInput", "showMaskTyped", "placeHolderCharacter", "shownMaskExpression", "showTemplate", "clearIfNotMatch", "validation", "separatorLimit", "allowNegativeNumbers", "leadZeroDateTime"] }, { kind: "component", type: i2$4.MatIcon, selector: "mat-icon", inputs: ["color", "inline", "svgIcon", "fontSet", "fontIcon"], exportAs: ["matIcon"] }], changeDetection: i0.ChangeDetectionStrategy.OnPush });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "15.2.9", ngImport: i0, type: FormFieldInputComponent, decorators: [{
            type: Component,
            args: [{ selector: 'shared-form-field-input', changeDetection: ChangeDetectionStrategy.OnPush, template: "<ng-container *ngIf=\"form.get(fieldData.field) as field\">\n  <div [formGroup]=\"form\">\n    <mat-form-field appearance=\"outline\"\n                    class=\"width100\">\n      <mat-label>{{fieldData.title}}{{fieldData.validators && fieldData.validators.includes('required') ? ' *' : ''}}</mat-label>\n      <div class=\"display-flex align-baseline \">\n        <ng-container *ngIf=\"inputMask\">\n          <input matInput\n                 #input\n                 [type]=\"inputType\"\n                 [placeholder]=\"placeholder\"\n                 [mask]=\"inputMask\"\n                 [formControlName]=\"fieldData.field\">\n        </ng-container>\n        <ng-container *ngIf=\"!inputMask\">\n          <input matInput\n                 #input\n                 [type]=\"inputType\"\n                 [placeholder]=\"placeholder\"\n                 [formControlName]=\"fieldData.field\">\n        </ng-container>\n        <div class=\"form-field-suffix\"\n             [ngClass]=\"{'input-field-icon-red': !field.valid}\"\n             *ngIf=\"fieldData.asyncValidators && fieldData.asyncValidators.length\">\n          <mat-icon *ngIf=\"field.status !== pendingStatus\"\n                    class=\"secondary-text mat-icon notranslate material-icons mat-icon-no-color\"\n                    role=\"img\" aria-hidden=\"true\">\n            {{field.valid ? 'done' : field.errors['itemUniqValue'] ? 'assignment_late' : ''}}\n          </mat-icon>\n          <shared-spinner *ngIf=\"field.status === pendingStatus\"\n                          [diameter]=\"24\"></shared-spinner>\n        </div>\n      </div>\n    </mat-form-field>\n  </div>\n</ng-container>\n", styles: [".form-field-suffix{width:17px;height:17px}.form-field-suffix mat-icon{color:#4caf50;font-size:17px;height:17px!important;width:17px!important;min-width:17px;min-height:17px;font-weight:700!important}.form-field-suffix.input-field-icon-red mat-icon{color:#f44336}\n"] }]
        }], ctorParameters: function () { return [{ type: i0.ChangeDetectorRef }]; }, propDecorators: { fieldData: [{
                type: Input
            }], form: [{
                type: Input
            }], input: [{
                type: ViewChild,
                args: ['input', { static: false }]
            }] } });

class ImageComponent {
    constructor() {
        this.haveZoom = false;
        this.clickEvent = new EventEmitter();
        this.delete = new EventEmitter();
        this.showDeleteButton = false;
    }
    ngOnInit() {
        this.checkSubscribersForDelete();
    }
    ngOnChanges(changes) {
        if (changes.versions.currentValue) {
            this.setSrc();
        }
    }
    checkSubscribersForDelete() {
        if (this.delete?.observers.length) {
            this.showDeleteButton = true;
        }
    }
    setSrc() {
        if (this.versions && this.version) {
            this.src = this.versions[this.version];
        }
        else if (this.url) {
            this.src = this.url;
        }
    }
    clickHandler() {
        this.clickEvent.emit(this.index);
    }
    deleteImage() {
        this.delete.emit();
    }
}
ImageComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "15.2.9", ngImport: i0, type: ImageComponent, deps: [], target: i0.ɵɵFactoryTarget.Component });
ImageComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "15.2.9", type: ImageComponent, selector: "shared-image", inputs: { versions: "versions", url: "url", version: "version", title: "title", index: "index", haveZoom: "haveZoom", imgClass: "imgClass" }, outputs: { clickEvent: "clickEvent", delete: "delete" }, usesOnChanges: true, ngImport: i0, template: "<div class=\"image-block\">\n  <div *ngIf=\"showDeleteButton\" class=\"form-field-file-close mat-elevation-z4\" (click)=\"deleteImage()\">\n    <mat-icon class=\"fs-14\">close</mat-icon>\n  </div>\n  <ng-container *ngIf=\"src\">\n    <img [src]=\"src\" [title]=\"title\" [alt]=\"title\" [class]=\"imgClass\"/>\n    <div *ngIf=\"haveZoom\" class=\"zoom\" (click)=\"clickHandler();\">\n      <span class=\"lnr lnr-magnifier\"></span>\n    </div>\n  </ng-container>\n  <ng-container *ngIf=\"!src\">\n    <div class=\"default-image\">\n      <img src=\"assets/images/default-image.png\" [alt]=\"title\"/>\n    </div>\n  </ng-container>\n</div>\n", styles: [":host{position:relative}.image-block{position:relative;height:100%}.image-block:hover .form-field-file-close{width:25px;height:25px;opacity:.8}.image-block:hover .form-field-file-close mat-icon{width:18px;min-width:18px;height:18px;min-height:18px;font-size:18px}.image-block .form-field-file-close{right:0;top:0;cursor:pointer;background:#fff;position:absolute;width:15px;height:15px;display:flex;align-items:center;justify-content:center;border-bottom-left-radius:4px;color:#f44336;transition:all .15s ease;opacity:.6}.image-block .form-field-file-close mat-icon{transition:transform .15s ease;width:15px;height:15px;min-width:15px;min-height:15px;margin-left:1px;margin-top:3px}.image-block .form-field-file-close:hover{opacity:1}.image-block .form-field-file-close:hover mat-icon{transform:rotate(90deg)}.image-block .zoom{position:absolute;transition:all .2s ease-in-out;opacity:0;inset:0;background-color:#313131b8;display:flex;align-items:center;justify-content:center;cursor:pointer}.image-block .zoom:hover{opacity:.8}.image-block .zoom .lnr{font-size:20px;font-weight:700;color:#49caff}.image-block .default-image{display:flex;align-items:center;justify-content:center;background-color:#e1eaf1;width:200px;height:150px;opacity:.6}.image-block .default-image img{width:auto!important;height:auto!important}.image-block img{object-fit:cover;width:100%!important;height:100%!important}\n"], dependencies: [{ kind: "directive", type: i1$3.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "component", type: i2$4.MatIcon, selector: "mat-icon", inputs: ["color", "inline", "svgIcon", "fontSet", "fontIcon"], exportAs: ["matIcon"] }], changeDetection: i0.ChangeDetectionStrategy.OnPush });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "15.2.9", ngImport: i0, type: ImageComponent, decorators: [{
            type: Component,
            args: [{ selector: 'shared-image', changeDetection: ChangeDetectionStrategy.OnPush, template: "<div class=\"image-block\">\n  <div *ngIf=\"showDeleteButton\" class=\"form-field-file-close mat-elevation-z4\" (click)=\"deleteImage()\">\n    <mat-icon class=\"fs-14\">close</mat-icon>\n  </div>\n  <ng-container *ngIf=\"src\">\n    <img [src]=\"src\" [title]=\"title\" [alt]=\"title\" [class]=\"imgClass\"/>\n    <div *ngIf=\"haveZoom\" class=\"zoom\" (click)=\"clickHandler();\">\n      <span class=\"lnr lnr-magnifier\"></span>\n    </div>\n  </ng-container>\n  <ng-container *ngIf=\"!src\">\n    <div class=\"default-image\">\n      <img src=\"assets/images/default-image.png\" [alt]=\"title\"/>\n    </div>\n  </ng-container>\n</div>\n", styles: [":host{position:relative}.image-block{position:relative;height:100%}.image-block:hover .form-field-file-close{width:25px;height:25px;opacity:.8}.image-block:hover .form-field-file-close mat-icon{width:18px;min-width:18px;height:18px;min-height:18px;font-size:18px}.image-block .form-field-file-close{right:0;top:0;cursor:pointer;background:#fff;position:absolute;width:15px;height:15px;display:flex;align-items:center;justify-content:center;border-bottom-left-radius:4px;color:#f44336;transition:all .15s ease;opacity:.6}.image-block .form-field-file-close mat-icon{transition:transform .15s ease;width:15px;height:15px;min-width:15px;min-height:15px;margin-left:1px;margin-top:3px}.image-block .form-field-file-close:hover{opacity:1}.image-block .form-field-file-close:hover mat-icon{transform:rotate(90deg)}.image-block .zoom{position:absolute;transition:all .2s ease-in-out;opacity:0;inset:0;background-color:#313131b8;display:flex;align-items:center;justify-content:center;cursor:pointer}.image-block .zoom:hover{opacity:.8}.image-block .zoom .lnr{font-size:20px;font-weight:700;color:#49caff}.image-block .default-image{display:flex;align-items:center;justify-content:center;background-color:#e1eaf1;width:200px;height:150px;opacity:.6}.image-block .default-image img{width:auto!important;height:auto!important}.image-block img{object-fit:cover;width:100%!important;height:100%!important}\n"] }]
        }], ctorParameters: function () { return []; }, propDecorators: { versions: [{
                type: Input
            }], url: [{
                type: Input
            }], version: [{
                type: Input
            }], title: [{
                type: Input
            }], index: [{
                type: Input
            }], haveZoom: [{
                type: Input
            }], imgClass: [{
                type: Input
            }], clickEvent: [{
                type: Output
            }], delete: [{
                type: Output
            }] } });

class FormFieldFileComponent {
    constructor(cd, dialogService, requestsFacade, formDeleteFileFacade) {
        this.cd = cd;
        this.dialogService = dialogService;
        this.requestsFacade = requestsFacade;
        this.formDeleteFileFacade = formDeleteFileFacade;
        this.inputStatus = "1";
        this.formDeleteFile = "form-delete-file";
        this.putMethod = "put";
        this.requestStatuses = RequestStatus;
        this.currentPristineValue = false;
    }
    ngOnInit() {
        this.statusChanges$ = this.form.valueChanges;
        // If the form reset, need to clear the field
        /*
            @TODO Need to test
            this.form.statusChanges
              .pipe(
                untilComponentDestroyed(this)
              )
              .subscribe(() => {
                if (!this.currentPristineValue && this.form.pristine) {
                  this.clearFile();
                }
                this.currentPristineValue = this.form.pristine;
              });*/
    }
    ngOnChanges(changes) {
        const field = this.fieldData.field;
        if (field && this.form) {
            this.imageVersions = this.form.get(field)?.value?.versions || "";
            if (this.imageVersions) {
                this.inputStatus = "0";
            }
        }
    }
    ngOnDestroy() {
    }
    ngAfterViewInit() {
        this.form.get(this.fieldData.field).statusChanges
            .pipe(distinctUntilChanged(), untilComponentDestroyed(this))
            .subscribe(() => {
            this.cd.markForCheck();
        });
    }
    onFileChange(event) {
        if (event.target.files.length > 0) {
            const file = event.target.files[0];
            this.form.get(this.fieldData.field).setValue(file);
            const reader = new FileReader();
            reader.readAsDataURL(file);
            reader.onload = (_event) => {
                this.imageSource = reader.result;
                this.inputStatus = "0";
                this.cd.markForCheck();
            };
        }
    }
    deleteImage() {
        const id = this.form.get("id")?.value;
        const field = this.fieldData.field;
        if (id) {
            this.dialogService.openDeleteDialog()
                .pipe(untilComponentDestroyed(this))
                .subscribe((result) => {
                if (result) {
                    if (!this.imageSource) {
                        this.initRequest();
                        this.formDeleteFileFacade.formDeleteFile(this.entity, id, field);
                        this.form.get(this.fieldData.field).setValue("");
                    }
                    else {
                        this.clearFile();
                    }
                }
            });
        }
    }
    initRequest() {
        if (!this.request$ && this.form.get("id")) {
            this.requestsFacade.createRequestListener(this.formDeleteFile, this.putMethod);
            this.request$ = this.requestsFacade.getRequestUpdates(this.formDeleteFile, this.putMethod);
            this.request$
                .pipe(filter(request => request.status === this.requestStatuses.LOADED), take(1), untilComponentDestroyed(this))
                .subscribe((data) => {
                this.clearFile();
            });
        }
    }
    clearFile() {
        this.input.nativeElement.value = "";
        this.imageSource = "";
        this.imageVersions = null;
        this.inputStatus = "1";
        this.cd.markForCheck();
    }
}
FormFieldFileComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "15.2.9", ngImport: i0, type: FormFieldFileComponent, deps: [{ token: i0.ChangeDetectorRef }, { token: DialogService }, { token: RequestsFacade }, { token: FormDeleteFileFacade }], target: i0.ɵɵFactoryTarget.Component });
FormFieldFileComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "15.2.9", type: FormFieldFileComponent, selector: "shared-form-field-file", inputs: { fieldData: "fieldData", form: "form", entity: "entity" }, viewQueries: [{ propertyName: "input", first: true, predicate: ["input"], descendants: true }], usesOnChanges: true, ngImport: i0, template: "<div class=\"form-field-file\">\n  <div class=\"pb-10 width100\">\n    <div class=\"mb-15 display-flex align-baseline form-field-input border-block\">\n      <mat-label>{{fieldData.title}}{{fieldData.validators && fieldData.validators.includes('required') ? ' *' : ''}}</mat-label>\n      <div\n        @appearFromLeft\n        *ngIf=\"imageSource || imageVersions\"\n        class=\"form-field-file-image\">\n        <div *ngIf=\"imageSource\" class=\"position-relative mat-elevation-z3 image-block\">\n          <div class=\"form-field-file-close mat-elevation-z4\" (click)=\"deleteImage()\">\n            <mat-icon class=\"fs-14\">close</mat-icon>\n          </div>\n          <img [src]=\"imageSource\" alt=\"\">\n        </div>\n        <div *ngIf=\"imageVersions\" class=\"position-relative image-block\">\n          <shared-image\n            class=\"width150100 display-block\"\n            [versions]=\"imageVersions\"\n            [version]=\"1\"\n            (delete)=\"deleteImage()\"></shared-image>\n        </div>\n      </div>\n      <div\n        [@inputAnim]=\"inputStatus\"\n        class=\"input\">\n        <input #input\n               type=\"file\"\n               (change)=\"onFileChange($event)\"/>\n      </div>\n    </div>\n  </div>\n  <shared-spinner\n    *ngIf=\"(request$ | async)?.status === requestStatuses.LOADING\"\n    [overlay]=\"true\"\n    [diameter]=\"20\"\n    [color]=\"'blue'\"></shared-spinner>\n</div>\n", styles: [".form-field-file .form-field-input{transition:all .2s ease;min-height:66px;align-items:center;padding-top:0;padding-bottom:0;position:relative}.form-field-file .form-field-input.height-0{height:0;padding:0;border:0}.form-field-file .form-field-input mat-label{color:#5f5b5b;font-size:12px;padding:0 5px;position:absolute;background-color:#fff;top:-10px;left:10px}.form-field-file .form-field-file-image{position:relative;transition:all .2s ease;overflow:hidden;display:flex;justify-content:flex-start;margin:10px 0}.form-field-file .form-field-file-image.height-100{height:100px}.form-field-file .form-field-file-image img{object-fit:cover;width:150px;height:100px;border-radius:4px;overflow:hidden;background:#fff}.form-field-file .form-field-file-image .form-field-file-close{right:0;top:0;cursor:pointer;background:#fff;position:absolute;width:15px;height:15px;display:flex;align-items:center;justify-content:center;border-bottom-left-radius:4px;color:#f44336;transition:all .15s ease;opacity:.6}.form-field-file .form-field-file-image .form-field-file-close mat-icon{transition:transform .15s ease;width:15px;height:15px;min-width:15px;min-height:15px;margin-left:1px;margin-top:3px}.form-field-file .form-field-file-image .form-field-file-close:hover{opacity:1}.form-field-file .form-field-file-image .form-field-file-close:hover mat-icon{transform:rotate(90deg)}.form-field-file .form-field-file-image .image-block:hover .form-field-file-close{width:25px;height:25px;opacity:.8}.form-field-file .form-field-file-image .image-block:hover .form-field-file-close mat-icon{width:18px;min-width:18px;height:18px;min-height:18px;font-size:18px}.form-field-file .position-absolute{position:absolute}\n"], dependencies: [{ kind: "directive", type: i1$3.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "directive", type: i2$3.MatLabel, selector: "mat-label" }, { kind: "component", type: SpinnerComponent, selector: "shared-spinner", inputs: ["overlay", "diameter", "color", "position"] }, { kind: "component", type: i2$4.MatIcon, selector: "mat-icon", inputs: ["color", "inline", "svgIcon", "fontSet", "fontIcon"], exportAs: ["matIcon"] }, { kind: "component", type: ImageComponent, selector: "shared-image", inputs: ["versions", "url", "version", "title", "index", "haveZoom", "imgClass"], outputs: ["clickEvent", "delete"] }, { kind: "pipe", type: i1$3.AsyncPipe, name: "async" }], animations: [
        appearFromLeft,
        trigger("inputAnim", [
            state("0", style({
                opacity: 0
            })),
            state("1", style({
                opacity: 1
            })),
            transition("0 => 1", [
                animate("500ms")
            ]),
            transition("1 => 0", [
                animate("500ms")
            ])
        ])
    ], changeDetection: i0.ChangeDetectionStrategy.OnPush });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "15.2.9", ngImport: i0, type: FormFieldFileComponent, decorators: [{
            type: Component,
            args: [{ selector: "shared-form-field-file", changeDetection: ChangeDetectionStrategy.OnPush, animations: [
                        appearFromLeft,
                        trigger("inputAnim", [
                            state("0", style({
                                opacity: 0
                            })),
                            state("1", style({
                                opacity: 1
                            })),
                            transition("0 => 1", [
                                animate("500ms")
                            ]),
                            transition("1 => 0", [
                                animate("500ms")
                            ])
                        ])
                    ], template: "<div class=\"form-field-file\">\n  <div class=\"pb-10 width100\">\n    <div class=\"mb-15 display-flex align-baseline form-field-input border-block\">\n      <mat-label>{{fieldData.title}}{{fieldData.validators && fieldData.validators.includes('required') ? ' *' : ''}}</mat-label>\n      <div\n        @appearFromLeft\n        *ngIf=\"imageSource || imageVersions\"\n        class=\"form-field-file-image\">\n        <div *ngIf=\"imageSource\" class=\"position-relative mat-elevation-z3 image-block\">\n          <div class=\"form-field-file-close mat-elevation-z4\" (click)=\"deleteImage()\">\n            <mat-icon class=\"fs-14\">close</mat-icon>\n          </div>\n          <img [src]=\"imageSource\" alt=\"\">\n        </div>\n        <div *ngIf=\"imageVersions\" class=\"position-relative image-block\">\n          <shared-image\n            class=\"width150100 display-block\"\n            [versions]=\"imageVersions\"\n            [version]=\"1\"\n            (delete)=\"deleteImage()\"></shared-image>\n        </div>\n      </div>\n      <div\n        [@inputAnim]=\"inputStatus\"\n        class=\"input\">\n        <input #input\n               type=\"file\"\n               (change)=\"onFileChange($event)\"/>\n      </div>\n    </div>\n  </div>\n  <shared-spinner\n    *ngIf=\"(request$ | async)?.status === requestStatuses.LOADING\"\n    [overlay]=\"true\"\n    [diameter]=\"20\"\n    [color]=\"'blue'\"></shared-spinner>\n</div>\n", styles: [".form-field-file .form-field-input{transition:all .2s ease;min-height:66px;align-items:center;padding-top:0;padding-bottom:0;position:relative}.form-field-file .form-field-input.height-0{height:0;padding:0;border:0}.form-field-file .form-field-input mat-label{color:#5f5b5b;font-size:12px;padding:0 5px;position:absolute;background-color:#fff;top:-10px;left:10px}.form-field-file .form-field-file-image{position:relative;transition:all .2s ease;overflow:hidden;display:flex;justify-content:flex-start;margin:10px 0}.form-field-file .form-field-file-image.height-100{height:100px}.form-field-file .form-field-file-image img{object-fit:cover;width:150px;height:100px;border-radius:4px;overflow:hidden;background:#fff}.form-field-file .form-field-file-image .form-field-file-close{right:0;top:0;cursor:pointer;background:#fff;position:absolute;width:15px;height:15px;display:flex;align-items:center;justify-content:center;border-bottom-left-radius:4px;color:#f44336;transition:all .15s ease;opacity:.6}.form-field-file .form-field-file-image .form-field-file-close mat-icon{transition:transform .15s ease;width:15px;height:15px;min-width:15px;min-height:15px;margin-left:1px;margin-top:3px}.form-field-file .form-field-file-image .form-field-file-close:hover{opacity:1}.form-field-file .form-field-file-image .form-field-file-close:hover mat-icon{transform:rotate(90deg)}.form-field-file .form-field-file-image .image-block:hover .form-field-file-close{width:25px;height:25px;opacity:.8}.form-field-file .form-field-file-image .image-block:hover .form-field-file-close mat-icon{width:18px;min-width:18px;height:18px;min-height:18px;font-size:18px}.form-field-file .position-absolute{position:absolute}\n"] }]
        }], ctorParameters: function () { return [{ type: i0.ChangeDetectorRef }, { type: DialogService }, { type: RequestsFacade }, { type: FormDeleteFileFacade }]; }, propDecorators: { fieldData: [{
                type: Input
            }], form: [{
                type: Input
            }], entity: [{
                type: Input
            }], input: [{
                type: ViewChild,
                args: ["input", { static: false }]
            }] } });

const FileListModeList = 'list';
const FileListModeSort = 'sort';

class FileListCardComponent {
    constructor(filesFacade, notificationsFacade, dialogService, cd, requestsFacade) {
        this.filesFacade = filesFacade;
        this.notificationsFacade = notificationsFacade;
        this.dialogService = dialogService;
        this.cd = cd;
        this.requestsFacade = requestsFacade;
        this.requestStatus = RequestStatus;
        this.ModeSort = FileListModeSort;
        this.edit = false;
        this.filesKey = 'files';
        this.firstRequest = true;
        this.allMethods = '*';
        this.loading = false;
        this.messages = {
            ATTENTION: 'Внимание',
            TITLE_SAVED: 'Заголовок успешно сохранен'
        };
    }
    ngOnInit() {
    }
    ngOnDestroy() {
        this.requestsFacade.deleteRequestWaiter(this.filesKey, this.allMethods, this.file.id);
        this.loading = false;
    }
    ngOnChanges(changes) {
    }
    changeTitle(event) {
        this.currentValue = event.target.value?.trim();
    }
    saveTitle(file) {
        if (this.currentValue !== file.title) {
            this.initRequest();
            this.fileUpdate(file.id, { title: this.currentValue });
        }
        else {
            this.sendNotification(file);
        }
    }
    sendNotification(file) {
        const rand = Math.random();
        this.notificationsFacade.addNotifications({
            id: `file-card-${file.id}-${rand}`,
            type: 'success',
            text: this.messages.TITLE_SAVED,
            title: this.messages.ATTENTION
        });
    }
    fileUpdate(id, params) {
        this.filesFacade.filesUpdate({ ...params, id, section: this.section, itemId: this.itemId });
    }
    fileDelete(id) {
        this.dialogService.openDeleteDialog()
            .pipe(untilComponentDestroyed(this))
            .subscribe((result) => {
            if (result) {
                this.initRequest();
                this.filesFacade.filesDelete(id);
            }
        });
    }
    setMain(id, main) {
        if (!main) {
            this.initRequest();
            this.fileUpdate(id, { main: true });
        }
    }
    editFile() {
        this.edit = true;
        this.cd.markForCheck();
    }
    subscribeToRequest() {
        this.request$
            .pipe(untilComponentDestroyed(this))
            .subscribe(data => {
            if (this.currentStatus !== data.status) {
                if (data.status === this.requestStatus.LOADING) {
                    this.loading = true;
                    this.edit = false;
                }
                if (data.status === this.requestStatus.LOADED) {
                    this.loading = false;
                    this.edit = false;
                }
                this.currentStatus = data.status;
                this.cd.markForCheck();
            }
        });
    }
    initRequest() {
        if (this.firstRequest) {
            this.requestsFacade.createRequestListener(this.filesKey, this.allMethods, this.file.id);
            this.request$ = this.requestsFacade.getRequestUpdates(this.filesKey, this.allMethods, this.file.id);
            this.subscribeToRequest();
            this.firstRequest = false;
        }
    }
}
FileListCardComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "15.2.9", ngImport: i0, type: FileListCardComponent, deps: [{ token: FilesFacade }, { token: NotificationsFacade }, { token: DialogService }, { token: i0.ChangeDetectorRef }, { token: RequestsFacade }], target: i0.ɵɵFactoryTarget.Component });
FileListCardComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "15.2.9", type: FileListCardComponent, selector: "shared-file-list-card", inputs: { file: "file", section: "section", itemId: "itemId", mode: "mode" }, usesOnChanges: true, ngImport: i0, template: "<div class=\"fuse-card\"\n     [ngClass]=\"{'fuse-card-sort': mode === ModeSort}\">\n  <div class=\"top-panel\" fxLayout=\"row\" fxLayoutAlign=\"end center\">\n    <button\n      mat-icon-button\n      aria-label=\"\u0420\u0435\u0434\u0430\u043A\u0442\u0438\u0440\u043E\u0432\u0430\u0442\u044C \u0437\u0430\u0433\u043E\u043B\u043E\u0432\u043E\u043A\"\n      title=\"\u0420\u0435\u0434\u0430\u043A\u0442\u0438\u0440\u043E\u0432\u0430\u0442\u044C \u0437\u0430\u0433\u043E\u043B\u043E\u0432\u043E\u043A\"\n      class=\"color-green\"\n      (click)=\"editFile()\"\n    >\n      <mat-icon>edit</mat-icon>\n    </button>\n    <button mat-icon-button\n            aria-label=\"\u0421\u0434\u0435\u043B\u0430\u0442\u044C \u0433\u043B\u0430\u0432\u043D\u044B\u043C\"\n            title=\"\u0421\u0434\u0435\u043B\u0430\u0442\u044C \u0433\u043B\u0430\u0432\u043D\u044B\u043C\"\n            (click)=\"setMain(file.id, file.main)\"\n            [ngClass]=\"{'cursor-no-pointer': file.main}\">\n      <mat-icon *ngIf=\"!file.main\">star_border</mat-icon>\n      <mat-icon *ngIf=\"file.main\">star</mat-icon>\n    </button>\n    <button\n      mat-icon-button\n      aria-label=\"\u0423\u0434\u0430\u043B\u0438\u0442\u044C \u0444\u0430\u0439\u043B\"\n      title=\"\u0423\u0434\u0430\u043B\u0438\u0442\u044C \u0444\u0430\u0439\u043B\"\n      class=\"color-red\"\n      (click)=\"fileDelete(file.id)\"\n    >\n      <mat-icon>delete_outline</mat-icon>\n    </button>\n  </div>\n  <div class=\"image\"\n       [ngStyle]=\"{'background-image': file.versions ? 'url(' + file.versions[2] + ')' : 'none'}\"></div>\n  <div class=\"p-10 cart-title p-0\"\n       [ngClass]=\"{'edit-title': edit, 'empty-title': !file.title}\">\n    <div class=\"width100 display-flex-space-between edit-block\"\n        [ngClass]=\"{'edit-block-open': edit}\">\n\n      <div *ngIf=\"!edit && file?.title\" class=\"h3\">{{file.title}}</div>\n      <ng-container *ngIf=\"edit\">\n        <textarea type=\"text\"\n                  placeholder=\"Enter image title...\"\n                  class=\"edit-textarea\"\n                  (change)=\"changeTitle($event)\"\n                  [innerText]=\"file && file.title ? file.title : ''\"></textarea>\n        <div class=\"edit-button\">\n          <button\n            mat-icon-button\n            aria-label=\"\u0421\u043E\u0445\u0440\u0430\u043D\u0438\u0442\u044C\"\n            title=\"\u0421\u043E\u0445\u0440\u0430\u043D\u0438\u0442\u044C\"\n            class=\"color-green\"\n            (click)=\"saveTitle(file)\"\n          >\n            <mat-icon>check</mat-icon>\n          </button>\n          <button\n            mat-icon-button\n            aria-label=\"\u041E\u0442\u043C\u0435\u043D\u0438\u0442\u044C\"\n            title=\"\u041E\u0442\u043C\u0435\u043D\u0438\u0442\u044C\"\n            class=\"color-red\"\n            (click)=\"edit = false\"\n          >\n            <mat-icon>close</mat-icon>\n          </button>\n        </div>\n      </ng-container>\n    </div>\n  </div>\n  <shared-spinner\n    *ngIf=\"loading\"\n    [overlay]=\"true\"\n    [diameter]=\"20\"\n    [color]=\"'blue'\"></shared-spinner>\n</div>\n", styles: [":host.cdk-drag-placeholder .fuse-card{z-index:1000}.custom-placeholder{background:#ccc;border:dotted 3px #999;min-height:60px;transition:transform .25s cubic-bezier(0,0,.2,1)}.fuse-card{margin:5px;position:relative;max-width:250px;min-width:250px;max-height:160px;min-height:160px;cursor:move}.fuse-card.fuse-card-sort{max-width:200px;min-width:200px;padding:5px!important}.fuse-card.fuse-card-sort .top-panel,.fuse-card.fuse-card-sort .cart-title{display:none}.fuse-card.fuse-card-sort .image{width:200px;height:100px}.fuse-card:hover .cart-title,.fuse-card:hover .top-panel{background:rgba(239,239,239,.78);transform:scale(1);margin-top:0;margin-right:0}.fuse-card:hover .cart-title button mat-icon,.fuse-card:hover .top-panel button mat-icon{transform:scale(.8)}.fuse-card:hover .cart-title .h3{font-size:14px}.fuse-card .image{width:250px;height:160px;text-align:center;background-size:cover;background-position:center top;border-radius:6px;overflow:hidden}.fuse-card .top-panel,.fuse-card .cart-title{background:rgba(239,239,239,.5);transition:all .2s linear}.fuse-card .top-panel:hover,.fuse-card .cart-title:hover{background:rgb(239,239,239)}.fuse-card .top-panel{position:absolute;right:0;border-bottom-left-radius:12px;transform:scale(.8);margin-top:-4px;margin-right:-12px}.fuse-card .top-panel button.color-green mat-icon{color:#236126cc}.fuse-card .top-panel button.color-green:hover mat-icon{color:#4caf50}.fuse-card .top-panel button.color-red mat-icon{color:#f44336cc}.fuse-card .top-panel button.color-red:hover mat-icon{color:#f44336}.fuse-card .top-panel button mat-icon{color:#323232cc}.fuse-card .top-panel button mat-icon{transition:all .2s linear;transform:scale(1)}.fuse-card .top-panel button:hover mat-icon{color:#000;transform:scale(1)}.fuse-card .top-panel button mat-icon{font-size:20px}.fuse-card .cart-title{position:absolute;left:0;right:0;bottom:0;font-size:12px;padding:10px;display:flex;transition:all .3s linear;border-bottom-left-radius:5px;border-bottom-right-radius:5px}.fuse-card .cart-title.empty-title{background:transparent}.fuse-card .cart-title.edit-title{background:#fff}.fuse-card .cart-title.edit-title button mat-icon:hover{color:#7f7f7f}.fuse-card .cart-title .h3{flex-grow:1;padding:9px 5px 9px 10px;color:#fff;white-space:nowrap;text-overflow:ellipsis;overflow:hidden;transition:all .2s linear;font-size:12px}.fuse-card .cart-title .h3:hover{color:#079be5}.fuse-card .cart-title .edit-block{transition:all .2s linear}.fuse-card .cart-title .edit-block.edit-block-open{background:#f5f5f5}.fuse-card .cart-title textarea.edit-textarea{flex-grow:1;background-color:transparent;border:0;resize:none;padding:5px 0 5px 5px}.fuse-card .cart-title .edit-button{width:40px}.fuse-card .cart-title .edit-button button mat-icon{color:#d0d0d0;transition:all .2s linear}.fuse-card .cart-title .edit-button button mat-icon:hover{color:#fff;box-shadow:0 0 3px}.fuse-card.fuse-card-sort{padding:20px 10px;border-right:solid 1px #ccc;color:#000000de;display:flex;flex-direction:row;align-items:center;justify-content:space-between;box-sizing:border-box;cursor:move;background:white;font-size:14px;flex-grow:1;flex-basis:0}.cdk-drag-preview{box-sizing:border-box;border-radius:4px;box-shadow:0 5px 5px -3px #0003,0 8px 10px 1px #00000024,0 3px 14px 2px #0000001f}.cdk-drag-placeholder{opacity:0}.cdk-drag-animating{transition:transform .25s cubic-bezier(0,0,.2,1)}.fuse-card:last-child{border:none}.card-list.cdk-drop-list-dragging .fuse-card:not(.cdk-drag-placeholder){transition:transform .25s cubic-bezier(0,0,.2,1)}\n"], dependencies: [{ kind: "directive", type: i1$3.NgClass, selector: "[ngClass]", inputs: ["class", "ngClass"] }, { kind: "directive", type: i1$3.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "directive", type: i1$3.NgStyle, selector: "[ngStyle]", inputs: ["ngStyle"] }, { kind: "component", type: i2$4.MatIcon, selector: "mat-icon", inputs: ["color", "inline", "svgIcon", "fontSet", "fontIcon"], exportAs: ["matIcon"] }, { kind: "component", type: SpinnerComponent, selector: "shared-spinner", inputs: ["overlay", "diameter", "color", "position"] }, { kind: "component", type: i5.MatIconButton, selector: "button[mat-icon-button]", inputs: ["disabled", "disableRipple", "color"], exportAs: ["matButton"] }, { kind: "directive", type: i9.DefaultLayoutDirective, selector: "  [fxLayout], [fxLayout.xs], [fxLayout.sm], [fxLayout.md],  [fxLayout.lg], [fxLayout.xl], [fxLayout.lt-sm], [fxLayout.lt-md],  [fxLayout.lt-lg], [fxLayout.lt-xl], [fxLayout.gt-xs], [fxLayout.gt-sm],  [fxLayout.gt-md], [fxLayout.gt-lg]", inputs: ["fxLayout", "fxLayout.xs", "fxLayout.sm", "fxLayout.md", "fxLayout.lg", "fxLayout.xl", "fxLayout.lt-sm", "fxLayout.lt-md", "fxLayout.lt-lg", "fxLayout.lt-xl", "fxLayout.gt-xs", "fxLayout.gt-sm", "fxLayout.gt-md", "fxLayout.gt-lg"] }, { kind: "directive", type: i9.DefaultLayoutAlignDirective, selector: "  [fxLayoutAlign], [fxLayoutAlign.xs], [fxLayoutAlign.sm], [fxLayoutAlign.md],  [fxLayoutAlign.lg], [fxLayoutAlign.xl], [fxLayoutAlign.lt-sm], [fxLayoutAlign.lt-md],  [fxLayoutAlign.lt-lg], [fxLayoutAlign.lt-xl], [fxLayoutAlign.gt-xs], [fxLayoutAlign.gt-sm],  [fxLayoutAlign.gt-md], [fxLayoutAlign.gt-lg]", inputs: ["fxLayoutAlign", "fxLayoutAlign.xs", "fxLayoutAlign.sm", "fxLayoutAlign.md", "fxLayoutAlign.lg", "fxLayoutAlign.xl", "fxLayoutAlign.lt-sm", "fxLayoutAlign.lt-md", "fxLayoutAlign.lt-lg", "fxLayoutAlign.lt-xl", "fxLayoutAlign.gt-xs", "fxLayoutAlign.gt-sm", "fxLayoutAlign.gt-md", "fxLayoutAlign.gt-lg"] }], changeDetection: i0.ChangeDetectionStrategy.OnPush });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "15.2.9", ngImport: i0, type: FileListCardComponent, decorators: [{
            type: Component,
            args: [{ selector: 'shared-file-list-card', changeDetection: ChangeDetectionStrategy.OnPush, template: "<div class=\"fuse-card\"\n     [ngClass]=\"{'fuse-card-sort': mode === ModeSort}\">\n  <div class=\"top-panel\" fxLayout=\"row\" fxLayoutAlign=\"end center\">\n    <button\n      mat-icon-button\n      aria-label=\"\u0420\u0435\u0434\u0430\u043A\u0442\u0438\u0440\u043E\u0432\u0430\u0442\u044C \u0437\u0430\u0433\u043E\u043B\u043E\u0432\u043E\u043A\"\n      title=\"\u0420\u0435\u0434\u0430\u043A\u0442\u0438\u0440\u043E\u0432\u0430\u0442\u044C \u0437\u0430\u0433\u043E\u043B\u043E\u0432\u043E\u043A\"\n      class=\"color-green\"\n      (click)=\"editFile()\"\n    >\n      <mat-icon>edit</mat-icon>\n    </button>\n    <button mat-icon-button\n            aria-label=\"\u0421\u0434\u0435\u043B\u0430\u0442\u044C \u0433\u043B\u0430\u0432\u043D\u044B\u043C\"\n            title=\"\u0421\u0434\u0435\u043B\u0430\u0442\u044C \u0433\u043B\u0430\u0432\u043D\u044B\u043C\"\n            (click)=\"setMain(file.id, file.main)\"\n            [ngClass]=\"{'cursor-no-pointer': file.main}\">\n      <mat-icon *ngIf=\"!file.main\">star_border</mat-icon>\n      <mat-icon *ngIf=\"file.main\">star</mat-icon>\n    </button>\n    <button\n      mat-icon-button\n      aria-label=\"\u0423\u0434\u0430\u043B\u0438\u0442\u044C \u0444\u0430\u0439\u043B\"\n      title=\"\u0423\u0434\u0430\u043B\u0438\u0442\u044C \u0444\u0430\u0439\u043B\"\n      class=\"color-red\"\n      (click)=\"fileDelete(file.id)\"\n    >\n      <mat-icon>delete_outline</mat-icon>\n    </button>\n  </div>\n  <div class=\"image\"\n       [ngStyle]=\"{'background-image': file.versions ? 'url(' + file.versions[2] + ')' : 'none'}\"></div>\n  <div class=\"p-10 cart-title p-0\"\n       [ngClass]=\"{'edit-title': edit, 'empty-title': !file.title}\">\n    <div class=\"width100 display-flex-space-between edit-block\"\n        [ngClass]=\"{'edit-block-open': edit}\">\n\n      <div *ngIf=\"!edit && file?.title\" class=\"h3\">{{file.title}}</div>\n      <ng-container *ngIf=\"edit\">\n        <textarea type=\"text\"\n                  placeholder=\"Enter image title...\"\n                  class=\"edit-textarea\"\n                  (change)=\"changeTitle($event)\"\n                  [innerText]=\"file && file.title ? file.title : ''\"></textarea>\n        <div class=\"edit-button\">\n          <button\n            mat-icon-button\n            aria-label=\"\u0421\u043E\u0445\u0440\u0430\u043D\u0438\u0442\u044C\"\n            title=\"\u0421\u043E\u0445\u0440\u0430\u043D\u0438\u0442\u044C\"\n            class=\"color-green\"\n            (click)=\"saveTitle(file)\"\n          >\n            <mat-icon>check</mat-icon>\n          </button>\n          <button\n            mat-icon-button\n            aria-label=\"\u041E\u0442\u043C\u0435\u043D\u0438\u0442\u044C\"\n            title=\"\u041E\u0442\u043C\u0435\u043D\u0438\u0442\u044C\"\n            class=\"color-red\"\n            (click)=\"edit = false\"\n          >\n            <mat-icon>close</mat-icon>\n          </button>\n        </div>\n      </ng-container>\n    </div>\n  </div>\n  <shared-spinner\n    *ngIf=\"loading\"\n    [overlay]=\"true\"\n    [diameter]=\"20\"\n    [color]=\"'blue'\"></shared-spinner>\n</div>\n", styles: [":host.cdk-drag-placeholder .fuse-card{z-index:1000}.custom-placeholder{background:#ccc;border:dotted 3px #999;min-height:60px;transition:transform .25s cubic-bezier(0,0,.2,1)}.fuse-card{margin:5px;position:relative;max-width:250px;min-width:250px;max-height:160px;min-height:160px;cursor:move}.fuse-card.fuse-card-sort{max-width:200px;min-width:200px;padding:5px!important}.fuse-card.fuse-card-sort .top-panel,.fuse-card.fuse-card-sort .cart-title{display:none}.fuse-card.fuse-card-sort .image{width:200px;height:100px}.fuse-card:hover .cart-title,.fuse-card:hover .top-panel{background:rgba(239,239,239,.78);transform:scale(1);margin-top:0;margin-right:0}.fuse-card:hover .cart-title button mat-icon,.fuse-card:hover .top-panel button mat-icon{transform:scale(.8)}.fuse-card:hover .cart-title .h3{font-size:14px}.fuse-card .image{width:250px;height:160px;text-align:center;background-size:cover;background-position:center top;border-radius:6px;overflow:hidden}.fuse-card .top-panel,.fuse-card .cart-title{background:rgba(239,239,239,.5);transition:all .2s linear}.fuse-card .top-panel:hover,.fuse-card .cart-title:hover{background:rgb(239,239,239)}.fuse-card .top-panel{position:absolute;right:0;border-bottom-left-radius:12px;transform:scale(.8);margin-top:-4px;margin-right:-12px}.fuse-card .top-panel button.color-green mat-icon{color:#236126cc}.fuse-card .top-panel button.color-green:hover mat-icon{color:#4caf50}.fuse-card .top-panel button.color-red mat-icon{color:#f44336cc}.fuse-card .top-panel button.color-red:hover mat-icon{color:#f44336}.fuse-card .top-panel button mat-icon{color:#323232cc}.fuse-card .top-panel button mat-icon{transition:all .2s linear;transform:scale(1)}.fuse-card .top-panel button:hover mat-icon{color:#000;transform:scale(1)}.fuse-card .top-panel button mat-icon{font-size:20px}.fuse-card .cart-title{position:absolute;left:0;right:0;bottom:0;font-size:12px;padding:10px;display:flex;transition:all .3s linear;border-bottom-left-radius:5px;border-bottom-right-radius:5px}.fuse-card .cart-title.empty-title{background:transparent}.fuse-card .cart-title.edit-title{background:#fff}.fuse-card .cart-title.edit-title button mat-icon:hover{color:#7f7f7f}.fuse-card .cart-title .h3{flex-grow:1;padding:9px 5px 9px 10px;color:#fff;white-space:nowrap;text-overflow:ellipsis;overflow:hidden;transition:all .2s linear;font-size:12px}.fuse-card .cart-title .h3:hover{color:#079be5}.fuse-card .cart-title .edit-block{transition:all .2s linear}.fuse-card .cart-title .edit-block.edit-block-open{background:#f5f5f5}.fuse-card .cart-title textarea.edit-textarea{flex-grow:1;background-color:transparent;border:0;resize:none;padding:5px 0 5px 5px}.fuse-card .cart-title .edit-button{width:40px}.fuse-card .cart-title .edit-button button mat-icon{color:#d0d0d0;transition:all .2s linear}.fuse-card .cart-title .edit-button button mat-icon:hover{color:#fff;box-shadow:0 0 3px}.fuse-card.fuse-card-sort{padding:20px 10px;border-right:solid 1px #ccc;color:#000000de;display:flex;flex-direction:row;align-items:center;justify-content:space-between;box-sizing:border-box;cursor:move;background:white;font-size:14px;flex-grow:1;flex-basis:0}.cdk-drag-preview{box-sizing:border-box;border-radius:4px;box-shadow:0 5px 5px -3px #0003,0 8px 10px 1px #00000024,0 3px 14px 2px #0000001f}.cdk-drag-placeholder{opacity:0}.cdk-drag-animating{transition:transform .25s cubic-bezier(0,0,.2,1)}.fuse-card:last-child{border:none}.card-list.cdk-drop-list-dragging .fuse-card:not(.cdk-drag-placeholder){transition:transform .25s cubic-bezier(0,0,.2,1)}\n"] }]
        }], ctorParameters: function () { return [{ type: FilesFacade }, { type: NotificationsFacade }, { type: DialogService }, { type: i0.ChangeDetectorRef }, { type: RequestsFacade }]; }, propDecorators: { file: [{
                type: Input
            }], section: [{
                type: Input
            }], itemId: [{
                type: Input
            }], mode: [{
                type: Input
            }] } });

class FilesUploadListImagesComponent {
    constructor(filesFacade) {
        this.filesFacade = filesFacade;
        this.mode = FileListModeList;
        this.changeSort = new EventEmitter();
        this.loaded = false;
        this.trackById = trackById;
        this.storedFirstSorting = [];
    }
    ngOnInit() {
        this.getFiles();
    }
    ngOnDestroy() {
    }
    getFiles() {
        this.files$ = this.filesFacade.getFiles({
            itemId: this.itemId,
            section: this.section,
            type: this.filesType
        })
            .pipe(map((files) => {
            if (files && files.length) {
                this.files = files.sort(this.sortFiles);
                this.storedFirstSorting = this.saveFirstSorting(this.files);
                return this.prepareFiles(files);
            }
            return files;
        }), untilComponentDestroyed(this));
    }
    saveFirstSorting(files) {
        return files.map((item, order) => ({ id: item.id, order }));
    }
    sortFiles(a, b) {
        // @ts-ignore
        if (a.order < b.order)
            return -1;
        // @ts-ignore
        if (a.order > b.order)
            return 1;
        return 0;
    }
    prepareFiles(files) {
        let mapFiles;
        if (files) {
            mapFiles = files.sort((a, b) => a.sort - b.sort);
            mapFiles
                .map(file => ({ ...file }))
                .forEach(item => {
                item.edit = false;
                if (!item.title) {
                    item.title = '';
                }
            });
        }
        this.loaded = true;
        return mapFiles;
    }
    drop(event) {
        moveItemInArray(this.files, event.previousIndex, event.currentIndex);
        const newSorting = [];
        this.files.forEach((item, index) => {
            // @ts-ignore
            newSorting.push({ id: item.id, order: index });
        });
        this.changeSort.emit({ newSorting, storedSorting: this.storedFirstSorting });
    }
}
FilesUploadListImagesComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "15.2.9", ngImport: i0, type: FilesUploadListImagesComponent, deps: [{ token: FilesFacade }], target: i0.ɵɵFactoryTarget.Component });
FilesUploadListImagesComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "15.2.9", type: FilesUploadListImagesComponent, selector: "shared-files-upload-list-images", inputs: { section: "section", filesType: "filesType", itemId: "itemId", mode: "mode" }, outputs: { changeSort: "changeSort" }, ngImport: i0, template: "<div class=\"cards position-relative\">\n  <ng-container *ngIf=\"files$ | async as files; else loading\">\n    <div *ngIf=\"files.length\"\n         cdkDropList\n         cdkDropListOrientation=\"horizontal\"\n         (cdkDropListDropped)=\"drop($event)\"\n         class=\"card-list\">\n      <!-- trackBy: trackById -->\n      <shared-file-list-card\n        cdkDrag\n        *ngFor=\"let file of files;\"\n        @hideToTopOpacity\n        [file]=\"file\"\n        [section]=\"section\"\n        [itemId]=\"itemId\"></shared-file-list-card>\n    </div>\n    <div *ngIf=\"!files.length\" class=\"empty-list\">\n      \u0421\u043F\u0438\u0441\u043E\u043A \u043F\u0443\u0441\u0442\n    </div>\n  </ng-container>\n</div>\n<ng-template #loading>\n  <shared-spinner [overlay]=\"true\"></shared-spinner>\n</ng-template>\n", styles: [".image{text-align:center;background-size:cover;background-position:center top;width:318px;height:200px;border-radius:6px;overflow:hidden}.custom-placeholder{background:#ccc;border:dotted 3px #999;min-height:60px;transition:transform .25s cubic-bezier(0,0,.2,1)}.cards,.card-list{display:flex;flex-wrap:wrap}.card-list-sort{flex-direction:column;flex-wrap:nowrap;overflow:hidden}.cdk-drag-preview{box-sizing:border-box;border-radius:4px;box-shadow:0 5px 5px -3px #0003,0 8px 10px 1px #00000024,0 3px 14px 2px #0000001f}.cdk-drag-placeholder{opacity:0}.cdk-drag-animating{transition:transform .25s cubic-bezier(0,0,.2,1)}.fuse-card:last-child{border:none}.card-list.cdk-drop-list-dragging .fuse-card:not(.cdk-drag-placeholder){transition:transform .25s cubic-bezier(0,0,.2,1)}\n"], dependencies: [{ kind: "directive", type: i1$3.NgForOf, selector: "[ngFor][ngForOf]", inputs: ["ngForOf", "ngForTrackBy", "ngForTemplate"] }, { kind: "directive", type: i1$3.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "directive", type: i3$2.CdkDropList, selector: "[cdkDropList], cdk-drop-list", inputs: ["cdkDropListConnectedTo", "cdkDropListData", "cdkDropListOrientation", "id", "cdkDropListLockAxis", "cdkDropListDisabled", "cdkDropListSortingDisabled", "cdkDropListEnterPredicate", "cdkDropListSortPredicate", "cdkDropListAutoScrollDisabled", "cdkDropListAutoScrollStep"], outputs: ["cdkDropListDropped", "cdkDropListEntered", "cdkDropListExited", "cdkDropListSorted"], exportAs: ["cdkDropList"] }, { kind: "directive", type: i3$2.CdkDrag, selector: "[cdkDrag]", inputs: ["cdkDragData", "cdkDragLockAxis", "cdkDragRootElement", "cdkDragBoundary", "cdkDragStartDelay", "cdkDragFreeDragPosition", "cdkDragDisabled", "cdkDragConstrainPosition", "cdkDragPreviewClass", "cdkDragPreviewContainer"], outputs: ["cdkDragStarted", "cdkDragReleased", "cdkDragEnded", "cdkDragEntered", "cdkDragExited", "cdkDragDropped", "cdkDragMoved"], exportAs: ["cdkDrag"] }, { kind: "component", type: SpinnerComponent, selector: "shared-spinner", inputs: ["overlay", "diameter", "color", "position"] }, { kind: "component", type: FileListCardComponent, selector: "shared-file-list-card", inputs: ["file", "section", "itemId", "mode"] }, { kind: "pipe", type: i1$3.AsyncPipe, name: "async" }], animations: [hideToTopOpacity], changeDetection: i0.ChangeDetectionStrategy.OnPush });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "15.2.9", ngImport: i0, type: FilesUploadListImagesComponent, decorators: [{
            type: Component,
            args: [{ selector: 'shared-files-upload-list-images', changeDetection: ChangeDetectionStrategy.OnPush, animations: [hideToTopOpacity], template: "<div class=\"cards position-relative\">\n  <ng-container *ngIf=\"files$ | async as files; else loading\">\n    <div *ngIf=\"files.length\"\n         cdkDropList\n         cdkDropListOrientation=\"horizontal\"\n         (cdkDropListDropped)=\"drop($event)\"\n         class=\"card-list\">\n      <!-- trackBy: trackById -->\n      <shared-file-list-card\n        cdkDrag\n        *ngFor=\"let file of files;\"\n        @hideToTopOpacity\n        [file]=\"file\"\n        [section]=\"section\"\n        [itemId]=\"itemId\"></shared-file-list-card>\n    </div>\n    <div *ngIf=\"!files.length\" class=\"empty-list\">\n      \u0421\u043F\u0438\u0441\u043E\u043A \u043F\u0443\u0441\u0442\n    </div>\n  </ng-container>\n</div>\n<ng-template #loading>\n  <shared-spinner [overlay]=\"true\"></shared-spinner>\n</ng-template>\n", styles: [".image{text-align:center;background-size:cover;background-position:center top;width:318px;height:200px;border-radius:6px;overflow:hidden}.custom-placeholder{background:#ccc;border:dotted 3px #999;min-height:60px;transition:transform .25s cubic-bezier(0,0,.2,1)}.cards,.card-list{display:flex;flex-wrap:wrap}.card-list-sort{flex-direction:column;flex-wrap:nowrap;overflow:hidden}.cdk-drag-preview{box-sizing:border-box;border-radius:4px;box-shadow:0 5px 5px -3px #0003,0 8px 10px 1px #00000024,0 3px 14px 2px #0000001f}.cdk-drag-placeholder{opacity:0}.cdk-drag-animating{transition:transform .25s cubic-bezier(0,0,.2,1)}.fuse-card:last-child{border:none}.card-list.cdk-drop-list-dragging .fuse-card:not(.cdk-drag-placeholder){transition:transform .25s cubic-bezier(0,0,.2,1)}\n"] }]
        }], ctorParameters: function () { return [{ type: FilesFacade }]; }, propDecorators: { section: [{
                type: Input
            }], filesType: [{
                type: Input
            }], itemId: [{
                type: Input
            }], mode: [{
                type: Input
            }], changeSort: [{
                type: Output
            }] } });

class TableFilesUploadingComponent {
    constructor(filesFacade, notificationsFacade, changeDetectorRef, authenticationService, config) {
        this.filesFacade = filesFacade;
        this.notificationsFacade = notificationsFacade;
        this.changeDetectorRef = changeDetectorRef;
        this.authenticationService = authenticationService;
        this.config = config;
        this.haveElevation = true;
        this.loadingCompleted = new EventEmitter();
        this.hasBaseDropZoneOver = false;
        this.loaded = false;
        this.allProgress$ = new Subject();
        this.itemsProgress$ = new Subject();
        this.itemsProgress = {};
        this.showInputs = true;
    }
    ngOnInit() {
        this.allProgress$.next(0);
        this.itemsProgress$.next({});
        this.initUploader();
    }
    ngOnDestroy() {
        this.allProgress$.complete();
        this.itemsProgress$.complete();
    }
    initUploader() {
        this.publicUrl = this.config.publicUrl;
        const apiUrl = this.config.apiUrl;
        const { token } = this.authenticationService.loadAuthDataFromLocalStore();
        const uploadUrl = `${apiUrl}/api/files/${this.section}/${this.itemId}`;
        this.url = `${this.publicUrl}/${this.section}/${this.itemId}`;
        this.uploader = new FileUploader({
            url: uploadUrl,
            authToken: `JWT ${token}`,
            isHTML5: true,
            autoUpload: true
        });
        this.uploader.onProgressItem = (item, progress) => this.onProgressItem(item, progress);
        this.uploader.onProgressAll = (progress) => this.onProgressAll(progress);
        this.uploader.onErrorItem = (item, response, status, headers) => this.onErrorItem(item, response, status, headers);
        this.uploader.onAfterAddingFile = () => this.onAfterAddingFile();
        this.uploader.onCompleteAll = this.onCompleteAll.bind(this);
    }
    onToggleImageBlockDone(e) {
        if (e.toState === 'open') {
        }
    }
    fileOverBase(e) {
        this.hasBaseDropZoneOver = e;
    }
    onAfterAddingFile() {
        this.showInputs = false;
        this.changeDetectorRef.markForCheck();
    }
    onProgressItem(fileItem, progress) {
        const fileName = fileItem.file.name;
        this.itemsProgress[fileName] = progress;
        this.itemsProgress$.next(this.itemsProgress);
    }
    onProgressAll(progress) {
        this.allProgress$.next(progress);
    }
    onCompleteAll() {
        this.notificationsFacade.addNotifications({
            type: 'success',
            text: 'Картинки успешно загружены',
            id: 'images.uploads',
            timeout: 2000
        });
        this.filesFacade.loadFiles({ itemId: this.itemId, section: this.section });
        this.loadingCompleted.emit();
    }
    onErrorItem(item, response, status, headers) {
        this.notificationsFacade.addNotifications({
            type: 'error',
            text: 'При загрузке возникли ошибки, попробуйте еще раз',
            title: 'Ошибка',
            id: 'images.uploads'
        });
    }
}
TableFilesUploadingComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "15.2.9", ngImport: i0, type: TableFilesUploadingComponent, deps: [{ token: FilesFacade }, { token: NotificationsFacade }, { token: i0.ChangeDetectorRef }, { token: AuthenticationService }, { token: CORE_CONFIG }], target: i0.ɵɵFactoryTarget.Component });
TableFilesUploadingComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "15.2.9", type: TableFilesUploadingComponent, selector: "shared-table-files-uploading", inputs: { section: "section", itemId: "itemId", haveElevation: "haveElevation" }, outputs: { loadingCompleted: "loadingCompleted" }, ngImport: i0, template: "<div\n  class=\"page-layout simple fullwidth fileUploads\"\n  fxLayout=\"column\">\n  <!-- CONTENT -->\n  <div class=\"p-24\"\n       [ngClass]=\"{'mat-card mat-elevation-z4': haveElevation}\">\n    <div class=\"row\">\n      <div class=\"col-md-12\" *ngIf=\"!uploader.queue.length\" [@appearFromLeftHideToRight]>\n        <div class=\"h2 mb-24\">\u0412\u044B\u0431\u0435\u0440\u0438\u0442\u0435 \u0444\u0430\u0439\u043B\u044B</div>\n        <div ng2FileDrop\n             [ngClass]=\"{'nv-file-over': hasBaseDropZoneOver}\"\n             (fileOver)=\"fileOverBase($event)\"\n             [uploader]=\"uploader\"\n             class=\"well my-drop-zone\">\n          \u041F\u0435\u0440\u0435\u043D\u0435\u0441\u0438\u0442\u0435 \u0444\u0430\u0439\u043B\u044B\n        </div>\n        <div class=\"p-5\">\n          \u0412\u044B\u0431\u0435\u0440\u0438\u0442\u0435 \u0444\u0430\u0439\u043B\u044B: <input type=\"file\" ng2FileSelect [uploader]=\"uploader\" multiple/><br/>\n        </div>\n      </div>\n\n      <div *ngIf=\"uploader && uploader.queue.length\" [@appearFromLeftHideToRight] class=\"col-md-12\">\n        <ng-container *ngIf=\"allProgress$ | async as allProgress\">\n          <ng-container *ngIf=\"itemsProgress$ | async as itemsProgress\">\n          <ng-container *ngIf=\"allProgress !== 100\">\n            <h3>\u0417\u0430\u0433\u0440\u0443\u0437\u043A\u0430 \u043A\u0430\u0440\u0442\u0438\u043D\u043E\u043A</h3>\n            <table class=\"table\">\n              <thead>\n              <tr>\n                <th width=\"50%\">\u0424\u0430\u0439\u043B</th>\n                <th>\u0420\u0430\u0437\u043C\u0435\u0440</th>\n                <th>\u041F\u0440\u043E\u0433\u0440\u0435\u0441\u0441</th>\n              </tr>\n              </thead>\n              <tbody>\n              <ng-container *ngFor=\"let item of uploader.queue\">\n                <tr [@appearFromLeftHideToRight] *ngIf=\"itemsProgress[item?.file?.name] !== 100\">\n                  <td><strong>{{ item?.file?.name }}</strong></td>\n                  <td nowrap>{{ item?.file?.size / 1024 / 1024 | number:'.2' }} MB</td>\n                  <td>\n                    <div class=\"progress\">\n                      <mat-progress-bar\n                        class=\"example-margin\"\n                        color=\"warn\"\n                        mode=\"determinate\"\n                        [value]=\"itemsProgress[item?.file?.name] || 0\">\n                      </mat-progress-bar>\n                    </div>\n                  </td>\n                </tr>\n              </ng-container>\n              </tbody>\n            </table>\n            <div>\n              <div class=\"progress-block\">\n                Queue progress:\n                <div class=\"progress\">\n                  <mat-progress-bar\n                    class=\"example-margin\"\n                    color=\"warn\"\n                    mode=\"determinate\"\n                    [value]=\"allProgress\">\n                  </mat-progress-bar>\n                </div>\n              </div>\n              <!--<div class=\"text-right\">\n                <button mat-flat-button color=\"accent\"\n                        class=\"mr-5\"\n                        (click)=\"uploader.uploadAll()\"\n                        [disabled]=\"!uploader.getNotUploadedItems().length\">\n                  <mat-icon class=\"fs-18\">get_app</mat-icon>\n                  \u0417\u0430\u0433\u0440\u0443\u0437\u0438\u0442\u044C \u0432\u0441\u0435\n                </button>\n                <button mat-flat-button color=\"primary\"\n                        class=\"mr-5\"\n                        (click)=\"uploader.cancelAll()\"\n                        [disabled]=\"!uploader.isUploading\">\n                  <mat-icon class=\"fs-18\">clear</mat-icon>\n                  \u041E\u0442\u043C\u0435\u043D\u0438\u0442\u044C \u0432\u0441\u0435\n                </button>\n                <button mat-flat-button color=\"warn\"\n                        class=\"mr-5\"\n                        (click)=\"uploader.clearQueue()\"\n                        [disabled]=\"!uploader.queue.length\">\n                  <mat-icon class=\"fs-18\">delete_outline</mat-icon>\n                  \u0423\u0434\u0430\u043B\u0438\u0442\u044C \u0432\u0441\u0435\n                </button>\n              </div>-->\n            </div>\n          </ng-container>\n          </ng-container>\n        </ng-container>\n      </div>\n    </div>\n  </div>\n</div>\n", styles: [":host{display:block}.fileUploads{margin-bottom:10px;margin-left:-5px}.fileUploads .mat-card{margin:5px}.nv-file-over{border:dotted 3px red}.cursor-no-pointer{cursor:auto}.table{width:100%}.table tr{line-height:40px;border-top:1px solid #efefef}.table thead{background:#efefef}.table thead th{padding:0 10px}.my-drop-zone{border:dotted 3px lightgray;padding:10px;margin-bottom:10px}\n"], dependencies: [{ kind: "directive", type: i1$3.NgClass, selector: "[ngClass]", inputs: ["class", "ngClass"] }, { kind: "directive", type: i1$3.NgForOf, selector: "[ngFor][ngForOf]", inputs: ["ngForOf", "ngForTrackBy", "ngForTemplate"] }, { kind: "directive", type: i1$3.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "component", type: i5$2.MatProgressBar, selector: "mat-progress-bar", inputs: ["color", "value", "bufferValue", "mode"], outputs: ["animationEnd"], exportAs: ["matProgressBar"] }, { kind: "directive", type: i6$2.FileDropDirective, selector: "[ng2FileDrop]", inputs: ["uploader"], outputs: ["fileOver", "onFileDrop"] }, { kind: "directive", type: i6$2.FileSelectDirective, selector: "[ng2FileSelect]", inputs: ["uploader"], outputs: ["onFileSelected"] }, { kind: "directive", type: i9.DefaultLayoutDirective, selector: "  [fxLayout], [fxLayout.xs], [fxLayout.sm], [fxLayout.md],  [fxLayout.lg], [fxLayout.xl], [fxLayout.lt-sm], [fxLayout.lt-md],  [fxLayout.lt-lg], [fxLayout.lt-xl], [fxLayout.gt-xs], [fxLayout.gt-sm],  [fxLayout.gt-md], [fxLayout.gt-lg]", inputs: ["fxLayout", "fxLayout.xs", "fxLayout.sm", "fxLayout.md", "fxLayout.lg", "fxLayout.xl", "fxLayout.lt-sm", "fxLayout.lt-md", "fxLayout.lt-lg", "fxLayout.lt-xl", "fxLayout.gt-xs", "fxLayout.gt-sm", "fxLayout.gt-md", "fxLayout.gt-lg"] }, { kind: "pipe", type: i1$3.AsyncPipe, name: "async" }, { kind: "pipe", type: i1$3.DecimalPipe, name: "number" }], animations: [
        hideToTopOpacity,
        appearFromLeftHideToRight
    ], changeDetection: i0.ChangeDetectionStrategy.OnPush });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "15.2.9", ngImport: i0, type: TableFilesUploadingComponent, decorators: [{
            type: Component,
            args: [{ selector: 'shared-table-files-uploading', animations: [
                        hideToTopOpacity,
                        appearFromLeftHideToRight
                    ], changeDetection: ChangeDetectionStrategy.OnPush, template: "<div\n  class=\"page-layout simple fullwidth fileUploads\"\n  fxLayout=\"column\">\n  <!-- CONTENT -->\n  <div class=\"p-24\"\n       [ngClass]=\"{'mat-card mat-elevation-z4': haveElevation}\">\n    <div class=\"row\">\n      <div class=\"col-md-12\" *ngIf=\"!uploader.queue.length\" [@appearFromLeftHideToRight]>\n        <div class=\"h2 mb-24\">\u0412\u044B\u0431\u0435\u0440\u0438\u0442\u0435 \u0444\u0430\u0439\u043B\u044B</div>\n        <div ng2FileDrop\n             [ngClass]=\"{'nv-file-over': hasBaseDropZoneOver}\"\n             (fileOver)=\"fileOverBase($event)\"\n             [uploader]=\"uploader\"\n             class=\"well my-drop-zone\">\n          \u041F\u0435\u0440\u0435\u043D\u0435\u0441\u0438\u0442\u0435 \u0444\u0430\u0439\u043B\u044B\n        </div>\n        <div class=\"p-5\">\n          \u0412\u044B\u0431\u0435\u0440\u0438\u0442\u0435 \u0444\u0430\u0439\u043B\u044B: <input type=\"file\" ng2FileSelect [uploader]=\"uploader\" multiple/><br/>\n        </div>\n      </div>\n\n      <div *ngIf=\"uploader && uploader.queue.length\" [@appearFromLeftHideToRight] class=\"col-md-12\">\n        <ng-container *ngIf=\"allProgress$ | async as allProgress\">\n          <ng-container *ngIf=\"itemsProgress$ | async as itemsProgress\">\n          <ng-container *ngIf=\"allProgress !== 100\">\n            <h3>\u0417\u0430\u0433\u0440\u0443\u0437\u043A\u0430 \u043A\u0430\u0440\u0442\u0438\u043D\u043E\u043A</h3>\n            <table class=\"table\">\n              <thead>\n              <tr>\n                <th width=\"50%\">\u0424\u0430\u0439\u043B</th>\n                <th>\u0420\u0430\u0437\u043C\u0435\u0440</th>\n                <th>\u041F\u0440\u043E\u0433\u0440\u0435\u0441\u0441</th>\n              </tr>\n              </thead>\n              <tbody>\n              <ng-container *ngFor=\"let item of uploader.queue\">\n                <tr [@appearFromLeftHideToRight] *ngIf=\"itemsProgress[item?.file?.name] !== 100\">\n                  <td><strong>{{ item?.file?.name }}</strong></td>\n                  <td nowrap>{{ item?.file?.size / 1024 / 1024 | number:'.2' }} MB</td>\n                  <td>\n                    <div class=\"progress\">\n                      <mat-progress-bar\n                        class=\"example-margin\"\n                        color=\"warn\"\n                        mode=\"determinate\"\n                        [value]=\"itemsProgress[item?.file?.name] || 0\">\n                      </mat-progress-bar>\n                    </div>\n                  </td>\n                </tr>\n              </ng-container>\n              </tbody>\n            </table>\n            <div>\n              <div class=\"progress-block\">\n                Queue progress:\n                <div class=\"progress\">\n                  <mat-progress-bar\n                    class=\"example-margin\"\n                    color=\"warn\"\n                    mode=\"determinate\"\n                    [value]=\"allProgress\">\n                  </mat-progress-bar>\n                </div>\n              </div>\n              <!--<div class=\"text-right\">\n                <button mat-flat-button color=\"accent\"\n                        class=\"mr-5\"\n                        (click)=\"uploader.uploadAll()\"\n                        [disabled]=\"!uploader.getNotUploadedItems().length\">\n                  <mat-icon class=\"fs-18\">get_app</mat-icon>\n                  \u0417\u0430\u0433\u0440\u0443\u0437\u0438\u0442\u044C \u0432\u0441\u0435\n                </button>\n                <button mat-flat-button color=\"primary\"\n                        class=\"mr-5\"\n                        (click)=\"uploader.cancelAll()\"\n                        [disabled]=\"!uploader.isUploading\">\n                  <mat-icon class=\"fs-18\">clear</mat-icon>\n                  \u041E\u0442\u043C\u0435\u043D\u0438\u0442\u044C \u0432\u0441\u0435\n                </button>\n                <button mat-flat-button color=\"warn\"\n                        class=\"mr-5\"\n                        (click)=\"uploader.clearQueue()\"\n                        [disabled]=\"!uploader.queue.length\">\n                  <mat-icon class=\"fs-18\">delete_outline</mat-icon>\n                  \u0423\u0434\u0430\u043B\u0438\u0442\u044C \u0432\u0441\u0435\n                </button>\n              </div>-->\n            </div>\n          </ng-container>\n          </ng-container>\n        </ng-container>\n      </div>\n    </div>\n  </div>\n</div>\n", styles: [":host{display:block}.fileUploads{margin-bottom:10px;margin-left:-5px}.fileUploads .mat-card{margin:5px}.nv-file-over{border:dotted 3px red}.cursor-no-pointer{cursor:auto}.table{width:100%}.table tr{line-height:40px;border-top:1px solid #efefef}.table thead{background:#efefef}.table thead th{padding:0 10px}.my-drop-zone{border:dotted 3px lightgray;padding:10px;margin-bottom:10px}\n"] }]
        }], ctorParameters: function () { return [{ type: FilesFacade }, { type: NotificationsFacade }, { type: i0.ChangeDetectorRef }, { type: AuthenticationService }, { type: undefined, decorators: [{
                    type: Inject,
                    args: [CORE_CONFIG]
                }] }]; }, propDecorators: { section: [{
                type: Input
            }], itemId: [{
                type: Input
            }], haveElevation: [{
                type: Input
            }], loadingCompleted: [{
                type: Output
            }] } });

class FilesUploadComponent {
    constructor(filesFacade, requestsFacade, cd) {
        this.filesFacade = filesFacade;
        this.requestsFacade = requestsFacade;
        this.cd = cd;
        this.haveElevation = true;
        this.uploadFilesState = 'close';
        this.mode = FileListModeList;
        this.fileListModeSort = FileListModeSort;
        this.openState = 'open';
        this.closeState = 'close';
        this.changedSort = false;
        this.filesUrl = 'files';
        this.sortUrl = 'sort';
        this.postMethod = 'post';
        this.request$ = this.requestsFacade.getRequestUpdates(this.filesUrl, this.postMethod, undefined, this.sortUrl);
        this.loadingStatus = RequestStatus.LOADING;
    }
    ngOnInit() {
    }
    ngOnDestroy() {
        this.requestsFacade.deleteRequestWaiter(this.filesUrl, this.postMethod, undefined, this.sortUrl);
    }
    saveSort() {
        this.cancelSort();
        this.requestsFacade.createRequestListener(this.filesUrl, this.postMethod, undefined, this.sortUrl);
        this.filesFacade.filesSort(this.fileOrders);
    }
    changeSort(data) {
        const { newSorting, storedSorting } = data;
        this.fileOrders = [...newSorting];
        this.storedSorting = [...storedSorting];
        this.changedSort = true;
        this.cd.markForCheck();
    }
    cancelSort() {
        this.changedSort = false;
        if (this.storedSorting) {
            this.filesFacade.filesUpdates(this.storedSorting);
        }
        this.cd.markForCheck();
    }
    uploadFilesToggle() {
        this.uploadFilesState = this.uploadFilesState === this.openState ? this.closeState : this.openState;
    }
    loadingCompleted() {
        this.uploadFilesState = this.closeState;
    }
}
FilesUploadComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "15.2.9", ngImport: i0, type: FilesUploadComponent, deps: [{ token: FilesFacade }, { token: RequestsFacade }, { token: i0.ChangeDetectorRef }], target: i0.ɵɵFactoryTarget.Component });
FilesUploadComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "15.2.9", type: FilesUploadComponent, selector: "shared-files-upload", inputs: { section: "section", itemId: "itemId", filesType: "filesType", haveElevation: "haveElevation" }, ngImport: i0, template: "<div class=\"text-center mb-14 top-button\">\n  <button\n    *ngIf=\"!changedSort\"\n    @appearOpacity\n    mat-stroked-button\n    color=\"accent\"\n    (click)=\"uploadFilesToggle()\">\n    <mat-icon class=\"fs-18\">add_a_photo</mat-icon>\n    \u0417\u0430\u0433\u0440\u0443\u0437\u0438\u0442\u044C \u043A\u0430\u0440\u0442\u0438\u043D\u043A\u0438\n  </button>\n\n  <button *ngIf=\"changedSort\"\n          @appearOpacity\n          mat-stroked-button\n          color=\"primary\"\n          (click)=\"cancelSort()\">\n    <mat-icon class=\"fs-18\">cancel</mat-icon>\n    \u041E\u0442\u043C\u0435\u043D\u0430\n  </button>\n  <button\n    *ngIf=\"changedSort\"\n    @appearOpacity\n    class=\"ml-5\"\n    mat-stroked-button\n    color=\"accent\"\n    [disabled]=\"!fileOrders\"\n    (click)=\"saveSort()\">\n    <mat-icon class=\"fs-18\">save</mat-icon>\n    \u0421\u043E\u0445\u0440\u0430\u043D\u0438\u0442\u044C \u0441\u043E\u0440\u0442\u0438\u0440\u043E\u0432\u043A\u0443\n  </button>\n</div>\n\n<shared-table-files-uploading\n  [@appearFromLeft]\n  *ngIf=\"uploadFilesState === openState\"\n  [section]=\"section\"\n  [itemId]=\"itemId\"\n  [haveElevation]=\"haveElevation\"\n  (loadingCompleted)=\"loadingCompleted()\"></shared-table-files-uploading>\n\n<shared-files-upload-list-images\n  [@appearFromLeft]\n  [section]=\"section\"\n  [filesType]=\"filesType\"\n  [itemId]=\"itemId\"\n  [mode]=\"mode\"\n  (changeSort)=\"changeSort($event)\"></shared-files-upload-list-images>\n\n<ng-container *ngIf=\"request$ | async as request\">\n  <shared-spinner *ngIf=\"request && request.status === loadingStatus\" [overlay]=\"true\"></shared-spinner>\n</ng-container>\n", styles: [":host{width:100%;padding:10px}.another-file-over-class{border:dotted 3px green}html,body{height:100%}.cursor-no-pointer{cursor:auto}.edit-title{display:flex;width:100%}.edit-title textarea{flex-grow:1}.edit-title button{width:40px}button mat-icon{margin-right:5px;font-size:20px!important}.mb-14{margin-bottom:14px}.progress-block{margin-bottom:10px}.ml-5{margin-left:5px}.top-button{position:relative;z-index:10}.sub-button{opacity:0;margin-top:-50px}\n"], dependencies: [{ kind: "directive", type: i1$3.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "component", type: i2$4.MatIcon, selector: "mat-icon", inputs: ["color", "inline", "svgIcon", "fontSet", "fontIcon"], exportAs: ["matIcon"] }, { kind: "component", type: SpinnerComponent, selector: "shared-spinner", inputs: ["overlay", "diameter", "color", "position"] }, { kind: "component", type: i5.MatButton, selector: "    button[mat-button], button[mat-raised-button], button[mat-flat-button],    button[mat-stroked-button]  ", inputs: ["disabled", "disableRipple", "color"], exportAs: ["matButton"] }, { kind: "component", type: FilesUploadListImagesComponent, selector: "shared-files-upload-list-images", inputs: ["section", "filesType", "itemId", "mode"], outputs: ["changeSort"] }, { kind: "component", type: TableFilesUploadingComponent, selector: "shared-table-files-uploading", inputs: ["section", "itemId", "haveElevation"], outputs: ["loadingCompleted"] }, { kind: "pipe", type: i1$3.AsyncPipe, name: "async" }], animations: [
        appearOpacity,
        appearFromLeft,
        appearFromLeftHideToRight
    ], changeDetection: i0.ChangeDetectionStrategy.OnPush });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "15.2.9", ngImport: i0, type: FilesUploadComponent, decorators: [{
            type: Component,
            args: [{ selector: 'shared-files-upload', changeDetection: ChangeDetectionStrategy.OnPush, animations: [
                        appearOpacity,
                        appearFromLeft,
                        appearFromLeftHideToRight
                    ], template: "<div class=\"text-center mb-14 top-button\">\n  <button\n    *ngIf=\"!changedSort\"\n    @appearOpacity\n    mat-stroked-button\n    color=\"accent\"\n    (click)=\"uploadFilesToggle()\">\n    <mat-icon class=\"fs-18\">add_a_photo</mat-icon>\n    \u0417\u0430\u0433\u0440\u0443\u0437\u0438\u0442\u044C \u043A\u0430\u0440\u0442\u0438\u043D\u043A\u0438\n  </button>\n\n  <button *ngIf=\"changedSort\"\n          @appearOpacity\n          mat-stroked-button\n          color=\"primary\"\n          (click)=\"cancelSort()\">\n    <mat-icon class=\"fs-18\">cancel</mat-icon>\n    \u041E\u0442\u043C\u0435\u043D\u0430\n  </button>\n  <button\n    *ngIf=\"changedSort\"\n    @appearOpacity\n    class=\"ml-5\"\n    mat-stroked-button\n    color=\"accent\"\n    [disabled]=\"!fileOrders\"\n    (click)=\"saveSort()\">\n    <mat-icon class=\"fs-18\">save</mat-icon>\n    \u0421\u043E\u0445\u0440\u0430\u043D\u0438\u0442\u044C \u0441\u043E\u0440\u0442\u0438\u0440\u043E\u0432\u043A\u0443\n  </button>\n</div>\n\n<shared-table-files-uploading\n  [@appearFromLeft]\n  *ngIf=\"uploadFilesState === openState\"\n  [section]=\"section\"\n  [itemId]=\"itemId\"\n  [haveElevation]=\"haveElevation\"\n  (loadingCompleted)=\"loadingCompleted()\"></shared-table-files-uploading>\n\n<shared-files-upload-list-images\n  [@appearFromLeft]\n  [section]=\"section\"\n  [filesType]=\"filesType\"\n  [itemId]=\"itemId\"\n  [mode]=\"mode\"\n  (changeSort)=\"changeSort($event)\"></shared-files-upload-list-images>\n\n<ng-container *ngIf=\"request$ | async as request\">\n  <shared-spinner *ngIf=\"request && request.status === loadingStatus\" [overlay]=\"true\"></shared-spinner>\n</ng-container>\n", styles: [":host{width:100%;padding:10px}.another-file-over-class{border:dotted 3px green}html,body{height:100%}.cursor-no-pointer{cursor:auto}.edit-title{display:flex;width:100%}.edit-title textarea{flex-grow:1}.edit-title button{width:40px}button mat-icon{margin-right:5px;font-size:20px!important}.mb-14{margin-bottom:14px}.progress-block{margin-bottom:10px}.ml-5{margin-left:5px}.top-button{position:relative;z-index:10}.sub-button{opacity:0;margin-top:-50px}\n"] }]
        }], ctorParameters: function () { return [{ type: FilesFacade }, { type: RequestsFacade }, { type: i0.ChangeDetectorRef }]; }, propDecorators: { section: [{
                type: Input
            }], itemId: [{
                type: Input
            }], filesType: [{
                type: Input
            }], haveElevation: [{
                type: Input
            }] } });

class FormFieldFilesComponent {
    constructor(cd) {
        this.cd = cd;
        this.unSubscribeSubject$ = new Subject();
        this.inputStatus = "1";
        this.emptyTitle = "Вы сможете добавить фотографии после сохранения";
    }
    ngOnInit() {
    }
    ngOnChanges(changes) {
        if (changes) {
            const field = this.fieldData.field;
            if (field && this.form) {
                this.imageSource = this.getControlValue() || "";
                if (this.imageSource) {
                    this.inputStatus = "0";
                }
            }
        }
    }
    ngOnDestroy() {
        this.unSubscribeSubject$.next();
        this.unSubscribeSubject$.complete();
    }
    ngAfterViewInit() {
        this.form.get(this.fieldData.field).statusChanges
            .pipe(distinctUntilChanged(), takeUntil(this.unSubscribeSubject$))
            .subscribe(() => {
            this.cd.markForCheck();
        });
    }
    getControlValue() {
        const field = this.fieldData.field;
        let value;
        const controlValue = this.form.get(field).value;
        if (controlValue && typeof controlValue === "object") {
            if (controlValue[2]) {
                value = controlValue[2];
            }
        }
        else
            value = controlValue;
        return value;
    }
}
FormFieldFilesComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "15.2.9", ngImport: i0, type: FormFieldFilesComponent, deps: [{ token: i0.ChangeDetectorRef }], target: i0.ɵɵFactoryTarget.Component });
FormFieldFilesComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "15.2.9", type: FormFieldFilesComponent, selector: "shared-form-field-files", inputs: { fieldData: "fieldData", form: "form", itemId: "itemId" }, viewQueries: [{ propertyName: "input", first: true, predicate: ["input"], descendants: true }], usesOnChanges: true, ngImport: i0, template: "<div class=\"form-field-file\">\n  <div class=\"pb-10 width100\">\n    <div *ngIf=\"itemId\" class=\"mb-15 display-flex align-baseline form-field-input border-block\">\n      <mat-label>{{fieldData.title}}{{fieldData.validators && fieldData.validators.includes('required') ? ' *' : ''}}</mat-label>\n      <shared-files-upload [haveElevation]=\"false\"\n                           [section]=\"fieldData.options.filesSection\"\n                           [filesType]=\"fieldData.options.filesType\"\n                           [itemId]=\"itemId\"></shared-files-upload>\n\n    </div>\n    <div *ngIf=\"!itemId\" class=\"display-flex-align-center empty-list\">\n      {{emptyTitle}}\n    </div>\n  </div>\n</div>\n\n\n", styles: [".form-field-file .form-field-input{transition:all .2s ease;min-height:66px;align-items:center;padding-top:0;padding-bottom:0;position:relative}.form-field-file .form-field-input.height-0{height:0;padding:0;border:0}.form-field-file .form-field-input mat-label{color:#5f5b5b;font-size:12px;padding:0 5px;position:absolute;background-color:#fff;top:-10px;left:10px}.form-field-file .form-field-file-image{position:relative;transition:all .2s ease;overflow:hidden;display:flex;justify-content:flex-start;margin:10px 0}.form-field-file .form-field-file-image.height-100{height:100px}.form-field-file .form-field-file-image img{object-fit:cover;width:150px;height:100px;border-radius:4px;overflow:hidden;background:#fff}.form-field-file .form-field-file-image .form-field-file-close{right:0;top:0;cursor:pointer;background:#fff;position:absolute;width:15px;height:15px;display:flex;align-items:center;justify-content:center;border-bottom-left-radius:4px;color:#f44336}.form-field-file .position-absolute{position:absolute}\n"], dependencies: [{ kind: "directive", type: i1$3.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "directive", type: i2$3.MatLabel, selector: "mat-label" }, { kind: "component", type: FilesUploadComponent, selector: "shared-files-upload", inputs: ["section", "itemId", "filesType", "haveElevation"] }], animations: [
        appearFromLeft,
        trigger("inputAnim", [
            state("0", style({
                opacity: 0
            })),
            state("1", style({
                opacity: 1
            })),
            transition("0 => 1", [
                animate("500ms")
            ]),
            transition("1 => 0", [
                animate("500ms")
            ])
        ])
    ], changeDetection: i0.ChangeDetectionStrategy.OnPush });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "15.2.9", ngImport: i0, type: FormFieldFilesComponent, decorators: [{
            type: Component,
            args: [{ selector: "shared-form-field-files", changeDetection: ChangeDetectionStrategy.OnPush, animations: [
                        appearFromLeft,
                        trigger("inputAnim", [
                            state("0", style({
                                opacity: 0
                            })),
                            state("1", style({
                                opacity: 1
                            })),
                            transition("0 => 1", [
                                animate("500ms")
                            ]),
                            transition("1 => 0", [
                                animate("500ms")
                            ])
                        ])
                    ], template: "<div class=\"form-field-file\">\n  <div class=\"pb-10 width100\">\n    <div *ngIf=\"itemId\" class=\"mb-15 display-flex align-baseline form-field-input border-block\">\n      <mat-label>{{fieldData.title}}{{fieldData.validators && fieldData.validators.includes('required') ? ' *' : ''}}</mat-label>\n      <shared-files-upload [haveElevation]=\"false\"\n                           [section]=\"fieldData.options.filesSection\"\n                           [filesType]=\"fieldData.options.filesType\"\n                           [itemId]=\"itemId\"></shared-files-upload>\n\n    </div>\n    <div *ngIf=\"!itemId\" class=\"display-flex-align-center empty-list\">\n      {{emptyTitle}}\n    </div>\n  </div>\n</div>\n\n\n", styles: [".form-field-file .form-field-input{transition:all .2s ease;min-height:66px;align-items:center;padding-top:0;padding-bottom:0;position:relative}.form-field-file .form-field-input.height-0{height:0;padding:0;border:0}.form-field-file .form-field-input mat-label{color:#5f5b5b;font-size:12px;padding:0 5px;position:absolute;background-color:#fff;top:-10px;left:10px}.form-field-file .form-field-file-image{position:relative;transition:all .2s ease;overflow:hidden;display:flex;justify-content:flex-start;margin:10px 0}.form-field-file .form-field-file-image.height-100{height:100px}.form-field-file .form-field-file-image img{object-fit:cover;width:150px;height:100px;border-radius:4px;overflow:hidden;background:#fff}.form-field-file .form-field-file-image .form-field-file-close{right:0;top:0;cursor:pointer;background:#fff;position:absolute;width:15px;height:15px;display:flex;align-items:center;justify-content:center;border-bottom-left-radius:4px;color:#f44336}.form-field-file .position-absolute{position:absolute}\n"] }]
        }], ctorParameters: function () { return [{ type: i0.ChangeDetectorRef }]; }, propDecorators: { fieldData: [{
                type: Input
            }], form: [{
                type: Input
            }], itemId: [{
                type: Input
            }], input: [{
                type: ViewChild,
                args: ["input", { static: false }]
            }] } });

class FormFieldTagsComponent {
    constructor(cd, staticDataFacade) {
        this.cd = cd;
        this.staticDataFacade = staticDataFacade;
        this.tagsContentType = 'tags';
        this.visible = true;
        this.selectable = true;
        this.removable = true;
        this.separatorKeysCodes = [ENTER];
        this.tagInputControl = new UntypedFormControl();
        this.selectedTags = [];
        this.fruits = [{ name: 'Lemon' }, { name: 'Lime' }, { name: 'Apple' }];
    }
    ngOnInit() {
        this.subscribeToFieldStatus();
        this.subscribeToSearchResult();
        const value = this.form.get(this.fieldData.field).value;
        if (value?.length) {
            this.selectedTags = [...value];
        }
    }
    ngOnDestroy() {
    }
    subscribeToFieldStatus() {
        this.form.get(this.fieldData.field).statusChanges
            .pipe(untilComponentDestroyed(this))
            .subscribe(() => {
            this.cd.markForCheck();
        });
    }
    subscribeToSearchResult() {
        this.tagsList$ = this.staticDataFacade.getStaticData$(this.tagsContentType)
            .pipe(filter$1(tags => !!tags), map(tags => {
            const listCurrentTagIds = this.selectedTags.map(item => item.id);
            return tags.filter(item => !listCurrentTagIds.includes(item.id));
        }));
    }
    enterNew(event) {
        if (event?.length > 2) {
            this.staticDataFacade.loadStaticData(this.tagsContentType, { search: event });
        }
    }
    add(event) {
        const input = event.input;
        const value = event.value;
        const currentValue = this.form.get(this.fieldData.field).value || [];
        this.form.get(this.fieldData.field).setValue([...currentValue, { name: value }]);
        if ((value || '').trim()) {
            this.selectedTags.push({ name: value.trim() });
        }
        // Reset the input value
        if (input) {
            input.value = '';
        }
        this.tagInputControl.setValue(null);
    }
    remove(tagId, tagName) {
        if (tagId) {
            this.selectedTags = this.selectedTags.filter(item => item.id !== tagId);
        }
        else {
            this.selectedTags = this.selectedTags.filter(item => item.name !== tagName);
        }
        this.form.get(this.fieldData.field).setValue([...this.selectedTags]);
    }
    selected(event) {
        this.selectedTags.push({ id: event.option.value, name: event.option.viewValue });
        this.tagInput.nativeElement.value = '';
        this.tagInputControl.setValue(null);
        const currentValue = this.form.get(this.fieldData.field).value || [];
        this.form.get(this.fieldData.field).setValue([...currentValue, {
                id: event.option.value,
                name: event.option.viewValue
            }]);
    }
}
FormFieldTagsComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "15.2.9", ngImport: i0, type: FormFieldTagsComponent, deps: [{ token: i0.ChangeDetectorRef }, { token: StaticDataFacade }], target: i0.ɵɵFactoryTarget.Component });
FormFieldTagsComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "15.2.9", type: FormFieldTagsComponent, selector: "shared-form-field-tags", inputs: { fieldData: "fieldData", form: "form", itemId: "itemId" }, viewQueries: [{ propertyName: "input", first: true, predicate: ["input"], descendants: true }, { propertyName: "tagInput", first: true, predicate: ["tagInput"], descendants: true }, { propertyName: "matAutocomplete", first: true, predicate: ["auto"], descendants: true }], ngImport: i0, template: "<ng-container *ngIf=\"form.get(fieldData.field) as field\">\n  <div [formGroup]=\"form\">\n    <mat-form-field class=\"example-chip-list w-100\" appearance=\"outline\">\n      <mat-label>\u0422\u044D\u0433\u0438</mat-label>\n      <mat-chip-grid #chipGrid aria-label=\"\u0422\u0435\u0433\u0438\">\n        <mat-chip-row *ngFor=\"let tag of selectedTags\"\n                      (removed)=\"remove(tag.id, tag.name)\">\n          {{tag.name}}\n          <button matChipRemove [attr.aria-label]=\"'\u0443\u0434\u0430\u043B\u0438\u0442\u044C ' + tag.name\">\n            <mat-icon>cancel</mat-icon>\n          </button>\n        </mat-chip-row>\n      </mat-chip-grid>\n      <input placeholder=\"\u041D\u043E\u0432\u044B\u0439 \u0442\u044D\u0433...\"\n             #tagInput\n             [formControl]=\"tagInputControl\"\n             [matChipInputFor]=\"chipGrid\"\n             [matAutocomplete]=\"auto\"\n             [matChipInputSeparatorKeyCodes]=\"separatorKeysCodes\"\n             (matChipInputTokenEnd)=\"add($event)\"\n             (ngModelChange)=\"enterNew($event)\"/>\n      <mat-autocomplete #auto=\"matAutocomplete\" (optionSelected)=\"selected($event)\">\n        <mat-option *ngFor=\"let item of tagsList$ | async\" [value]=\"item.id\">\n          {{item['name']}}\n        </mat-option>\n      </mat-autocomplete>\n    </mat-form-field>\n  </div>\n</ng-container>\n", styles: [".form-field-suffix{width:17px;height:17px}.form-field-suffix mat-icon{color:#4caf50;font-size:17px;height:17px!important;width:17px!important;min-width:17px;min-height:17px;font-weight:700!important}.form-field-suffix.input-field-icon-red mat-icon{color:#f44336}\n"], dependencies: [{ kind: "directive", type: i1$3.NgForOf, selector: "[ngFor][ngForOf]", inputs: ["ngForOf", "ngForTrackBy", "ngForTemplate"] }, { kind: "directive", type: i1$3.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "component", type: i2$3.MatFormField, selector: "mat-form-field", inputs: ["hideRequiredMarker", "color", "floatLabel", "appearance", "subscriptSizing", "hintLabel"], exportAs: ["matFormField"] }, { kind: "directive", type: i2$3.MatLabel, selector: "mat-label" }, { kind: "component", type: i5$1.MatOption, selector: "mat-option", exportAs: ["matOption"] }, { kind: "directive", type: i6.DefaultValueAccessor, selector: "input:not([type=checkbox])[formControlName],textarea[formControlName],input:not([type=checkbox])[formControl],textarea[formControl],input:not([type=checkbox])[ngModel],textarea[ngModel],[ngDefaultControl]" }, { kind: "directive", type: i6.NgControlStatus, selector: "[formControlName],[ngModel],[formControl]" }, { kind: "directive", type: i6.NgControlStatusGroup, selector: "[formGroupName],[formArrayName],[ngModelGroup],[formGroup],form:not([ngNoForm]),[ngForm]" }, { kind: "directive", type: i6.FormControlDirective, selector: "[formControl]", inputs: ["formControl", "disabled", "ngModel"], outputs: ["ngModelChange"], exportAs: ["ngForm"] }, { kind: "directive", type: i6.FormGroupDirective, selector: "[formGroup]", inputs: ["formGroup"], outputs: ["ngSubmit"], exportAs: ["ngForm"] }, { kind: "component", type: i2$4.MatIcon, selector: "mat-icon", inputs: ["color", "inline", "svgIcon", "fontSet", "fontIcon"], exportAs: ["matIcon"] }, { kind: "component", type: i7$1.MatChipGrid, selector: "mat-chip-grid", inputs: ["tabIndex", "disabled", "placeholder", "required", "value", "errorStateMatcher"], outputs: ["change", "valueChange"] }, { kind: "directive", type: i7$1.MatChipInput, selector: "input[matChipInputFor]", inputs: ["matChipInputFor", "matChipInputAddOnBlur", "matChipInputSeparatorKeyCodes", "placeholder", "id", "disabled"], outputs: ["matChipInputTokenEnd"], exportAs: ["matChipInput", "matChipInputFor"] }, { kind: "directive", type: i7$1.MatChipRemove, selector: "[matChipRemove]" }, { kind: "component", type: i7$1.MatChipRow, selector: "mat-chip-row, [mat-chip-row], mat-basic-chip-row, [mat-basic-chip-row]", inputs: ["color", "disabled", "disableRipple", "tabIndex", "editable"], outputs: ["edited"] }, { kind: "component", type: i8.MatAutocomplete, selector: "mat-autocomplete", inputs: ["disableRipple", "hideSingleSelectionIndicator"], exportAs: ["matAutocomplete"] }, { kind: "directive", type: i8.MatAutocompleteTrigger, selector: "input[matAutocomplete], textarea[matAutocomplete]", exportAs: ["matAutocompleteTrigger"] }, { kind: "pipe", type: i1$3.AsyncPipe, name: "async" }], changeDetection: i0.ChangeDetectionStrategy.OnPush });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "15.2.9", ngImport: i0, type: FormFieldTagsComponent, decorators: [{
            type: Component,
            args: [{ selector: 'shared-form-field-tags', changeDetection: ChangeDetectionStrategy.OnPush, template: "<ng-container *ngIf=\"form.get(fieldData.field) as field\">\n  <div [formGroup]=\"form\">\n    <mat-form-field class=\"example-chip-list w-100\" appearance=\"outline\">\n      <mat-label>\u0422\u044D\u0433\u0438</mat-label>\n      <mat-chip-grid #chipGrid aria-label=\"\u0422\u0435\u0433\u0438\">\n        <mat-chip-row *ngFor=\"let tag of selectedTags\"\n                      (removed)=\"remove(tag.id, tag.name)\">\n          {{tag.name}}\n          <button matChipRemove [attr.aria-label]=\"'\u0443\u0434\u0430\u043B\u0438\u0442\u044C ' + tag.name\">\n            <mat-icon>cancel</mat-icon>\n          </button>\n        </mat-chip-row>\n      </mat-chip-grid>\n      <input placeholder=\"\u041D\u043E\u0432\u044B\u0439 \u0442\u044D\u0433...\"\n             #tagInput\n             [formControl]=\"tagInputControl\"\n             [matChipInputFor]=\"chipGrid\"\n             [matAutocomplete]=\"auto\"\n             [matChipInputSeparatorKeyCodes]=\"separatorKeysCodes\"\n             (matChipInputTokenEnd)=\"add($event)\"\n             (ngModelChange)=\"enterNew($event)\"/>\n      <mat-autocomplete #auto=\"matAutocomplete\" (optionSelected)=\"selected($event)\">\n        <mat-option *ngFor=\"let item of tagsList$ | async\" [value]=\"item.id\">\n          {{item['name']}}\n        </mat-option>\n      </mat-autocomplete>\n    </mat-form-field>\n  </div>\n</ng-container>\n", styles: [".form-field-suffix{width:17px;height:17px}.form-field-suffix mat-icon{color:#4caf50;font-size:17px;height:17px!important;width:17px!important;min-width:17px;min-height:17px;font-weight:700!important}.form-field-suffix.input-field-icon-red mat-icon{color:#f44336}\n"] }]
        }], ctorParameters: function () { return [{ type: i0.ChangeDetectorRef }, { type: StaticDataFacade }]; }, propDecorators: { fieldData: [{
                type: Input
            }], form: [{
                type: Input
            }], itemId: [{
                type: Input
            }], input: [{
                type: ViewChild,
                args: ['input', { static: false }]
            }], tagInput: [{
                type: ViewChild,
                args: ['tagInput']
            }], matAutocomplete: [{
                type: ViewChild,
                args: ['auto']
            }] } });

class FormFieldComponent {
    get fieldPublishError() {
        if (this.publicationMessages) {
            return this.publicationMessages.filter((item) => item.field === this.fieldData.field && item.isError);
        }
        return null;
    }
    get fieldPublicationMessages() {
        if (this.publicationMessages) {
            return this.publicationMessages.filter((item) => item.field === this.fieldData.field && !item.isError);
        }
        return null;
    }
    get haveFieldError() {
        return ((!this.fieldControl.pristine || this.fieldControl.touched) && this.fieldControl.status === this.invalidStatus) || !!this.fieldPublishError?.length;
    }
    get haveFieldWarning() {
        return !!this.fieldPublicationMessages?.length;
    }
    constructor(config, authenticationService, coreFacade, cd, dialog) {
        this.config = config;
        this.authenticationService = authenticationService;
        this.coreFacade = coreFacade;
        this.cd = cd;
        this.dialog = dialog;
        this.editorImageUploadUrl = '';
        this.eventUpdateForm = new EventEmitter();
        this.eventSendAction = new EventEmitter();
        this.fieldTypes = FieldType;
        this.invalidStatus = 'INVALID';
        this.unSubscribeSubject$ = new Subject();
    }
    ngOnInit() {
        this.field = this.fieldData.field;
        this.fieldControl = this.form.get(this.field);
        this.setEditorConfig();
        this.subscribeToChangeStatus();
    }
    ngOnDestroy() {
        this.unSubscribeSubject$.next();
        this.unSubscribeSubject$.complete();
    }
    fieldActionHandler(data) {
        try {
            if (data.action) {
                this.coreFacade.sendGlobalEvent(data.action, this.entity, this.itemId, this.fieldData, this.form.value);
            }
        }
        catch (e) {
            console.error('[ form-field ][ fieldActionHandler ]', { error: e, data, fieldData: this.fieldData });
        }
    }
    openHintDialog(hint) {
        this.dialog.open(CommonDialogComponent, {
            panelClass: 'dialog-without-margin',
            data: {
                message: hint,
                falseButtonTitle: 'Закрыть',
                messageType: 'info',
                size: 'middle',
                hideTrueButton: true
            }
        });
    }
    subscribeToChangeStatus() {
        this.form.get(this.field).statusChanges
            .pipe(takeUntil(this.unSubscribeSubject$))
            .subscribe(() => {
            this.cd.markForCheck();
        });
    }
    setEditorConfig() {
        const entityId = this.form.get('id')?.value;
        const { token } = this.authenticationService.loadAuthDataFromLocalStore();
        const newConfig = {
            apiUrl: this.config.apiUrl,
            panelUrl: this.config.panelUrl
        };
        this.ckeConfig = {
            extraPlugins: "image,uploadimage,tabletools,undo,indent,justify,showblocks",
            fileTools_requestHeaders: {
                'Authorization': `JWT ${token}`
            },
            imagebrowserUrl: this.entity ? `${newConfig.apiUrl}/api/files/browser/${this.entity.toLowerCase()}/${entityId}` : '',
            filebrowserBrowseUrl: this.entity ? `${newConfig.panelUrl}/file-browser/${this.entity.toLowerCase()}/${entityId}` : '',
            filebrowserWindowWidth: '905',
            filebrowserWindowHeight: '480',
            filebrowserUploadUrl: this.entity ? `${newConfig.apiUrl}/api/files/${this.entity.toLowerCase()}/${entityId}/editor` : '',
            uploadUrl: this.entity ? `${newConfig.apiUrl}/api/files/${this.entity.toLowerCase()}/${entityId}/editor` : '',
            easyimage_toolbar: ['EasyImageAlignLeft', 'EasyImageAlignCenter', 'EasyImageAlignRight'],
        };
        /*
        removePlugins: 'removePlugins',
        extraPlugins:
            "image2, easyimage,enhancedimage, uploadimage,dialogui,dialog,a11yhelp,about,basicstyles,bidi,blockquote,clipboard," +
            "button,panelbutton,panel,floatpanel,colorbutton,colordialog,menu," +
            "contextmenu,dialogadvtab,div,elementspath,enterkey,entities,popup," +
            "filebrowser,find,fakeobjects,flash,floatingspace,listblock,richcombo," +
            "font,format,forms,horizontalrule,htmlwriter,iframe,image,indent," +
            "indentblock,indentlist,justify,link,list,liststyle,magicline," +
            "maximize,newpage,pagebreak,pastefromword,pastetext,preview,print," +
            "removeformat,resize,save,menubutton,scayt,selectall,showblocks," +
            "showborders,smiley,sourcearea,specialchar,stylescombo,tab,table," +
            "tabletools,templates,toolbar,undo,wsc,wysiwygarea"
         */
    }
}
FormFieldComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "15.2.9", ngImport: i0, type: FormFieldComponent, deps: [{ token: CORE_CONFIG }, { token: AuthenticationService }, { token: CoreFacade }, { token: i0.ChangeDetectorRef }, { token: i1$4.MatDialog }], target: i0.ɵɵFactoryTarget.Component });
FormFieldComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "15.2.9", type: FormFieldComponent, selector: "shared-form-field", inputs: { fieldData: "fieldData", itemId: "itemId", form: "form", editorImageUploadUrl: "editorImageUploadUrl", errorMessageTexts: "errorMessageTexts", entity: "entity", publicationMessages: "publicationMessages", entityTypeUserRoleRights: "entityTypeUserRoleRights", autoCompleteFields: "autoCompleteFields" }, outputs: { eventUpdateForm: "eventUpdateForm", eventSendAction: "eventSendAction" }, ngImport: i0, template: "<div *ngIf=\"!fieldData.options.notEditable && !fieldData.options.hide\"\n     fxLayout=\"column\"\n     class=\"position-relative form-field\"\n     [id]=\"'field-' + fieldData.field\"\n     [formGroup]=\"form\"\n     [ngClass]=\"{\n     'border-block textarea-field mb-21': fieldData.type === fieldTypes.FieldTypeTextarea || fieldData.type === fieldTypes.FieldTypeTextareaEditor,\n      'form-field-error': haveFieldError,\n      'form-field-warning': haveFieldWarning,\n      'check-box-field': fieldData.type === fieldTypes.FieldTypeSlideToggle\n      }\">\n  <ng-container [ngSwitch]=\"fieldData.type\">\n    <ng-container *ngSwitchCase=\"fieldTypes.FieldTypeSelect\">\n        <shared-form-field-select\n          [fieldData]=\"fieldData\"\n          [form]=\"form\"\n          [autoCompleteFields]=\"autoCompleteFields\"\n        ></shared-form-field-select>\n    </ng-container>\n\n    <ng-container *ngSwitchCase=\"fieldTypes.FieldTypeSlideToggle\">\n      <shared-form-field-slide-toggle\n        [fieldData]=\"fieldData\"\n        [form]=\"form\"\n      ></shared-form-field-slide-toggle>\n    </ng-container>\n\n    <ng-container *ngSwitchCase=\"fieldTypes.FieldTypeTextarea\">\n      <div class=\"textarea-field-width\">\n        <label\n          [id]=\"'field-' + fieldData.field\">{{fieldData.title}}{{fieldData.validators && fieldData.validators.includes('required') ? ' *' : ''}}</label>\n        <textarea matInput rows=\"6\" [formControlName]=\"fieldData.field\"></textarea>\n        <div class=\"textarea-field-length\">\n          <b>\u0422\u0435\u043A\u0443\u0449\u0430\u044F \u0434\u043B\u0438\u043D\u0430: {{form.get(fieldData.field).value?.length || 0}}</b>\n        </div>\n      </div>\n    </ng-container>\n\n    <ng-container *ngSwitchCase=\"fieldTypes.FieldTypeTextareaEditor\">\n      <div class=\"textarea-field-width\">\n        <label\n          [id]=\"'field-' + fieldData.field\">{{fieldData.title}}{{fieldData.validators && fieldData.validators.includes('required') ? ' *' : ''}}</label>\n        <div *ngIf=\"fieldData.description\" class=\"field-description\">\n          {{fieldData.description}}\n        </div>\n        <ckeditor [formControlName]=\"fieldData.field\"\n                  [config]=\"ckeConfig\"></ckeditor>\n        <div class=\"textarea-field-length\">\n          <b>\u0422\u0435\u043A\u0443\u0449\u0430\u044F \u0434\u043B\u0438\u043D\u0430: {{form.get(fieldData.field).value?.length || 0}}</b>\n        </div>\n      </div>\n    </ng-container>\n\n    <ng-container *ngSwitchCase=\"fieldTypes.FieldTypeFile\">\n      <shared-form-field-file\n        [fieldData]=\"fieldData\"\n        [form]=\"form\"\n        [entity]=\"entity\"\n      ></shared-form-field-file>\n    </ng-container>\n\n    <ng-container *ngSwitchCase=\"fieldTypes.FieldTypeFiles\">\n      <shared-form-field-files\n        [fieldData]=\"fieldData\"\n        [form]=\"form\"\n        [itemId]=\"itemId\"\n      ></shared-form-field-files>\n    </ng-container>\n\n    <ng-container *ngSwitchCase=\"fieldTypes.FieldTypeTags\">\n      <shared-form-field-tags\n        [fieldData]=\"fieldData\"\n        [form]=\"form\"\n        [itemId]=\"itemId\"\n      ></shared-form-field-tags>\n    </ng-container>\n\n    <ng-container *ngSwitchDefault>\n      <shared-form-field-input\n        [fieldData]=\"fieldData\"\n        [form]=\"form\"\n      ></shared-form-field-input>\n    </ng-container>\n  </ng-container>\n\n  <div *ngIf=\"fieldData.actions\" class=\"field-actions\">\n      <ng-container *ngFor=\"let action of fieldData.actions\">\n        <div class=\"field-actions-action\" (click)=\"fieldActionHandler(action)\">{{action.title}}</div>\n      </ng-container>\n  </div>\n\n  <shared-form-field-spinner *ngIf=\"fieldData.options.loading\"></shared-form-field-spinner>\n\n  <ng-container *ngIf=\"fieldData.options.hint\">\n    <mat-icon class=\"hint-icons\" (click)=\"openHintDialog(fieldData.options.hint)\">help_outline</mat-icon>\n  </ng-container>\n\n  <shared-form-field-error\n    @appearFromLeft\n    *ngIf=\"fieldControl.touched && !fieldControl.valid\"\n    [form]=\"form\"\n    [fieldData]=\"fieldData\"\n    [errorMessageTexts]=\"errorMessageTexts\"\n    [ngClass]=\"{'textarea-error': fieldData.type === fieldTypes.FieldTypeTextarea}\"\n  ></shared-form-field-error>\n\n  <shared-form-field-publish-error\n    [form]=\"form\"\n    [entity]=\"entity\"\n    [fieldData]=\"fieldData\"\n    [errorMessageTexts]=\"errorMessageTexts\"\n    [ngClass]=\"{'textarea-error': fieldData.type === fieldTypes.FieldTypeTextarea}\"\n  ></shared-form-field-publish-error>\n</div>\n", styles: [".mb-21{margin-bottom:21px}.field-description{border-radius:8px;color:#5f5b5b;margin:5px 5px 15px;border-left:3px solid #009ce5;padding:10px 0 10px 10px;background:rgba(0,156,229,.2588235294)}.field-actions{display:flex;justify-content:flex-end;margin-bottom:5px}.field-actions .field-actions-action{padding:0 10px;text-align:right;background:#007bff;color:#fff;border-radius:4px}.textarea-field-length{background:#f8f8f8;text-align:right;padding-right:10px;color:#989494;border-bottom:1px solid #d1d1d1;font-size:11px}.hint-icons{position:absolute;right:0;margin-top:9px}\n"], dependencies: [{ kind: "directive", type: i1$3.NgClass, selector: "[ngClass]", inputs: ["class", "ngClass"] }, { kind: "directive", type: i1$3.NgForOf, selector: "[ngFor][ngForOf]", inputs: ["ngForOf", "ngForTrackBy", "ngForTemplate"] }, { kind: "directive", type: i1$3.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "directive", type: i1$3.NgSwitch, selector: "[ngSwitch]", inputs: ["ngSwitch"] }, { kind: "directive", type: i1$3.NgSwitchCase, selector: "[ngSwitchCase]", inputs: ["ngSwitchCase"] }, { kind: "directive", type: i1$3.NgSwitchDefault, selector: "[ngSwitchDefault]" }, { kind: "component", type: FormFieldErrorComponent, selector: "shared-form-field-error", inputs: ["fieldData", "form", "errorMessageTexts"] }, { kind: "component", type: FormFieldPublishErrorComponent, selector: "shared-form-field-publish-error", inputs: ["fieldData", "form", "entity", "errorMessageTexts"] }, { kind: "directive", type: i3$1.MatInput, selector: "input[matInput], textarea[matInput], select[matNativeControl],      input[matNativeControl], textarea[matNativeControl]", inputs: ["disabled", "id", "placeholder", "name", "required", "type", "errorStateMatcher", "aria-describedby", "value", "readonly"], exportAs: ["matInput"] }, { kind: "directive", type: i6.DefaultValueAccessor, selector: "input:not([type=checkbox])[formControlName],textarea[formControlName],input:not([type=checkbox])[formControl],textarea[formControl],input:not([type=checkbox])[ngModel],textarea[ngModel],[ngDefaultControl]" }, { kind: "directive", type: i6.NgControlStatus, selector: "[formControlName],[ngModel],[formControl]" }, { kind: "directive", type: i6.NgControlStatusGroup, selector: "[formGroupName],[formArrayName],[ngModelGroup],[formGroup],form:not([ngNoForm]),[ngForm]" }, { kind: "directive", type: i6.FormGroupDirective, selector: "[formGroup]", inputs: ["formGroup"], outputs: ["ngSubmit"], exportAs: ["ngForm"] }, { kind: "directive", type: i6.FormControlName, selector: "[formControlName]", inputs: ["formControlName", "disabled", "ngModel"], outputs: ["ngModelChange"] }, { kind: "directive", type: i9.DefaultLayoutDirective, selector: "  [fxLayout], [fxLayout.xs], [fxLayout.sm], [fxLayout.md],  [fxLayout.lg], [fxLayout.xl], [fxLayout.lt-sm], [fxLayout.lt-md],  [fxLayout.lt-lg], [fxLayout.lt-xl], [fxLayout.gt-xs], [fxLayout.gt-sm],  [fxLayout.gt-md], [fxLayout.gt-lg]", inputs: ["fxLayout", "fxLayout.xs", "fxLayout.sm", "fxLayout.md", "fxLayout.lg", "fxLayout.xl", "fxLayout.lt-sm", "fxLayout.lt-md", "fxLayout.lt-lg", "fxLayout.lt-xl", "fxLayout.gt-xs", "fxLayout.gt-sm", "fxLayout.gt-md", "fxLayout.gt-lg"] }, { kind: "component", type: i2$4.MatIcon, selector: "mat-icon", inputs: ["color", "inline", "svgIcon", "fontSet", "fontIcon"], exportAs: ["matIcon"] }, { kind: "component", type: i11.CKEditorComponent, selector: "ckeditor", inputs: ["editorUrl", "tagName", "type", "data", "readOnly", "config"], outputs: ["namespaceLoaded", "ready", "dataReady", "change", "dataChange", "dragStart", "dragEnd", "drop", "fileUploadResponse", "fileUploadRequest", "focus", "paste", "afterPaste", "blur"] }, { kind: "component", type: FormFieldSpinnerComponent, selector: "shared-form-field-spinner" }, { kind: "component", type: FormFieldSelectComponent, selector: "shared-form-field-select", inputs: ["fieldData", "form", "autoCompleteFields"] }, { kind: "component", type: FormFieldSlideToggleComponent, selector: "shared-form-field-slide-toggle", inputs: ["fieldData", "form"] }, { kind: "component", type: FormFieldInputComponent, selector: "shared-form-field-input", inputs: ["fieldData", "form"] }, { kind: "component", type: FormFieldFileComponent, selector: "shared-form-field-file", inputs: ["fieldData", "form", "entity"] }, { kind: "component", type: FormFieldFilesComponent, selector: "shared-form-field-files", inputs: ["fieldData", "form", "itemId"] }, { kind: "component", type: FormFieldTagsComponent, selector: "shared-form-field-tags", inputs: ["fieldData", "form", "itemId"] }], animations: [appearFromLeft], changeDetection: i0.ChangeDetectionStrategy.OnPush });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "15.2.9", ngImport: i0, type: FormFieldComponent, decorators: [{
            type: Component,
            args: [{ selector: 'shared-form-field', changeDetection: ChangeDetectionStrategy.OnPush, animations: [appearFromLeft], template: "<div *ngIf=\"!fieldData.options.notEditable && !fieldData.options.hide\"\n     fxLayout=\"column\"\n     class=\"position-relative form-field\"\n     [id]=\"'field-' + fieldData.field\"\n     [formGroup]=\"form\"\n     [ngClass]=\"{\n     'border-block textarea-field mb-21': fieldData.type === fieldTypes.FieldTypeTextarea || fieldData.type === fieldTypes.FieldTypeTextareaEditor,\n      'form-field-error': haveFieldError,\n      'form-field-warning': haveFieldWarning,\n      'check-box-field': fieldData.type === fieldTypes.FieldTypeSlideToggle\n      }\">\n  <ng-container [ngSwitch]=\"fieldData.type\">\n    <ng-container *ngSwitchCase=\"fieldTypes.FieldTypeSelect\">\n        <shared-form-field-select\n          [fieldData]=\"fieldData\"\n          [form]=\"form\"\n          [autoCompleteFields]=\"autoCompleteFields\"\n        ></shared-form-field-select>\n    </ng-container>\n\n    <ng-container *ngSwitchCase=\"fieldTypes.FieldTypeSlideToggle\">\n      <shared-form-field-slide-toggle\n        [fieldData]=\"fieldData\"\n        [form]=\"form\"\n      ></shared-form-field-slide-toggle>\n    </ng-container>\n\n    <ng-container *ngSwitchCase=\"fieldTypes.FieldTypeTextarea\">\n      <div class=\"textarea-field-width\">\n        <label\n          [id]=\"'field-' + fieldData.field\">{{fieldData.title}}{{fieldData.validators && fieldData.validators.includes('required') ? ' *' : ''}}</label>\n        <textarea matInput rows=\"6\" [formControlName]=\"fieldData.field\"></textarea>\n        <div class=\"textarea-field-length\">\n          <b>\u0422\u0435\u043A\u0443\u0449\u0430\u044F \u0434\u043B\u0438\u043D\u0430: {{form.get(fieldData.field).value?.length || 0}}</b>\n        </div>\n      </div>\n    </ng-container>\n\n    <ng-container *ngSwitchCase=\"fieldTypes.FieldTypeTextareaEditor\">\n      <div class=\"textarea-field-width\">\n        <label\n          [id]=\"'field-' + fieldData.field\">{{fieldData.title}}{{fieldData.validators && fieldData.validators.includes('required') ? ' *' : ''}}</label>\n        <div *ngIf=\"fieldData.description\" class=\"field-description\">\n          {{fieldData.description}}\n        </div>\n        <ckeditor [formControlName]=\"fieldData.field\"\n                  [config]=\"ckeConfig\"></ckeditor>\n        <div class=\"textarea-field-length\">\n          <b>\u0422\u0435\u043A\u0443\u0449\u0430\u044F \u0434\u043B\u0438\u043D\u0430: {{form.get(fieldData.field).value?.length || 0}}</b>\n        </div>\n      </div>\n    </ng-container>\n\n    <ng-container *ngSwitchCase=\"fieldTypes.FieldTypeFile\">\n      <shared-form-field-file\n        [fieldData]=\"fieldData\"\n        [form]=\"form\"\n        [entity]=\"entity\"\n      ></shared-form-field-file>\n    </ng-container>\n\n    <ng-container *ngSwitchCase=\"fieldTypes.FieldTypeFiles\">\n      <shared-form-field-files\n        [fieldData]=\"fieldData\"\n        [form]=\"form\"\n        [itemId]=\"itemId\"\n      ></shared-form-field-files>\n    </ng-container>\n\n    <ng-container *ngSwitchCase=\"fieldTypes.FieldTypeTags\">\n      <shared-form-field-tags\n        [fieldData]=\"fieldData\"\n        [form]=\"form\"\n        [itemId]=\"itemId\"\n      ></shared-form-field-tags>\n    </ng-container>\n\n    <ng-container *ngSwitchDefault>\n      <shared-form-field-input\n        [fieldData]=\"fieldData\"\n        [form]=\"form\"\n      ></shared-form-field-input>\n    </ng-container>\n  </ng-container>\n\n  <div *ngIf=\"fieldData.actions\" class=\"field-actions\">\n      <ng-container *ngFor=\"let action of fieldData.actions\">\n        <div class=\"field-actions-action\" (click)=\"fieldActionHandler(action)\">{{action.title}}</div>\n      </ng-container>\n  </div>\n\n  <shared-form-field-spinner *ngIf=\"fieldData.options.loading\"></shared-form-field-spinner>\n\n  <ng-container *ngIf=\"fieldData.options.hint\">\n    <mat-icon class=\"hint-icons\" (click)=\"openHintDialog(fieldData.options.hint)\">help_outline</mat-icon>\n  </ng-container>\n\n  <shared-form-field-error\n    @appearFromLeft\n    *ngIf=\"fieldControl.touched && !fieldControl.valid\"\n    [form]=\"form\"\n    [fieldData]=\"fieldData\"\n    [errorMessageTexts]=\"errorMessageTexts\"\n    [ngClass]=\"{'textarea-error': fieldData.type === fieldTypes.FieldTypeTextarea}\"\n  ></shared-form-field-error>\n\n  <shared-form-field-publish-error\n    [form]=\"form\"\n    [entity]=\"entity\"\n    [fieldData]=\"fieldData\"\n    [errorMessageTexts]=\"errorMessageTexts\"\n    [ngClass]=\"{'textarea-error': fieldData.type === fieldTypes.FieldTypeTextarea}\"\n  ></shared-form-field-publish-error>\n</div>\n", styles: [".mb-21{margin-bottom:21px}.field-description{border-radius:8px;color:#5f5b5b;margin:5px 5px 15px;border-left:3px solid #009ce5;padding:10px 0 10px 10px;background:rgba(0,156,229,.2588235294)}.field-actions{display:flex;justify-content:flex-end;margin-bottom:5px}.field-actions .field-actions-action{padding:0 10px;text-align:right;background:#007bff;color:#fff;border-radius:4px}.textarea-field-length{background:#f8f8f8;text-align:right;padding-right:10px;color:#989494;border-bottom:1px solid #d1d1d1;font-size:11px}.hint-icons{position:absolute;right:0;margin-top:9px}\n"] }]
        }], ctorParameters: function () { return [{ type: undefined, decorators: [{
                    type: Inject,
                    args: [CORE_CONFIG]
                }] }, { type: AuthenticationService }, { type: CoreFacade }, { type: i0.ChangeDetectorRef }, { type: i1$4.MatDialog }]; }, propDecorators: { fieldData: [{
                type: Input
            }], itemId: [{
                type: Input
            }], form: [{
                type: Input
            }], editorImageUploadUrl: [{
                type: Input
            }], errorMessageTexts: [{
                type: Input
            }], entity: [{
                type: Input
            }], publicationMessages: [{
                type: Input
            }], entityTypeUserRoleRights: [{
                type: Input
            }], autoCompleteFields: [{
                type: Input
            }], eventUpdateForm: [{
                type: Output
            }], eventSendAction: [{
                type: Output
            }] } });

class FormMessageBoxComponent {
    constructor(cd, baseAutoFormService) {
        this.cd = cd;
        this.baseAutoFormService = baseAutoFormService;
        this.listErrors = [];
        this.invalidFieldValidStatus = 'INVALID';
        this.titleUpdate = 'Внимание! Для сохранение нужно исправить:';
        this.titleAdd = 'Внимание! Необходимо исправить:';
        this.unSubscribeSubject$ = new Subject();
        this.fullPrefix = '_FULL';
    }
    ngOnInit() {
        this.checkFormField();
        this.subscribeToFormStatus();
        this.title = this.form.value.id ? this.titleUpdate : this.titleAdd;
    }
    ngOnDestroy() {
        this.unSubscribeSubject$.next();
        this.unSubscribeSubject$.complete();
    }
    subscribeToFormStatus() {
        this.form.statusChanges
            .pipe(takeUntil(this.unSubscribeSubject$))
            .subscribe(() => {
            this.checkFormField();
        });
    }
    checkFormField() {
        this.listErrors = [];
        const fields = this.getPreparedFields();
        if (this.form.errors) {
            const formErrors = Object.keys(this.form.errors);
            if (formErrors.length) {
                formErrors.forEach(errorKey => {
                    const message = this.getErrorMessage(errorKey);
                    this.listErrors.push(message);
                });
            }
        }
        Object.keys(this.form.controls)
            .filter(controlKey => this.form.controls[controlKey].status === this.invalidFieldValidStatus)
            .forEach(controlKey => {
            const errors = this.form.controls[controlKey].errors;
            Object.keys(errors)
                .forEach(errorKey => {
                let message = this.getErrorMessage(errorKey, fields[controlKey]);
                if (errorKey === message && errors[errorKey]) {
                    message = errors[errorKey];
                }
                this.listErrors.push(message);
            });
        });
        this.cd.markForCheck();
    }
    getPreparedFields() {
        const result = {};
        this.fields.forEach(fieldData => {
            result[fieldData.field] = fieldData;
        });
        return result;
    }
    ;
    getErrorMessage(errorKey, field) {
        let baseErrorMessage = '';
        if (ERRORS[errorKey]) {
            baseErrorMessage = ERRORS[errorKey] ? ERRORS[errorKey].message2 : '';
        }
        if (!baseErrorMessage && this.errorMessageTexts && this.errorMessageTexts[errorKey]) {
            baseErrorMessage = this.errorMessageTexts[`${errorKey}${this.fullPrefix}`] || this.errorMessageTexts[errorKey];
        }
        if (!baseErrorMessage) {
            baseErrorMessage = errorKey;
        }
        return this.baseAutoFormService.prepareFieldError(baseErrorMessage, {
            ['field']: field?.title,
        });
    }
}
FormMessageBoxComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "15.2.9", ngImport: i0, type: FormMessageBoxComponent, deps: [{ token: i0.ChangeDetectorRef }, { token: BaseAutoFormService }], target: i0.ɵɵFactoryTarget.Component });
FormMessageBoxComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "15.2.9", type: FormMessageBoxComponent, selector: "shred-form-message-box", inputs: { form: "form", fields: "fields", errorMessageTexts: "errorMessageTexts" }, ngImport: i0, template: "<ng-container *ngIf=\"!form.pristine\">\n  <div @appearFromLeft *ngIf=\"listErrors && listErrors.length\" class=\"message-box error mb-10\">\n    <b>{{title}}</b>\n    <ul>\n      <li *ngFor=\"let error of listErrors\" [innerHTML]=\"error\"></li>\n    </ul>\n  </div>\n</ng-container>\n", styles: [""], dependencies: [{ kind: "directive", type: i1$3.NgForOf, selector: "[ngFor][ngForOf]", inputs: ["ngForOf", "ngForTrackBy", "ngForTemplate"] }, { kind: "directive", type: i1$3.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }], animations: [appearFromLeft], changeDetection: i0.ChangeDetectionStrategy.OnPush });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "15.2.9", ngImport: i0, type: FormMessageBoxComponent, decorators: [{
            type: Component,
            args: [{ selector: 'shred-form-message-box', changeDetection: ChangeDetectionStrategy.OnPush, animations: [appearFromLeft], template: "<ng-container *ngIf=\"!form.pristine\">\n  <div @appearFromLeft *ngIf=\"listErrors && listErrors.length\" class=\"message-box error mb-10\">\n    <b>{{title}}</b>\n    <ul>\n      <li *ngFor=\"let error of listErrors\" [innerHTML]=\"error\"></li>\n    </ul>\n  </div>\n</ng-container>\n" }]
        }], ctorParameters: function () { return [{ type: i0.ChangeDetectorRef }, { type: BaseAutoFormService }]; }, propDecorators: { form: [{
                type: Input
            }], fields: [{
                type: Input
            }], errorMessageTexts: [{
                type: Input
            }] } });

/**
 * Icon component.
 * Add svg icon to any place.
 * By default it uses size and color of host element or you can set predefined values by settings inputs size and color
 *
 * Usage:
 * ````
 * <shared-ui-icon icon="add"></app-ui-icon>
 * <shared-ui-icon icon="add" size="xs" color="primary"></app-ui-icon>
 * ````
 */
class IconComponent {
    constructor() {
        this.size = 'normal';
        this.color = 'inherit';
        this.iconSize = 's-22';
    }
    ngOnChanges(changes) {
        if (this.size === 'normal') {
            this.iconSize = `s-22`;
        }
        if (this.size === 'small') {
            this.iconSize = `s-18`;
        }
    }
}
IconComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "15.2.9", ngImport: i0, type: IconComponent, deps: [], target: i0.ɵɵFactoryTarget.Component });
IconComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "15.2.9", type: IconComponent, selector: "shared-ui-icon", inputs: { icon: "icon", size: "size", color: "color" }, usesOnChanges: true, ngImport: i0, template: "<mat-icon\n  [ngClass]=\"'icon-size-' + size + ' color-' + color + ' ' + iconSize\"\n  class=\"secondary-text mat-icon notranslate material-icons\" role=\"img\" aria-hidden=\"true\">{{icon}}</mat-icon>\n", styles: [":host{display:inline-flex;align-items:center}.orange_gray{color:#c17e5d!important}.color-yellow{color:#fcb202!important}.color-red{color:#f44336!important}.color-white{color:#fff9!important}.color-black{color:#000000de!important}\n"], dependencies: [{ kind: "directive", type: i1$3.NgClass, selector: "[ngClass]", inputs: ["class", "ngClass"] }, { kind: "component", type: i2$4.MatIcon, selector: "mat-icon", inputs: ["color", "inline", "svgIcon", "fontSet", "fontIcon"], exportAs: ["matIcon"] }], changeDetection: i0.ChangeDetectionStrategy.OnPush });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "15.2.9", ngImport: i0, type: IconComponent, decorators: [{
            type: Component,
            args: [{ selector: 'shared-ui-icon', changeDetection: ChangeDetectionStrategy.OnPush, template: "<mat-icon\n  [ngClass]=\"'icon-size-' + size + ' color-' + color + ' ' + iconSize\"\n  class=\"secondary-text mat-icon notranslate material-icons\" role=\"img\" aria-hidden=\"true\">{{icon}}</mat-icon>\n", styles: [":host{display:inline-flex;align-items:center}.orange_gray{color:#c17e5d!important}.color-yellow{color:#fcb202!important}.color-red{color:#f44336!important}.color-white{color:#fff9!important}.color-black{color:#000000de!important}\n"] }]
        }], propDecorators: { icon: [{
                type: Input
            }], size: [{
                type: Input
            }], color: [{
                type: Input
            }] } });

class ButtonComponent {
    constructor() {
        this.icon = '';
        this.rightIcon = '';
        this.disabled = false;
        this.loading = false;
        this.active = false;
        this.stopPropagation = false;
        this.type = 'button';
        this.color = '';
        this.size = 'normal';
        this.styleTheme = 'basic';
        this.tooltipPosition = 'above';
        this.clickButton = new EventEmitter();
        this.context = { size: 'normal', iconSize: 'normal', disabled: false };
        this.spinnerDiameter = 30;
    }
    ngOnInit() {
        this.context.buttonIconSize = this.iconSize ? this.iconSize : this.size;
        this.calculateSpinnerDiameter();
    }
    ngOnChanges(changes) {
        if (changes['loading']) {
            this.context.loading = changes['loading'].currentValue;
        }
        if (changes['iconColor'] && changes['iconColor'].currentValue) {
            this.context.iconColor = changes['iconColor'].currentValue;
        }
        if (changes['color'] && changes['color'].currentValue) {
            this.context.color = changes['color'].currentValue;
        }
        if (changes['buttonIconSize'] && changes['buttonIconSize'].currentValue) {
            this.context.buttonIconSize = changes['buttonIconSize'].currentValue;
        }
        if (changes['icon'] && changes['icon'].currentValue) {
            this.context.icon = changes['icon'].currentValue;
        }
        if (changes['disabled'] && changes['disabled'].currentValue) {
            this.context.disabled = changes['disabled'].currentValue;
        }
    }
    calculateSpinnerDiameter() {
        switch (this.size) {
            case 'normal':
                this.spinnerDiameter = 30;
                break;
        }
    }
    onClick(evt) {
        if (this.stopPropagation) {
            evt.preventDefault();
            evt.stopPropagation();
        }
        if (!this.disabled) {
            this.clickButton.emit(true);
        }
    }
}
ButtonComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "15.2.9", ngImport: i0, type: ButtonComponent, deps: [], target: i0.ɵɵFactoryTarget.Component });
ButtonComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "15.2.9", type: ButtonComponent, selector: "shared-button", inputs: { icon: "icon", iconColor: "iconColor", iconSize: "iconSize", rightIcon: "rightIcon", disabled: "disabled", loading: "loading", active: "active", stopPropagation: "stopPropagation", type: "type", color: "color", size: "size", styleTheme: "styleTheme", tooltip: "tooltip", tooltipPosition: "tooltipPosition" }, outputs: { clickButton: "clickButton" }, usesOnChanges: true, ngImport: i0, template: "<button\n  *ngIf=\"styleTheme === 'basic'\"\n  mat-button\n  class=\"button-effect\"\n  [color]=\"'accent'\"\n  [type]=\"type\"\n  [disabled]=\"disabled || loading\"\n  [ngClass]=\"[size]\"\n  [matTooltip]=\"tooltip\"\n  [matTooltipPosition]=\"tooltipPosition\"\n  [matTooltipDisabled]=\"disabled\"\n  (click)=\"onClick($event)\"\n  [class.active]=\"active\"\n  [class.has-right-icon]=\"rightIcon\">\n  <ng-container *ngTemplateOutlet=\"innerButton; context: context\"></ng-container>\n</button>\n<button\n  *ngIf=\"styleTheme === 'raised'\"\n  mat-raised-button\n  class=\"button-effect\"\n  [color]=\"color\"\n  [type]=\"type\"\n  [disabled]=\"disabled || loading\"\n  [ngClass]=\"[size]\"\n  [matTooltip]=\"tooltip\"\n  [matTooltipPosition]=\"tooltipPosition\"\n  [matTooltipDisabled]=\"disabled\"\n  (click)=\"onClick($event)\"\n  [class.active]=\"active\"\n  [class.has-right-icon]=\"rightIcon\">\n  <ng-container *ngTemplateOutlet=\"innerButton; context: context\"></ng-container>\n</button>\n<button\n  *ngIf=\"styleTheme === 'stroked'\"\n  mat-stroked-button\n  [color]=\"color\"\n  [type]=\"type\"\n  [disabled]=\"disabled || loading\"\n  [ngClass]=\"[size]\"\n  [matTooltip]=\"tooltip\"\n  [matTooltipPosition]=\"tooltipPosition\"\n  [matTooltipDisabled]=\"disabled\"\n  (click)=\"onClick($event)\"\n  [class.active]=\"active\"\n  [class.has-right-icon]=\"rightIcon\">\n  <ng-container *ngTemplateOutlet=\"innerButton; context: context\"></ng-container>\n</button>\n<button\n  *ngIf=\"styleTheme === 'flat'\"\n  mat-flat-button\n  [color]=\"color\"\n  [type]=\"type\"\n  [disabled]=\"disabled || loading\"\n  [ngClass]=\"[size]\"\n  [matTooltip]=\"tooltip\"\n  [matTooltipPosition]=\"tooltipPosition\"\n  [matTooltipDisabled]=\"disabled\"\n  (click)=\"onClick($event)\"\n  [class.active]=\"active\"\n  [class.has-right-icon]=\"rightIcon\">\n  <ng-container\n    *ngTemplateOutlet=\"innerButton; context:{loading: loading, icon: icon, color: color, size: size}\"></ng-container>\n</button>\n<button\n  *ngIf=\"styleTheme === 'fab'\"\n  mat-fab\n  [color]=\"color\"\n  [type]=\"type\"\n  [disabled]=\"disabled || loading\"\n  [ngClass]=\"[size]\"\n  [matTooltip]=\"tooltip\"\n  [matTooltipPosition]=\"tooltipPosition\"\n  [matTooltipDisabled]=\"disabled\"\n  (click)=\"onClick($event)\"\n  [class.active]=\"active\"\n  [class.has-right-icon]=\"rightIcon\">\n  <ng-container *ngTemplateOutlet=\"innerButton; context: context\"></ng-container>\n</button>\n<button\n  *ngIf=\"styleTheme === 'mini-fab'\"\n  mat-mini-fab\n  [color]=\"color\"\n  [type]=\"type\"\n  [disabled]=\"disabled || loading\"\n  [ngClass]=\"[size]\"\n  [matTooltip]=\"tooltip\"\n  [matTooltipPosition]=\"tooltipPosition\"\n  [matTooltipDisabled]=\"disabled\"\n  (click)=\"onClick($event)\"\n  [class.active]=\"active\"\n  [class.has-right-icon]=\"rightIcon\">\n  <ng-container *ngTemplateOutlet=\"innerButton; context: context\"></ng-container>\n</button>\n<ng-template #innerButton\n             let-loading=\"loading\"\n             let-iconColor=\"iconColor\"\n             let-buttonIconSize=\"buttonIconSize\"\n             let-icon=\"icon\"\n             let-disabled=\"disabled\">\n  <shared-ui-icon *ngIf=\"icon\"\n                  [color]=\"iconColor\"\n                  [size]=\"buttonIconSize\"\n                  [icon]=\"icon\"\n                  [ngClass]=\"[icon]\"></shared-ui-icon>\n  <span @appearOpacity\n        class=\"text\"\n        #text>\n    <ng-content></ng-content>\n  </span>\n  <shared-spinner\n    @spinnerAnimation\n    *ngIf=\"loading\"\n    class=\"loader button-loader\"\n    [diameter]=\"spinnerDiameter\"></shared-spinner>\n  <div *ngIf=\"!disabled && !loading\" class=\"button-effect-spans\">\n    <span class=\"button-effect-span\"></span>\n    <span class=\"button-effect-span\"></span>\n    <span class=\"button-effect-span\"></span>\n    <span class=\"button-effect-span\"></span>\n  </div>\n</ng-template>\n", styles: ["shared-ui-icon{margin-left:0!important;margin-right:5px!important}.button-loader{position:absolute}button{line-height:normal;margin:0}button .mdc-button__label{display:flex;align-items:center}\n"], dependencies: [{ kind: "directive", type: i1$3.NgClass, selector: "[ngClass]", inputs: ["class", "ngClass"] }, { kind: "directive", type: i1$3.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "directive", type: i1$3.NgTemplateOutlet, selector: "[ngTemplateOutlet]", inputs: ["ngTemplateOutletContext", "ngTemplateOutlet", "ngTemplateOutletInjector"] }, { kind: "directive", type: i2$5.MatTooltip, selector: "[matTooltip]", exportAs: ["matTooltip"] }, { kind: "component", type: IconComponent, selector: "shared-ui-icon", inputs: ["icon", "size", "color"] }, { kind: "component", type: SpinnerComponent, selector: "shared-spinner", inputs: ["overlay", "diameter", "color", "position"] }, { kind: "component", type: i5.MatButton, selector: "    button[mat-button], button[mat-raised-button], button[mat-flat-button],    button[mat-stroked-button]  ", inputs: ["disabled", "disableRipple", "color"], exportAs: ["matButton"] }, { kind: "component", type: i5.MatMiniFabButton, selector: "button[mat-mini-fab]", inputs: ["disabled", "disableRipple", "color"], exportAs: ["matButton"] }, { kind: "component", type: i5.MatFabButton, selector: "button[mat-fab]", inputs: ["disabled", "disableRipple", "color", "tabIndex", "extended"], exportAs: ["matButton"] }], animations: [
        trigger('spinnerAnimation', [
            transition(':enter', [
                animate('300ms', keyframes([
                    style({ opacity: 0, transform: 'translateY(-10px)', offset: 0 }),
                    style({ opacity: 1, transform: 'translateY(0)', offset: 1 }),
                ]))
            ]),
            transition(':leave', [
                animate('200ms', keyframes([
                    style({ opacity: 1, transform: 'translateY(0)', offset: 0 }),
                    style({ opacity: 0, transform: 'translateY(-10px)', offset: 1 }),
                ]))
            ])
        ]),
        appearOpacity
    ], changeDetection: i0.ChangeDetectionStrategy.OnPush });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "15.2.9", ngImport: i0, type: ButtonComponent, decorators: [{
            type: Component,
            args: [{ selector: 'shared-button', changeDetection: ChangeDetectionStrategy.OnPush, animations: [
                        trigger('spinnerAnimation', [
                            transition(':enter', [
                                animate('300ms', keyframes([
                                    style({ opacity: 0, transform: 'translateY(-10px)', offset: 0 }),
                                    style({ opacity: 1, transform: 'translateY(0)', offset: 1 }),
                                ]))
                            ]),
                            transition(':leave', [
                                animate('200ms', keyframes([
                                    style({ opacity: 1, transform: 'translateY(0)', offset: 0 }),
                                    style({ opacity: 0, transform: 'translateY(-10px)', offset: 1 }),
                                ]))
                            ])
                        ]),
                        appearOpacity
                    ], template: "<button\n  *ngIf=\"styleTheme === 'basic'\"\n  mat-button\n  class=\"button-effect\"\n  [color]=\"'accent'\"\n  [type]=\"type\"\n  [disabled]=\"disabled || loading\"\n  [ngClass]=\"[size]\"\n  [matTooltip]=\"tooltip\"\n  [matTooltipPosition]=\"tooltipPosition\"\n  [matTooltipDisabled]=\"disabled\"\n  (click)=\"onClick($event)\"\n  [class.active]=\"active\"\n  [class.has-right-icon]=\"rightIcon\">\n  <ng-container *ngTemplateOutlet=\"innerButton; context: context\"></ng-container>\n</button>\n<button\n  *ngIf=\"styleTheme === 'raised'\"\n  mat-raised-button\n  class=\"button-effect\"\n  [color]=\"color\"\n  [type]=\"type\"\n  [disabled]=\"disabled || loading\"\n  [ngClass]=\"[size]\"\n  [matTooltip]=\"tooltip\"\n  [matTooltipPosition]=\"tooltipPosition\"\n  [matTooltipDisabled]=\"disabled\"\n  (click)=\"onClick($event)\"\n  [class.active]=\"active\"\n  [class.has-right-icon]=\"rightIcon\">\n  <ng-container *ngTemplateOutlet=\"innerButton; context: context\"></ng-container>\n</button>\n<button\n  *ngIf=\"styleTheme === 'stroked'\"\n  mat-stroked-button\n  [color]=\"color\"\n  [type]=\"type\"\n  [disabled]=\"disabled || loading\"\n  [ngClass]=\"[size]\"\n  [matTooltip]=\"tooltip\"\n  [matTooltipPosition]=\"tooltipPosition\"\n  [matTooltipDisabled]=\"disabled\"\n  (click)=\"onClick($event)\"\n  [class.active]=\"active\"\n  [class.has-right-icon]=\"rightIcon\">\n  <ng-container *ngTemplateOutlet=\"innerButton; context: context\"></ng-container>\n</button>\n<button\n  *ngIf=\"styleTheme === 'flat'\"\n  mat-flat-button\n  [color]=\"color\"\n  [type]=\"type\"\n  [disabled]=\"disabled || loading\"\n  [ngClass]=\"[size]\"\n  [matTooltip]=\"tooltip\"\n  [matTooltipPosition]=\"tooltipPosition\"\n  [matTooltipDisabled]=\"disabled\"\n  (click)=\"onClick($event)\"\n  [class.active]=\"active\"\n  [class.has-right-icon]=\"rightIcon\">\n  <ng-container\n    *ngTemplateOutlet=\"innerButton; context:{loading: loading, icon: icon, color: color, size: size}\"></ng-container>\n</button>\n<button\n  *ngIf=\"styleTheme === 'fab'\"\n  mat-fab\n  [color]=\"color\"\n  [type]=\"type\"\n  [disabled]=\"disabled || loading\"\n  [ngClass]=\"[size]\"\n  [matTooltip]=\"tooltip\"\n  [matTooltipPosition]=\"tooltipPosition\"\n  [matTooltipDisabled]=\"disabled\"\n  (click)=\"onClick($event)\"\n  [class.active]=\"active\"\n  [class.has-right-icon]=\"rightIcon\">\n  <ng-container *ngTemplateOutlet=\"innerButton; context: context\"></ng-container>\n</button>\n<button\n  *ngIf=\"styleTheme === 'mini-fab'\"\n  mat-mini-fab\n  [color]=\"color\"\n  [type]=\"type\"\n  [disabled]=\"disabled || loading\"\n  [ngClass]=\"[size]\"\n  [matTooltip]=\"tooltip\"\n  [matTooltipPosition]=\"tooltipPosition\"\n  [matTooltipDisabled]=\"disabled\"\n  (click)=\"onClick($event)\"\n  [class.active]=\"active\"\n  [class.has-right-icon]=\"rightIcon\">\n  <ng-container *ngTemplateOutlet=\"innerButton; context: context\"></ng-container>\n</button>\n<ng-template #innerButton\n             let-loading=\"loading\"\n             let-iconColor=\"iconColor\"\n             let-buttonIconSize=\"buttonIconSize\"\n             let-icon=\"icon\"\n             let-disabled=\"disabled\">\n  <shared-ui-icon *ngIf=\"icon\"\n                  [color]=\"iconColor\"\n                  [size]=\"buttonIconSize\"\n                  [icon]=\"icon\"\n                  [ngClass]=\"[icon]\"></shared-ui-icon>\n  <span @appearOpacity\n        class=\"text\"\n        #text>\n    <ng-content></ng-content>\n  </span>\n  <shared-spinner\n    @spinnerAnimation\n    *ngIf=\"loading\"\n    class=\"loader button-loader\"\n    [diameter]=\"spinnerDiameter\"></shared-spinner>\n  <div *ngIf=\"!disabled && !loading\" class=\"button-effect-spans\">\n    <span class=\"button-effect-span\"></span>\n    <span class=\"button-effect-span\"></span>\n    <span class=\"button-effect-span\"></span>\n    <span class=\"button-effect-span\"></span>\n  </div>\n</ng-template>\n", styles: ["shared-ui-icon{margin-left:0!important;margin-right:5px!important}.button-loader{position:absolute}button{line-height:normal;margin:0}button .mdc-button__label{display:flex;align-items:center}\n"] }]
        }], ctorParameters: function () { return []; }, propDecorators: { icon: [{
                type: Input
            }], iconColor: [{
                type: Input
            }], iconSize: [{
                type: Input
            }], rightIcon: [{
                type: Input
            }], disabled: [{
                type: Input
            }], loading: [{
                type: Input
            }], active: [{
                type: Input
            }], stopPropagation: [{
                type: Input
            }], type: [{
                type: Input
            }], color: [{
                type: Input
            }], size: [{
                type: Input
            }], styleTheme: [{
                type: Input
            }], tooltip: [{
                type: Input
            }], tooltipPosition: [{
                type: Input
            }], clickButton: [{
                type: Output
            }] } });

class PanelComponent {
    constructor() {
        this.close = new EventEmitter();
        this.isOpened = false;
    }
    ngOnInit() {
    }
    toggleExpanded() {
        this.isOpened = !this.isOpened;
    }
}
PanelComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "15.2.9", ngImport: i0, type: PanelComponent, deps: [], target: i0.ɵɵFactoryTarget.Component });
PanelComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "15.2.9", type: PanelComponent, selector: "shared-panel", inputs: { title: "title", smallDescription: "smallDescription", description: "description", color: "color", buttonColor: "buttonColor" }, outputs: { close: "close" }, ngImport: i0, template: "<div class=\"fuse-card\" [ngClass]=\"'bg-'+color\">\n\n  <div class=\"p-10 cursor-pointer\"\n       fxLayout=\"row\"\n       fxLayoutAlign=\"space-between center\"\n        (click)=\"toggleExpanded()\">\n    <div class=\"h4\">{{title}}</div>\n    <shared-button\n      [color]=\"buttonColor\"\n      [icon]=\"isOpened ? 'keyboard_arrow_up' : 'keyboard_arrow_down'\"></shared-button>\n  </div>\n\n  <div *ngIf=\"smallDescription\" class=\"p-16 pt-0 line-height-1.75\" [innerHTML]=\"smallDescription\">\n  </div>\n\n  <div class=\"card-expand-area\" *ngIf=\"isOpened\" [@expandCollapse]>\n    <div class=\"card-expanded-content\" [innerHTML]=\"description\"></div>\n  </div>\n\n</div>\n", styles: [""], dependencies: [{ kind: "directive", type: i1$3.NgClass, selector: "[ngClass]", inputs: ["class", "ngClass"] }, { kind: "directive", type: i1$3.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "component", type: ButtonComponent, selector: "shared-button", inputs: ["icon", "iconColor", "iconSize", "rightIcon", "disabled", "loading", "active", "stopPropagation", "type", "color", "size", "styleTheme", "tooltip", "tooltipPosition"], outputs: ["clickButton"] }, { kind: "directive", type: i9.DefaultLayoutDirective, selector: "  [fxLayout], [fxLayout.xs], [fxLayout.sm], [fxLayout.md],  [fxLayout.lg], [fxLayout.xl], [fxLayout.lt-sm], [fxLayout.lt-md],  [fxLayout.lt-lg], [fxLayout.lt-xl], [fxLayout.gt-xs], [fxLayout.gt-sm],  [fxLayout.gt-md], [fxLayout.gt-lg]", inputs: ["fxLayout", "fxLayout.xs", "fxLayout.sm", "fxLayout.md", "fxLayout.lg", "fxLayout.xl", "fxLayout.lt-sm", "fxLayout.lt-md", "fxLayout.lt-lg", "fxLayout.lt-xl", "fxLayout.gt-xs", "fxLayout.gt-sm", "fxLayout.gt-md", "fxLayout.gt-lg"] }, { kind: "directive", type: i9.DefaultLayoutAlignDirective, selector: "  [fxLayoutAlign], [fxLayoutAlign.xs], [fxLayoutAlign.sm], [fxLayoutAlign.md],  [fxLayoutAlign.lg], [fxLayoutAlign.xl], [fxLayoutAlign.lt-sm], [fxLayoutAlign.lt-md],  [fxLayoutAlign.lt-lg], [fxLayoutAlign.lt-xl], [fxLayoutAlign.gt-xs], [fxLayoutAlign.gt-sm],  [fxLayoutAlign.gt-md], [fxLayoutAlign.gt-lg]", inputs: ["fxLayoutAlign", "fxLayoutAlign.xs", "fxLayoutAlign.sm", "fxLayoutAlign.md", "fxLayoutAlign.lg", "fxLayoutAlign.xl", "fxLayoutAlign.lt-sm", "fxLayoutAlign.lt-md", "fxLayoutAlign.lt-lg", "fxLayoutAlign.lt-xl", "fxLayoutAlign.gt-xs", "fxLayoutAlign.gt-sm", "fxLayoutAlign.gt-md", "fxLayoutAlign.gt-lg"] }], animations: [expandCollapse], changeDetection: i0.ChangeDetectionStrategy.OnPush });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "15.2.9", ngImport: i0, type: PanelComponent, decorators: [{
            type: Component,
            args: [{ selector: 'shared-panel', animations: [expandCollapse], changeDetection: ChangeDetectionStrategy.OnPush, template: "<div class=\"fuse-card\" [ngClass]=\"'bg-'+color\">\n\n  <div class=\"p-10 cursor-pointer\"\n       fxLayout=\"row\"\n       fxLayoutAlign=\"space-between center\"\n        (click)=\"toggleExpanded()\">\n    <div class=\"h4\">{{title}}</div>\n    <shared-button\n      [color]=\"buttonColor\"\n      [icon]=\"isOpened ? 'keyboard_arrow_up' : 'keyboard_arrow_down'\"></shared-button>\n  </div>\n\n  <div *ngIf=\"smallDescription\" class=\"p-16 pt-0 line-height-1.75\" [innerHTML]=\"smallDescription\">\n  </div>\n\n  <div class=\"card-expand-area\" *ngIf=\"isOpened\" [@expandCollapse]>\n    <div class=\"card-expanded-content\" [innerHTML]=\"description\"></div>\n  </div>\n\n</div>\n" }]
        }], ctorParameters: function () { return []; }, propDecorators: { title: [{
                type: Input
            }], smallDescription: [{
                type: Input
            }], description: [{
                type: Input
            }], color: [{
                type: Input
            }], buttonColor: [{
                type: Input
            }], close: [{
                type: Output
            }] } });

class PublicationMessagesComponent {
    constructor(publicationMessagesFacade, autoFormService, cd) {
        this.publicationMessagesFacade = publicationMessagesFacade;
        this.autoFormService = autoFormService;
        this.cd = cd;
        this.config = { needToPublish: true };
        this.havePublication = true;
        this.scrollToField = new EventEmitter();
        this.errorOpened = false;
        this.messagesOpened = false;
        this.publishedTitle = 'Позиция опубликована до';
        this.unPublishedTitle = 'Внимание позиция НЕ опубликована';
        this.unPublishedMessage = 'Для публикации позиции нужно заполнить все поля и нажать на кнопку ОПУБЛИКОВАТЬ';
        this.errorTitleSource = 'Для публикации Вам обязательно нужно исправить <b>${pointCount}</b> пункт(а/ов)';
        this.recommendationTitleSource = 'Мы также рекомендуем Вам исправить <b>${pointCount}</b> пункт(а/ов)';
        this.errorTitle = '';
        this.recommendationTitle = '';
        this.publishErrorConstants = PublishErrors;
        this.itemPublishFinishedField = 'publishFinishedAt';
        this.itemPublishFinishedAt = '';
        this.itemPublishFinishedAtTmp = '';
        this.globalSubscription = new Subscription();
    }
    ngOnInit() {
        this.preparingComponent();
    }
    ngOnDestroy() {
        this.globalSubscription.unsubscribe();
    }
    ngOnChanges(changes) {
        if (changes?.form?.currentValue.value[this.itemPublishFinishedField]) {
            this.updateItemPublishFinishAt(changes.form.currentValue.value[this.itemPublishFinishedField]);
        }
        if (changes.entity || changes.itemId) {
            this.globalSubscription.unsubscribe();
            this.globalSubscription = new Subscription();
            this.preparingComponent();
        }
    }
    preparingComponent() {
        this.subscribeToFormChanges();
        this.definitionPublicationMessages();
    }
    showScrollToFieldMethod(field) {
        this.scrollToField.emit(field);
    }
    subscribeToFormChanges() {
        const subscription = this.form.valueChanges
            .subscribe((data) => {
            this.updateItemPublishFinishAt(data?.publishFinishedAt);
        });
        this.globalSubscription.add(subscription);
    }
    updateItemPublishFinishAt(itemPublishFinishedAt) {
        if (this.itemPublishFinishedAtTmp !== itemPublishFinishedAt) {
            this.itemPublishFinishedAt = itemPublishFinishedAt;
            this.itemPublishFinishedAtTmp = itemPublishFinishedAt;
            this.cd.markForCheck();
        }
    }
    definitionPublicationMessages() {
        if (typeof this.entity === 'string') {
            const subscription = this.publicationMessagesFacade.getPublicationMessage(this.entity?.toLowerCase(), this.itemId)
                .subscribe((messages) => {
                if (messages?.length) {
                    const tmpErrors = this.filterMessages(true, messages);
                    this.errors = this.prepareErrors(tmpErrors);
                    const tmpRecommendation = this.filterMessages(false, messages);
                    this.recommendation = this.prepareErrors(tmpRecommendation);
                    if (this.errors.length) {
                        this.errorTitle = this.errorTitleSource.replace('${pointCount}', String(this.errors.length));
                    }
                    if (this.recommendation.length) {
                        this.recommendationTitle = this.recommendationTitleSource.replace('${pointCount}', String(this.recommendation.length));
                    }
                }
                else {
                    this.errors = [];
                    this.recommendation = [];
                }
                this.cd.markForCheck();
            });
            this.globalSubscription.add(subscription);
        }
        else {
            console.error('[ publish-messages ][ entity-type ]', { entity: this.entity }, 'INCORRECT_ENTITY_TYPE');
        }
    }
    filterMessages(error = false, messages) {
        return messages.filter(item => item.isError === error);
    }
    toggleExpand(isError = false) {
        if (isError) {
            this.errorOpened = !this.errorOpened;
        }
        else {
            this.messagesOpened = !this.messagesOpened;
        }
        this.cd.markForCheck();
    }
    truckByField(index, item) {
        return item.field;
    }
    prepareErrors(messages) {
        return this.autoFormService.prepareFormFieldPublicationMessage(messages, this.publishErrorConstants, this.fields);
    }
}
PublicationMessagesComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "15.2.9", ngImport: i0, type: PublicationMessagesComponent, deps: [{ token: PublicationMessagesFacade }, { token: AutoFormService }, { token: i0.ChangeDetectorRef }], target: i0.ɵɵFactoryTarget.Component });
PublicationMessagesComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "15.2.9", type: PublicationMessagesComponent, selector: "shared-publication-messages", inputs: { entity: "entity", form: "form", itemId: "itemId", fields: "fields", config: "config", havePublication: "havePublication" }, outputs: { scrollToField: "scrollToField" }, usesOnChanges: true, ngImport: i0, template: "<div *ngIf=\"itemPublishFinishedAt\" @appearFromLeftWithDelay class=\"message-box success mb-10\">\n  <div>{{publishedTitle}} <b>{{itemPublishFinishedAt| date : 'MMM d, y'}}</b></div>\n</div>\n<div *ngIf=\"!itemPublishFinishedAt && havePublication\" @appearFromLeftWithDelay class=\"message-box error mb-10\">\n  <div class=\"no-publish-error\">\n    <mat-icon class=\"no-publish-error-ico\">assignment_late</mat-icon>\n    <div class=\"no-publish-error-text\">\n      <div>{{unPublishedTitle}}</div>\n      <div class=\"fs-12 pt-0\">{{unPublishedMessage}}</div>\n    </div>\n  </div>\n</div>\n<ng-container *ngIf=\"errors?.length\">\n  <ng-container\n    *ngTemplateOutlet=\"listMessages; context: {title: errorTitle, isError: true, messages: errors}\"></ng-container>\n</ng-container>\n<ng-container *ngIf=\"recommendation?.length\">\n  <ng-container\n    *ngTemplateOutlet=\"listMessages; context: {title: recommendationTitle, isError: false, messages: recommendation}\"></ng-container>\n</ng-container>\n<ng-template #listMessages let-title=\"title\" let-isError=\"isError\" let-messages=\"messages\">\n  <div class=\"publish-messages mb-10\"\n       [ngClass]=\"{'error-messages': isError, 'warning-messages': !isError}\">\n    <div class=\"title cursor-pointer\"\n         fxLayout=\"row\"\n         fxLayoutAlign=\"space-between center\"\n         (click)=\"toggleExpand(isError)\">\n      <div fxLayout=\"row\" fxLayoutAlign=\"left center\">\n        <mat-icon class=\"f-28 ml-10 mr-20\">{{isError ? 'error' : 'report_problem'}}</mat-icon>\n        <h4 [innerHTML]=\"title\"></h4>\n      </div>\n      <shared-button\n        color=\"basic\"\n        iconColor=\"orange_gray\"\n        size=\"large\"\n        [icon]=\"(isError && errorOpened) || (!isError && messagesOpened) ? 'keyboard_arrow_up' : 'keyboard_arrow_down'\"></shared-button>\n    </div>\n    <div *ngIf=\"(errorOpened && isError) || (messagesOpened && !isError)\"\n         [@expandCollapse]\n         class=\"publish-messages-list\">\n      <div *ngFor=\"let messageData of messages;trackBy: truckByField\" class=\"mb-10\">\n        <shared-panel [title]=\"messageData.title\"\n                      [description]=\"messageData.description\"\n                      color=\"red-light\"\n                      buttonColor=\"accent\"\n        ></shared-panel>\n        <a class=\"cursor-pointer color-grey fs-12\" (click)=\"showScrollToFieldMethod(messageData.field)\">\u041F\u043E\u043A\u0430\u0437\u0430\u0442\u044C\n          \u043F\u043E\u043B\u0435</a>\n      </div>\n    </div>\n  </div>\n</ng-template>\n<div *ngIf=\"errors?.length || recommendation?.length\" fxLayout=\"row\" fxLayoutAlign=\"end center\" class=\"fs-12\">\n  \u0415\u0441\u043B\u0438 \u0443 \u0412\u0430\u0441 \u0435\u0441\u0442\u044C \u0432\u043E\u043F\u0440\u043E\u0441\u044B \u043F\u043E \u043F\u0443\u0431\u043B\u0438\u043A\u0430\u0446\u0438\u0438 \u043F\u0438\u0448\u0438\u0442\u0435 \u0432 <a class=\"pl-5\" href=\"mailto:support@world-travel.uz\">support@world-travel.uz</a>\n</div>\n", styles: [".publish-messages{border-radius:8px;overflow:hidden}.publish-messages.error-messages{background:linear-gradient(90deg,#ef847c,#f190af)}.publish-messages.error-messages .title{background:#f44336;background:linear-gradient(to bottom,#f44336,#af3b32);color:#fff}.publish-messages.warning-messages{background:linear-gradient(260deg,#faf0cd,#fab397)}.publish-messages.warning-messages .title{background:#e28d0b;background:linear-gradient(to bottom,#ffb646,#e28d0b);color:#fff}.publish-messages .title{padding:10px;border-top-left-radius:8px;border-top-right-radius:8px;text-shadow:0 0 6px rgba(56,56,56,.5803921569);font-size:16px}.publish-messages .publish-messages-list{padding:10px}.publish-messages .h4,.publish-messages h4{cursor:pointer}.no-publish-error{display:flex}.no-publish-error .no-publish-error-ico{font-size:43px;margin-right:10px}\n"], dependencies: [{ kind: "directive", type: i1$3.NgClass, selector: "[ngClass]", inputs: ["class", "ngClass"] }, { kind: "directive", type: i1$3.NgForOf, selector: "[ngFor][ngForOf]", inputs: ["ngForOf", "ngForTrackBy", "ngForTemplate"] }, { kind: "directive", type: i1$3.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "directive", type: i1$3.NgTemplateOutlet, selector: "[ngTemplateOutlet]", inputs: ["ngTemplateOutletContext", "ngTemplateOutlet", "ngTemplateOutletInjector"] }, { kind: "directive", type: i9.DefaultLayoutDirective, selector: "  [fxLayout], [fxLayout.xs], [fxLayout.sm], [fxLayout.md],  [fxLayout.lg], [fxLayout.xl], [fxLayout.lt-sm], [fxLayout.lt-md],  [fxLayout.lt-lg], [fxLayout.lt-xl], [fxLayout.gt-xs], [fxLayout.gt-sm],  [fxLayout.gt-md], [fxLayout.gt-lg]", inputs: ["fxLayout", "fxLayout.xs", "fxLayout.sm", "fxLayout.md", "fxLayout.lg", "fxLayout.xl", "fxLayout.lt-sm", "fxLayout.lt-md", "fxLayout.lt-lg", "fxLayout.lt-xl", "fxLayout.gt-xs", "fxLayout.gt-sm", "fxLayout.gt-md", "fxLayout.gt-lg"] }, { kind: "directive", type: i9.DefaultLayoutAlignDirective, selector: "  [fxLayoutAlign], [fxLayoutAlign.xs], [fxLayoutAlign.sm], [fxLayoutAlign.md],  [fxLayoutAlign.lg], [fxLayoutAlign.xl], [fxLayoutAlign.lt-sm], [fxLayoutAlign.lt-md],  [fxLayoutAlign.lt-lg], [fxLayoutAlign.lt-xl], [fxLayoutAlign.gt-xs], [fxLayoutAlign.gt-sm],  [fxLayoutAlign.gt-md], [fxLayoutAlign.gt-lg]", inputs: ["fxLayoutAlign", "fxLayoutAlign.xs", "fxLayoutAlign.sm", "fxLayoutAlign.md", "fxLayoutAlign.lg", "fxLayoutAlign.xl", "fxLayoutAlign.lt-sm", "fxLayoutAlign.lt-md", "fxLayoutAlign.lt-lg", "fxLayoutAlign.lt-xl", "fxLayoutAlign.gt-xs", "fxLayoutAlign.gt-sm", "fxLayoutAlign.gt-md", "fxLayoutAlign.gt-lg"] }, { kind: "component", type: i2$4.MatIcon, selector: "mat-icon", inputs: ["color", "inline", "svgIcon", "fontSet", "fontIcon"], exportAs: ["matIcon"] }, { kind: "component", type: PanelComponent, selector: "shared-panel", inputs: ["title", "smallDescription", "description", "color", "buttonColor"], outputs: ["close"] }, { kind: "component", type: ButtonComponent, selector: "shared-button", inputs: ["icon", "iconColor", "iconSize", "rightIcon", "disabled", "loading", "active", "stopPropagation", "type", "color", "size", "styleTheme", "tooltip", "tooltipPosition"], outputs: ["clickButton"] }, { kind: "pipe", type: i1$3.DatePipe, name: "date" }], animations: [expandCollapse, appearFromLeftWithDelay], changeDetection: i0.ChangeDetectionStrategy.OnPush });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "15.2.9", ngImport: i0, type: PublicationMessagesComponent, decorators: [{
            type: Component,
            args: [{ selector: 'shared-publication-messages', animations: [expandCollapse, appearFromLeftWithDelay], changeDetection: ChangeDetectionStrategy.OnPush, template: "<div *ngIf=\"itemPublishFinishedAt\" @appearFromLeftWithDelay class=\"message-box success mb-10\">\n  <div>{{publishedTitle}} <b>{{itemPublishFinishedAt| date : 'MMM d, y'}}</b></div>\n</div>\n<div *ngIf=\"!itemPublishFinishedAt && havePublication\" @appearFromLeftWithDelay class=\"message-box error mb-10\">\n  <div class=\"no-publish-error\">\n    <mat-icon class=\"no-publish-error-ico\">assignment_late</mat-icon>\n    <div class=\"no-publish-error-text\">\n      <div>{{unPublishedTitle}}</div>\n      <div class=\"fs-12 pt-0\">{{unPublishedMessage}}</div>\n    </div>\n  </div>\n</div>\n<ng-container *ngIf=\"errors?.length\">\n  <ng-container\n    *ngTemplateOutlet=\"listMessages; context: {title: errorTitle, isError: true, messages: errors}\"></ng-container>\n</ng-container>\n<ng-container *ngIf=\"recommendation?.length\">\n  <ng-container\n    *ngTemplateOutlet=\"listMessages; context: {title: recommendationTitle, isError: false, messages: recommendation}\"></ng-container>\n</ng-container>\n<ng-template #listMessages let-title=\"title\" let-isError=\"isError\" let-messages=\"messages\">\n  <div class=\"publish-messages mb-10\"\n       [ngClass]=\"{'error-messages': isError, 'warning-messages': !isError}\">\n    <div class=\"title cursor-pointer\"\n         fxLayout=\"row\"\n         fxLayoutAlign=\"space-between center\"\n         (click)=\"toggleExpand(isError)\">\n      <div fxLayout=\"row\" fxLayoutAlign=\"left center\">\n        <mat-icon class=\"f-28 ml-10 mr-20\">{{isError ? 'error' : 'report_problem'}}</mat-icon>\n        <h4 [innerHTML]=\"title\"></h4>\n      </div>\n      <shared-button\n        color=\"basic\"\n        iconColor=\"orange_gray\"\n        size=\"large\"\n        [icon]=\"(isError && errorOpened) || (!isError && messagesOpened) ? 'keyboard_arrow_up' : 'keyboard_arrow_down'\"></shared-button>\n    </div>\n    <div *ngIf=\"(errorOpened && isError) || (messagesOpened && !isError)\"\n         [@expandCollapse]\n         class=\"publish-messages-list\">\n      <div *ngFor=\"let messageData of messages;trackBy: truckByField\" class=\"mb-10\">\n        <shared-panel [title]=\"messageData.title\"\n                      [description]=\"messageData.description\"\n                      color=\"red-light\"\n                      buttonColor=\"accent\"\n        ></shared-panel>\n        <a class=\"cursor-pointer color-grey fs-12\" (click)=\"showScrollToFieldMethod(messageData.field)\">\u041F\u043E\u043A\u0430\u0437\u0430\u0442\u044C\n          \u043F\u043E\u043B\u0435</a>\n      </div>\n    </div>\n  </div>\n</ng-template>\n<div *ngIf=\"errors?.length || recommendation?.length\" fxLayout=\"row\" fxLayoutAlign=\"end center\" class=\"fs-12\">\n  \u0415\u0441\u043B\u0438 \u0443 \u0412\u0430\u0441 \u0435\u0441\u0442\u044C \u0432\u043E\u043F\u0440\u043E\u0441\u044B \u043F\u043E \u043F\u0443\u0431\u043B\u0438\u043A\u0430\u0446\u0438\u0438 \u043F\u0438\u0448\u0438\u0442\u0435 \u0432 <a class=\"pl-5\" href=\"mailto:support@world-travel.uz\">support@world-travel.uz</a>\n</div>\n", styles: [".publish-messages{border-radius:8px;overflow:hidden}.publish-messages.error-messages{background:linear-gradient(90deg,#ef847c,#f190af)}.publish-messages.error-messages .title{background:#f44336;background:linear-gradient(to bottom,#f44336,#af3b32);color:#fff}.publish-messages.warning-messages{background:linear-gradient(260deg,#faf0cd,#fab397)}.publish-messages.warning-messages .title{background:#e28d0b;background:linear-gradient(to bottom,#ffb646,#e28d0b);color:#fff}.publish-messages .title{padding:10px;border-top-left-radius:8px;border-top-right-radius:8px;text-shadow:0 0 6px rgba(56,56,56,.5803921569);font-size:16px}.publish-messages .publish-messages-list{padding:10px}.publish-messages .h4,.publish-messages h4{cursor:pointer}.no-publish-error{display:flex}.no-publish-error .no-publish-error-ico{font-size:43px;margin-right:10px}\n"] }]
        }], ctorParameters: function () { return [{ type: PublicationMessagesFacade }, { type: AutoFormService }, { type: i0.ChangeDetectorRef }]; }, propDecorators: { entity: [{
                type: Input
            }], form: [{
                type: Input
            }], itemId: [{
                type: Input
            }], fields: [{
                type: Input
            }], config: [{
                type: Input
            }], havePublication: [{
                type: Input
            }], scrollToField: [{
                type: Output
            }] } });

class AutoFormMainComponent {
    constructor(formErrors, formsFacade, publicationMessagesFacade, route, cd) {
        this.formErrors = formErrors;
        this.formsFacade = formsFacade;
        this.publicationMessagesFacade = publicationMessagesFacade;
        this.route = route;
        this.cd = cd;
        this.showPublicationMessages = false;
        this.editorImageUploadUrl = '';
        this.havePublication = true;
        this.config = { needToPublish: true };
        this.changed = new EventEmitter();
        this.formCompleted = new EventEmitter();
        this.globalSubscription = new Subscription();
        this.object_ = Object;
        this.dataStored = false;
        this.dataStoredTitle = 'Данные сохранены';
        this.formSaveErrorKey = 'FORM_SAVE_ERROR';
        this.groupsState = {};
    }
    ngOnInit() {
        this.currentEntity = this.entity;
        this.currentItemId = this.itemId;
        if (this.itemId) {
            this.dataStored = true;
        }
        this.storedFormValue = this.form.value;
        // @TODO Need to test 31.01
        // this.preparingData();
        this.getQueryParams();
    }
    ngOnDestroy() {
        this.globalSubscription.unsubscribe();
    }
    ngOnChanges(changes) {
        if ((changes.entity && changes.entity.currentValue !== this.currentEntity) ||
            (changes.itemId && changes.itemId.currentValue !== this.currentItemId)) {
            this.globalSubscription.unsubscribe();
            this.globalSubscription = new Subscription();
            this.preparingData();
        }
    }
    getQueryParams() {
        this.route.queryParamMap
            .pipe(untilComponentDestroyed(this))
            .subscribe(params => {
            this.autoCompleteFields = [];
            const fields = params.getAll('fields');
            const fieldsValue = params.getAll('fieldsvalue');
            for (let i = 0; i < fields.length; i++) {
                this.autoCompleteFields.push({
                    field: fields[i],
                    value: Number(fieldsValue[i])
                });
            }
        });
    }
    preparingData() {
        this.groupFields();
        this.subscribeToFormErrors();
        this.subscribeToFormStatus();
        this.subscribeToFormChanges();
        this.subscribeToPublicationMessages();
    }
    groupFields() {
        this.groupedFields = {};
        this.fields.filter(formField => !formField.options?.notEditable)
            .forEach(formField => {
            const groupName = formField.options?.groupName || '';
            if (!this.groupedFields[groupName]) {
                this.groupedFields[groupName] = [];
            }
            this.groupedFields[groupName].push({ ...formField });
        });
        Object.keys(this.groupedFields)?.forEach((group, index) => {
            this.groupsState[group] = index === 0;
        });
    }
    truckByFieldName(index, item) {
        return item.field;
    }
    scrollToField(field) {
        const fieldGroup = this.fields.find(item => item.field === field)?.options.groupName;
        this.groupsState[fieldGroup] = 1;
        setTimeout(() => {
            let el = document.getElementById(`field-${field}`);
            el.scrollIntoView();
        }, 0);
    }
    subscribeToFormErrors() {
        const newSubscription = this.formErrors.getFormErrors(this.formId)
            .pipe(filter((errors) => !!(errors && errors.length)))
            .subscribe((errors) => {
            if (errors && errors.length) {
                errors.forEach(error => {
                    const { field, code } = error;
                    if (field && code) {
                        const control = this.form.get(field);
                        if (control) {
                            const codeUpperCase = code.toUpperCase();
                            control.setErrors({ [codeUpperCase]: codeUpperCase });
                            control.markAsDirty();
                            control.markAsTouched();
                        }
                    }
                });
                this.cd.markForCheck();
            }
        });
        this.globalSubscription.add(newSubscription);
    }
    subscribeToFormStatus() {
        this.formsFacade.initForm({
            formId: this.formId,
            loading: false
        });
        const newSubscription = this.formsFacade.getForm(this.formId)
            .pipe(distinctUntilChanged((a, b) => {
            return a.isComplete === b.isComplete;
        }))
            .subscribe((form) => {
            if (form.isComplete) {
                this.formCompleted.emit({ newId: form.data.itemId });
            }
            if (form && form.isComplete) {
                if (!form.hasError) {
                    this.dataStored = true;
                }
                else {
                    this.form.setErrors({ [this.formSaveErrorKey]: this.formSaveErrorKey });
                }
                this.cd.markForCheck();
            }
        });
        this.globalSubscription.add(newSubscription);
    }
    subscribeToFormChanges() {
        const newSubscription = this.form.valueChanges
            .subscribe((formValue) => {
            const areEquals = this.areObjectsEquals(formValue, this.storedFormValue);
            if (!areEquals) {
                this.storedFormValue = formValue;
            }
            this.dataStored = areEquals;
            this.changed.emit({ valueChanged: !areEquals });
        });
        this.globalSubscription.add(newSubscription);
    }
    groupClick(groupName) {
        this.groupsState[groupName] = !this.groupsState[groupName];
    }
    areObjectsEquals(a, b) {
        return Object.keys(a)
            .every(field => {
            let theyEqual;
            if (isObject(a[field])) {
                if (isObject(b[field])) {
                    theyEqual = this.areObjectsEquals(a[field], b[field]);
                }
                else {
                    theyEqual = false;
                }
            }
            else {
                theyEqual = a[field] === b[field];
            }
            return theyEqual;
        });
    }
    subscribeToPublicationMessages() {
        if (this.itemId) {
            const newSubscription = this.publicationMessagesFacade.getPublicationMessage(this.entity, this.itemId)
                .subscribe((publicationMessages) => {
                this.allPublicationMessages = publicationMessages;
            });
            this.globalSubscription.add(newSubscription);
        }
    }
}
AutoFormMainComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "15.2.9", ngImport: i0, type: AutoFormMainComponent, deps: [{ token: FormErrorsFacade }, { token: FormsFacade }, { token: PublicationMessagesFacade }, { token: i2.ActivatedRoute }, { token: i0.ChangeDetectorRef }], target: i0.ɵɵFactoryTarget.Component });
AutoFormMainComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "15.2.9", type: AutoFormMainComponent, selector: "shared-auto-form", inputs: { fields: "fields", itemId: "itemId", formId: "formId", showPublicationMessages: "showPublicationMessages", form: "form", editorImageUploadUrl: "editorImageUploadUrl", errorMessageTexts: "errorMessageTexts", entity: "entity", havePublication: "havePublication", config: "config" }, outputs: { changed: "changed", formCompleted: "formCompleted" }, usesOnChanges: true, ngImport: i0, template: "<shared-smart-progress-bar *ngIf=\"storedFormValue._occupancyRating\"\n                           [value]=\"storedFormValue._occupancyRating\"\n                            [title]=\"'\u0423\u0440\u043E\u0432\u0435\u043D\u044C \u0437\u0430\u043F\u043E\u043B\u043D\u0435\u043D\u043D\u043E\u0441\u0442\u0438 \u0444\u043E\u0440\u043C\u044B'\"></shared-smart-progress-bar>\n\n<ng-container *ngIf=\"showPublicationMessages && fields?.length\">\n  <ng-container\n    *ngTemplateOutlet=\"publicationMessages, context: {form: form, entity: entity, itemId: itemId, fields: fields}\"></ng-container>\n</ng-container>\n\n<div *ngFor=\"let group of object_.keys(groupedFields); trackBy: truckByFieldName\"\n     class=\"form-group\"\n     [ngClass]=\"{'form-group-open': groupsState[group]}\">\n  <h2 *ngIf=\"group\" class=\"form-field-group-title\" (click)=\"groupClick(group)\">\n    <mat-icon class=\"fs-20 field-group-icon\">expand_more</mat-icon>\n    {{group}}\n  </h2>\n  <div *ngIf=\"groupsState[group]\"\n       class=\"form-group-fields\">\n    <div *ngFor=\"let item of groupedFields[group]; trackBy: truckByFieldName\"\n         class=\"form-field-row col-md-12\"\n         [ngClass]=\"item.options.col ? 'col-lg-'+item.options.col : ''\">\n\n      <div [ngClass]=\"{'field-tab': group}\">\n        <shared-form-field\n          [itemId]=\"itemId\"\n          [fieldData]=\"item\"\n          [form]=\"form\"\n          [errorMessageTexts]=\"errorMessageTexts\"\n          [editorImageUploadUrl]=\"editorImageUploadUrl\"\n          [entity]=\"entity\"\n          [publicationMessages]=\"allPublicationMessages\"\n          [autoCompleteFields]=\"autoCompleteFields\"\n        ></shared-form-field>\n      </div>\n    </div>\n  </div>\n</div>\n<div @appearFromLeft *ngIf=\"dataStored && form.valid\" class=\"message-box warning mt-20 mb-10\">\n  <ul>\n    <li>{{dataStoredTitle}}</li>\n  </ul>\n</div>\n<shred-form-message-box\n  class=\"mt-20 mb-10\"\n  [form]=\"form\"\n  [fields]=\"fields\"\n  [errorMessageTexts]=\"errorMessageTexts\"></shred-form-message-box>\n\n<ng-container *ngIf=\"havePublication\">\n  <ng-container *ngIf=\"showPublicationMessages && fields?.length\">\n    <ng-container\n      *ngTemplateOutlet=\"publicationMessages, context: {form: form, entity: entity, itemId: itemId, fields: fields}\"></ng-container>\n  </ng-container>\n</ng-container>\n\n<ng-template #publicationMessages let-form=\"form\" let-entity=\"entity\" let-itemId=\"itemId\" let-fields=\"fields\">\n  <shared-publication-messages\n    *ngIf=\"itemId\"\n    [@appearFromLeft]\n    [form]=\"form\"\n    [entity]=\"entity\"\n    [itemId]=\"itemId\"\n    [fields]=\"fields\"\n    [havePublication]=\"havePublication\"\n    (scrollToField)=\"scrollToField($event)\"></shared-publication-messages>\n</ng-template>\n", styles: [":host{display:flex;flex-direction:column;flex-wrap:wrap}.form-group{cursor:pointer}.form-group h2{display:flex;transition:color .3s}.progress-bar{margin-bottom:10px}\n"], dependencies: [{ kind: "directive", type: i1$3.NgClass, selector: "[ngClass]", inputs: ["class", "ngClass"] }, { kind: "directive", type: i1$3.NgForOf, selector: "[ngFor][ngForOf]", inputs: ["ngForOf", "ngForTrackBy", "ngForTemplate"] }, { kind: "directive", type: i1$3.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "directive", type: i1$3.NgTemplateOutlet, selector: "[ngTemplateOutlet]", inputs: ["ngTemplateOutletContext", "ngTemplateOutlet", "ngTemplateOutletInjector"] }, { kind: "component", type: i2$4.MatIcon, selector: "mat-icon", inputs: ["color", "inline", "svgIcon", "fontSet", "fontIcon"], exportAs: ["matIcon"] }, { kind: "component", type: SmartProgressBarComponent, selector: "shared-smart-progress-bar", inputs: ["value", "title", "showValue"] }, { kind: "component", type: FormFieldComponent, selector: "shared-form-field", inputs: ["fieldData", "itemId", "form", "editorImageUploadUrl", "errorMessageTexts", "entity", "publicationMessages", "entityTypeUserRoleRights", "autoCompleteFields"], outputs: ["eventUpdateForm", "eventSendAction"] }, { kind: "component", type: FormMessageBoxComponent, selector: "shred-form-message-box", inputs: ["form", "fields", "errorMessageTexts"] }, { kind: "component", type: PublicationMessagesComponent, selector: "shared-publication-messages", inputs: ["entity", "form", "itemId", "fields", "config", "havePublication"], outputs: ["scrollToField"] }], animations: [appearFromLeft, appearOpacity], changeDetection: i0.ChangeDetectionStrategy.OnPush });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "15.2.9", ngImport: i0, type: AutoFormMainComponent, decorators: [{
            type: Component,
            args: [{ selector: 'shared-auto-form', changeDetection: ChangeDetectionStrategy.OnPush, animations: [appearFromLeft, appearOpacity], template: "<shared-smart-progress-bar *ngIf=\"storedFormValue._occupancyRating\"\n                           [value]=\"storedFormValue._occupancyRating\"\n                            [title]=\"'\u0423\u0440\u043E\u0432\u0435\u043D\u044C \u0437\u0430\u043F\u043E\u043B\u043D\u0435\u043D\u043D\u043E\u0441\u0442\u0438 \u0444\u043E\u0440\u043C\u044B'\"></shared-smart-progress-bar>\n\n<ng-container *ngIf=\"showPublicationMessages && fields?.length\">\n  <ng-container\n    *ngTemplateOutlet=\"publicationMessages, context: {form: form, entity: entity, itemId: itemId, fields: fields}\"></ng-container>\n</ng-container>\n\n<div *ngFor=\"let group of object_.keys(groupedFields); trackBy: truckByFieldName\"\n     class=\"form-group\"\n     [ngClass]=\"{'form-group-open': groupsState[group]}\">\n  <h2 *ngIf=\"group\" class=\"form-field-group-title\" (click)=\"groupClick(group)\">\n    <mat-icon class=\"fs-20 field-group-icon\">expand_more</mat-icon>\n    {{group}}\n  </h2>\n  <div *ngIf=\"groupsState[group]\"\n       class=\"form-group-fields\">\n    <div *ngFor=\"let item of groupedFields[group]; trackBy: truckByFieldName\"\n         class=\"form-field-row col-md-12\"\n         [ngClass]=\"item.options.col ? 'col-lg-'+item.options.col : ''\">\n\n      <div [ngClass]=\"{'field-tab': group}\">\n        <shared-form-field\n          [itemId]=\"itemId\"\n          [fieldData]=\"item\"\n          [form]=\"form\"\n          [errorMessageTexts]=\"errorMessageTexts\"\n          [editorImageUploadUrl]=\"editorImageUploadUrl\"\n          [entity]=\"entity\"\n          [publicationMessages]=\"allPublicationMessages\"\n          [autoCompleteFields]=\"autoCompleteFields\"\n        ></shared-form-field>\n      </div>\n    </div>\n  </div>\n</div>\n<div @appearFromLeft *ngIf=\"dataStored && form.valid\" class=\"message-box warning mt-20 mb-10\">\n  <ul>\n    <li>{{dataStoredTitle}}</li>\n  </ul>\n</div>\n<shred-form-message-box\n  class=\"mt-20 mb-10\"\n  [form]=\"form\"\n  [fields]=\"fields\"\n  [errorMessageTexts]=\"errorMessageTexts\"></shred-form-message-box>\n\n<ng-container *ngIf=\"havePublication\">\n  <ng-container *ngIf=\"showPublicationMessages && fields?.length\">\n    <ng-container\n      *ngTemplateOutlet=\"publicationMessages, context: {form: form, entity: entity, itemId: itemId, fields: fields}\"></ng-container>\n  </ng-container>\n</ng-container>\n\n<ng-template #publicationMessages let-form=\"form\" let-entity=\"entity\" let-itemId=\"itemId\" let-fields=\"fields\">\n  <shared-publication-messages\n    *ngIf=\"itemId\"\n    [@appearFromLeft]\n    [form]=\"form\"\n    [entity]=\"entity\"\n    [itemId]=\"itemId\"\n    [fields]=\"fields\"\n    [havePublication]=\"havePublication\"\n    (scrollToField)=\"scrollToField($event)\"></shared-publication-messages>\n</ng-template>\n", styles: [":host{display:flex;flex-direction:column;flex-wrap:wrap}.form-group{cursor:pointer}.form-group h2{display:flex;transition:color .3s}.progress-bar{margin-bottom:10px}\n"] }]
        }], ctorParameters: function () { return [{ type: FormErrorsFacade }, { type: FormsFacade }, { type: PublicationMessagesFacade }, { type: i2.ActivatedRoute }, { type: i0.ChangeDetectorRef }]; }, propDecorators: { fields: [{
                type: Input
            }], itemId: [{
                type: Input
            }], formId: [{
                type: Input
            }], showPublicationMessages: [{
                type: Input
            }], form: [{
                type: Input
            }], editorImageUploadUrl: [{
                type: Input
            }], errorMessageTexts: [{
                type: Input
            }], entity: [{
                type: Input
            }], havePublication: [{
                type: Input
            }], config: [{
                type: Input
            }], changed: [{
                type: Output
            }], formCompleted: [{
                type: Output
            }] } });

class FormFieldSelectShowComponent {
    constructor(coreFacade, cd) {
        this.coreFacade = coreFacade;
        this.cd = cd;
        this.listItems = [];
    }
    ngOnDestroy() {
    }
    ngOnChanges(changes) {
        if (changes.fieldData.currentValue) {
            let values = !Array.isArray(this.value) ? [this.value] : this.value;
            const loadOptionFromStore = this.fieldData.options.loadOptionFromStore;
            if (!this.listItems.length) {
                this.storeItemsFromStore(loadOptionFromStore, values);
            }
        }
    }
    storeItemsFromStore(keyFromStore, ids) {
        this.coreFacade.getStoreByName(keyFromStore)
            .pipe(untilComponentDestroyed(this))
            .subscribe(items => {
            if (items?.length) {
                this.listItems = items
                    .filter(item => ids.includes(item.id))
                    .map(item => item.name);
                this.cd.markForCheck();
            }
        });
    }
    trackById(index, item) {
        return item?.id || undefined;
    }
}
FormFieldSelectShowComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "15.2.9", ngImport: i0, type: FormFieldSelectShowComponent, deps: [{ token: CoreFacade }, { token: i0.ChangeDetectorRef }], target: i0.ɵɵFactoryTarget.Component });
FormFieldSelectShowComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "15.2.9", type: FormFieldSelectShowComponent, selector: "shared-form-field-select-show", inputs: { fieldData: "fieldData", value: "value" }, usesOnChanges: true, ngImport: i0, template: "<label class=\"show-label\">{{fieldData.title}}</label>\n<div class=\"form-field-value\">\n  <span *ngFor=\"let value of listItems;trackBy: trackById\">{{value}}</span>\n</div>\n", styles: [".form-field-value{display:flex;flex-direction:column}\n"], dependencies: [{ kind: "directive", type: i1$3.NgForOf, selector: "[ngFor][ngForOf]", inputs: ["ngForOf", "ngForTrackBy", "ngForTemplate"] }], changeDetection: i0.ChangeDetectionStrategy.OnPush });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "15.2.9", ngImport: i0, type: FormFieldSelectShowComponent, decorators: [{
            type: Component,
            args: [{ selector: 'shared-form-field-select-show', changeDetection: ChangeDetectionStrategy.OnPush, template: "<label class=\"show-label\">{{fieldData.title}}</label>\n<div class=\"form-field-value\">\n  <span *ngFor=\"let value of listItems;trackBy: trackById\">{{value}}</span>\n</div>\n", styles: [".form-field-value{display:flex;flex-direction:column}\n"] }]
        }], ctorParameters: function () { return [{ type: CoreFacade }, { type: i0.ChangeDetectorRef }]; }, propDecorators: { fieldData: [{
                type: Input
            }], value: [{
                type: Input
            }] } });

class StarRatingComponent {
    constructor() {
        this.rating = 0;
        this.size = 'normal';
        this.arrayList = ['', '', ''];
    }
    ngOnInit() {
    }
}
StarRatingComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "15.2.9", ngImport: i0, type: StarRatingComponent, deps: [], target: i0.ɵɵFactoryTarget.Component });
StarRatingComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "15.2.9", type: StarRatingComponent, selector: "shared-star-rating", inputs: { rating: "rating", size: "size" }, ngImport: i0, template: "<div class=\"star-rating-block\" [ngClass]=\"{'block-big': size === 'big'}\">\n  <span class=\"d-flex align-items-center\">\n       <i class=\"fa fa-star\"></i>\n       <i class=\"fa fa-star\"></i>\n       <i class=\"fa fa-star\"></i>\n       <i class=\"fa fa-star\"></i>\n       <i class=\"fa fa-star\"></i>\n  </span>\n    <span class=\"d-flex align-items-center yellow-starts\">\n       <i *ngFor=\"let number of arrayList\" class=\"fa fa-star\"></i>\n  </span>\n</div>\n", styles: [".star-rating-block{overflow:hidden;position:relative}.star-rating-block span.yellow-starts{position:absolute;left:0;top:0}.star-rating-block span.yellow-starts i{color:#fdae5c!important}.star-rating-block span i{font-size:15px;color:#faae5c73!important}.star-rating-block.block-big i{font-size:20px!important}\n"], dependencies: [{ kind: "directive", type: i1$3.NgClass, selector: "[ngClass]", inputs: ["class", "ngClass"] }, { kind: "directive", type: i1$3.NgForOf, selector: "[ngFor][ngForOf]", inputs: ["ngForOf", "ngForTrackBy", "ngForTemplate"] }], changeDetection: i0.ChangeDetectionStrategy.OnPush });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "15.2.9", ngImport: i0, type: StarRatingComponent, decorators: [{
            type: Component,
            args: [{ selector: 'shared-star-rating', changeDetection: ChangeDetectionStrategy.OnPush, template: "<div class=\"star-rating-block\" [ngClass]=\"{'block-big': size === 'big'}\">\n  <span class=\"d-flex align-items-center\">\n       <i class=\"fa fa-star\"></i>\n       <i class=\"fa fa-star\"></i>\n       <i class=\"fa fa-star\"></i>\n       <i class=\"fa fa-star\"></i>\n       <i class=\"fa fa-star\"></i>\n  </span>\n    <span class=\"d-flex align-items-center yellow-starts\">\n       <i *ngFor=\"let number of arrayList\" class=\"fa fa-star\"></i>\n  </span>\n</div>\n", styles: [".star-rating-block{overflow:hidden;position:relative}.star-rating-block span.yellow-starts{position:absolute;left:0;top:0}.star-rating-block span.yellow-starts i{color:#fdae5c!important}.star-rating-block span i{font-size:15px;color:#faae5c73!important}.star-rating-block.block-big i{font-size:20px!important}\n"] }]
        }], ctorParameters: function () { return []; }, propDecorators: { rating: [{
                type: Input
            }], size: [{
                type: Input
            }] } });

class FormFieldFileShowComponent {
}
FormFieldFileShowComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "15.2.9", ngImport: i0, type: FormFieldFileShowComponent, deps: [], target: i0.ɵɵFactoryTarget.Component });
FormFieldFileShowComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "15.2.9", type: FormFieldFileShowComponent, selector: "shared-form-field-file-show", inputs: { fieldData: "fieldData", value: "value" }, ngImport: i0, template: "<div>\n  <div class=\"width100\">\n    <label class=\"show-label\">{{fieldData.title}}</label>\n    <div\n      @appearFromLeft\n      *ngIf=\"value\"\n      class=\"form-field-file-image\">\n      <div class=\"image-block mlr--5\">\n        <shared-image class=\"mlr-5 mat-elevation-z3 width150100\"\n                      [versions]=\"value.versions\"\n                      [version]=\"1\"\n                      [haveZoom]=\"true\"></shared-image>\n      </div>\n    </div>\n  </div>\n</div>\n", styles: [".image-block{display:flex;margin-bottom:10px}\n"], dependencies: [{ kind: "directive", type: i1$3.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "component", type: ImageComponent, selector: "shared-image", inputs: ["versions", "url", "version", "title", "index", "haveZoom", "imgClass"], outputs: ["clickEvent", "delete"] }], animations: [
        appearFromLeft,
        trigger('inputAnim', [
            state('0', style({
                opacity: 0
            })),
            state('1', style({
                opacity: 1
            })),
            transition('0 => 1', [
                animate('500ms')
            ]),
            transition('1 => 0', [
                animate('500ms')
            ])
        ])
    ], changeDetection: i0.ChangeDetectionStrategy.OnPush });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "15.2.9", ngImport: i0, type: FormFieldFileShowComponent, decorators: [{
            type: Component,
            args: [{ selector: 'shared-form-field-file-show', changeDetection: ChangeDetectionStrategy.OnPush, animations: [
                        appearFromLeft,
                        trigger('inputAnim', [
                            state('0', style({
                                opacity: 0
                            })),
                            state('1', style({
                                opacity: 1
                            })),
                            transition('0 => 1', [
                                animate('500ms')
                            ]),
                            transition('1 => 0', [
                                animate('500ms')
                            ])
                        ])
                    ], template: "<div>\n  <div class=\"width100\">\n    <label class=\"show-label\">{{fieldData.title}}</label>\n    <div\n      @appearFromLeft\n      *ngIf=\"value\"\n      class=\"form-field-file-image\">\n      <div class=\"image-block mlr--5\">\n        <shared-image class=\"mlr-5 mat-elevation-z3 width150100\"\n                      [versions]=\"value.versions\"\n                      [version]=\"1\"\n                      [haveZoom]=\"true\"></shared-image>\n      </div>\n    </div>\n  </div>\n</div>\n", styles: [".image-block{display:flex;margin-bottom:10px}\n"] }]
        }], propDecorators: { fieldData: [{
                type: Input
            }], value: [{
                type: Input
            }] } });

class FormFieldSlideToggleShowComponent {
    constructor() {
        this.publishTitle = 'Опубликован';
        this.unPublishTitle = 'Не опубликован';
    }
}
FormFieldSlideToggleShowComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "15.2.9", ngImport: i0, type: FormFieldSlideToggleShowComponent, deps: [], target: i0.ɵɵFactoryTarget.Component });
FormFieldSlideToggleShowComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "15.2.9", type: FormFieldSlideToggleShowComponent, selector: "shared-form-field-slide-toggle-show", inputs: { fieldData: "fieldData", value: "value" }, ngImport: i0, template: "<label class=\"show-label\">{{fieldData.title}}</label>\n<div class=\"display-flex-align-center form-field-value\" [ngClass]=\"{'color-green': value, 'color-red': !value }\">\n  <ng-container *ngIf=\"value\">\n    <mat-icon>check</mat-icon>{{publishTitle}}\n  </ng-container>\n  <ng-container *ngIf=\"!value\">\n    <mat-icon>clear</mat-icon>{{unPublishTitle}}\n  </ng-container>\n</div>\n", styles: [""], dependencies: [{ kind: "directive", type: i1$3.NgClass, selector: "[ngClass]", inputs: ["class", "ngClass"] }, { kind: "directive", type: i1$3.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "component", type: i2$4.MatIcon, selector: "mat-icon", inputs: ["color", "inline", "svgIcon", "fontSet", "fontIcon"], exportAs: ["matIcon"] }], changeDetection: i0.ChangeDetectionStrategy.OnPush });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "15.2.9", ngImport: i0, type: FormFieldSlideToggleShowComponent, decorators: [{
            type: Component,
            args: [{ selector: 'shared-form-field-slide-toggle-show', changeDetection: ChangeDetectionStrategy.OnPush, template: "<label class=\"show-label\">{{fieldData.title}}</label>\n<div class=\"display-flex-align-center form-field-value\" [ngClass]=\"{'color-green': value, 'color-red': !value }\">\n  <ng-container *ngIf=\"value\">\n    <mat-icon>check</mat-icon>{{publishTitle}}\n  </ng-container>\n  <ng-container *ngIf=\"!value\">\n    <mat-icon>clear</mat-icon>{{unPublishTitle}}\n  </ng-container>\n</div>\n" }]
        }], propDecorators: { fieldData: [{
                type: Input
            }], value: [{
                type: Input
            }] } });

class FormFieldInputShowComponent {
    constructor() {
    }
    ngOnChanges(changes) {
        if (changes?.value) {
            this.checkInputType(changes?.value.currentValue);
        }
    }
    checkInputType(value) {
        switch (this.fieldData.options.format) {
            case IFormFieldFormat.Email:
                this.inputValue = value;
                break;
            case IFormFieldFormat.Phone:
                this.inputValue = value;
                break;
            case IFormFieldFormat.Date:
                const dateParams = value.split('-');
                this.inputValue = dateParams?.length === 3 ? `${dateParams[2]}.${dateParams[1]}.${dateParams[0]}` : '---';
                break;
            default:
                this.inputValue = value;
        }
    }
}
FormFieldInputShowComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "15.2.9", ngImport: i0, type: FormFieldInputShowComponent, deps: [], target: i0.ɵɵFactoryTarget.Component });
FormFieldInputShowComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "15.2.9", type: FormFieldInputShowComponent, selector: "shared-form-field-input-show", inputs: { fieldData: "fieldData", value: "value" }, usesOnChanges: true, ngImport: i0, template: "<div>\n  <div class=\"width100\">\n    <label class=\"show-label\">{{fieldData.title}}</label>\n    <div class=\"display-flex align-baseline\">\n      {{inputValue}}\n    </div>\n  </div>\n</div>\n", styles: [""], changeDetection: i0.ChangeDetectionStrategy.OnPush });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "15.2.9", ngImport: i0, type: FormFieldInputShowComponent, decorators: [{
            type: Component,
            args: [{ selector: 'shared-form-field-input-show', changeDetection: ChangeDetectionStrategy.OnPush, template: "<div>\n  <div class=\"width100\">\n    <label class=\"show-label\">{{fieldData.title}}</label>\n    <div class=\"display-flex align-baseline\">\n      {{inputValue}}\n    </div>\n  </div>\n</div>\n" }]
        }], ctorParameters: function () { return []; }, propDecorators: { fieldData: [{
                type: Input
            }], value: [{
                type: Input
            }] } });

class FormFieldFilesShowComponent {
    constructor(filesFacade) {
        this.filesFacade = filesFacade;
    }
    ngOnInit() {
        if (this.entityId && this.entitySection) {
            this.loadFiles();
        }
    }
    ngOnDestroy() {
    }
    loadFiles() {
        const params = {
            itemId: this.entityId,
            section: this.entitySection
        };
        this.files$ = this.filesFacade.getFiles(params)
            .pipe(take(1));
    }
}
FormFieldFilesShowComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "15.2.9", ngImport: i0, type: FormFieldFilesShowComponent, deps: [{ token: FilesFacade }], target: i0.ɵɵFactoryTarget.Component });
FormFieldFilesShowComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "15.2.9", type: FormFieldFilesShowComponent, selector: "shared-form-field-files-show", inputs: { fieldData: "fieldData", entityId: "entityId", entitySection: "entitySection" }, ngImport: i0, template: "<div>\n  <div class=\"width100\">\n    <label class=\"show-label\">{{fieldData.title}}</label>\n    <div class=\"display-flex align-baseline\">\n      <ng-container *ngIf=\"files$ | async as files\">\n      <div class=\"position-relative image-block mlr--5\">\n        <shared-image *ngFor=\"let file of files\"\n                      class=\"mlr-5 mat-elevation-z3\"\n                      [versions]=\"file.versions\"\n                      [version]=\"1\"\n                      [haveZoom]=\"true\"></shared-image>\n      </div>\n      </ng-container>\n    </div>\n  </div>\n</div>\n", styles: [".image-block{display:flex}.image-block shared-image{max-width:150px;max-height:100px}\n"], dependencies: [{ kind: "directive", type: i1$3.NgForOf, selector: "[ngFor][ngForOf]", inputs: ["ngForOf", "ngForTrackBy", "ngForTemplate"] }, { kind: "directive", type: i1$3.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "component", type: ImageComponent, selector: "shared-image", inputs: ["versions", "url", "version", "title", "index", "haveZoom", "imgClass"], outputs: ["clickEvent", "delete"] }, { kind: "pipe", type: i1$3.AsyncPipe, name: "async" }], changeDetection: i0.ChangeDetectionStrategy.OnPush });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "15.2.9", ngImport: i0, type: FormFieldFilesShowComponent, decorators: [{
            type: Component,
            args: [{ selector: 'shared-form-field-files-show', changeDetection: ChangeDetectionStrategy.OnPush, template: "<div>\n  <div class=\"width100\">\n    <label class=\"show-label\">{{fieldData.title}}</label>\n    <div class=\"display-flex align-baseline\">\n      <ng-container *ngIf=\"files$ | async as files\">\n      <div class=\"position-relative image-block mlr--5\">\n        <shared-image *ngFor=\"let file of files\"\n                      class=\"mlr-5 mat-elevation-z3\"\n                      [versions]=\"file.versions\"\n                      [version]=\"1\"\n                      [haveZoom]=\"true\"></shared-image>\n      </div>\n      </ng-container>\n    </div>\n  </div>\n</div>\n", styles: [".image-block{display:flex}.image-block shared-image{max-width:150px;max-height:100px}\n"] }]
        }], ctorParameters: function () { return [{ type: FilesFacade }]; }, propDecorators: { fieldData: [{
                type: Input
            }], entityId: [{
                type: Input
            }], entitySection: [{
                type: Input
            }] } });

class AutoFormShowFieldComponent {
    constructor() {
        this.fieldTypes = FieldType;
        this.inputType = InputType.Text;
    }
    ngOnInit() {
        this.setInputType();
        this.field = this.fieldData.field;
        this.value = this.data[this.field] || "";
    }
    setInputType() {
        switch (this.fieldData.options.format) {
            case IFormFieldFormat.Email:
                this.inputType = InputType.Email;
                break;
            case IFormFieldFormat.Phone:
                this.inputType = InputType.Tel;
                break;
            default:
                this.inputType = InputType.Text;
        }
    }
}
AutoFormShowFieldComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "15.2.9", ngImport: i0, type: AutoFormShowFieldComponent, deps: [], target: i0.ɵɵFactoryTarget.Component });
AutoFormShowFieldComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "15.2.9", type: AutoFormShowFieldComponent, selector: "shared-auto-form-show-field", inputs: { fieldData: "fieldData", data: "data", entityId: "entityId", entitySection: "entitySection" }, ngImport: i0, template: "<div fxLayout=\"column\"\n     class=\"position-relative form-field\">\n  <ng-container [ngSwitch]=\"fieldData.type\">\n\n    <ng-container *ngSwitchCase=\"fieldTypes.FieldTypeSelect\">\n      <shared-form-field-select-show\n        [fieldData]=\"fieldData\"\n        [value]=\"value\"\n      ></shared-form-field-select-show>\n    </ng-container>\n\n    <ng-container *ngSwitchCase=\"fieldTypes.FieldTypeSelectMultiple\">\n      <shared-form-field-select-show\n        [fieldData]=\"fieldData\"\n        [value]=\"value\"\n      ></shared-form-field-select-show>\n    </ng-container>\n\n    <ng-container *ngSwitchCase=\"fieldTypes.FieldTypeSlideToggle\">\n      <shared-form-field-slide-toggle-show [fieldData]=\"fieldData\" [value]=\"value\"></shared-form-field-slide-toggle-show>\n    </ng-container>\n\n    <ng-container *ngSwitchCase=\"fieldTypes.FieldTypeTextarea\">\n      <label class=\"show-label\">{{fieldData.title}}</label>\n      <div class=\"form-field-value\">{{value}}</div>\n    </ng-container>\n\n    <ng-container *ngSwitchCase=\"fieldTypes.FieldTypeTextareaEditor\">\n      <label class=\"show-label\">{{fieldData.title}}</label>\n      <div class=\"form-field-value\" [innerHTML]=\"value\"></div>\n    </ng-container>\n\n    <ng-container *ngSwitchCase=\"fieldTypes.FieldTypeFile\">\n      <shared-form-field-file-show [fieldData]=\"fieldData\" [value]=\"value\"></shared-form-field-file-show>\n    </ng-container>\n\n    <ng-container *ngSwitchCase=\"fieldTypes.FieldTypeRating\">\n      <shared-star-rating [rating]=\"value\"></shared-star-rating>\n    </ng-container>\n\n    <ng-container *ngSwitchCase=\"fieldTypes.FieldTypeFiles\">\n      <shared-form-field-files-show [fieldData]=\"fieldData\"\n                                    [entityId]=\"entityId\"\n                                    [entitySection]=\"entitySection\"></shared-form-field-files-show>\n    </ng-container>\n\n    <ng-container *ngSwitchDefault>\n      <shared-form-field-input-show [fieldData]=\"fieldData\" [value]=\"value\"></shared-form-field-input-show>\n    </ng-container>\n  </ng-container>\n</div>\n", styles: [".form-field{margin-bottom:20px}.form-field:last-child{margin-bottom:0}.show-label{font-size:12px;opacity:.5}.form-field-value{font-size:16px}.mb-21{margin-bottom:21px}.textarea-field-width{width:100%;max-width:1000px}\n"], dependencies: [{ kind: "directive", type: i1$3.NgSwitch, selector: "[ngSwitch]", inputs: ["ngSwitch"] }, { kind: "directive", type: i1$3.NgSwitchCase, selector: "[ngSwitchCase]", inputs: ["ngSwitchCase"] }, { kind: "directive", type: i1$3.NgSwitchDefault, selector: "[ngSwitchDefault]" }, { kind: "directive", type: i9.DefaultLayoutDirective, selector: "  [fxLayout], [fxLayout.xs], [fxLayout.sm], [fxLayout.md],  [fxLayout.lg], [fxLayout.xl], [fxLayout.lt-sm], [fxLayout.lt-md],  [fxLayout.lt-lg], [fxLayout.lt-xl], [fxLayout.gt-xs], [fxLayout.gt-sm],  [fxLayout.gt-md], [fxLayout.gt-lg]", inputs: ["fxLayout", "fxLayout.xs", "fxLayout.sm", "fxLayout.md", "fxLayout.lg", "fxLayout.xl", "fxLayout.lt-sm", "fxLayout.lt-md", "fxLayout.lt-lg", "fxLayout.lt-xl", "fxLayout.gt-xs", "fxLayout.gt-sm", "fxLayout.gt-md", "fxLayout.gt-lg"] }, { kind: "component", type: StarRatingComponent, selector: "shared-star-rating", inputs: ["rating", "size"] }, { kind: "component", type: FormFieldSelectShowComponent, selector: "shared-form-field-select-show", inputs: ["fieldData", "value"] }, { kind: "component", type: FormFieldFileShowComponent, selector: "shared-form-field-file-show", inputs: ["fieldData", "value"] }, { kind: "component", type: FormFieldSlideToggleShowComponent, selector: "shared-form-field-slide-toggle-show", inputs: ["fieldData", "value"] }, { kind: "component", type: FormFieldInputShowComponent, selector: "shared-form-field-input-show", inputs: ["fieldData", "value"] }, { kind: "component", type: FormFieldFilesShowComponent, selector: "shared-form-field-files-show", inputs: ["fieldData", "entityId", "entitySection"] }], changeDetection: i0.ChangeDetectionStrategy.OnPush });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "15.2.9", ngImport: i0, type: AutoFormShowFieldComponent, decorators: [{
            type: Component,
            args: [{ selector: "shared-auto-form-show-field", changeDetection: ChangeDetectionStrategy.OnPush, template: "<div fxLayout=\"column\"\n     class=\"position-relative form-field\">\n  <ng-container [ngSwitch]=\"fieldData.type\">\n\n    <ng-container *ngSwitchCase=\"fieldTypes.FieldTypeSelect\">\n      <shared-form-field-select-show\n        [fieldData]=\"fieldData\"\n        [value]=\"value\"\n      ></shared-form-field-select-show>\n    </ng-container>\n\n    <ng-container *ngSwitchCase=\"fieldTypes.FieldTypeSelectMultiple\">\n      <shared-form-field-select-show\n        [fieldData]=\"fieldData\"\n        [value]=\"value\"\n      ></shared-form-field-select-show>\n    </ng-container>\n\n    <ng-container *ngSwitchCase=\"fieldTypes.FieldTypeSlideToggle\">\n      <shared-form-field-slide-toggle-show [fieldData]=\"fieldData\" [value]=\"value\"></shared-form-field-slide-toggle-show>\n    </ng-container>\n\n    <ng-container *ngSwitchCase=\"fieldTypes.FieldTypeTextarea\">\n      <label class=\"show-label\">{{fieldData.title}}</label>\n      <div class=\"form-field-value\">{{value}}</div>\n    </ng-container>\n\n    <ng-container *ngSwitchCase=\"fieldTypes.FieldTypeTextareaEditor\">\n      <label class=\"show-label\">{{fieldData.title}}</label>\n      <div class=\"form-field-value\" [innerHTML]=\"value\"></div>\n    </ng-container>\n\n    <ng-container *ngSwitchCase=\"fieldTypes.FieldTypeFile\">\n      <shared-form-field-file-show [fieldData]=\"fieldData\" [value]=\"value\"></shared-form-field-file-show>\n    </ng-container>\n\n    <ng-container *ngSwitchCase=\"fieldTypes.FieldTypeRating\">\n      <shared-star-rating [rating]=\"value\"></shared-star-rating>\n    </ng-container>\n\n    <ng-container *ngSwitchCase=\"fieldTypes.FieldTypeFiles\">\n      <shared-form-field-files-show [fieldData]=\"fieldData\"\n                                    [entityId]=\"entityId\"\n                                    [entitySection]=\"entitySection\"></shared-form-field-files-show>\n    </ng-container>\n\n    <ng-container *ngSwitchDefault>\n      <shared-form-field-input-show [fieldData]=\"fieldData\" [value]=\"value\"></shared-form-field-input-show>\n    </ng-container>\n  </ng-container>\n</div>\n", styles: [".form-field{margin-bottom:20px}.form-field:last-child{margin-bottom:0}.show-label{font-size:12px;opacity:.5}.form-field-value{font-size:16px}.mb-21{margin-bottom:21px}.textarea-field-width{width:100%;max-width:1000px}\n"] }]
        }], ctorParameters: function () { return []; }, propDecorators: { fieldData: [{
                type: Input
            }], data: [{
                type: Input
            }], entityId: [{
                type: Input
            }], entitySection: [{
                type: Input
            }] } });

class AutoFormShowComponent {
    constructor() {
        this.fieldGrouped = false;
        this.object_ = Object;
    }
    ngOnInit() {
    }
    ngOnChanges(changes) {
        if (changes.fields) {
            this.groupFields();
        }
    }
    truckByFieldName(index, item) {
        return item.field;
    }
    groupFields() {
        if (!this.fieldGrouped) {
            this.groupedFields = {};
            this.fields.forEach(formField => {
                const groupName = formField.options.groupName || '';
                if (!this.groupedFields[groupName]) {
                    this.groupedFields[groupName] = [];
                }
                this.groupedFields[groupName].push({ ...formField });
            });
            this.fieldGrouped = true;
        }
    }
}
AutoFormShowComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "15.2.9", ngImport: i0, type: AutoFormShowComponent, deps: [], target: i0.ɵɵFactoryTarget.Component });
AutoFormShowComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "15.2.9", type: AutoFormShowComponent, selector: "shared-auto-form-show", inputs: { fields: "fields", data: "data", entityId: "entityId", entitySection: "entitySection" }, usesOnChanges: true, ngImport: i0, template: "<div *ngFor=\"let group of object_.keys(groupedFields); trackBy: truckByFieldName\"\n     class=\"form-group\">\n  <h2 *ngIf=\"group\" class=\"form-field-group-title\">\n    {{group}}\n  </h2>\n  <div class=\"form-group-fields\">\n    <div *ngFor=\"let item of groupedFields[group]; trackBy: truckByFieldName\"\n         class=\"form-field-row col-md-12\"\n         [ngClass]=\"item.options.col ? 'col-lg-'+item.options.col : ''\">\n      <!-- [ngClass]=\"item.options.col ? 'form-field-col-'+item.options.col : ''\" -->\n      <div [ngClass]=\"{'field-tab': group}\">\n        <shared-auto-form-show-field\n          [fieldData]=\"item\"\n          [data]=\"data\"\n          [entityId]=\"entityId\"\n          [entitySection]=\"entitySection\"\n        ></shared-auto-form-show-field>\n      </div>\n    </div>\n  </div>\n</div>\n", styles: [":host{display:flex;flex-direction:column}.form-field-group-title{padding:0 20px}.form-group-fields{overflow:hidden;padding-left:20px;padding-right:20px}.form-group{margin-left:20px;width:calc(100% - 40px);margin-right:20px}\n"], dependencies: [{ kind: "directive", type: i1$3.NgClass, selector: "[ngClass]", inputs: ["class", "ngClass"] }, { kind: "directive", type: i1$3.NgForOf, selector: "[ngFor][ngForOf]", inputs: ["ngForOf", "ngForTrackBy", "ngForTemplate"] }, { kind: "directive", type: i1$3.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "component", type: AutoFormShowFieldComponent, selector: "shared-auto-form-show-field", inputs: ["fieldData", "data", "entityId", "entitySection"] }], changeDetection: i0.ChangeDetectionStrategy.OnPush });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "15.2.9", ngImport: i0, type: AutoFormShowComponent, decorators: [{
            type: Component,
            args: [{ selector: 'shared-auto-form-show', changeDetection: ChangeDetectionStrategy.OnPush, template: "<div *ngFor=\"let group of object_.keys(groupedFields); trackBy: truckByFieldName\"\n     class=\"form-group\">\n  <h2 *ngIf=\"group\" class=\"form-field-group-title\">\n    {{group}}\n  </h2>\n  <div class=\"form-group-fields\">\n    <div *ngFor=\"let item of groupedFields[group]; trackBy: truckByFieldName\"\n         class=\"form-field-row col-md-12\"\n         [ngClass]=\"item.options.col ? 'col-lg-'+item.options.col : ''\">\n      <!-- [ngClass]=\"item.options.col ? 'form-field-col-'+item.options.col : ''\" -->\n      <div [ngClass]=\"{'field-tab': group}\">\n        <shared-auto-form-show-field\n          [fieldData]=\"item\"\n          [data]=\"data\"\n          [entityId]=\"entityId\"\n          [entitySection]=\"entitySection\"\n        ></shared-auto-form-show-field>\n      </div>\n    </div>\n  </div>\n</div>\n", styles: [":host{display:flex;flex-direction:column}.form-field-group-title{padding:0 20px}.form-group-fields{overflow:hidden;padding-left:20px;padding-right:20px}.form-group{margin-left:20px;width:calc(100% - 40px);margin-right:20px}\n"] }]
        }], propDecorators: { fields: [{
                type: Input
            }], data: [{
                type: Input
            }], entityId: [{
                type: Input
            }], entitySection: [{
                type: Input
            }] } });

class FormFieldErrorModule {
}
FormFieldErrorModule.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "15.2.9", ngImport: i0, type: FormFieldErrorModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule });
FormFieldErrorModule.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "15.2.9", ngImport: i0, type: FormFieldErrorModule, declarations: [FormFieldErrorComponent], imports: [CommonModule,
        MatFormFieldModule], exports: [FormFieldErrorComponent] });
FormFieldErrorModule.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "15.2.9", ngImport: i0, type: FormFieldErrorModule, imports: [CommonModule,
        MatFormFieldModule] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "15.2.9", ngImport: i0, type: FormFieldErrorModule, decorators: [{
            type: NgModule,
            args: [{
                    declarations: [FormFieldErrorComponent],
                    exports: [
                        FormFieldErrorComponent
                    ],
                    imports: [
                        CommonModule,
                        MatFormFieldModule
                    ]
                }]
        }] });

class FormFieldPublishErrorModule {
}
FormFieldPublishErrorModule.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "15.2.9", ngImport: i0, type: FormFieldPublishErrorModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule });
FormFieldPublishErrorModule.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "15.2.9", ngImport: i0, type: FormFieldPublishErrorModule, declarations: [FormFieldPublishErrorComponent], imports: [CommonModule,
        MatFormFieldModule], exports: [FormFieldPublishErrorComponent] });
FormFieldPublishErrorModule.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "15.2.9", ngImport: i0, type: FormFieldPublishErrorModule, imports: [CommonModule,
        MatFormFieldModule] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "15.2.9", ngImport: i0, type: FormFieldPublishErrorModule, decorators: [{
            type: NgModule,
            args: [{
                    declarations: [FormFieldPublishErrorComponent],
                    exports: [
                        FormFieldPublishErrorComponent
                    ],
                    imports: [
                        CommonModule,
                        MatFormFieldModule
                    ]
                }]
        }] });

class SharedSpinnerModule {
}
SharedSpinnerModule.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "15.2.9", ngImport: i0, type: SharedSpinnerModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule });
SharedSpinnerModule.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "15.2.9", ngImport: i0, type: SharedSpinnerModule, declarations: [SpinnerComponent], imports: [CommonModule,
        MatProgressSpinnerModule], exports: [SpinnerComponent] });
SharedSpinnerModule.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "15.2.9", ngImport: i0, type: SharedSpinnerModule, imports: [CommonModule,
        MatProgressSpinnerModule] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "15.2.9", ngImport: i0, type: SharedSpinnerModule, decorators: [{
            type: NgModule,
            args: [{
                    declarations: [SpinnerComponent],
                    imports: [
                        CommonModule,
                        MatProgressSpinnerModule
                    ],
                    exports: [SpinnerComponent]
                }]
        }] });

class FilesUploadModule {
}
FilesUploadModule.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "15.2.9", ngImport: i0, type: FilesUploadModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule });
FilesUploadModule.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "15.2.9", ngImport: i0, type: FilesUploadModule, declarations: [FilesUploadComponent,
        FilesUploadListImagesComponent,
        FileListCardComponent,
        TableFilesUploadingComponent], imports: [CommonModule,
        MatIconModule,
        MatProgressBarModule,
        FileUploadModule,
        DragDropModule,
        SharedSpinnerModule,
        MatButtonModule,
        FlexModule
        // SortablejsModule
    ], exports: [FilesUploadComponent,
        DragDropModule] });
FilesUploadModule.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "15.2.9", ngImport: i0, type: FilesUploadModule, imports: [CommonModule,
        MatIconModule,
        MatProgressBarModule,
        FileUploadModule,
        DragDropModule,
        SharedSpinnerModule,
        MatButtonModule,
        FlexModule
        // SortablejsModule
        , DragDropModule] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "15.2.9", ngImport: i0, type: FilesUploadModule, decorators: [{
            type: NgModule,
            args: [{
                    imports: [
                        CommonModule,
                        MatIconModule,
                        MatProgressBarModule,
                        FileUploadModule,
                        DragDropModule,
                        SharedSpinnerModule,
                        MatButtonModule,
                        FlexModule
                        // SortablejsModule
                    ],
                    declarations: [
                        FilesUploadComponent,
                        FilesUploadListImagesComponent,
                        FileListCardComponent,
                        TableFilesUploadingComponent
                    ],
                    exports: [
                        FilesUploadComponent,
                        DragDropModule
                    ]
                }]
        }] });

class ImageModule {
}
ImageModule.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "15.2.9", ngImport: i0, type: ImageModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule });
ImageModule.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "15.2.9", ngImport: i0, type: ImageModule, declarations: [ImageComponent], imports: [CommonModule,
        MatIconModule], exports: [ImageComponent] });
ImageModule.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "15.2.9", ngImport: i0, type: ImageModule, imports: [CommonModule,
        MatIconModule] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "15.2.9", ngImport: i0, type: ImageModule, decorators: [{
            type: NgModule,
            args: [{
                    declarations: [ImageComponent],
                    imports: [
                        CommonModule,
                        MatIconModule
                    ],
                    exports: [ImageComponent]
                }]
        }] });

class SharedIconModule {
}
SharedIconModule.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "15.2.9", ngImport: i0, type: SharedIconModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule });
SharedIconModule.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "15.2.9", ngImport: i0, type: SharedIconModule, declarations: [IconComponent], imports: [CommonModule,
        MatIconModule], exports: [IconComponent] });
SharedIconModule.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "15.2.9", ngImport: i0, type: SharedIconModule, imports: [CommonModule,
        MatIconModule] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "15.2.9", ngImport: i0, type: SharedIconModule, decorators: [{
            type: NgModule,
            args: [{
                    imports: [
                        CommonModule,
                        MatIconModule
                    ],
                    declarations: [IconComponent],
                    exports: [IconComponent]
                }]
        }] });

class ButtonModule {
}
ButtonModule.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "15.2.9", ngImport: i0, type: ButtonModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule });
ButtonModule.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "15.2.9", ngImport: i0, type: ButtonModule, declarations: [ButtonComponent], imports: [CommonModule,
        FormsModule,
        MatTooltipModule,
        SharedIconModule,
        SharedSpinnerModule,
        MatButtonModule], exports: [ButtonComponent] });
ButtonModule.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "15.2.9", ngImport: i0, type: ButtonModule, imports: [CommonModule,
        FormsModule,
        MatTooltipModule,
        SharedIconModule,
        SharedSpinnerModule,
        MatButtonModule] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "15.2.9", ngImport: i0, type: ButtonModule, decorators: [{
            type: NgModule,
            args: [{
                    imports: [
                        CommonModule,
                        FormsModule,
                        MatTooltipModule,
                        SharedIconModule,
                        SharedSpinnerModule,
                        MatButtonModule
                    ],
                    declarations: [ButtonComponent],
                    exports: [ButtonComponent]
                }]
        }] });

class PanelModule {
}
PanelModule.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "15.2.9", ngImport: i0, type: PanelModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule });
PanelModule.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "15.2.9", ngImport: i0, type: PanelModule, declarations: [PanelComponent], imports: [CommonModule,
        ButtonModule,
        FlexModule], exports: [PanelComponent] });
PanelModule.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "15.2.9", ngImport: i0, type: PanelModule, imports: [CommonModule,
        ButtonModule,
        FlexModule] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "15.2.9", ngImport: i0, type: PanelModule, decorators: [{
            type: NgModule,
            args: [{
                    declarations: [PanelComponent],
                    imports: [
                        CommonModule,
                        ButtonModule,
                        FlexModule
                    ],
                    exports: [PanelComponent]
                }]
        }] });

class StarRatingModule {
}
StarRatingModule.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "15.2.9", ngImport: i0, type: StarRatingModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule });
StarRatingModule.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "15.2.9", ngImport: i0, type: StarRatingModule, declarations: [StarRatingComponent], imports: [CommonModule], exports: [StarRatingComponent] });
StarRatingModule.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "15.2.9", ngImport: i0, type: StarRatingModule, imports: [CommonModule] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "15.2.9", ngImport: i0, type: StarRatingModule, decorators: [{
            type: NgModule,
            args: [{
                    declarations: [StarRatingComponent],
                    exports: [
                        StarRatingComponent
                    ],
                    imports: [
                        CommonModule
                    ]
                }]
        }] });

class SmartProgressBarModule {
}
SmartProgressBarModule.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "15.2.9", ngImport: i0, type: SmartProgressBarModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule });
SmartProgressBarModule.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "15.2.9", ngImport: i0, type: SmartProgressBarModule, declarations: [SmartProgressBarComponent], imports: [CommonModule], exports: [SmartProgressBarComponent] });
SmartProgressBarModule.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "15.2.9", ngImport: i0, type: SmartProgressBarModule, imports: [CommonModule] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "15.2.9", ngImport: i0, type: SmartProgressBarModule, decorators: [{
            type: NgModule,
            args: [{
                    declarations: [SmartProgressBarComponent],
                    imports: [CommonModule],
                    exports: [SmartProgressBarComponent]
                }]
        }] });

class AutoFormModule {
}
AutoFormModule.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "15.2.9", ngImport: i0, type: AutoFormModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule });
AutoFormModule.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "15.2.9", ngImport: i0, type: AutoFormModule, declarations: [FormFieldComponent,
        FormFieldSpinnerComponent,
        FormFieldSelectComponent,
        FormFieldSelectShowComponent,
        FormFieldSlideToggleComponent,
        AutoFormMainComponent,
        AutoFormShowComponent,
        AutoFormShowFieldComponent,
        FormFieldInputComponent,
        FormMessageBoxComponent,
        FormFieldFileComponent,
        FormFieldFilesComponent,
        FormFieldFileShowComponent,
        FormFieldSlideToggleShowComponent,
        FormFieldInputShowComponent,
        FormFieldFilesShowComponent,
        PublicationMessagesComponent,
        FormFieldTagsComponent], imports: [CommonModule,
        FormFieldErrorModule,
        FormFieldPublishErrorModule,
        MatFormFieldModule,
        MatInputModule,
        MatSlideToggleModule,
        MatSelectModule,
        FormsModule,
        SharedSpinnerModule,
        ReactiveFormsModule,
        FlexModule,
        NgxMaskModule,
        MatIconModule,
        MatTooltipModule,
        CKEditorModule,
        FilesUploadModule,
        ImageModule,
        PanelModule,
        ButtonModule,
        SmartProgressBarModule,
        StarRatingModule,
        MatChipsModule,
        MatAutocompleteModule,
        NgxMatSelectSearchModule], exports: [AutoFormMainComponent,
        AutoFormShowComponent] });
AutoFormModule.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "15.2.9", ngImport: i0, type: AutoFormModule, imports: [CommonModule,
        FormFieldErrorModule,
        FormFieldPublishErrorModule,
        MatFormFieldModule,
        MatInputModule,
        MatSlideToggleModule,
        MatSelectModule,
        FormsModule,
        SharedSpinnerModule,
        ReactiveFormsModule,
        FlexModule,
        NgxMaskModule,
        MatIconModule,
        MatTooltipModule,
        CKEditorModule,
        FilesUploadModule,
        ImageModule,
        PanelModule,
        ButtonModule,
        SmartProgressBarModule,
        StarRatingModule,
        MatChipsModule,
        MatAutocompleteModule,
        NgxMatSelectSearchModule] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "15.2.9", ngImport: i0, type: AutoFormModule, decorators: [{
            type: NgModule,
            args: [{
                    declarations: [
                        FormFieldComponent,
                        FormFieldSpinnerComponent,
                        FormFieldSelectComponent,
                        FormFieldSelectShowComponent,
                        FormFieldSlideToggleComponent,
                        AutoFormMainComponent,
                        AutoFormShowComponent,
                        AutoFormShowFieldComponent,
                        FormFieldInputComponent,
                        FormMessageBoxComponent,
                        FormFieldFileComponent,
                        FormFieldFilesComponent,
                        FormFieldFileShowComponent,
                        FormFieldSlideToggleShowComponent,
                        FormFieldInputShowComponent,
                        FormFieldFilesShowComponent,
                        PublicationMessagesComponent,
                        FormFieldTagsComponent
                    ],
                    imports: [
                        CommonModule,
                        FormFieldErrorModule,
                        FormFieldPublishErrorModule,
                        MatFormFieldModule,
                        MatInputModule,
                        MatSlideToggleModule,
                        MatSelectModule,
                        FormsModule,
                        SharedSpinnerModule,
                        ReactiveFormsModule,
                        FlexModule,
                        NgxMaskModule,
                        MatIconModule,
                        MatTooltipModule,
                        CKEditorModule,
                        FilesUploadModule,
                        ImageModule,
                        PanelModule,
                        ButtonModule,
                        SmartProgressBarModule,
                        StarRatingModule,
                        MatChipsModule,
                        MatAutocompleteModule,
                        NgxMatSelectSearchModule,
                    ],
                    exports: [
                        AutoFormMainComponent,
                        AutoFormShowComponent
                    ]
                }]
        }] });

class BreadCrumbsComponent {
    constructor() { }
    ngOnInit() {
    }
}
BreadCrumbsComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "15.2.9", ngImport: i0, type: BreadCrumbsComponent, deps: [], target: i0.ɵɵFactoryTarget.Component });
BreadCrumbsComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "15.2.9", type: BreadCrumbsComponent, selector: "shared-bread-crumbs", inputs: { list: "list" }, ngImport: i0, template: "<div class=\"bread-crumbs\" *ngIf=\"list\">\n  <ng-container *ngFor=\"let item of list\">\n    <ng-container *ngIf=\"item.url\">\n      <a [routerLink]=\"item.url\">{{item.title}}</a><span class=\"separate\">/</span>\n    </ng-container>\n    <ng-container *ngIf=\"!item.url\">\n      <span>{{item.title}}</span>\n    </ng-container>\n  </ng-container>\n</div>\n", styles: [".bread-crumbs{margin-bottom:15px;font-size:12px;opacity:.8}.bread-crumbs .separate{padding:0 5px}\n"], dependencies: [{ kind: "directive", type: i1$3.NgForOf, selector: "[ngFor][ngForOf]", inputs: ["ngForOf", "ngForTrackBy", "ngForTemplate"] }, { kind: "directive", type: i1$3.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "directive", type: i2.RouterLink, selector: "[routerLink]", inputs: ["target", "queryParams", "fragment", "queryParamsHandling", "state", "relativeTo", "preserveFragment", "skipLocationChange", "replaceUrl", "routerLink"] }], changeDetection: i0.ChangeDetectionStrategy.OnPush });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "15.2.9", ngImport: i0, type: BreadCrumbsComponent, decorators: [{
            type: Component,
            args: [{ selector: 'shared-bread-crumbs', changeDetection: ChangeDetectionStrategy.OnPush, template: "<div class=\"bread-crumbs\" *ngIf=\"list\">\n  <ng-container *ngFor=\"let item of list\">\n    <ng-container *ngIf=\"item.url\">\n      <a [routerLink]=\"item.url\">{{item.title}}</a><span class=\"separate\">/</span>\n    </ng-container>\n    <ng-container *ngIf=\"!item.url\">\n      <span>{{item.title}}</span>\n    </ng-container>\n  </ng-container>\n</div>\n", styles: [".bread-crumbs{margin-bottom:15px;font-size:12px;opacity:.8}.bread-crumbs .separate{padding:0 5px}\n"] }]
        }], ctorParameters: function () { return []; }, propDecorators: { list: [{
                type: Input
            }] } });

class BreadCrumbsModule {
}
BreadCrumbsModule.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "15.2.9", ngImport: i0, type: BreadCrumbsModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule });
BreadCrumbsModule.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "15.2.9", ngImport: i0, type: BreadCrumbsModule, declarations: [BreadCrumbsComponent], imports: [CommonModule, RouterModule], exports: [CommonModule, BreadCrumbsComponent] });
BreadCrumbsModule.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "15.2.9", ngImport: i0, type: BreadCrumbsModule, imports: [CommonModule, RouterModule, CommonModule] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "15.2.9", ngImport: i0, type: BreadCrumbsModule, decorators: [{
            type: NgModule,
            args: [{
                    declarations: [BreadCrumbsComponent],
                    imports: [CommonModule, RouterModule],
                    exports: [CommonModule, BreadCrumbsComponent]
                }]
        }] });

const publicationErrorTourConfigs = {
    '0': {
        option: {
            callNextAfter: 1000,
        }
    },
    '1': {
        text: 'У вас имеются замечания, которые требуется исправить перед публикацией вашей записи.',
        image: 'assets/site-helper/base.png',
        option: {
            callNextAfter: 3000
        }
    },
    '2': {
        text: 'Давайте посмотрим на них',
        image: 'assets/site-helper/site-tour.png',
        tourSteps: [
            {
                element: '.publish-messages.error-messages', popover: { title: 'Блок ошибок публикации', description: 'В данном разделе вы можете ознакомиться с теми изменениями, которые необходимо внести для публикации вашей записи.' }
            },
            {
                actionBeforeStep: () => {
                    return new Promise((resolve, reject) => {
                        const buttonElement = document.querySelector('.publish-messages button');
                        if (buttonElement) {
                            buttonElement.click();
                        }
                        resolve(null);
                    });
                },
                element: '.publish-messages-list div:nth-child(1) shared-panel', popover: { title: 'Первое замечание' }
            },
            {
                element: '.publish-messages-list div:nth-child(1) a', popover: { title: 'По клику на эту ссылку вы сможете найти поле в форме' }
            },
            {
                actionBeforeStep: () => {
                    return new Promise((resolve, reject) => {
                        const buttonElement = document.querySelector('.publish-messages div:nth-child(1) .fuse-card button');
                        if (buttonElement) {
                            buttonElement.click();
                        }
                        resolve(null);
                    });
                },
                element: '.publish-messages-list div:nth-child(1) .fuse-card .card-expand-area', popover: { title: 'Тут можно просмотреть описание ошибки' }
            },
            {
                element: '#publish-button', popover: { title: 'После испправления всех замечаний нажмите на кнопку опубликовать' }
            },
        ]
    },
    '3': {
        image: 'assets/site-helper/all-ok.png',
        option: {
            callNextAfter: 1000,
        }
    },
    '4': {}
};

const unPublishTourConfigs = {
    '0': {
        option: {
            callNextAfter: 1000,
        }
    },
    '1': {
        text: 'Для того чтобы пользователи могли увидеть запись, необходимо её опубликовать.',
        image: 'assets/site-helper/base.png',
        option: {
            callNextByClickButton: 'Я понял'
        }
    },
    '2': {
        image: 'assets/site-helper/all-ok.png',
        option: {
            callNextAfter: 1000,
        }
    },
    '3': {}
};

class SiteHelperComponent {
    constructor(cd, renderer, formsFacade, publicationMessagesFacade, staticDataFacade, cookieService, router) {
        this.cd = cd;
        this.renderer = renderer;
        this.formsFacade = formsFacade;
        this.publicationMessagesFacade = publicationMessagesFacade;
        this.staticDataFacade = staticDataFacade;
        this.cookieService = cookieService;
        this.router = router;
        this.activeConfigStep = -1;
        this.staticDataUrlKey = 'static-data';
        this.cookiesKeyPrefix = 'wt-site-tour';
        this.siteHelperRunning = false;
        this.siteHelperKeys = {
            errorPublication: 'error-publication'
        };
    }
    async ngOnInit() {
        this.pageUrl = this.router.url || '/';
        this.subscribeToRouteChanges();
        const isStartedTour = await this.checkStaticItemData(this.router.url);
        if (!isStartedTour) {
            this.siteHelperRunning = true;
            this.runSiteHelper();
        }
        this.subscribeToFormsStatus();
    }
    subscribeToFormsStatus() {
        this.formsFacade.getAllForms()
            .pipe(untilComponentDestroyed(this))
            .subscribe((allForms) => {
            const inValidForms = allForms.filter(item => item.hasError);
        });
    }
    subscribeToRouteChanges() {
        this.router.events
            .pipe(filter$1(event => event instanceof NavigationEnd), untilComponentDestroyed(this))
            .subscribe(async (event) => {
            this.stopSiteTour();
            if (event.url !== '/auth') {
                this.currentSiteHelperKey = '';
                this.pageUrl = event.url;
                const isStartedTour = await this.checkStaticItemData(event.url);
                if (!isStartedTour) {
                    this.siteHelperRunning = true;
                    this.runSiteHelper();
                }
            }
            else {
                this.hideSiteTour();
                this.siteHelperRunning = false;
            }
        });
    }
    async checkStaticItemData(url) {
        const urlParams = url.split('/');
        if (urlParams?.length > 2 && urlParams[1] === this.staticDataUrlKey && urlParams[2] && Number(urlParams[3])) {
            const contentType = urlParams[2];
            const itemId = Number(urlParams[3]);
            const staticItemData = await this.getStaticDataItemData(contentType, itemId);
            if (staticItemData?.id) {
                const publicationMessages = await this.getStaticDataFormErrors(contentType, itemId);
                const errorPublicationMessages = publicationMessages.filter(item => item.isError);
                if (errorPublicationMessages?.length) {
                    const cookieKey = this.getCookieKey(this.siteHelperKeys.errorPublication);
                    if (!this.cookieService.get(cookieKey)) {
                        this.currentSiteHelperKey = this.siteHelperKeys.errorPublication;
                        this.siteHelperRunning = true;
                        this.runSiteHelper(publicationErrorTourConfigs);
                        return true;
                    }
                }
                // if user open an item, which has not published yet
                if (!staticItemData.publishedAt) {
                    this.siteHelperRunning = true;
                    this.runSiteHelper(unPublishTourConfigs);
                    return true;
                }
                // if user just have saved, need to say that he needs to publish
            }
        }
        return false;
    }
    saveCompletedStatusInCookies() {
        if (this.currentSiteHelperKey) {
            const cookieKey = this.getCookieKey(this.currentSiteHelperKey);
            const cookiesExpiresDate = new Date();
            cookiesExpiresDate.setDate(cookiesExpiresDate.getDate() + 10e5);
            this.cookieService.set(cookieKey, 'true', cookiesExpiresDate);
        }
    }
    getCookieKey(key) {
        return key ? `${this.cookiesKeyPrefix}-${key}` : null;
    }
    getStaticDataFormErrors(contentType, itemId) {
        return new Promise((resolve, reject) => {
            this.publicationMessagesFacade.getPublicationMessage(contentType, itemId)
                .pipe(filter$1(item => !!item?.length), untilComponentDestroyed(this))
                .subscribe((publicationMessage) => {
                resolve(publicationMessage);
            });
        });
    }
    getStaticDataItemData(contentType, itemId) {
        return new Promise((resolve, reject) => {
            this.staticDataFacade.getStaticDataItem$(contentType, 'list', itemId)
                .pipe(filter$1(item => !!item.id), untilComponentDestroyed(this))
                .subscribe((data) => {
                resolve(data);
            });
        });
    }
    stopSiteTour() {
        if (this.activeConfigStep !== -1) {
            this.activeConfigStep = -1;
            this.hideSiteTour();
        }
    }
    hideSiteTour() {
        const createdElement = document.getElementsByClassName('site-helper')?.[0];
        if (createdElement) {
            createdElement.remove();
        }
    }
    runSiteHelper(configuration) {
        this.stopSiteTour();
        if (this.siteHelperRunning) {
            this.activeConfigStep = -1;
            if (configuration) {
                this.currentSiteHelperConfiguration = configuration;
            }
            else if (this.configurations[this.pageUrl]) {
                const helperKey = `url-${this.pageUrl}`;
                const cookieKey = this.getCookieKey(helperKey);
                if (!this.cookieService.get(cookieKey)) {
                    this.currentSiteHelperKey = `url-${this.pageUrl}`;
                    this.currentSiteHelperConfiguration = this.configurations[this.pageUrl];
                }
            }
            if (this.currentSiteHelperConfiguration) {
                this.runSiteHelperNextStep();
            }
        }
    }
    async runSiteHelperNextStep() {
        if (!this.siteHelperRunning) {
            return;
        }
        this.activeConfigStep++;
        const configItem = this.currentSiteHelperConfiguration?.[this.activeConfigStep];
        if (configItem) {
            let textDiv;
            let imageDiv;
            this.hideSiteTour();
            if (configItem.tourSteps) {
                await this.initSiteTour(configItem.tourSteps);
            }
            if (configItem.text) {
                textDiv = this.renderer.createElement('div');
                textDiv.classList.add('site-helper-text');
                textDiv.innerHTML = configItem.text;
                if (configItem.option?.callNextByClickButton) {
                    const buttonDiv = this.renderer.createElement('div');
                    buttonDiv.classList.add('site-helper-text-button');
                    const button = this.renderer.createElement('button');
                    button.textContent = configItem.option.callNextByClickButton;
                    button.onclick = () => {
                        this.runSiteHelperNextStep();
                    };
                    this.renderer.appendChild(buttonDiv, button);
                    this.renderer.appendChild(textDiv, buttonDiv);
                }
            }
            if (configItem.image) {
                imageDiv = this.renderer.createElement('div');
                imageDiv.classList.add('site-helper-image');
                const image = this.renderer.createElement('img');
                image.src = configItem.image;
                this.renderer.appendChild(imageDiv, image);
            }
            if (textDiv || imageDiv) {
                const commonDiv = this.renderer.createElement('div');
                commonDiv.classList.add('site-helper');
                if (textDiv) {
                    this.renderer.appendChild(commonDiv, textDiv);
                }
                if (imageDiv) {
                    this.renderer.appendChild(commonDiv, imageDiv);
                }
                this.renderer.appendChild(document.body, commonDiv);
            }
            if (configItem?.option?.callNextAfter) {
                setTimeout(() => {
                    this.runSiteHelperNextStep();
                }, configItem.option.callNextAfter);
            }
            this.cd.markForCheck();
        }
        // Complete the site tour
        if (this.activeConfigStep === (Object.keys(this.currentSiteHelperConfiguration).length + 1)) {
            this.siteHelperRunning = false;
        }
    }
    initSiteTour(steps) {
        return new Promise((resolve, reject) => {
            const driverObj = driver({
                showProgress: true,
                steps: [
                    ...steps
                ],
                progressText: '{{current}} из {{total}}',
                nextBtnText: 'Следующий',
                prevBtnText: 'Предыдыщий',
                doneBtnText: 'Готово',
                onNextClick: async (element, step, options) => {
                    if (driverObj.isLastStep()) {
                        this.saveCompletedStatusInCookies();
                        this.runSiteHelperNextStep();
                        driverObj.destroy();
                        resolve(null);
                    }
                    else {
                        // if next step has actionBeforeStep, need to run it firstly
                        const nextStep = steps[options.state.activeIndex + 1];
                        if (nextStep?.actionBeforeStep) {
                            await nextStep.actionBeforeStep();
                        }
                        setTimeout(() => {
                            driverObj.moveNext();
                        }, 0);
                    }
                },
                onCloseClick: () => {
                    driverObj.destroy();
                    this.runSiteHelperNextStep();
                    this.saveCompletedStatusInCookies();
                },
                popoverClass: 'site-helper-popover',
                onHighlighted: () => {
                    resolve(null);
                }
            });
            driverObj.drive();
        });
    }
    ngOnDestroy() {
    }
}
SiteHelperComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "15.2.9", ngImport: i0, type: SiteHelperComponent, deps: [{ token: i0.ChangeDetectorRef }, { token: i0.Renderer2 }, { token: FormsFacade }, { token: PublicationMessagesFacade }, { token: StaticDataFacade }, { token: i2$1.CookieService }, { token: i2.Router }], target: i0.ɵɵFactoryTarget.Component });
SiteHelperComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "15.2.9", type: SiteHelperComponent, selector: "shared-site-helper", inputs: { configurations: "configurations" }, viewQueries: [{ propertyName: "textDiv", first: true, predicate: ["siteHelperText"], descendants: true }], ngImport: i0, template: "", styles: [".site-helper{position:fixed;right:20px;bottom:0;z-index:100000;display:flex;flex-direction:column}.site-helper .site-helper-text-button button{background:#4caf50;border:0;color:#fff;height:30px;margin-top:10px}\n"], animations: [appearOpacity2], changeDetection: i0.ChangeDetectionStrategy.OnPush });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "15.2.9", ngImport: i0, type: SiteHelperComponent, decorators: [{
            type: Component,
            args: [{ selector: 'shared-site-helper', changeDetection: ChangeDetectionStrategy.OnPush, animations: [appearOpacity2], template: "", styles: [".site-helper{position:fixed;right:20px;bottom:0;z-index:100000;display:flex;flex-direction:column}.site-helper .site-helper-text-button button{background:#4caf50;border:0;color:#fff;height:30px;margin-top:10px}\n"] }]
        }], ctorParameters: function () { return [{ type: i0.ChangeDetectorRef }, { type: i0.Renderer2 }, { type: FormsFacade }, { type: PublicationMessagesFacade }, { type: StaticDataFacade }, { type: i2$1.CookieService }, { type: i2.Router }]; }, propDecorators: { configurations: [{
                type: Input
            }], textDiv: [{
                type: ViewChild,
                args: ['siteHelperText']
            }] } });

class SiteHelperModule {
}
SiteHelperModule.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "15.2.9", ngImport: i0, type: SiteHelperModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule });
SiteHelperModule.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "15.2.9", ngImport: i0, type: SiteHelperModule, declarations: [SiteHelperComponent], imports: [CommonModule], exports: [SiteHelperComponent] });
SiteHelperModule.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "15.2.9", ngImport: i0, type: SiteHelperModule, imports: [CommonModule] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "15.2.9", ngImport: i0, type: SiteHelperModule, decorators: [{
            type: NgModule,
            args: [{
                    declarations: [SiteHelperComponent],
                    imports: [CommonModule],
                    exports: [SiteHelperComponent]
                }]
        }] });

class StaticDataComponentInputData {
}
StaticDataComponentInputData.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "15.2.9", ngImport: i0, type: StaticDataComponentInputData, deps: [], target: i0.ɵɵFactoryTarget.Injectable });
StaticDataComponentInputData.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "15.2.9", ngImport: i0, type: StaticDataComponentInputData });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "15.2.9", ngImport: i0, type: StaticDataComponentInputData, decorators: [{
            type: Injectable
        }] });

var RightBlocks;
(function (RightBlocks) {
    RightBlocks["FIRMS"] = "firms";
    RightBlocks["FIRM_OPTIONS"] = "firm-options";
    RightBlocks["FILES"] = "files";
    RightBlocks["HASH_TAGS"] = "hash-tags";
    RightBlocks["TOURS"] = "tours";
    RightBlocks["TOUR_OPTIONS"] = "tour-options";
    RightBlocks["FORM_DELETE_FILES"] = "form-delete-file";
    RightBlocks["PUBLICATION"] = "publish";
    RightBlocks["STATIC_DATA"] = "static-data";
})(RightBlocks || (RightBlocks = {}));
var RightActions;
(function (RightActions) {
    RightActions[RightActions["CREATE"] = 0] = "CREATE";
    RightActions[RightActions["READ"] = 1] = "READ";
    RightActions[RightActions["UPDATE"] = 2] = "UPDATE";
    RightActions[RightActions["DELETE"] = 3] = "DELETE";
})(RightActions || (RightActions = {}));
class RightService {
    constructor(authenticationService) {
        this.authenticationService = authenticationService;
    }
    haveRightInSectionForAction$(params) {
        return this.authenticationService.currentUser
            .pipe(take(1), map((user) => {
            const result = {};
            params.forEach(paramsItem => {
                result[paramsItem.sectionKey] = {};
                const sectionRights = user.rights.find(item => item.block === paramsItem.sectionKey);
                if (sectionRights) {
                    paramsItem.actions.forEach(actionItem => {
                        result[paramsItem.sectionKey][actionItem] = sectionRights.value[actionItem] === '1';
                    });
                }
            });
            return result;
        }));
    }
    getUserRoleRightsForSection(sectionName, subSectionName) {
        return this.authenticationService.currentUser
            .pipe(take(1), map((user) => {
            return user?.rights ? user.rights.find(item => item.block === (subSectionName || sectionName)) : null;
        }), map(item => {
            if (item) {
                return {
                    0: item.value[0] === '1',
                    1: item.value[1] === '1',
                    2: item.value[2] === '1',
                    3: item.value[3] === '1'
                };
            }
            return {
                0: false,
                1: false,
                2: false,
                3: false
            };
        }));
    }
}
RightService.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "15.2.9", ngImport: i0, type: RightService, deps: [{ token: AuthenticationService }], target: i0.ɵɵFactoryTarget.Injectable });
RightService.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "15.2.9", ngImport: i0, type: RightService, providedIn: 'root' });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "15.2.9", ngImport: i0, type: RightService, decorators: [{
            type: Injectable,
            args: [{
                    providedIn: 'root'
                }]
        }], ctorParameters: function () { return [{ type: AuthenticationService }]; } });

class PanelHeaderComponent {
    constructor() { }
    ngOnInit() {
    }
}
PanelHeaderComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "15.2.9", ngImport: i0, type: PanelHeaderComponent, deps: [], target: i0.ɵɵFactoryTarget.Component });
PanelHeaderComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "15.2.9", type: PanelHeaderComponent, selector: "shared-panel-header", inputs: { title: "title", parentTitle: "parentTitle", parentUrl: "parentUrl" }, ngImport: i0, template: "<div class=\"header accent p-24 h-160\">\n  <div class=\"header-breadcrumbs mt-16\">\n    <mat-icon\n      class=\"secondary-text s-18 mat-icon notranslate material-icons mat-icon-no-color\"\n      role=\"img\" aria-hidden=\"true\">home\n    </mat-icon>\n\n    <!--\n    <span class=\"secondary-text\">Documentation</span>\n    <mat-icon\n      class=\"secondary-text s-16 mat-icon notranslate material-icons mat-icon-no-color\"\n      role=\"img\" aria-hidden=\"true\">chevron_right\n    </mat-icon>\n    <span class=\"secondary-text\">Components</span>-->\n    <ng-container *ngIf=\"parentTitle\">\n      <mat-icon\n        class=\"secondary-text s-16 mat-icon notranslate material-icons mat-icon-no-color\"\n        role=\"img\" aria-hidden=\"true\">chevron_right\n      </mat-icon>\n      <div class=\"address-paren-item address-item\" [routerLink]=\"parentUrl\">{{parentTitle}}</div>\n    </ng-container>\n    <mat-icon\n      class=\"secondary-text s-16 mat-icon notranslate material-icons mat-icon-no-color\"\n      role=\"img\" aria-hidden=\"true\">chevron_right\n    </mat-icon>\n    <div class=\"address-item\">{{title}}</div>\n  </div>\n\n  <!--  <div class=\"find-block\">\n    <mat-form-field>\n      <div class=\"find-field\">\n        <input matInput #filterInput placeholder=\"\u041F\u043E\u0438\u0441\u043A\">\n        <button mat-button [color]=\"'primary'\" (click)=\"applyFilter(filterInput)\" class=\"w-100\">\n          \u041D\u0430\u0439\u0442\u0438\n        </button>\n        <button *ngIf=\"searchText\" mat-button\n                (click)=\"applyFilter(filterInput, true)\"\n                class=\"ml-5 w-100\">\n          \u041E\u0442\u043C\u0435\u043D\u0430\n        </button>\n      </div>\n    </mat-form-field>\n    </div>-->\n</div>\n\n", styles: [".address-item{font-size:12px}.address-item.address-paren-item{cursor:pointer;color:#007bff}\n"], dependencies: [{ kind: "directive", type: i1$3.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "component", type: i2$4.MatIcon, selector: "mat-icon", inputs: ["color", "inline", "svgIcon", "fontSet", "fontIcon"], exportAs: ["matIcon"] }, { kind: "directive", type: i2.RouterLink, selector: "[routerLink]", inputs: ["target", "queryParams", "fragment", "queryParamsHandling", "state", "relativeTo", "preserveFragment", "skipLocationChange", "replaceUrl", "routerLink"] }], changeDetection: i0.ChangeDetectionStrategy.OnPush });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "15.2.9", ngImport: i0, type: PanelHeaderComponent, decorators: [{
            type: Component,
            args: [{ selector: 'shared-panel-header', changeDetection: ChangeDetectionStrategy.OnPush, template: "<div class=\"header accent p-24 h-160\">\n  <div class=\"header-breadcrumbs mt-16\">\n    <mat-icon\n      class=\"secondary-text s-18 mat-icon notranslate material-icons mat-icon-no-color\"\n      role=\"img\" aria-hidden=\"true\">home\n    </mat-icon>\n\n    <!--\n    <span class=\"secondary-text\">Documentation</span>\n    <mat-icon\n      class=\"secondary-text s-16 mat-icon notranslate material-icons mat-icon-no-color\"\n      role=\"img\" aria-hidden=\"true\">chevron_right\n    </mat-icon>\n    <span class=\"secondary-text\">Components</span>-->\n    <ng-container *ngIf=\"parentTitle\">\n      <mat-icon\n        class=\"secondary-text s-16 mat-icon notranslate material-icons mat-icon-no-color\"\n        role=\"img\" aria-hidden=\"true\">chevron_right\n      </mat-icon>\n      <div class=\"address-paren-item address-item\" [routerLink]=\"parentUrl\">{{parentTitle}}</div>\n    </ng-container>\n    <mat-icon\n      class=\"secondary-text s-16 mat-icon notranslate material-icons mat-icon-no-color\"\n      role=\"img\" aria-hidden=\"true\">chevron_right\n    </mat-icon>\n    <div class=\"address-item\">{{title}}</div>\n  </div>\n\n  <!--  <div class=\"find-block\">\n    <mat-form-field>\n      <div class=\"find-field\">\n        <input matInput #filterInput placeholder=\"\u041F\u043E\u0438\u0441\u043A\">\n        <button mat-button [color]=\"'primary'\" (click)=\"applyFilter(filterInput)\" class=\"w-100\">\n          \u041D\u0430\u0439\u0442\u0438\n        </button>\n        <button *ngIf=\"searchText\" mat-button\n                (click)=\"applyFilter(filterInput, true)\"\n                class=\"ml-5 w-100\">\n          \u041E\u0442\u043C\u0435\u043D\u0430\n        </button>\n      </div>\n    </mat-form-field>\n    </div>-->\n</div>\n\n", styles: [".address-item{font-size:12px}.address-item.address-paren-item{cursor:pointer;color:#007bff}\n"] }]
        }], ctorParameters: function () { return []; }, propDecorators: { title: [{
                type: Input
            }], parentTitle: [{
                type: Input
            }], parentUrl: [{
                type: Input
            }] } });

class StaticDataItemsComponent {
    constructor(routerFacade, staticDataFacade) {
        this.routerFacade = routerFacade;
        this.staticDataFacade = staticDataFacade;
        this.queryParams = null;
        this.delete = new EventEmitter();
        this.fieldsList = [{ field: 'id', title: 'id' }, { field: 'name', title: 'Нзвание' }];
    }
    ngOnInit() {
    }
    ngOnChanges(changes) {
        if (changes.items) {
            this.editUrlArray = ['/static-data', this.contentType];
            this.listOfItems = changes.items.currentValue;
            this.preparingItems();
        }
        if (changes.staticSection) {
            if (changes.staticSection.currentValue.options?.fieldsOnListPage) {
                this.fieldsList = changes.staticSection.currentValue.options?.fieldsOnListPage;
            }
        }
    }
    edit(id) {
        /*    let queryParams = null;
            if (this.parentSection && this.parentItemId) {
              queryParams = {
                parentSection: this.parentSection,
                parentItemId: this.parentItemId,
              }
            }*/
        this.routerFacade.goTo([...this.editUrlArray, id], { queryParams: this.queryParams });
    }
    deleteAction(item) {
        this.delete.emit(item);
    }
    preparingItems() {
        const listFields = this.fieldsList.map(item => item.field);
        const listOfContentTypesFields = this.staticSection.fields
            .filter(item => item.type === FieldType.FieldTypeSelect)
            .filter(item => listFields.includes(item.field))
            .map(item => {
            const params = item.options.loadOptionFromStore.split('.');
            return params[params.length - 1];
        });
        if (listOfContentTypesFields.length) {
            this.preparedItems$ = this.staticDataFacade.getStaticDataForListContentTypes$(listOfContentTypesFields)
                .pipe(map(selectsData => {
                let preparedItems = [];
                this.listOfItems.forEach(item => {
                    let preparedRow = this.getRowValue(item, selectsData);
                    preparedItems.push(preparedRow);
                });
                return preparedItems;
            }));
        }
        else {
            this.preparedItems$ = of(this.checkFieldGetValueMethod(this.listOfItems));
        }
    }
    checkFieldGetValueMethod(listOfItems) {
        try {
            const newListOfItems = [];
            const fieldWithGetValue = this.fieldsList
                .filter(fieldData => !!fieldData.getValue);
            listOfItems.forEach(item => {
                const newItem = { ...item };
                fieldWithGetValue.forEach(fieldData => {
                    const field = fieldData.field;
                    newItem[field] = fieldData.getValue(newItem[field]);
                });
                newListOfItems.push(newItem);
            });
            return newListOfItems;
        }
        catch (e) {
            console.error('[ static-data-items ][ checkFieldGetValueMethod ]', e);
        }
    }
    getRowValue(item, selectsData) {
        let preparedRow = { id: null };
        this.staticSection.fields.forEach(fieldData => {
            let fieldValue = item[fieldData.field];
            if (fieldData.type === FieldType.FieldTypeSelect) {
                const contentTypeValue = fieldData.options.loadOptionFromStore;
                const storeParams = contentTypeValue.split('.');
                const contentType = storeParams[storeParams.length - 1];
                if (selectsData[contentType]) {
                    const storeItem = selectsData[contentType].find(storeItem => storeItem.id === fieldValue);
                    if (storeItem && storeItem['name']) {
                        fieldValue = storeItem['name'];
                    }
                }
            }
            /*      if (fieldData.getValue) {
      
                  }*/
            preparedRow[fieldData.field] = fieldValue;
        });
        return preparedRow;
    }
}
StaticDataItemsComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "15.2.9", ngImport: i0, type: StaticDataItemsComponent, deps: [{ token: RouterFacade }, { token: StaticDataFacade }], target: i0.ɵɵFactoryTarget.Component });
StaticDataItemsComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "15.2.9", type: StaticDataItemsComponent, selector: "app-static-data-items", inputs: { items: "items", contentType: "contentType", queryParams: "queryParams", userRights: "userRights", staticSection: "staticSection" }, outputs: { delete: "delete" }, usesOnChanges: true, ngImport: i0, template: "<table class=\"list-items\">\n  <tr>\n    <th *ngFor=\"let fieldData of fieldsList\">{{fieldData.title}}</th>\n  </tr>\n  <tr *ngFor=\"let item of ( preparedItems$ | async ) as items\">\n    <ng-container *ngFor=\"let fieldData of fieldsList\">\n      <td (click)=\"edit(item.id)\" [ngClass]=\"{'true-select': item[fieldData.field] === true }\">\n        {{item[fieldData.field]}}\n      </td>\n    </ng-container>\n\n    <td class=\"action-field\">\n      <shared-button\n        *ngIf=\"userRights[2]\"\n        class=\"mr-5\"\n        size=\"small\"\n        icon=\"edit\"\n        iconColor=\"white\"\n        styleTheme=\"raised\"\n        color=\"accent\"\n        (click)=\"edit(item.id)\">\n      </shared-button>\n      <shared-button\n        *ngIf=\"userRights[3]\"\n        icon=\"clear\"\n        size=\"small\"\n        iconColor=\"white\"\n        styleTheme=\"raised\"\n        color=\"warn\"\n        (click)=\"deleteAction(item)\">\n      </shared-button>\n    </td>\n\n  </tr>\n</table>\n", styles: [".field{margin:0 10px}.list-items{width:100%}.list-items tr{cursor:pointer}.list-items tr:first-child{cursor:default}.list-items tr:first-child:hover{background:none}.list-items tr:hover{background:rgba(199,222,239,.43)}.list-items .action-field{text-align:right}.true-select{background:rgba(195,252,197,.5019607843)}table tr{border-bottom:1px solid rgba(0,0,0,.1294117647)}\n"], dependencies: [{ kind: "directive", type: i1$3.NgClass, selector: "[ngClass]", inputs: ["class", "ngClass"] }, { kind: "directive", type: i1$3.NgForOf, selector: "[ngFor][ngForOf]", inputs: ["ngForOf", "ngForTrackBy", "ngForTemplate"] }, { kind: "directive", type: i1$3.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "component", type: ButtonComponent, selector: "shared-button", inputs: ["icon", "iconColor", "iconSize", "rightIcon", "disabled", "loading", "active", "stopPropagation", "type", "color", "size", "styleTheme", "tooltip", "tooltipPosition"], outputs: ["clickButton"] }, { kind: "pipe", type: i1$3.AsyncPipe, name: "async" }], changeDetection: i0.ChangeDetectionStrategy.OnPush });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "15.2.9", ngImport: i0, type: StaticDataItemsComponent, decorators: [{
            type: Component,
            args: [{ selector: 'app-static-data-items', changeDetection: ChangeDetectionStrategy.OnPush, template: "<table class=\"list-items\">\n  <tr>\n    <th *ngFor=\"let fieldData of fieldsList\">{{fieldData.title}}</th>\n  </tr>\n  <tr *ngFor=\"let item of ( preparedItems$ | async ) as items\">\n    <ng-container *ngFor=\"let fieldData of fieldsList\">\n      <td (click)=\"edit(item.id)\" [ngClass]=\"{'true-select': item[fieldData.field] === true }\">\n        {{item[fieldData.field]}}\n      </td>\n    </ng-container>\n\n    <td class=\"action-field\">\n      <shared-button\n        *ngIf=\"userRights[2]\"\n        class=\"mr-5\"\n        size=\"small\"\n        icon=\"edit\"\n        iconColor=\"white\"\n        styleTheme=\"raised\"\n        color=\"accent\"\n        (click)=\"edit(item.id)\">\n      </shared-button>\n      <shared-button\n        *ngIf=\"userRights[3]\"\n        icon=\"clear\"\n        size=\"small\"\n        iconColor=\"white\"\n        styleTheme=\"raised\"\n        color=\"warn\"\n        (click)=\"deleteAction(item)\">\n      </shared-button>\n    </td>\n\n  </tr>\n</table>\n", styles: [".field{margin:0 10px}.list-items{width:100%}.list-items tr{cursor:pointer}.list-items tr:first-child{cursor:default}.list-items tr:first-child:hover{background:none}.list-items tr:hover{background:rgba(199,222,239,.43)}.list-items .action-field{text-align:right}.true-select{background:rgba(195,252,197,.5019607843)}table tr{border-bottom:1px solid rgba(0,0,0,.1294117647)}\n"] }]
        }], ctorParameters: function () { return [{ type: RouterFacade }, { type: StaticDataFacade }]; }, propDecorators: { items: [{
                type: Input
            }], contentType: [{
                type: Input
            }], queryParams: [{
                type: Input
            }], userRights: [{
                type: Input
            }], staticSection: [{
                type: Input
            }], delete: [{
                type: Output
            }] } });

/**
 * @title Data table with sorting, pagination, and filtering.
 */
class StaticDataListItemsComponent {
    constructor(dialog, rightService, staticDataFacade, changeDetectorRef, routerFacade) {
        this.dialog = dialog;
        this.rightService = rightService;
        this.staticDataFacade = staticDataFacade;
        this.changeDetectorRef = changeDetectorRef;
        this.routerFacade = routerFacade;
        this.showPanelHeader = false;
        this.isLoaded = false;
        this.trackByFn = trackById;
        this.perPage = 10;
        this.pageIndex = 0;
        this.queryParams = null;
    }
    ngOnInit() {
        // this.preparingData();
    }
    // eslint-disable-next-line @angular-eslint/no-empty-lifecycle-method
    ngOnDestroy() {
    }
    ngOnChanges(changes) {
        if (changes.contentType) {
            this.preparingData();
        }
    }
    preparingData() {
        this.preparingQueryParams();
        this.loadData();
        this.preLoadSections();
    }
    addHandle() {
        const urlParameters = ['/static-data', this.contentType, 'new'];
        this.routerFacade.goTo(urlParameters, { queryParams: this.queryParams });
    }
    searchHandle(searchValue) {
        this.loadStaticData(1, this.perPage, searchValue);
    }
    searchCancelHandle() {
        this.loadStaticData(1);
        this.searchInput.nativeElement.value = '';
    }
    preparingQueryParams() {
        if (this.parentSection && this.parentItemId) {
            this.queryParams = {
                parentSection: this.parentSection,
                parentItemId: this.parentItemId
            };
            if (this.parentSectionHashtag) {
                this.queryParams['parentHashTag'] = this.parentSectionHashtag;
            }
            //const autoCompleteFields = [];
            if (this.autoCompleteFields) {
                this.queryParams.fields = [];
                this.queryParams.fieldsvalue = [];
                this.autoCompleteFields.forEach(fieldData => {
                    this.queryParams.fields.push(fieldData.field);
                    this.queryParams.fieldsvalue.push(fieldData.getValue(this.parentData));
                });
            }
        }
    }
    loadData() {
        this.staticSection = this.staticDataConfiguration[this.contentType];
        if (this.staticSection) {
            this.userRights$ = this.rightService.getUserRoleRightsForSection('static-data', this.contentType);
            this.title = this.customTitle || this.staticSection?.title || '';
            this.loadStaticData();
            this.loadStaticDataMeta();
            this.changeDetectorRef.markForCheck();
        }
        else {
            console.error('[ wt-front-shared ][ static-data-items ][ loadData ]', 'NOT_FOUND_STATIC_DATA_SECTION', { contentType: this.contentType });
        }
    }
    loadStaticData(pageIndex = 1, perPage = this.perPage, searchValue = '') {
        const params = { fields: ['id', 'name'] };
        if (this.staticSection?.options?.allItems) {
            params['paging'] = { perPage: -1 };
        }
        else {
            params['paging'] = { page: pageIndex, perPage };
        }
        if (this.staticSection.options?.orderByField) {
            params['sort'] = this.staticSection.options.orderByField;
        }
        if (searchValue) {
            params['search'] = searchValue;
        }
        if (this.filteringQuery) {
            params['where'] = this.filteringQuery;
        }
        const staticSectionKey = this.staticDataConfiguration[this.contentType].key || this.contentType;
        this.staticDataFacade.loadStaticData(staticSectionKey, params);
        this.staticData$ = this.staticDataFacade.getStaticData$(this.staticSection.key)
            .pipe(map((staticData) => {
            if (!staticData) {
                return [];
            }
            this.totalCount = staticData?.length;
            this.isLoaded = true;
            if (staticData?.length && this.staticSection.options?.nestedByField) {
                return this.groupItemsByNestedField(staticData);
            }
            return [...staticData];
        }));
    }
    groupItemsByNestedField(items) {
        let newItems = [];
        items.filter(item => !item[this.staticSection.options?.nestedByField])
            .forEach(item => {
            const newItem = { ...item };
            const subItems = this.groupItemsByNestedFieldRecursion(items, item.id);
            newItems.push(newItem);
            if (subItems?.length) {
                newItems = [...newItems, ...subItems];
            }
        });
        return newItems;
    }
    groupItemsByNestedFieldRecursion(items, parentId, prefix = '---') {
        const nestedByFieldName = this.staticSection.options?.nestedByField;
        const findItems = items.filter(item => item[nestedByFieldName] === parentId);
        if (findItems?.length) {
            let newItems = [];
            findItems.forEach(item => {
                newItems.push({ ...item, name: `${prefix} ${item.name}` });
                const subItems = this.groupItemsByNestedFieldRecursion(items, item.id, prefix + '---');
                if (subItems?.length) {
                    newItems = [...newItems, ...subItems];
                }
            });
            return newItems;
        }
        return null;
    }
    loadStaticDataMeta() {
        const staticSectionKey = this.staticDataConfiguration[this.contentType].key || this.contentType;
        this.staticDataMeta$ = this.staticDataFacade.getStaticDataMeta$(staticSectionKey)
            .pipe(startWith({ meta: {} }), map((staticDataMeta) => {
            return { meta: staticDataMeta };
        }));
    }
    openDeleteDialog(item) {
        const dialogRef = this.dialog.open(CommonDialogComponent, {
            panelClass: 'dialog-without-margin',
            data: {
                title: 'Удаление',
                message: `Вы действительно хотите удалить?`,
                trueButtonTitle: 'Удалить',
                falseButtonTitle: 'Отменить',
                messageType: 'error',
                size: 'middle'
            }
        });
        dialogRef.afterClosed().subscribe((result) => {
            if (result) {
                this.staticDataFacade.delete(this.contentType, item.id);
            }
        });
    }
    preLoadSections() {
        const preLoadSections = this.staticDataConfiguration[this.contentType]?.preLoadSections;
        if (preLoadSections) {
            this.staticDataFacade.staticDataLoadCategories(preLoadSections);
        }
    }
    deleteEvent(item) {
        this.openDeleteDialog(item);
    }
    changePage(data) {
        this.pageIndex = data.pageIndex;
        this.loadStaticData(this.pageIndex + 1, data.pageSize);
    }
}
StaticDataListItemsComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "15.2.9", ngImport: i0, type: StaticDataListItemsComponent, deps: [{ token: i1$4.MatDialog }, { token: RightService }, { token: StaticDataFacade }, { token: i0.ChangeDetectorRef }, { token: RouterFacade }], target: i0.ɵɵFactoryTarget.Component });
StaticDataListItemsComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "15.2.9", type: StaticDataListItemsComponent, selector: "app-static-data-list-items", inputs: { staticDataConfiguration: "staticDataConfiguration", contentType: "contentType", customTitle: "customTitle", addTitle: "addTitle", parentSection: "parentSection", parentItemId: "parentItemId", showPanelHeader: "showPanelHeader", parentData: "parentData", parentSectionHashtag: "parentSectionHashtag", autoCompleteFields: "autoCompleteFields", filteringQuery: "filteringQuery" }, viewQueries: [{ propertyName: "paginator", first: true, predicate: MatPaginator, descendants: true, static: true }, { propertyName: "sort", first: true, predicate: MatSort, descendants: true, static: true }, { propertyName: "searchInput", first: true, predicate: ["search"], descendants: true }], usesOnChanges: true, ngImport: i0, template: "<ng-container *ngIf=\"(userRights$ | async) as userRights\">\n    <ng-container *ngIf=\"(staticDataMeta$ | async) as staticDataObj\">\n        <div class=\"page-layout simple fullwidth angular-material-elements\">\n            <shared-panel-header *ngIf=\"showPanelHeader\" [title]=\"title\"></shared-panel-header>\n\n            <h1>{{title}}</h1>\n            <div class=\"content p-24\">\n                <div *ngIf=\"staticSection.options?.search\" class=\"top-bar\">\n                    <div class=\"search-block\">\n                        \u041F\u043E\u0438\u0441\u043A:&nbsp; <input #search class=\"search-input\">\n                        <shared-button\n                                icon=\"search\"\n                                color=\"accent\"\n                                iconColor=\"black\"\n                                (click)=\"searchHandle(search.value)\"></shared-button>\n                        <div class=\"cancel-button\">\n                            <shared-button\n                                    *ngIf=\"search.value\"\n                                    icon=\"clear\"\n                                    color=\"warn\"\n                                    iconColor=\"black\"\n                                    (click)=\"searchCancelHandle()\"></shared-button>\n                        </div>\n                    </div>\n                </div>\n                <ng-container *ngIf=\"staticData$ | async as staticData\">\n                    <div class=\"center-block p-10\">\n                        <app-static-data-items [items]=\"staticData\"\n                                               [userRights]=\"userRights\"\n                                               [staticSection]=\"staticSection\"\n                                               [contentType]=\"contentType\"\n                                               [queryParams]=\"queryParams\"\n                                               (delete)=\"deleteEvent($event)\"></app-static-data-items>\n                    </div>\n                    <div *ngIf=\"staticDataObj.meta?.perPage !== -1\">\n                        <mat-paginator\n                                *ngIf=\"totalCount\"\n                                [length]=\"staticDataObj.meta?.totalCount\"\n                                [pageIndex]=\"pageIndex\"\n                                [pageSizeOptions]=\"[10, 25, 100]\"\n                                (page)=\"changePage($event)\"></mat-paginator>\n                    </div>\n                </ng-container>\n                <div *ngIf=\"isLoaded && !totalCount\">\u0421\u043F\u0438\u0441\u043E\u043A \u043F\u0443\u0441\u0442</div>\n                <div *ngIf=\"userRights[0]\" class=\"text-center mt-30 mb-30\">\n                    <shared-button\n                            id=\"go-to-create-form-button\"\n                            class=\"mr-5\"\n                            iconSize=\"small\"\n                            icon=\"add\"\n                            iconColor=\"white\"\n                            styleTheme=\"raised\"\n                            color=\"accent\"\n                            (click)=\"addHandle()\">{{ addTitle || '\u0414\u043E\u0431\u0430\u0432\u0438\u0442\u044C' }}\n                    </shared-button>\n                </div>\n            </div>\n            <ng-container *ngIf=\"loaded$|async; let loaded;\">\n                <shared-spinner *ngIf=\"!loaded\"></shared-spinner>\n            </ng-container>\n        </div>\n    </ng-container>\n</ng-container>\n", styles: [".top-bar{background:#c7deef;display:flex;justify-content:flex-end}.top-bar .search-block{display:flex;align-content:center;align-items:center}.top-bar .search-block .search-input{background-color:#adcde8!important;padding:11px 10px!important}.top-bar .search-block .cancel-button{width:64px;height:40px}\n"], dependencies: [{ kind: "directive", type: i1$3.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "component", type: i6$3.MatPaginator, selector: "mat-paginator", inputs: ["disabled"], exportAs: ["matPaginator"] }, { kind: "component", type: SpinnerComponent, selector: "shared-spinner", inputs: ["overlay", "diameter", "color", "position"] }, { kind: "component", type: ButtonComponent, selector: "shared-button", inputs: ["icon", "iconColor", "iconSize", "rightIcon", "disabled", "loading", "active", "stopPropagation", "type", "color", "size", "styleTheme", "tooltip", "tooltipPosition"], outputs: ["clickButton"] }, { kind: "component", type: PanelHeaderComponent, selector: "shared-panel-header", inputs: ["title", "parentTitle", "parentUrl"] }, { kind: "component", type: StaticDataItemsComponent, selector: "app-static-data-items", inputs: ["items", "contentType", "queryParams", "userRights", "staticSection"], outputs: ["delete"] }, { kind: "pipe", type: i1$3.AsyncPipe, name: "async" }], changeDetection: i0.ChangeDetectionStrategy.OnPush });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "15.2.9", ngImport: i0, type: StaticDataListItemsComponent, decorators: [{
            type: Component,
            args: [{ selector: 'app-static-data-list-items', changeDetection: ChangeDetectionStrategy.OnPush, template: "<ng-container *ngIf=\"(userRights$ | async) as userRights\">\n    <ng-container *ngIf=\"(staticDataMeta$ | async) as staticDataObj\">\n        <div class=\"page-layout simple fullwidth angular-material-elements\">\n            <shared-panel-header *ngIf=\"showPanelHeader\" [title]=\"title\"></shared-panel-header>\n\n            <h1>{{title}}</h1>\n            <div class=\"content p-24\">\n                <div *ngIf=\"staticSection.options?.search\" class=\"top-bar\">\n                    <div class=\"search-block\">\n                        \u041F\u043E\u0438\u0441\u043A:&nbsp; <input #search class=\"search-input\">\n                        <shared-button\n                                icon=\"search\"\n                                color=\"accent\"\n                                iconColor=\"black\"\n                                (click)=\"searchHandle(search.value)\"></shared-button>\n                        <div class=\"cancel-button\">\n                            <shared-button\n                                    *ngIf=\"search.value\"\n                                    icon=\"clear\"\n                                    color=\"warn\"\n                                    iconColor=\"black\"\n                                    (click)=\"searchCancelHandle()\"></shared-button>\n                        </div>\n                    </div>\n                </div>\n                <ng-container *ngIf=\"staticData$ | async as staticData\">\n                    <div class=\"center-block p-10\">\n                        <app-static-data-items [items]=\"staticData\"\n                                               [userRights]=\"userRights\"\n                                               [staticSection]=\"staticSection\"\n                                               [contentType]=\"contentType\"\n                                               [queryParams]=\"queryParams\"\n                                               (delete)=\"deleteEvent($event)\"></app-static-data-items>\n                    </div>\n                    <div *ngIf=\"staticDataObj.meta?.perPage !== -1\">\n                        <mat-paginator\n                                *ngIf=\"totalCount\"\n                                [length]=\"staticDataObj.meta?.totalCount\"\n                                [pageIndex]=\"pageIndex\"\n                                [pageSizeOptions]=\"[10, 25, 100]\"\n                                (page)=\"changePage($event)\"></mat-paginator>\n                    </div>\n                </ng-container>\n                <div *ngIf=\"isLoaded && !totalCount\">\u0421\u043F\u0438\u0441\u043E\u043A \u043F\u0443\u0441\u0442</div>\n                <div *ngIf=\"userRights[0]\" class=\"text-center mt-30 mb-30\">\n                    <shared-button\n                            id=\"go-to-create-form-button\"\n                            class=\"mr-5\"\n                            iconSize=\"small\"\n                            icon=\"add\"\n                            iconColor=\"white\"\n                            styleTheme=\"raised\"\n                            color=\"accent\"\n                            (click)=\"addHandle()\">{{ addTitle || '\u0414\u043E\u0431\u0430\u0432\u0438\u0442\u044C' }}\n                    </shared-button>\n                </div>\n            </div>\n            <ng-container *ngIf=\"loaded$|async; let loaded;\">\n                <shared-spinner *ngIf=\"!loaded\"></shared-spinner>\n            </ng-container>\n        </div>\n    </ng-container>\n</ng-container>\n", styles: [".top-bar{background:#c7deef;display:flex;justify-content:flex-end}.top-bar .search-block{display:flex;align-content:center;align-items:center}.top-bar .search-block .search-input{background-color:#adcde8!important;padding:11px 10px!important}.top-bar .search-block .cancel-button{width:64px;height:40px}\n"] }]
        }], ctorParameters: function () { return [{ type: i1$4.MatDialog }, { type: RightService }, { type: StaticDataFacade }, { type: i0.ChangeDetectorRef }, { type: RouterFacade }]; }, propDecorators: { staticDataConfiguration: [{
                type: Input
            }], contentType: [{
                type: Input
            }], customTitle: [{
                type: Input
            }], addTitle: [{
                type: Input
            }], parentSection: [{
                type: Input
            }], parentItemId: [{
                type: Input
            }], showPanelHeader: [{
                type: Input
            }], parentData: [{
                type: Input
            }], parentSectionHashtag: [{
                type: Input
            }], autoCompleteFields: [{
                type: Input
            }], filteringQuery: [{
                type: Input
            }], paginator: [{
                type: ViewChild,
                args: [MatPaginator, { static: true }]
            }], sort: [{
                type: ViewChild,
                args: [MatSort, { static: true }]
            }], searchInput: [{
                type: ViewChild,
                args: ['search']
            }] } });

class StaticDataDetailsComponent {
    constructor(fb, router, route, autoFormService, routerFacade, formErrors, formsFacade, requestsFacade, staticDataFacade, rightService, dialog, notificationsFacade, coreFacade, publicationMessagesFacade, actionsFacade, injector, cd) {
        this.fb = fb;
        this.router = router;
        this.route = route;
        this.autoFormService = autoFormService;
        this.routerFacade = routerFacade;
        this.formErrors = formErrors;
        this.formsFacade = formsFacade;
        this.requestsFacade = requestsFacade;
        this.staticDataFacade = staticDataFacade;
        this.rightService = rightService;
        this.dialog = dialog;
        this.notificationsFacade = notificationsFacade;
        this.coreFacade = coreFacade;
        this.publicationMessagesFacade = publicationMessagesFacade;
        this.actionsFacade = actionsFacade;
        this.injector = injector;
        this.cd = cd;
        this.data = {};
        this.storedFormValues = null;
        this.dataStored = false;
        this.unSubscribeSubject$ = new Subject();
        this.globalErrorMessageTexts = GlobalErrorMessages;
        this.formStatus = 'loaded';
        this.statusType = StaticDataMetaStatus$1;
        this.publishButtonLoading = false;
        this.publishStatus = 1;
        this.unPublishStatus = 0;
        this.putMethod = 'put';
        this.activeTabIndex = 0;
        this.MESSAGES = {
            delete: {
                title: 'Внимание',
                text: 'Запись успешно удаленна'
            },
            update: {
                title: 'Внимание',
                text: 'Запись успешно обновлена'
            },
            create: {
                title: 'Внимание',
                text: 'Запись успешно создана'
            }
        };
        this.publishInTelegramAction = 'publish-in-telegram';
        this.publishInTelegramActionId = Math.random();
    }
    ngOnInit() {
        this.loadStaticDataConfiguration();
        this.init();
        this.subscribeToRoute();
    }
    ngOnChanges(changes) {
    }
    ngOnDestroy() {
        this.unSubscribeSubject$.next();
        this.unSubscribeSubject$.complete();
        this.formsFacade.removeForm(this.formId);
    }
    publishInTelegram() {
        const formData = this.form.value;
        const configFields = this.staticSection.options.publicationInTelegramBot.fields;
        const data = {
            title: formData[configFields.title],
            description: formData[configFields.description],
            image: `/${formData[configFields.imageURL]?.origin}`,
            url: this.staticSection.options.publicationInTelegramBot.getDetailsURL(formData)
        };
        this.actionsFacade.sendAction(this.publishInTelegramAction, this.publishInTelegramActionId, data);
    }
    subscribeToRequestStatusStatus() {
        if (this.subscriptionToRequestStatus$) {
            this.subscriptionToRequestStatus$.unsubscribe();
        }
        this.requestsFacade.createRequestListener(`static-data/${this.contentType}`, this.putMethod, this.itemId);
        this.subscriptionToRequestStatus$ = this.requestsFacade.getRequestUpdates('static-data', this.putMethod, this.itemId)
            .pipe(map((item) => ({ value: item?.status })))
            .subscribe(data => {
            this.formStatus = data.value;
            this.cd.markForCheck();
        });
    }
    getUrlExtras() {
        let urlExtras = null;
        if ((this.parentSection && this.parentItemId) || this.parentParentHashTag) {
            urlExtras = {};
            if (this.parentSection && this.parentItemId) {
                urlExtras.queryParams = {
                    parentSection: this.parentSection,
                    parentItemId: Number(this.parentItemId)
                };
            }
            if (this.parentParentHashTag) {
                urlExtras.queryParams.parentHashTag = this.parentParentHashTag;
            }
        }
        return urlExtras;
    }
    formCompleted(data) {
        let notificationParams;
        if (!this.currentItemId || data.newId !== this.currentItemId) {
            this.currentItemId = data.newId;
            let urlExtras = this.getUrlExtras();
            this.itemId = data.newId;
            this.routerFacade.goTo(['/static-data', this.contentType, data.newId], urlExtras);
            this.staticDataSubscription();
            notificationParams = {
                id: `form-message-create-${this.contentType}-${this.itemId}`,
                type: 'success',
                text: this.MESSAGES.create.text,
                title: this.MESSAGES.create.title,
                timeout: NOTIFICATION_LONG_TIMEOUT
            };
        }
        else {
            notificationParams = {
                id: `form-message-create-${this.contentType}-${this.itemId}`,
                type: 'success',
                text: this.MESSAGES.update.text,
                title: this.MESSAGES.update.title,
                timeout: NOTIFICATION_LONG_TIMEOUT
            };
        }
        this.notificationsFacade.addNotifications(notificationParams);
    }
    globalActionHandle(data) {
        try {
            if (data.action) {
                this.coreFacade.sendGlobalEvent(data.action, this.contentType, this.itemId, null, this.form.value);
            }
        }
        catch (e) {
            console.error('[ static-data-form.component ][ globalActionHandle ]', { error: e, data });
        }
    }
    goBack() {
        const urlParameters = ['/static-data'];
        if (this.parentSection && this.parentItemId) {
            urlParameters.push(this.parentSection);
            urlParameters.push(this.parentItemId.toString());
        }
        else {
            urlParameters.push(this.contentType);
        }
        let urlFragment = this.parentParentHashTag || null;
        this.routerFacade.goTo(urlParameters, { fragment: urlFragment });
    }
    async submitClick() {
        const fieldStatus = this.form.get('status');
        const itemStatus = this.form.get('status')?.value || 0;
        // Add disabled fields in the request
        const formData = this.form.value;
        Object.keys(this.form.controls)
            .filter(key => this.form.get(key).disabled)
            ?.forEach(key => {
            formData[key] = this.form.get(key).value;
        });
        if (this.form.valid) {
            if (fieldStatus && itemStatus === this.publishStatus) {
                this.updatePublishedItemPopup()
                    .then((result) => {
                    if (result) {
                        this.submitClickHandler();
                    }
                });
            }
            else {
                this.submitClickHandler();
            }
        }
    }
    async publishToggle() {
        const statusField = this.form.get('status');
        if (statusField) {
            const itemStatus = this.form.get('status').value;
            if (!this.form.valid) {
                const notification = {
                    id: 5,
                    type: 'error',
                    text: 'Перед публикацией Вам нажно исправить все ошибки',
                    timeout: 2000,
                    showingType: NotificationShowingType.POPUP
                };
                this.notificationsFacade.addNotifications(notification);
                return;
            }
            if (this.itemId) {
                if (itemStatus === this.unPublishStatus) {
                    await this.submitClick();
                    this.requestsFacade.getRequestUpdates('static-data', this.putMethod, this.itemId, this.contentType)
                        .pipe(untilComponentDestroyed(this))
                        .subscribe((data) => {
                        if (itemStatus === this.unPublishStatus && data.status === RequestStatus.LOADED) {
                            this.publicationMessagesFacade.publishPost('static-data', this.itemId, this.contentType);
                        }
                    });
                }
                if (itemStatus === this.publishStatus) {
                    this.dialog.open(CommonDialogComponent, {
                        panelClass: 'dialog-without-margin',
                        data: {
                            title: 'Внимание!!!',
                            message: 'Вы действительно снять фирму с публикации?',
                            trueButtonTitle: 'Снять с публикации',
                            falseButtonTitle: 'Отменить',
                            messageType: 'info',
                            size: 'middle'
                        }
                    }).afterClosed().toPromise()
                        .then((result) => {
                        if (result) {
                            this.publicationMessagesFacade.unPublishPost('static-data', this.itemId, this.contentType);
                        }
                    });
                }
            }
        }
    }
    changedFormValue(formChanged) {
        this.dataStored = !formChanged.valueChanged;
    }
    deleteAction(item) {
        const dialogRef = this.dialog.open(CommonDialogComponent, {
            panelClass: 'dialog-without-margin',
            data: {
                title: 'Удаление',
                message: `Вы действительно хотите удалить?`,
                trueButtonTitle: 'Удалить',
                falseButtonTitle: 'Отменить',
                messageType: 'error',
                size: 'middle'
            }
        });
        dialogRef.afterClosed()
            .toPromise()
            .then((result) => {
            if (result) {
                this.staticDataFacade.delete(this.contentType, item.id);
            }
        });
    }
    loadStaticDataConfiguration() {
        this.route.data
            .pipe(untilComponentDestroyed(this))
            .subscribe(staticDataConfiguration => {
            console.log('staticDataConfiguration', staticDataConfiguration);
            this.staticDataConfiguration = staticDataConfiguration?.configuration;
            this.languageList = staticDataConfiguration?.languages;
            this.defaultLanguageId = this.languageList?.find(item => item.default)?.id;
        });
    }
    subscribeToRoute() {
        this.router.events
            .pipe(untilComponentDestroyed(this), filter$1(event => event instanceof NavigationEnd))
            .subscribe((data) => {
            const url = data.url;
            const urlParams = url.split('/');
            if (urlParams.length >= 4) {
                this.init();
            }
        });
    }
    init() {
        this.itemId = +this.route?.snapshot?.params?.id || null;
        this.currentLanguageId = +this.route?.snapshot?.params?.langId || null;
        this.parentSection = this.route?.snapshot?.queryParams?.parentSection;
        this.parentItemId = this.route?.snapshot?.queryParams?.parentItemId;
        this.parentParentHashTag = this.route?.snapshot?.queryParams?.parentHashTag;
        const urlFragment = this.route?.snapshot?.fragment;
        this.contentType = this.route?.snapshot?.params?.contentType;
        this.staticSection = this.staticDataConfiguration[this.contentType];
        this.staticSectionKey = this.staticSection?.key || this.contentType;
        this.formId = `static_data_${this.staticSectionKey}_${this.itemId || '*'}`;
        this.userRights$ = this.rightService.getUserRoleRightsForSection('static-data', this.contentType);
        if (this.contentType !== this.currentContentType || this.itemId !== this.currentItemId) {
            this.activeTabIndex = 0;
            this.currentItemId = this.itemId;
            this.currentContentType = this.contentType;
            if (this.contentType && this.staticSection) {
                this.initForm();
                this.subscribeToDataStatus();
                this.staticDataSubscription();
                this.preLoadSections();
                if (this.itemId) {
                    this.subscribeToRequestStatusStatus();
                }
            }
        }
        if (this.staticSection.options?.subEntities && urlFragment) {
            this.staticSection.options.subEntities.forEach((item, index) => {
                if (item.hashTag === urlFragment) {
                    this.activeTabIndex = index + 1;
                }
            });
        }
        // this.subscribeToRequestStatusStatus();
    }
    preLoadSections() {
        const preLoadSections = this.staticDataConfiguration[this.contentType]?.preLoadSections;
        if (preLoadSections) {
            this.staticDataFacade.staticDataLoadCategories(preLoadSections);
        }
    }
    staticDataSubscription() {
        if (this.itemId && this.contentType) {
            const staticSectionKey = this.staticDataConfiguration[this.contentType].key || this.contentType;
            const sectionFields = this.staticSection.fields.map(item => item.field);
            const loadStaticDataParams = {
                where: { id: this.itemId },
                fields: { fields: [...sectionFields], ...this.staticSection.embeddedFields }
            };
            if (this.staticSection?.options?.hasMultiLanguage) {
                loadStaticDataParams.where['_langId'] = this.currentLanguageId || this.defaultLanguageId;
                loadStaticDataParams.where['_langGroupId'] = this.itemId;
            }
            this.staticDataFacade.loadStaticData(staticSectionKey, loadStaticDataParams);
            this.staticData$ = this.staticDataFacade.getStaticDataItem$(staticSectionKey, 'list', this.itemId)
                .pipe(filter$1((item) => !!item), tap((item) => {
                console.log('item', item);
                this.form.patchValue(item);
                this.storedFormValues = this.form.value;
            }), tap((item) => {
                this.componentDataInjector = ReflectiveInjector.resolveAndCreate([{
                        provide: StaticDataComponentInputData,
                        useValue: { data: { ...item } }
                    }], this.injector);
            }), map((item) => ({ value: item })));
        }
        else {
            this.staticData$ = of({ value: null });
        }
    }
    initForm() {
        if (this.contentType && this.staticDataConfiguration[this.contentType]?.fields) {
            this.fields = this.staticDataConfiguration[this.contentType].fields;
            const preparedFields = this.autoFormService.getPreparedFields(this.fields);
            this.form = this.fb.group(preparedFields);
        }
        else {
            console.error('[ static-data ][ initForm ] Incorrect contentType', { contentType: this.contentType });
        }
    }
    subscribeToDataStatus() {
        if (this.itemId) {
            this.status$ = this.staticDataFacade.getStatus$(this.staticSectionKey)
                .pipe(map(item => {
                return { value: item };
            }));
        }
        else {
            this.status$ = of({ value: this.statusType.LOADED });
        }
    }
    submitClickHandler() {
        this.storedFormValues = this.form.value;
        const fieldForSaving = this.staticDataConfiguration[this.contentType].fields
            .filter(fieldData => !fieldData.options.notEditable)
            .map(fieldData => fieldData.field);
        const formValue = {};
        Object.keys(this.form.value)
            .filter(field => fieldForSaving.includes(field))
            .forEach(field => {
            formValue[field] = this.form.value[field];
        });
        this.dataStored = true;
        const params = {
            ...formValue,
            formId: this.formId,
            id: this.form.value?.id
        };
        this.fields.filter(item => item.type === FieldType.FieldTypeFile)
            .forEach(item => {
            const fileField = this.form.value[item.field];
            params[item.field] = fileField?.origin ? fileField.origin : fileField;
        });
        if (!this.itemId) {
            this.staticDataFacade.create(this.formId, this.contentType, formValue);
        }
        else {
            this.staticDataFacade.update(this.formId, this.contentType, this.itemId, formValue);
        }
        this.formErrors.clearFormErrors(this.formId);
        this.formsFacade.updateForm({
            formId: this.formId,
            loading: true
        });
    }
    updatePublishedItemPopup() {
        const dialogRef = this.dialog.open(CommonDialogComponent, {
            panelClass: 'dialog-without-margin',
            data: {
                title: 'Обновление',
                message: 'Если вы обновите уже опубликованную запись, и в обновлении нужно будет внести корректировки то ее публикация будет отменена. Вам придется опубликовать ее заново.',
                trueButtonTitle: 'Обновить',
                falseButtonTitle: 'Отменить',
                messageType: 'error',
                size: 'middle'
            }
        });
        return dialogRef.afterClosed()
            .toPromise();
    }
}
StaticDataDetailsComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "15.2.9", ngImport: i0, type: StaticDataDetailsComponent, deps: [{ token: i6.UntypedFormBuilder }, { token: i2.Router }, { token: i2.ActivatedRoute }, { token: AutoFormService }, { token: RouterFacade }, { token: FormErrorsFacade }, { token: FormsFacade }, { token: RequestsFacade }, { token: StaticDataFacade }, { token: RightService }, { token: i1$4.MatDialog }, { token: NotificationsFacade }, { token: CoreFacade }, { token: PublicationMessagesFacade }, { token: ActionsFacade }, { token: i0.Injector }, { token: i0.ChangeDetectorRef }], target: i0.ɵɵFactoryTarget.Component });
StaticDataDetailsComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "15.2.9", type: StaticDataDetailsComponent, selector: "app-static-data-details", usesOnChanges: true, ngImport: i0, template: "<ng-container *ngIf=\"(status$ | async) as status\">\n  <ng-container *ngIf=\"(userRights$ | async) as userRights\">\n    <ng-container *ngIf=\"(staticData$ | async) as staticData\">\n      <div class=\"page-layout simple fullwidth angular-material-elements\">\n        <shared-panel-header *ngIf=\"form.get('name')\" [parentTitle]=\"staticSection.title\"\n                             [parentUrl]=\"['/static-data', contentType]\"\n                             [title]=\"form.get('name')?.value\">>\n        </shared-panel-header>\n\n        <div class=\"content p-24\">\n          <div class=\"center-block bg-white mat-elevation-z1\">\n            <mat-tab-group [selectedIndex]=\"activeTabIndex\">\n              <mat-tab>\n                <ng-template mat-tab-label>\n                  <mat-icon class=\"static-data-tab-icon\">edit</mat-icon>\n                  \u0424\u043E\u0440\u043C\u0430 \u0440\u0435\u0434\u0430\u043A\u0442\u0438\u0440\u043E\u0432\u0430\u043D\u0438\u044F\n                </ng-template>\n                <ng-template matTabContent>\n                  <div class=\"center-block-header position-relative\">\n                    <div @appearFromLeftWithDelay class=\"center-block-header-title\">\n                      {{ form.get('name')?.value || '\u0420\u0435\u0434\u0430\u043A\u0442\u0438\u0440\u043E\u0432\u0430\u043D\u0438\u0435' }}\n                    </div>\n                  </div>\n                  <div *ngIf=\"staticSection?.options?.hasMultiLanguage\" class=\"languages\">\n                    <div *ngFor=\"let item of languageList\" class=\"language-item\">\n                      <a\n                        [ngClass]=\"{'activeLang': currentLanguageId ? item.id === currentLanguageId : defaultLanguageId ? item.id === defaultLanguageId : false }\"\n                        [routerLink]=\"['/static-data', contentType, itemId, item.id]\">[ {{item.slug}} ]</a>\n                    </div>\n                  </div>\n                  <div class=\"center-block-inner\">\n                    <form [formGroup]=\"form\">\n                      <shared-auto-form\n                        *ngIf=\"status.value === statusType.LOADED\"\n                        class=\"mb-20\"\n                        [showPublicationMessages]=\"staticSection.options?.havePublication || false\"\n                        [entity]=\"contentType\"\n                        [itemId]=\"itemId\"\n                        [formId]=\"formId\"\n                        [fields]=\"fields\"\n                        [form]=\"form\"\n                        [config]=\"{needToPublish: false}\"\n                        [havePublication]=\"staticSection.options?.havePublication || false\"\n                        [errorMessageTexts]=\"globalErrorMessageTexts\"\n                        (changed)=\"changedFormValue($event)\"\n                        (formCompleted)=\"formCompleted($event)\"\n                      ></shared-auto-form>\n\n                      <div *ngIf=\"staticSection.globalActions\" class=\"global-actions\">\n                        <div *ngFor=\"let action of staticSection.globalActions\"\n                             (click)=\"globalActionHandle(action)\" class=\"global-action\">\n                          {{ action.title }}\n                        </div>\n                      </div>\n                      <div @appearFromLeftWithDelay\n                           fxLayout=\"row\"\n                           fxLayoutAlign=\"center center\"\n                           class=\"mt-20\">\n                        <shared-button\n                          id=\"back-to-list-button\"\n                          class=\"mr-8\"\n                          icon=\"chevron_left\"\n                          type=\"button\"\n                          styleTheme=\"raised\"\n                          color=\"basic\"\n                          iconColor=\"black\"\n                          (click)=\"goBack()\"\n                        >\u041A \u0441\u043F\u0438\u0441\u043A\u0443\n                        </shared-button>\n                        <shared-button\n                          *ngIf=\"userRights[0]\"\n                          id=\"form-create-button\"\n                          class=\"mr-8\"\n                          type=\"submit\"\n                          icon=\"edit\"\n                          iconColor=\"white\"\n                          color=\"accent\"\n                          styleTheme=\"raised\"\n                          [loading]=\"status.value === statusType.LOADING\"\n                          [disabled]=\"!form.valid || formStatus === 'loading'\"\n                          (click)=\"submitClick()\"\n                        >{{ itemId ? '\u041E\u0431\u043D\u043E\u0432\u0438\u0442\u044C' : '\u0421\u043E\u0437\u0434\u0430\u0442\u044C' }}\n                          <!-- [disabled]=\"!form.valid dataStored\" -->\n                        </shared-button>\n                        <ng-container *ngIf=\"staticSection.options?.havePublication\">\n                          <shared-button\n                            *ngIf=\"!form.get('status')?.value\"\n                            id=\"publish-button\"\n                            class=\"mr-8\"\n                            icon=\"check\"\n                            type=\"button\"\n                            iconColor=\"white\"\n                            styleTheme=\"raised\"\n                            color=\"orange\"\n                            [disabled]=\"!itemId || publishButtonLoading\"\n                            [loading]=\"publishButtonLoading\"\n                            (click)=\"publishToggle()\"\n                          >\u041E\u043F\u0443\u0431\u043B\u0438\u043A\u043E\u0432\u0430\u0442\u044C\n                          </shared-button>\n                          <shared-button\n                            *ngIf=\"form.get('status')?.value === publishStatus\"\n                            class=\"mr-8\"\n                            icon=\"check\"\n                            type=\"button\"\n                            iconColor=\"white\"\n                            styleTheme=\"raised\"\n                            color=\"orange\"\n                            [disabled]=\"publishButtonLoading\"\n                            [loading]=\"publishButtonLoading\"\n                            (click)=\"publishToggle()\"\n                          >\u0421\u043D\u044F\u0442\u044C \u0441 \u043F\u0443\u0431\u043B\u0438\u043A\u0430\u0446\u0438\u0438\n                          </shared-button>\n                        </ng-container>\n                        <shared-button\n                          *ngIf=\"userRights[3]\"\n                          id=\"delete-button\"\n                          [disabled]=\"!itemId\"\n                          class=\"mr-8\"\n                          type=\"submit\"\n                          icon=\"clear\"\n                          color=\"warn\"\n                          iconColor=\"white\"\n                          styleTheme=\"raised\"\n                          (click)=\"deleteAction(staticData.value)\"\n                        >\u0423\u0434\u0430\u043B\u0438\u0442\u044C\n                        </shared-button>\n                        <ng-container *ngIf=\"staticSection.options?.publicationInTelegramBot\">\n                          <shared-button\n                            icon=\"send\"\n                            type=\"button\"\n                            iconColor=\"white\"\n                            styleTheme=\"raised\"\n                            color=\"orange\"\n                            (click)=\"publishInTelegram()\"\n                          >\u041E\u0442\u043F\u0440\u0430\u0432\u0438\u0442\u044C \u0432 Telegram\n                          </shared-button>\n                        </ng-container>\n                      </div>\n                    </form>\n                  </div>\n                </ng-template>\n              </mat-tab>\n              <ng-container *ngFor=\"let subEntity of staticSection.options?.subEntities\">\n                <mat-tab>\n                  <ng-template mat-tab-label>\n                    <mat-icon *ngIf=\"subEntity.titleIcon\"\n                              class=\"static-data-tab-icon\">{{ subEntity.titleIcon }}\n                    </mat-icon>\n                    {{ subEntity.title }}\n                  </ng-template>\n                  <ng-template matTabContent>\n                    <div class=\"center-block-inner\">\n                      <ng-container *ngIf=\"subEntity.subEntitiesType === 'static-data'\">\n                        <ng-container *ngIf=\"staticData.value?.id\">\n                          <ng-container *ngIf=\"staticData.value?.id\" class=\"center-block-inner\">\n                            <app-static-data-list-items\n                              [staticDataConfiguration]=\"staticDataConfiguration\"\n                              [contentType]=\"subEntity.entity\"\n                              [customTitle]=\"subEntity.title + ' ' + staticData.value?.['name']\"\n                              [addTitle]=\"subEntity.addTitle + ' ' + staticData.value?.['name']\"\n                              [filteringQuery]=\"subEntity.getFilteringQuery(staticData.value)\"\n                              [parentSection]=\"contentType\"\n                              [parentItemId]=\"itemId\"\n                              [parentSectionHashtag]=\"subEntity.hashTag\"\n                              [parentData]=\"form.value\"\n                              [autoCompleteFields]=\"subEntity.autoCompleteFields\"\n                            ></app-static-data-list-items>\n                          </ng-container>\n                          <shared-spinner *ngIf=\"!staticData.value?.id\"\n                                          [overlay]=\"true\"></shared-spinner>\n                        </ng-container>\n                        <ng-container *ngIf=\"!staticData.value?.id\">\n                          <div class=\"message-box error\">\n                            <ng-container *ngIf=\"!subEntity.entity\">\n                              \u041F\u0435\u0440\u0435\u0434 \u0434\u043E\u0431\u0430\u0432\u043B\u0435\u043D\u0438\u0435\u043C \u0432\u043B\u043E\u0436\u0435\u043D\u043D\u044B\u0445 \u0437\u0430\u043F\u0438\u0441\u0435\u0439 \u0412\u0430\u043C \u043D\u0443\u0436\u043D\u043E \u0441\u043D\u0430\u0447\u0430\u043B\u0430 \u0441\u043E\u0445\u0440\u0430\u043D\u0438\u0442\u044C\n                              \u043E\u0441\u043D\u043E\u0432\u043D\u0443\u044E \u0437\u0430\u043F\u0438\u0441\u044C\n                            </ng-container>\n                            <ng-container *ngIf=\"subEntity.emptyTitle\">\n                              {{ subEntity.emptyTitle }}\n                            </ng-container>\n                          </div>\n                        </ng-container>\n                      </ng-container>\n                      <ng-container *ngIf=\"subEntity.subEntitiesType === 'component'\">\n                        <ng-container *ngComponentOutlet=\"\n                          subEntity.component;\n                          injector: componentDataInjector;\n                        \" /> <!-- subEntity.getInputData(form.value) -->\n                      </ng-container>\n                    </div>\n                  </ng-template>\n                </mat-tab>\n              </ng-container>\n            </mat-tab-group>\n          </div>\n        </div>\n      </div>\n    </ng-container>\n  </ng-container>\n  <shared-spinner *ngIf=\"status.value !== statusType.LOADED || formStatus === 'loading'\" [overlay]=\"true\"></shared-spinner>\n</ng-container>\n\n\n", styles: [".update-published-tour-popup{position:absolute;top:0;left:0;width:100%;background:rgba(72,88,96,.6509803922);height:100%;z-index:100}.static-data-tab-icon{margin-right:5px}.languages{display:flex;justify-content:center;margin:5px 0 10px}.languages .language-item .activeLang{background:#007bff;color:#fff}\n"], dependencies: [{ kind: "directive", type: i1$3.NgClass, selector: "[ngClass]", inputs: ["class", "ngClass"] }, { kind: "directive", type: i1$3.NgComponentOutlet, selector: "[ngComponentOutlet]", inputs: ["ngComponentOutlet", "ngComponentOutletInjector", "ngComponentOutletContent", "ngComponentOutletNgModule", "ngComponentOutletNgModuleFactory"] }, { kind: "directive", type: i1$3.NgForOf, selector: "[ngFor][ngForOf]", inputs: ["ngForOf", "ngForTrackBy", "ngForTemplate"] }, { kind: "directive", type: i1$3.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "component", type: AutoFormMainComponent, selector: "shared-auto-form", inputs: ["fields", "itemId", "formId", "showPublicationMessages", "form", "editorImageUploadUrl", "errorMessageTexts", "entity", "havePublication", "config"], outputs: ["changed", "formCompleted"] }, { kind: "directive", type: i2.RouterLink, selector: "[routerLink]", inputs: ["target", "queryParams", "fragment", "queryParamsHandling", "state", "relativeTo", "preserveFragment", "skipLocationChange", "replaceUrl", "routerLink"] }, { kind: "component", type: i2$4.MatIcon, selector: "mat-icon", inputs: ["color", "inline", "svgIcon", "fontSet", "fontIcon"], exportAs: ["matIcon"] }, { kind: "component", type: SpinnerComponent, selector: "shared-spinner", inputs: ["overlay", "diameter", "color", "position"] }, { kind: "component", type: ButtonComponent, selector: "shared-button", inputs: ["icon", "iconColor", "iconSize", "rightIcon", "disabled", "loading", "active", "stopPropagation", "type", "color", "size", "styleTheme", "tooltip", "tooltipPosition"], outputs: ["clickButton"] }, { kind: "component", type: PanelHeaderComponent, selector: "shared-panel-header", inputs: ["title", "parentTitle", "parentUrl"] }, { kind: "directive", type: i6.ɵNgNoValidate, selector: "form:not([ngNoForm]):not([ngNativeValidate])" }, { kind: "directive", type: i6.NgControlStatusGroup, selector: "[formGroupName],[formArrayName],[ngModelGroup],[formGroup],form:not([ngNoForm]),[ngForm]" }, { kind: "directive", type: i6.FormGroupDirective, selector: "[formGroup]", inputs: ["formGroup"], outputs: ["ngSubmit"], exportAs: ["ngForm"] }, { kind: "directive", type: i9.DefaultLayoutDirective, selector: "  [fxLayout], [fxLayout.xs], [fxLayout.sm], [fxLayout.md],  [fxLayout.lg], [fxLayout.xl], [fxLayout.lt-sm], [fxLayout.lt-md],  [fxLayout.lt-lg], [fxLayout.lt-xl], [fxLayout.gt-xs], [fxLayout.gt-sm],  [fxLayout.gt-md], [fxLayout.gt-lg]", inputs: ["fxLayout", "fxLayout.xs", "fxLayout.sm", "fxLayout.md", "fxLayout.lg", "fxLayout.xl", "fxLayout.lt-sm", "fxLayout.lt-md", "fxLayout.lt-lg", "fxLayout.lt-xl", "fxLayout.gt-xs", "fxLayout.gt-sm", "fxLayout.gt-md", "fxLayout.gt-lg"] }, { kind: "directive", type: i9.DefaultLayoutAlignDirective, selector: "  [fxLayoutAlign], [fxLayoutAlign.xs], [fxLayoutAlign.sm], [fxLayoutAlign.md],  [fxLayoutAlign.lg], [fxLayoutAlign.xl], [fxLayoutAlign.lt-sm], [fxLayoutAlign.lt-md],  [fxLayoutAlign.lt-lg], [fxLayoutAlign.lt-xl], [fxLayoutAlign.gt-xs], [fxLayoutAlign.gt-sm],  [fxLayoutAlign.gt-md], [fxLayoutAlign.gt-lg]", inputs: ["fxLayoutAlign", "fxLayoutAlign.xs", "fxLayoutAlign.sm", "fxLayoutAlign.md", "fxLayoutAlign.lg", "fxLayoutAlign.xl", "fxLayoutAlign.lt-sm", "fxLayoutAlign.lt-md", "fxLayoutAlign.lt-lg", "fxLayoutAlign.lt-xl", "fxLayoutAlign.gt-xs", "fxLayoutAlign.gt-sm", "fxLayoutAlign.gt-md", "fxLayoutAlign.gt-lg"] }, { kind: "directive", type: i22.MatTabContent, selector: "[matTabContent]" }, { kind: "directive", type: i22.MatTabLabel, selector: "[mat-tab-label], [matTabLabel]" }, { kind: "component", type: i22.MatTab, selector: "mat-tab", inputs: ["disabled"], exportAs: ["matTab"] }, { kind: "component", type: i22.MatTabGroup, selector: "mat-tab-group", inputs: ["color", "disableRipple", "fitInkBarToContent", "mat-stretch-tabs"], exportAs: ["matTabGroup"] }, { kind: "component", type: StaticDataListItemsComponent, selector: "app-static-data-list-items", inputs: ["staticDataConfiguration", "contentType", "customTitle", "addTitle", "parentSection", "parentItemId", "showPanelHeader", "parentData", "parentSectionHashtag", "autoCompleteFields", "filteringQuery"] }, { kind: "pipe", type: i1$3.AsyncPipe, name: "async" }], animations: [appearFromRightWithDelay, appearFromLeftWithDelay, appearOpacity], changeDetection: i0.ChangeDetectionStrategy.OnPush });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "15.2.9", ngImport: i0, type: StaticDataDetailsComponent, decorators: [{
            type: Component,
            args: [{ selector: 'app-static-data-details', changeDetection: ChangeDetectionStrategy.OnPush, animations: [appearFromRightWithDelay, appearFromLeftWithDelay, appearOpacity], template: "<ng-container *ngIf=\"(status$ | async) as status\">\n  <ng-container *ngIf=\"(userRights$ | async) as userRights\">\n    <ng-container *ngIf=\"(staticData$ | async) as staticData\">\n      <div class=\"page-layout simple fullwidth angular-material-elements\">\n        <shared-panel-header *ngIf=\"form.get('name')\" [parentTitle]=\"staticSection.title\"\n                             [parentUrl]=\"['/static-data', contentType]\"\n                             [title]=\"form.get('name')?.value\">>\n        </shared-panel-header>\n\n        <div class=\"content p-24\">\n          <div class=\"center-block bg-white mat-elevation-z1\">\n            <mat-tab-group [selectedIndex]=\"activeTabIndex\">\n              <mat-tab>\n                <ng-template mat-tab-label>\n                  <mat-icon class=\"static-data-tab-icon\">edit</mat-icon>\n                  \u0424\u043E\u0440\u043C\u0430 \u0440\u0435\u0434\u0430\u043A\u0442\u0438\u0440\u043E\u0432\u0430\u043D\u0438\u044F\n                </ng-template>\n                <ng-template matTabContent>\n                  <div class=\"center-block-header position-relative\">\n                    <div @appearFromLeftWithDelay class=\"center-block-header-title\">\n                      {{ form.get('name')?.value || '\u0420\u0435\u0434\u0430\u043A\u0442\u0438\u0440\u043E\u0432\u0430\u043D\u0438\u0435' }}\n                    </div>\n                  </div>\n                  <div *ngIf=\"staticSection?.options?.hasMultiLanguage\" class=\"languages\">\n                    <div *ngFor=\"let item of languageList\" class=\"language-item\">\n                      <a\n                        [ngClass]=\"{'activeLang': currentLanguageId ? item.id === currentLanguageId : defaultLanguageId ? item.id === defaultLanguageId : false }\"\n                        [routerLink]=\"['/static-data', contentType, itemId, item.id]\">[ {{item.slug}} ]</a>\n                    </div>\n                  </div>\n                  <div class=\"center-block-inner\">\n                    <form [formGroup]=\"form\">\n                      <shared-auto-form\n                        *ngIf=\"status.value === statusType.LOADED\"\n                        class=\"mb-20\"\n                        [showPublicationMessages]=\"staticSection.options?.havePublication || false\"\n                        [entity]=\"contentType\"\n                        [itemId]=\"itemId\"\n                        [formId]=\"formId\"\n                        [fields]=\"fields\"\n                        [form]=\"form\"\n                        [config]=\"{needToPublish: false}\"\n                        [havePublication]=\"staticSection.options?.havePublication || false\"\n                        [errorMessageTexts]=\"globalErrorMessageTexts\"\n                        (changed)=\"changedFormValue($event)\"\n                        (formCompleted)=\"formCompleted($event)\"\n                      ></shared-auto-form>\n\n                      <div *ngIf=\"staticSection.globalActions\" class=\"global-actions\">\n                        <div *ngFor=\"let action of staticSection.globalActions\"\n                             (click)=\"globalActionHandle(action)\" class=\"global-action\">\n                          {{ action.title }}\n                        </div>\n                      </div>\n                      <div @appearFromLeftWithDelay\n                           fxLayout=\"row\"\n                           fxLayoutAlign=\"center center\"\n                           class=\"mt-20\">\n                        <shared-button\n                          id=\"back-to-list-button\"\n                          class=\"mr-8\"\n                          icon=\"chevron_left\"\n                          type=\"button\"\n                          styleTheme=\"raised\"\n                          color=\"basic\"\n                          iconColor=\"black\"\n                          (click)=\"goBack()\"\n                        >\u041A \u0441\u043F\u0438\u0441\u043A\u0443\n                        </shared-button>\n                        <shared-button\n                          *ngIf=\"userRights[0]\"\n                          id=\"form-create-button\"\n                          class=\"mr-8\"\n                          type=\"submit\"\n                          icon=\"edit\"\n                          iconColor=\"white\"\n                          color=\"accent\"\n                          styleTheme=\"raised\"\n                          [loading]=\"status.value === statusType.LOADING\"\n                          [disabled]=\"!form.valid || formStatus === 'loading'\"\n                          (click)=\"submitClick()\"\n                        >{{ itemId ? '\u041E\u0431\u043D\u043E\u0432\u0438\u0442\u044C' : '\u0421\u043E\u0437\u0434\u0430\u0442\u044C' }}\n                          <!-- [disabled]=\"!form.valid dataStored\" -->\n                        </shared-button>\n                        <ng-container *ngIf=\"staticSection.options?.havePublication\">\n                          <shared-button\n                            *ngIf=\"!form.get('status')?.value\"\n                            id=\"publish-button\"\n                            class=\"mr-8\"\n                            icon=\"check\"\n                            type=\"button\"\n                            iconColor=\"white\"\n                            styleTheme=\"raised\"\n                            color=\"orange\"\n                            [disabled]=\"!itemId || publishButtonLoading\"\n                            [loading]=\"publishButtonLoading\"\n                            (click)=\"publishToggle()\"\n                          >\u041E\u043F\u0443\u0431\u043B\u0438\u043A\u043E\u0432\u0430\u0442\u044C\n                          </shared-button>\n                          <shared-button\n                            *ngIf=\"form.get('status')?.value === publishStatus\"\n                            class=\"mr-8\"\n                            icon=\"check\"\n                            type=\"button\"\n                            iconColor=\"white\"\n                            styleTheme=\"raised\"\n                            color=\"orange\"\n                            [disabled]=\"publishButtonLoading\"\n                            [loading]=\"publishButtonLoading\"\n                            (click)=\"publishToggle()\"\n                          >\u0421\u043D\u044F\u0442\u044C \u0441 \u043F\u0443\u0431\u043B\u0438\u043A\u0430\u0446\u0438\u0438\n                          </shared-button>\n                        </ng-container>\n                        <shared-button\n                          *ngIf=\"userRights[3]\"\n                          id=\"delete-button\"\n                          [disabled]=\"!itemId\"\n                          class=\"mr-8\"\n                          type=\"submit\"\n                          icon=\"clear\"\n                          color=\"warn\"\n                          iconColor=\"white\"\n                          styleTheme=\"raised\"\n                          (click)=\"deleteAction(staticData.value)\"\n                        >\u0423\u0434\u0430\u043B\u0438\u0442\u044C\n                        </shared-button>\n                        <ng-container *ngIf=\"staticSection.options?.publicationInTelegramBot\">\n                          <shared-button\n                            icon=\"send\"\n                            type=\"button\"\n                            iconColor=\"white\"\n                            styleTheme=\"raised\"\n                            color=\"orange\"\n                            (click)=\"publishInTelegram()\"\n                          >\u041E\u0442\u043F\u0440\u0430\u0432\u0438\u0442\u044C \u0432 Telegram\n                          </shared-button>\n                        </ng-container>\n                      </div>\n                    </form>\n                  </div>\n                </ng-template>\n              </mat-tab>\n              <ng-container *ngFor=\"let subEntity of staticSection.options?.subEntities\">\n                <mat-tab>\n                  <ng-template mat-tab-label>\n                    <mat-icon *ngIf=\"subEntity.titleIcon\"\n                              class=\"static-data-tab-icon\">{{ subEntity.titleIcon }}\n                    </mat-icon>\n                    {{ subEntity.title }}\n                  </ng-template>\n                  <ng-template matTabContent>\n                    <div class=\"center-block-inner\">\n                      <ng-container *ngIf=\"subEntity.subEntitiesType === 'static-data'\">\n                        <ng-container *ngIf=\"staticData.value?.id\">\n                          <ng-container *ngIf=\"staticData.value?.id\" class=\"center-block-inner\">\n                            <app-static-data-list-items\n                              [staticDataConfiguration]=\"staticDataConfiguration\"\n                              [contentType]=\"subEntity.entity\"\n                              [customTitle]=\"subEntity.title + ' ' + staticData.value?.['name']\"\n                              [addTitle]=\"subEntity.addTitle + ' ' + staticData.value?.['name']\"\n                              [filteringQuery]=\"subEntity.getFilteringQuery(staticData.value)\"\n                              [parentSection]=\"contentType\"\n                              [parentItemId]=\"itemId\"\n                              [parentSectionHashtag]=\"subEntity.hashTag\"\n                              [parentData]=\"form.value\"\n                              [autoCompleteFields]=\"subEntity.autoCompleteFields\"\n                            ></app-static-data-list-items>\n                          </ng-container>\n                          <shared-spinner *ngIf=\"!staticData.value?.id\"\n                                          [overlay]=\"true\"></shared-spinner>\n                        </ng-container>\n                        <ng-container *ngIf=\"!staticData.value?.id\">\n                          <div class=\"message-box error\">\n                            <ng-container *ngIf=\"!subEntity.entity\">\n                              \u041F\u0435\u0440\u0435\u0434 \u0434\u043E\u0431\u0430\u0432\u043B\u0435\u043D\u0438\u0435\u043C \u0432\u043B\u043E\u0436\u0435\u043D\u043D\u044B\u0445 \u0437\u0430\u043F\u0438\u0441\u0435\u0439 \u0412\u0430\u043C \u043D\u0443\u0436\u043D\u043E \u0441\u043D\u0430\u0447\u0430\u043B\u0430 \u0441\u043E\u0445\u0440\u0430\u043D\u0438\u0442\u044C\n                              \u043E\u0441\u043D\u043E\u0432\u043D\u0443\u044E \u0437\u0430\u043F\u0438\u0441\u044C\n                            </ng-container>\n                            <ng-container *ngIf=\"subEntity.emptyTitle\">\n                              {{ subEntity.emptyTitle }}\n                            </ng-container>\n                          </div>\n                        </ng-container>\n                      </ng-container>\n                      <ng-container *ngIf=\"subEntity.subEntitiesType === 'component'\">\n                        <ng-container *ngComponentOutlet=\"\n                          subEntity.component;\n                          injector: componentDataInjector;\n                        \" /> <!-- subEntity.getInputData(form.value) -->\n                      </ng-container>\n                    </div>\n                  </ng-template>\n                </mat-tab>\n              </ng-container>\n            </mat-tab-group>\n          </div>\n        </div>\n      </div>\n    </ng-container>\n  </ng-container>\n  <shared-spinner *ngIf=\"status.value !== statusType.LOADED || formStatus === 'loading'\" [overlay]=\"true\"></shared-spinner>\n</ng-container>\n\n\n", styles: [".update-published-tour-popup{position:absolute;top:0;left:0;width:100%;background:rgba(72,88,96,.6509803922);height:100%;z-index:100}.static-data-tab-icon{margin-right:5px}.languages{display:flex;justify-content:center;margin:5px 0 10px}.languages .language-item .activeLang{background:#007bff;color:#fff}\n"] }]
        }], ctorParameters: function () { return [{ type: i6.UntypedFormBuilder }, { type: i2.Router }, { type: i2.ActivatedRoute }, { type: AutoFormService }, { type: RouterFacade }, { type: FormErrorsFacade }, { type: FormsFacade }, { type: RequestsFacade }, { type: StaticDataFacade }, { type: RightService }, { type: i1$4.MatDialog }, { type: NotificationsFacade }, { type: CoreFacade }, { type: PublicationMessagesFacade }, { type: ActionsFacade }, { type: i0.Injector }, { type: i0.ChangeDetectorRef }]; } });

/**
 * @title Data table with sorting, pagination, and filtering.
 */
class StaticDataListComponent {
    constructor(activatedRoute) {
        this.activatedRoute = activatedRoute;
    }
    async ngOnInit() {
        this.loadStaticDataConfiguration();
        this.loadContentType();
    }
    // eslint-disable-next-line @angular-eslint/no-empty-lifecycle-method
    ngOnDestroy() {
    }
    loadStaticDataConfiguration() {
        this.activatedRoute.data
            .pipe(untilComponentDestroyed(this))
            .subscribe(staticDataConfiguration => {
            this.staticDataConfiguration = staticDataConfiguration?.configuration;
        });
    }
    loadContentType() {
        this.contentType$ = this.activatedRoute.url
            .pipe(map((params) => {
            return params?.[0].path;
        }));
    }
}
StaticDataListComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "15.2.9", ngImport: i0, type: StaticDataListComponent, deps: [{ token: i2.ActivatedRoute }], target: i0.ɵɵFactoryTarget.Component });
StaticDataListComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "15.2.9", type: StaticDataListComponent, selector: "app-static-data-list", ngImport: i0, template: "<ng-container *ngIf=\"contentType$ | async as contentType\">\n  <app-static-data-list-items\n    [staticDataConfiguration]=\"staticDataConfiguration\"\n    [contentType]=\"contentType\"\n    [showPanelHeader]=\"true\"></app-static-data-list-items>\n</ng-container>\n", styles: [".top-bar{background:#c7deef;display:flex;justify-content:flex-end}.top-bar .search-block{display:flex;align-content:center;align-items:center}.top-bar .search-block .search-input{background-color:#adcde8!important;padding:11px 10px!important}.top-bar .search-block .cancel-button{width:64px;height:40px}\n"], dependencies: [{ kind: "directive", type: i1$3.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "component", type: StaticDataListItemsComponent, selector: "app-static-data-list-items", inputs: ["staticDataConfiguration", "contentType", "customTitle", "addTitle", "parentSection", "parentItemId", "showPanelHeader", "parentData", "parentSectionHashtag", "autoCompleteFields", "filteringQuery"] }, { kind: "pipe", type: i1$3.AsyncPipe, name: "async" }], changeDetection: i0.ChangeDetectionStrategy.OnPush });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "15.2.9", ngImport: i0, type: StaticDataListComponent, decorators: [{
            type: Component,
            args: [{ selector: 'app-static-data-list', changeDetection: ChangeDetectionStrategy.OnPush, template: "<ng-container *ngIf=\"contentType$ | async as contentType\">\n  <app-static-data-list-items\n    [staticDataConfiguration]=\"staticDataConfiguration\"\n    [contentType]=\"contentType\"\n    [showPanelHeader]=\"true\"></app-static-data-list-items>\n</ng-container>\n", styles: [".top-bar{background:#c7deef;display:flex;justify-content:flex-end}.top-bar .search-block{display:flex;align-content:center;align-items:center}.top-bar .search-block .search-input{background-color:#adcde8!important;padding:11px 10px!important}.top-bar .search-block .cancel-button{width:64px;height:40px}\n"] }]
        }], ctorParameters: function () { return [{ type: i2.ActivatedRoute }]; } });

const routes = [
    {
        path: ':contentType',
        pathMatch: 'full',
        component: StaticDataListComponent,
    },
    {
        path: 'new/:contentType',
        component: StaticDataDetailsComponent,
    },
    {
        path: ':contentType/:id',
        component: StaticDataDetailsComponent,
    },
    {
        path: ':contentType/:id/:langId',
        component: StaticDataDetailsComponent,
    }
];
class StaticDataRoutingModule {
}
StaticDataRoutingModule.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "15.2.9", ngImport: i0, type: StaticDataRoutingModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule });
StaticDataRoutingModule.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "15.2.9", ngImport: i0, type: StaticDataRoutingModule, imports: [i2.RouterModule], exports: [RouterModule] });
StaticDataRoutingModule.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "15.2.9", ngImport: i0, type: StaticDataRoutingModule, imports: [RouterModule.forChild(routes), RouterModule] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "15.2.9", ngImport: i0, type: StaticDataRoutingModule, decorators: [{
            type: NgModule,
            args: [{
                    imports: [RouterModule.forChild(routes)],
                    exports: [RouterModule],
                }]
        }] });

class TableMenuComponent {
    constructor() {
        this.edit = new EventEmitter();
        this.delete = new EventEmitter();
    }
    ngOnInit() {
    }
    editAction() {
        this.edit.emit();
    }
    deleteAction() {
        this.delete.emit();
    }
}
TableMenuComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "15.2.9", ngImport: i0, type: TableMenuComponent, deps: [], target: i0.ɵɵFactoryTarget.Component });
TableMenuComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "15.2.9", type: TableMenuComponent, selector: "shared-table-menu", outputs: { edit: "edit", delete: "delete" }, ngImport: i0, template: "<mat-icon class=\"cursor-pointer\" [matMenuTriggerFor]=\"menu\">more_vert</mat-icon>\n<mat-menu #menu=\"matMenu\">\n  <button mat-menu-item (click)=\"editAction()\">\n    <mat-icon>edit</mat-icon>\n    <span>\u0420\u0435\u0434.</span>\n  </button>\n  <button mat-menu-item (click)=\"deleteAction()\">\n    <mat-icon>delete</mat-icon>\n    <span>\u0423\u0434\u0430\u043B\u0438\u0442\u044C</span>\n  </button>\n</mat-menu>\n", styles: [""], dependencies: [{ kind: "component", type: i2$4.MatIcon, selector: "mat-icon", inputs: ["color", "inline", "svgIcon", "fontSet", "fontIcon"], exportAs: ["matIcon"] }, { kind: "component", type: i2$6.MatMenu, selector: "mat-menu", exportAs: ["matMenu"] }, { kind: "component", type: i2$6.MatMenuItem, selector: "[mat-menu-item]", inputs: ["disabled", "disableRipple", "role"], exportAs: ["matMenuItem"] }, { kind: "directive", type: i2$6.MatMenuTrigger, selector: "[mat-menu-trigger-for], [matMenuTriggerFor]", exportAs: ["matMenuTrigger"] }] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "15.2.9", ngImport: i0, type: TableMenuComponent, decorators: [{
            type: Component,
            args: [{ selector: 'shared-table-menu', template: "<mat-icon class=\"cursor-pointer\" [matMenuTriggerFor]=\"menu\">more_vert</mat-icon>\n<mat-menu #menu=\"matMenu\">\n  <button mat-menu-item (click)=\"editAction()\">\n    <mat-icon>edit</mat-icon>\n    <span>\u0420\u0435\u0434.</span>\n  </button>\n  <button mat-menu-item (click)=\"deleteAction()\">\n    <mat-icon>delete</mat-icon>\n    <span>\u0423\u0434\u0430\u043B\u0438\u0442\u044C</span>\n  </button>\n</mat-menu>\n" }]
        }], ctorParameters: function () { return []; }, propDecorators: { edit: [{
                type: Output
            }], delete: [{
                type: Output
            }] } });

class TableMenuModule {
}
TableMenuModule.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "15.2.9", ngImport: i0, type: TableMenuModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule });
TableMenuModule.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "15.2.9", ngImport: i0, type: TableMenuModule, declarations: [TableMenuComponent], imports: [CommonModule,
        MatIconModule,
        MatMenuModule], exports: [TableMenuComponent,
        MatIconModule,
        MatMenuModule] });
TableMenuModule.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "15.2.9", ngImport: i0, type: TableMenuModule, imports: [CommonModule,
        MatIconModule,
        MatMenuModule, MatIconModule,
        MatMenuModule] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "15.2.9", ngImport: i0, type: TableMenuModule, decorators: [{
            type: NgModule,
            args: [{
                    declarations: [TableMenuComponent],
                    imports: [
                        CommonModule,
                        MatIconModule,
                        MatMenuModule
                    ],
                    exports: [
                        TableMenuComponent,
                        MatIconModule,
                        MatMenuModule
                    ]
                }]
        }] });

class PanelHeaderModule {
}
PanelHeaderModule.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "15.2.9", ngImport: i0, type: PanelHeaderModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule });
PanelHeaderModule.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "15.2.9", ngImport: i0, type: PanelHeaderModule, declarations: [PanelHeaderComponent], imports: [CommonModule,
        MatIconModule,
        MatFormFieldModule,
        MatButtonModule,
        MatInputModule,
        FlexLayoutModule,
        RouterModule], exports: [PanelHeaderComponent] });
PanelHeaderModule.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "15.2.9", ngImport: i0, type: PanelHeaderModule, imports: [CommonModule,
        MatIconModule,
        MatFormFieldModule,
        MatButtonModule,
        MatInputModule,
        FlexLayoutModule,
        RouterModule] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "15.2.9", ngImport: i0, type: PanelHeaderModule, decorators: [{
            type: NgModule,
            args: [{
                    declarations: [PanelHeaderComponent],
                    exports: [PanelHeaderComponent],
                    imports: [
                        CommonModule,
                        MatIconModule,
                        MatFormFieldModule,
                        MatButtonModule,
                        MatInputModule,
                        FlexLayoutModule,
                        RouterModule
                    ]
                }]
        }] });

class StaticDataModule {
}
StaticDataModule.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "15.2.9", ngImport: i0, type: StaticDataModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule });
StaticDataModule.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "15.2.9", ngImport: i0, type: StaticDataModule, declarations: [StaticDataDetailsComponent,
        StaticDataListComponent,
        StaticDataItemsComponent,
        StaticDataListItemsComponent], imports: [CommonModule,
        AutoFormModule,
        StaticDataRoutingModule,
        MatTableModule,
        MatButtonModule,
        MatFormFieldModule,
        MatIconModule,
        TableMenuModule,
        MatPaginatorModule,
        SharedSpinnerModule,
        FilesUploadModule,
        ButtonModule,
        NgrxFormsModule,
        MatInputModule,
        PanelHeaderModule,
        SharedIconModule,
        MatTooltipModule,
        ReactiveFormsModule,
        FlexModule, i6$1.NgxMaskModule, ImageModule,
        MatDialogModule,
        MatTabsModule,
        PanelModule,
        MatChipsModule,
        MatAutocompleteModule] });
StaticDataModule.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "15.2.9", ngImport: i0, type: StaticDataModule, providers: [
        AutoFormService,
        DialogService,
        StaticDataComponentInputData
    ], imports: [CommonModule,
        AutoFormModule,
        StaticDataRoutingModule,
        MatTableModule,
        MatButtonModule,
        MatFormFieldModule,
        MatIconModule,
        TableMenuModule,
        MatPaginatorModule,
        SharedSpinnerModule,
        FilesUploadModule,
        ButtonModule,
        NgrxFormsModule,
        MatInputModule,
        PanelHeaderModule,
        SharedIconModule,
        MatTooltipModule,
        ReactiveFormsModule,
        FlexModule,
        NgxMaskModule.forRoot(),
        ImageModule,
        MatDialogModule,
        MatTabsModule,
        PanelModule,
        MatChipsModule,
        MatAutocompleteModule] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "15.2.9", ngImport: i0, type: StaticDataModule, decorators: [{
            type: NgModule,
            args: [{
                    declarations: [
                        StaticDataDetailsComponent,
                        StaticDataListComponent,
                        StaticDataItemsComponent,
                        StaticDataListItemsComponent
                    ],
                    imports: [
                        CommonModule,
                        AutoFormModule,
                        StaticDataRoutingModule,
                        MatTableModule,
                        MatButtonModule,
                        MatFormFieldModule,
                        MatIconModule,
                        TableMenuModule,
                        MatPaginatorModule,
                        SharedSpinnerModule,
                        FilesUploadModule,
                        ButtonModule,
                        NgrxFormsModule,
                        MatInputModule,
                        PanelHeaderModule,
                        SharedIconModule,
                        MatTooltipModule,
                        ReactiveFormsModule,
                        FlexModule,
                        NgxMaskModule.forRoot(),
                        ImageModule,
                        MatDialogModule,
                        MatTabsModule,
                        PanelModule,
                        MatChipsModule,
                        MatAutocompleteModule
                    ],
                    providers: [
                        AutoFormService,
                        DialogService,
                        StaticDataComponentInputData
                    ]
                }]
        }] });

class ChipsInputComponent {
    constructor() {
        this.items = [];
        this.selectedItems = [];
        this.changedList = new EventEmitter();
        this.changedText = new EventEmitter();
        this.visible = true;
        this.selectable = true;
        this.removable = true;
        this.addOnBlur = true;
        this.separatorKeysCodes = [ENTER, COMMA];
        this.itemsCtrl = new UntypedFormControl();
        this.filteredItems = this.itemsCtrl.valueChanges.pipe(startWith(null), map((item) => {
            this.changedText.emit(item);
            if (this.items) {
                return item ? this._filter(item) : this.items.slice();
            }
            return [];
        }));
    }
    add(event) {
        // Add item only when MatAutocomplete is not open
        // To make sure this does not conflict with OptionSelected Event
        if (!this.matAutocomplete.isOpen) {
            const input = event.input;
            const value = event.value;
            // Add our item
            if ((value || '').trim()) {
                this.selectedItems.push({ id: 3, title: value.trim() });
                this.changedList.emit(this.selectedItems);
            }
            // Reset the input value
            if (input) {
                input.value = '';
            }
            this.itemsCtrl.setValue(null);
        }
    }
    remove(item) {
        this.selectedItems = this.selectedItems.filter(SItem => SItem.id !== item.id);
        this.changedList.emit(this.selectedItems);
    }
    selected(event) {
        this.selectedItems.push({ id: 1, title: event.option.viewValue });
        this.itemInput.nativeElement.value = '';
        this.itemsCtrl.setValue(null);
        this.changedList.emit(this.selectedItems);
    }
    _filter(value) {
        if (typeof value === 'string') {
            return this.items.filter(itemFilter => itemFilter.title.indexOf(value) === 0);
        }
        else {
            return this.items.filter(itemFilter => {
                return itemFilter.id !== value.id;
            });
        }
    }
}
ChipsInputComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "15.2.9", ngImport: i0, type: ChipsInputComponent, deps: [], target: i0.ɵɵFactoryTarget.Component });
ChipsInputComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "15.2.9", type: ChipsInputComponent, selector: "shared-chips-input", inputs: { title: "title", items: "items", selectedItems: "selectedItems" }, outputs: { changedList: "changedList", changedText: "changedText" }, viewQueries: [{ propertyName: "itemInput", first: true, predicate: ["itemInput"], descendants: true }, { propertyName: "matAutocomplete", first: true, predicate: ["auto"], descendants: true }], ngImport: i0, template: "<!--\n<mat-form-field class=\"example-chip-list\">\n  <mat-label class=\"title\">{{title}}</mat-label>\n  <mat-chip-list #chipList aria-label=\"Fruit selection\">\n    <mat-chip\n      *ngFor=\"let item of selectedItems\"\n      [selectable]=\"selectable\"\n      [removable]=\"removable\"\n      (removed)=\"remove(item)\">\n      {{item.title}}\n      <mat-icon matChipRemove *ngIf=\"removable\">cancel</mat-icon>\n    </mat-chip>\n    <input\n      #itemInput\n      [placeholder]=\"''\"\n      [formControl]=\"itemsCtrl\"\n      [matAutocomplete]=\"auto\"\n      [matChipInputFor]=\"chipList\"\n      [matChipInputSeparatorKeyCodes]=\"separatorKeysCodes\"\n      [matChipInputAddOnBlur]=\"addOnBlur\"\n      (matChipInputTokenEnd)=\"add($event)\">\n  </mat-chip-list>\n  <mat-autocomplete #auto=\"matAutocomplete\" (optionSelected)=\"selected($event)\">\n    <mat-option *ngFor=\"let item of filteredItems | async\" [value]=\"item\">\n      {{item.title}}\n    </mat-option>\n  </mat-autocomplete>\n</mat-form-field>\n-->\n<!--\n<mat-form-field class=\"example-chip-list\">\n    <mat-label>Favorite Fruits</mat-label>\n    <mat-chip-grid #chipGrid aria-label=\"Fruit selection\">\n      <mat-chip-row *ngFor=\"let fruit of fruits\" (removed)=\"remove(fruit)\">\n        {{fruit}}\n        <button matChipRemove [attr.aria-label]=\"'remove ' + fruit\">\n          <mat-icon>cancel</mat-icon>\n        </button>\n      </mat-chip-row>\n    </mat-chip-grid>\n    <input placeholder=\"New Fruit...\" #fruitInput [formControl]=\"fruitCtrl\"\n      [matChipInputFor]=\"chipGrid\" [matAutocomplete]=\"auto\"\n      [matChipInputSeparatorKeyCodes]=\"separatorKeysCodes\"\n      (matChipInputTokenEnd)=\"add($event)\"/>\n    <mat-autocomplete #auto=\"matAutocomplete\" (optionSelected)=\"selected($event)\">\n      <mat-option *ngFor=\"let fruit of filteredFruits | async\" [value]=\"fruit\">\n        {{fruit}}\n      </mat-option>\n    </mat-autocomplete>\n  </mat-form-field>\n-->\n", styles: [".example-chip-list{width:100%}.title{color:#0009;font-size:16px}\n"] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "15.2.9", ngImport: i0, type: ChipsInputComponent, decorators: [{
            type: Component,
            args: [{ selector: 'shared-chips-input', template: "<!--\n<mat-form-field class=\"example-chip-list\">\n  <mat-label class=\"title\">{{title}}</mat-label>\n  <mat-chip-list #chipList aria-label=\"Fruit selection\">\n    <mat-chip\n      *ngFor=\"let item of selectedItems\"\n      [selectable]=\"selectable\"\n      [removable]=\"removable\"\n      (removed)=\"remove(item)\">\n      {{item.title}}\n      <mat-icon matChipRemove *ngIf=\"removable\">cancel</mat-icon>\n    </mat-chip>\n    <input\n      #itemInput\n      [placeholder]=\"''\"\n      [formControl]=\"itemsCtrl\"\n      [matAutocomplete]=\"auto\"\n      [matChipInputFor]=\"chipList\"\n      [matChipInputSeparatorKeyCodes]=\"separatorKeysCodes\"\n      [matChipInputAddOnBlur]=\"addOnBlur\"\n      (matChipInputTokenEnd)=\"add($event)\">\n  </mat-chip-list>\n  <mat-autocomplete #auto=\"matAutocomplete\" (optionSelected)=\"selected($event)\">\n    <mat-option *ngFor=\"let item of filteredItems | async\" [value]=\"item\">\n      {{item.title}}\n    </mat-option>\n  </mat-autocomplete>\n</mat-form-field>\n-->\n<!--\n<mat-form-field class=\"example-chip-list\">\n    <mat-label>Favorite Fruits</mat-label>\n    <mat-chip-grid #chipGrid aria-label=\"Fruit selection\">\n      <mat-chip-row *ngFor=\"let fruit of fruits\" (removed)=\"remove(fruit)\">\n        {{fruit}}\n        <button matChipRemove [attr.aria-label]=\"'remove ' + fruit\">\n          <mat-icon>cancel</mat-icon>\n        </button>\n      </mat-chip-row>\n    </mat-chip-grid>\n    <input placeholder=\"New Fruit...\" #fruitInput [formControl]=\"fruitCtrl\"\n      [matChipInputFor]=\"chipGrid\" [matAutocomplete]=\"auto\"\n      [matChipInputSeparatorKeyCodes]=\"separatorKeysCodes\"\n      (matChipInputTokenEnd)=\"add($event)\"/>\n    <mat-autocomplete #auto=\"matAutocomplete\" (optionSelected)=\"selected($event)\">\n      <mat-option *ngFor=\"let fruit of filteredFruits | async\" [value]=\"fruit\">\n        {{fruit}}\n      </mat-option>\n    </mat-autocomplete>\n  </mat-form-field>\n-->\n", styles: [".example-chip-list{width:100%}.title{color:#0009;font-size:16px}\n"] }]
        }], ctorParameters: function () { return []; }, propDecorators: { title: [{
                type: Input
            }], items: [{
                type: Input
            }], selectedItems: [{
                type: Input
            }], changedList: [{
                type: Output
            }], changedText: [{
                type: Output
            }], itemInput: [{
                type: ViewChild,
                args: ['itemInput', { static: false }]
            }], matAutocomplete: [{
                type: ViewChild,
                args: ['auto', { static: false }]
            }] } });

class ChipsInputModule {
}
ChipsInputModule.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "15.2.9", ngImport: i0, type: ChipsInputModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule });
ChipsInputModule.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "15.2.9", ngImport: i0, type: ChipsInputModule, declarations: [ChipsInputComponent], imports: [CommonModule,
        MatFormFieldModule,
        MatChipsModule,
        MatAutocompleteModule,
        MatIconModule,
        ReactiveFormsModule,
        MatLegacyChipsModule], exports: [ChipsInputComponent] });
ChipsInputModule.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "15.2.9", ngImport: i0, type: ChipsInputModule, imports: [CommonModule,
        MatFormFieldModule,
        MatChipsModule,
        MatAutocompleteModule,
        MatIconModule,
        ReactiveFormsModule,
        MatLegacyChipsModule] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "15.2.9", ngImport: i0, type: ChipsInputModule, decorators: [{
            type: NgModule,
            args: [{
                    declarations: [ChipsInputComponent],
                    exports: [ChipsInputComponent],
                    imports: [
                        CommonModule,
                        MatFormFieldModule,
                        MatChipsModule,
                        MatAutocompleteModule,
                        MatIconModule,
                        ReactiveFormsModule,
                        MatLegacyChipsModule
                    ]
                }]
        }] });

class HeaderComponent {
    constructor() {
        this.title = 'Travel BloGG';
        this.small = false;
    }
    ngOnInit() {
    }
}
HeaderComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "15.2.9", ngImport: i0, type: HeaderComponent, deps: [], target: i0.ɵɵFactoryTarget.Component });
HeaderComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "15.2.9", type: HeaderComponent, selector: "shared-header", inputs: { title: "title", subTitle: "subTitle", description: "description", image: "image", small: "small" }, ngImport: i0, template: "<section class=\"home_banner_area\" [ngStyle]=\"{'background-image': image ? ' url(assets/' + image + ')' : '', 'color': '#ff0000'}\">\n  <div class=\"banner_inner\" [ngClass]=\"{'dark-bg': image}\">\n    <div class=\"container\">\n      <div class=\"row\">\n        <div class=\"col-lg-3 text-right\">\n          <div class=\"home_left_img mb-14\">\n            <img class=\"img-fluid\"  src=\"assets/images/banner/logo.png\" [alt]=\"title\">\n          </div>\n        </div>\n        <div class=\"col-lg-9\" style=\"margin-top: 45px\">\n          <div class=\"banner_content\">\n            <div *ngIf=\"subTitle\" class=\"sub-title\">{{subTitle}}</div>\n            <h1>\n              {{title}}\n            </h1>\n            <p class=\"description\" *ngIf=\"description\">\n              {{description}}\n            </p>\n          </div>\n        </div>\n      </div>\n    </div>\n  </div>\n</section>\n", styles: [".description{height:83px;overflow:hidden;line-height:20px;font-size:14px}.dark-bg{background-color:#0000008c}.mb-14{margin-bottom:14px}\n"], dependencies: [{ kind: "directive", type: i1$3.NgClass, selector: "[ngClass]", inputs: ["class", "ngClass"] }, { kind: "directive", type: i1$3.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "directive", type: i1$3.NgStyle, selector: "[ngStyle]", inputs: ["ngStyle"] }] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "15.2.9", ngImport: i0, type: HeaderComponent, decorators: [{
            type: Component,
            args: [{ selector: 'shared-header', template: "<section class=\"home_banner_area\" [ngStyle]=\"{'background-image': image ? ' url(assets/' + image + ')' : '', 'color': '#ff0000'}\">\n  <div class=\"banner_inner\" [ngClass]=\"{'dark-bg': image}\">\n    <div class=\"container\">\n      <div class=\"row\">\n        <div class=\"col-lg-3 text-right\">\n          <div class=\"home_left_img mb-14\">\n            <img class=\"img-fluid\"  src=\"assets/images/banner/logo.png\" [alt]=\"title\">\n          </div>\n        </div>\n        <div class=\"col-lg-9\" style=\"margin-top: 45px\">\n          <div class=\"banner_content\">\n            <div *ngIf=\"subTitle\" class=\"sub-title\">{{subTitle}}</div>\n            <h1>\n              {{title}}\n            </h1>\n            <p class=\"description\" *ngIf=\"description\">\n              {{description}}\n            </p>\n          </div>\n        </div>\n      </div>\n    </div>\n  </div>\n</section>\n", styles: [".description{height:83px;overflow:hidden;line-height:20px;font-size:14px}.dark-bg{background-color:#0000008c}.mb-14{margin-bottom:14px}\n"] }]
        }], ctorParameters: function () { return []; }, propDecorators: { title: [{
                type: Input
            }], subTitle: [{
                type: Input
            }], description: [{
                type: Input
            }], image: [{
                type: Input
            }], small: [{
                type: Input
            }] } });

class HeaderModule {
}
HeaderModule.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "15.2.9", ngImport: i0, type: HeaderModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule });
HeaderModule.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "15.2.9", ngImport: i0, type: HeaderModule, declarations: [HeaderComponent], imports: [CommonModule], exports: [CommonModule,
        HeaderComponent] });
HeaderModule.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "15.2.9", ngImport: i0, type: HeaderModule, imports: [CommonModule, CommonModule] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "15.2.9", ngImport: i0, type: HeaderModule, decorators: [{
            type: NgModule,
            args: [{
                    declarations: [HeaderComponent],
                    imports: [
                        CommonModule
                    ],
                    exports: [
                        CommonModule,
                        HeaderComponent
                    ]
                }]
        }] });

class InputTagsComponent {
    constructor() {
        this.allTags = [
            { id: 1, title: 'Apple' },
            { id: 2, title: 'Lemon' },
            { id: 3, title: 'Lime' },
            { id: 4, title: 'Orange' },
            { id: 5, title: 'Strawberry' }
        ];
        this.tags = [{ id: 2, title: 'Lemon' }];
    }
    ngOnInit() {
    }
    changedText(tags) {
    }
    changedList(tags) {
    }
}
InputTagsComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "15.2.9", ngImport: i0, type: InputTagsComponent, deps: [], target: i0.ɵɵFactoryTarget.Component });
InputTagsComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "15.2.9", type: InputTagsComponent, selector: "shared-input-tags", ngImport: i0, template: "<ng-container *ngIf=\"allTags && allTags.length\">\n  <shared-chips-input\n    [title]=\"'Tags'\"\n    [items]=\"allTags\"\n    [selectedItems]=\"tags\"\n    (changedText)=\"changedText($event)\"\n    (changedList)=\"changedList($event)\"></shared-chips-input>\n</ng-container>\n", styles: [""], dependencies: [{ kind: "directive", type: i1$3.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "component", type: ChipsInputComponent, selector: "shared-chips-input", inputs: ["title", "items", "selectedItems"], outputs: ["changedList", "changedText"] }] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "15.2.9", ngImport: i0, type: InputTagsComponent, decorators: [{
            type: Component,
            args: [{ selector: 'shared-input-tags', template: "<ng-container *ngIf=\"allTags && allTags.length\">\n  <shared-chips-input\n    [title]=\"'Tags'\"\n    [items]=\"allTags\"\n    [selectedItems]=\"tags\"\n    (changedText)=\"changedText($event)\"\n    (changedList)=\"changedList($event)\"></shared-chips-input>\n</ng-container>\n" }]
        }], ctorParameters: function () { return []; } });

class InputTagsModule {
}
InputTagsModule.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "15.2.9", ngImport: i0, type: InputTagsModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule });
InputTagsModule.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "15.2.9", ngImport: i0, type: InputTagsModule, declarations: [InputTagsComponent], imports: [CommonModule,
        ChipsInputModule], exports: [InputTagsComponent] });
InputTagsModule.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "15.2.9", ngImport: i0, type: InputTagsModule, imports: [CommonModule,
        ChipsInputModule] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "15.2.9", ngImport: i0, type: InputTagsModule, decorators: [{
            type: NgModule,
            args: [{
                    declarations: [InputTagsComponent],
                    exports: [InputTagsComponent],
                    imports: [
                        CommonModule,
                        ChipsInputModule
                    ]
                }]
        }] });

class PaginationComponent {
    constructor() {
        this.pages = [];
    }
    ngOnInit() {
    }
    ngOnChanges(changes) {
        if (changes.page || changes.count) {
            this.preparePages();
        }
    }
    preparePages() {
        this.pages = [];
        let pageNumber = 0;
        if (this.count > 0 && this.perPage > 0) {
            pageNumber = Math.ceil(this.count / this.perPage);
        }
        const templatePages = [1, pageNumber, Number(this.page) - 3, Number(this.page) - 2, Number(this.page) - 1, Number(this.page), Number(this.page) + 1, Number(this.page) + 2, Number(this.page) + 3];
        let addedDots = false;
        for (let i = 1; i <= pageNumber; i++) {
            if (templatePages.includes(i)) {
                this.pages.push(i);
                addedDots = false;
            }
            else if (!addedDots) {
                this.pages.push(0);
                addedDots = true;
            }
        }
    }
}
PaginationComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "15.2.9", ngImport: i0, type: PaginationComponent, deps: [], target: i0.ɵɵFactoryTarget.Component });
PaginationComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "15.2.9", type: PaginationComponent, selector: "shared-pagination", inputs: { count: "count", perPage: "perPage", page: "page", url: "url" }, usesOnChanges: true, ngImport: i0, template: "<nav aria-label=\"\u041F\u0430\u0433\u0438\u043D\u0430\u0446\u0438\u044F\">\n  <ul class=\"pagination\">\n    <li *ngFor=\"let pageIndex of pages\" class=\"page-item\">\n      <a *ngIf=\"pageIndex !== 0 && page !== pageIndex\" class=\"page-link\" [routerLink]=\"[url]\"\n         [queryParams]=\"{p: pageIndex}\">{{pageIndex}}</a>\n      <span *ngIf=\"pageIndex === 0\" class=\"page-link\">...</span>\n      <span *ngIf=\"page === pageIndex\" class=\"page-link active-page\">{{pageIndex}}</span>\n    </li>\n  </ul>\n</nav>\n", styles: [".page-link{border:1px solid rgba(222,226,230,.368627451)}.page-link.active-page,.page-link.active-page:hover{background:#1fc6b6;color:#fff!important;-webkit-text-fill-color:white!important}.page-link:hover{background:-webkit-linear-gradient(131deg,#11736a 0%,#1fc6b6 99%);-webkit-background-clip:text;-webkit-text-fill-color:transparent;text-decoration:none;transition:.5s}.page-item span{color:#666!important;cursor:default}\n"], dependencies: [{ kind: "directive", type: i1$3.NgForOf, selector: "[ngFor][ngForOf]", inputs: ["ngForOf", "ngForTrackBy", "ngForTemplate"] }, { kind: "directive", type: i1$3.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "directive", type: i2.RouterLink, selector: "[routerLink]", inputs: ["target", "queryParams", "fragment", "queryParamsHandling", "state", "relativeTo", "preserveFragment", "skipLocationChange", "replaceUrl", "routerLink"] }], changeDetection: i0.ChangeDetectionStrategy.OnPush });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "15.2.9", ngImport: i0, type: PaginationComponent, decorators: [{
            type: Component,
            args: [{ selector: 'shared-pagination', changeDetection: ChangeDetectionStrategy.OnPush, template: "<nav aria-label=\"\u041F\u0430\u0433\u0438\u043D\u0430\u0446\u0438\u044F\">\n  <ul class=\"pagination\">\n    <li *ngFor=\"let pageIndex of pages\" class=\"page-item\">\n      <a *ngIf=\"pageIndex !== 0 && page !== pageIndex\" class=\"page-link\" [routerLink]=\"[url]\"\n         [queryParams]=\"{p: pageIndex}\">{{pageIndex}}</a>\n      <span *ngIf=\"pageIndex === 0\" class=\"page-link\">...</span>\n      <span *ngIf=\"page === pageIndex\" class=\"page-link active-page\">{{pageIndex}}</span>\n    </li>\n  </ul>\n</nav>\n", styles: [".page-link{border:1px solid rgba(222,226,230,.368627451)}.page-link.active-page,.page-link.active-page:hover{background:#1fc6b6;color:#fff!important;-webkit-text-fill-color:white!important}.page-link:hover{background:-webkit-linear-gradient(131deg,#11736a 0%,#1fc6b6 99%);-webkit-background-clip:text;-webkit-text-fill-color:transparent;text-decoration:none;transition:.5s}.page-item span{color:#666!important;cursor:default}\n"] }]
        }], ctorParameters: function () { return []; }, propDecorators: { count: [{
                type: Input
            }], perPage: [{
                type: Input
            }], page: [{
                type: Input
            }], url: [{
                type: Input
            }] } });

class PaginationModule {
}
PaginationModule.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "15.2.9", ngImport: i0, type: PaginationModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule });
PaginationModule.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "15.2.9", ngImport: i0, type: PaginationModule, declarations: [PaginationComponent], imports: [CommonModule,
        RouterModule], exports: [CommonModule,
        PaginationComponent] });
PaginationModule.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "15.2.9", ngImport: i0, type: PaginationModule, imports: [CommonModule,
        RouterModule, CommonModule] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "15.2.9", ngImport: i0, type: PaginationModule, decorators: [{
            type: NgModule,
            args: [{
                    declarations: [PaginationComponent],
                    imports: [
                        CommonModule,
                        RouterModule
                    ],
                    exports: [
                        CommonModule,
                        PaginationComponent
                    ]
                }]
        }] });

const defaultStickySidebarOptions = {
    topSpacing: 0,
    bottomSpacing: 0,
    stickyClass: 'is-affixed',
    resizeSensor: true,
    minWidth: false,
    containerSelector: '.container',
    containerForWidth: false
};
const STICKY_SIDEBAR_OPTIONS = new InjectionToken('STICKY_SIDEBAR_OPTIONS');
class StickySidebarDirective {
    constructor(element, _options, zone, renderer, platform) {
        this.element = element;
        this._options = _options;
        this.zone = zone;
        this.renderer = renderer;
        this.platform = platform;
        this.affixedType = 'STATIC';
        this.direction = 'down';
        this.support = {
            transform: false,
            transform3d: false
        };
        this._initialized = false;
        this._reStyle = false;
        this._breakpoint = false;
        // Dimensions of sidebar, container and screen viewport.
        this.dimensions = {
            translateY: 0,
            maxTranslateY: 0,
            topSpacing: 0,
            lastTopSpacing: 0,
            bottomSpacing: 0,
            lastBottomSpacing: 0,
            sidebarHeight: 0,
            sidebarWidth: 0,
            containerTop: 0,
            containerHeight: 0,
            containerBottom: 0,
            viewportHeight: 0,
            viewportTop: 0,
            lastViewportTop: 0,
            sidebarLeft: 0,
            viewportBottom: 0,
            viewportLeft: 0
        };
        this.lastScrollTop = 0;
        this.resize = new Subject();
        this.options = _options && { ...defaultStickySidebarOptions, ..._options } || defaultStickySidebarOptions;
        if (isPlatformBrowser(platform)) {
            this.sidebarEl = this.element.nativeElement;
            this._setSupportFeatures();
            this.bindEvents();
        }
    }
    static offsetRelative(element) {
        const result = { left: 0, top: 0 };
        let el = element;
        do {
            const offsetTop = el.offsetTop;
            const offsetLeft = el.offsetLeft;
            if (!isNaN(offsetTop))
                result.top += offsetTop;
            if (!isNaN(offsetLeft))
                result.left += offsetLeft;
            el =
                'BODY' === element.tagName
                    ? el.parentElement
                    : el.offsetParent;
        } while (el);
        return result;
    }
    ngOnInit() {
    }
    bindEvents() {
        // this.resizeDetector = elementResizeDetectorMaker();
        this.zone.runOutsideAngular(() => {
            this.eventSub = merge(fromEvent(window, 'scroll'), fromEvent(window, 'resize')).subscribe(evt => {
                if (evt.type === 'scroll') {
                    const scrollTop = this.getScrollTop();
                    this.scrollDirection = scrollTop > this.lastScrollTop ? 'down' : 'top';
                    this.lastScrollTop = scrollTop;
                }
                this.updateSticky(evt);
            });
        });
    }
    ngOnDestroy() {
        if (!isPlatformBrowser(this.platform))
            return;
        if (this.eventSub)
            this.eventSub.unsubscribe();
        if (this.sidebarInner && this.sidebarInner.nativeElement)
            this.removeResizeEventListener(this.sidebarInner.nativeElement);
        if (this.container)
            this.removeResizeEventListener(this.container);
    }
    ngAfterContentInit() {
        if (!isPlatformBrowser(this.platform))
            return;
        if (this.options.containerSelector) {
            let containers = document.querySelectorAll(this.options.containerSelector);
            containers = Array.prototype.slice.call(containers);
            containers.forEach((container, item) => {
                if (!container.contains(this.element.nativeElement))
                    return;
                this.container = container;
            });
            if (!containers.length)
                throw new Error('The container does not contains on the sidebar.');
        }
        if (this.options.containerForWidth) {
            let containersForWidth = document.querySelectorAll(this.options.containerForWidth);
            containersForWidth = Array.prototype.slice.call(containersForWidth);
            containersForWidth.forEach((containerW, item) => {
                if (!containerW.contains(this.element.nativeElement))
                    return;
                this.containerForWidth = containerW;
            });
            if (!containersForWidth.length)
                throw new Error('The container does not contains on the sidebar.');
        }
        this._widthBreakpoint();
        this.calcDimensions();
        this.stickyPosition();
        this._updateStickyListener = this.handleResizeEvent.bind(this);
        this.addResizeEventListener(this.sidebarInner.nativeElement, this._updateStickyListener);
        this.addResizeEventListener(this.container, this._updateStickyListener);
        this.zone.runOutsideAngular(() => {
            this.eventSub.add(this.resize.subscribe((evt) => {
                this.updateSticky(evt);
            }));
        });
    }
    handleResizeEvent(evt) {
        this.direction = 'down';
        this.resize.next(evt);
    }
    addResizeEventListener(element, handler) {
        // this.resizeDetector.listenTo(element, handler);
    }
    removeResizeEventListener(element) {
        // if (this.resizeDetector)
        //  this.resizeDetector.uninstall(element);
    }
    calcDimensions() {
        if (this._breakpoint)
            return;
        const dims = this.dimensions;
        // Container of sticky sidebar dimensions.
        dims.containerTop = StickySidebarDirective.offsetRelative(this.container).top;
        dims.containerHeight = this.container.clientHeight;
        dims.containerBottom = dims.containerTop + dims.containerHeight;
        // Sidebar dimensions.
        dims.sidebarHeight = this.sidebarInner.nativeElement.offsetHeight;
        dims.sidebarWidth = this.options.containerForWidth ? this.containerForWidth.offsetWidth : this.sidebarInner.nativeElement.offsetWidth;
        // Screen viewport dimensions.
        dims.viewportHeight = window.innerHeight;
        // Maximum sidebar translate Y.
        dims.maxTranslateY = dims.containerHeight - dims.sidebarHeight;
        this._calcDimensionsWithScroll();
    }
    _calcDimensionsWithScroll() {
        const dims = this.dimensions;
        dims.sidebarLeft = StickySidebarDirective.offsetRelative(this.sidebarEl).left;
        dims.viewportTop = this.getScrollTop();
        dims.viewportBottom = dims.viewportTop + dims.viewportHeight;
        dims.viewportLeft = document.documentElement.scrollLeft || document.body.scrollLeft;
        dims.topSpacing = this.options.topSpacing;
        dims.bottomSpacing = this.options.bottomSpacing;
        if ('VIEWPORT-TOP' === this.affixedType) {
            if (dims.topSpacing < dims.lastTopSpacing) {
                dims.translateY += dims.lastTopSpacing - dims.topSpacing;
                this._reStyle = true;
            }
        }
        else if ('VIEWPORT-BOTTOM' === this.affixedType) {
            // Adjust translate Y in the case decrease bottom spacing value.
            if (dims.bottomSpacing < dims.lastBottomSpacing) {
                dims.translateY += dims.lastBottomSpacing - dims.bottomSpacing;
                this._reStyle = true;
            }
        }
        dims.lastTopSpacing = dims.topSpacing;
        dims.lastBottomSpacing = dims.bottomSpacing;
    }
    isSidebarFitsViewport() {
        const dims = this.dimensions;
        const offset = this.scrollDirection === 'down' ? dims.lastBottomSpacing : dims.lastTopSpacing;
        return this.dimensions.sidebarHeight + offset < this.dimensions.viewportHeight;
    }
    observeScrollDir() {
        const dims = this.dimensions;
        if (dims.lastViewportTop === dims.viewportTop)
            return;
        const furthest = 'down' === this.direction ? Math.min : Math.max;
        if (dims.viewportTop === furthest(dims.viewportTop, dims.lastViewportTop))
            this.direction = 'down' === this.direction ? 'up' : 'down';
    }
    getAffixType() {
        this._calcDimensionsWithScroll();
        const dims = this.dimensions;
        const colliderTop = dims.viewportTop + dims.topSpacing;
        let affixType = this.affixedType;
        if (colliderTop <= dims.containerTop || dims.containerHeight <= dims.sidebarHeight) {
            dims.translateY = 0;
            affixType = 'STATIC';
        }
        else {
            affixType =
                'up' === this.direction
                    ? this._getAffixTypeScrollingUp()
                    : this._getAffixTypeScrollingDown();
        }
        dims.translateY = Math.max(0, dims.translateY);
        dims.translateY = Math.min(dims.containerHeight, dims.translateY);
        dims.translateY = Math.round(dims.translateY);
        dims.lastViewportTop = dims.viewportTop;
        return affixType;
    }
    _getAffixTypeScrollingDown() {
        const dims = this.dimensions;
        const sidebarBottom = dims.sidebarHeight + dims.containerTop;
        const colliderTop = dims.viewportTop + dims.topSpacing;
        const colliderBottom = dims.viewportBottom - dims.bottomSpacing;
        let affixType = this.affixedType;
        if (this.isSidebarFitsViewport()) {
            if (dims.sidebarHeight + colliderTop >= dims.containerBottom) {
                dims.translateY = dims.containerBottom - sidebarBottom;
                affixType = 'CONTAINER-BOTTOM';
            }
            else if (colliderTop >= dims.containerTop) {
                dims.translateY = colliderTop - dims.containerTop;
                affixType = 'VIEWPORT-TOP';
            }
        }
        else {
            if (dims.containerBottom <= colliderBottom) {
                dims.translateY = dims.containerBottom - sidebarBottom;
                affixType = 'CONTAINER-BOTTOM';
            }
            else if (sidebarBottom + dims.translateY <= colliderBottom) {
                dims.translateY = colliderBottom - sidebarBottom;
                affixType = 'VIEWPORT-BOTTOM';
            }
            else if (dims.containerTop + dims.translateY <= colliderTop &&
                (0 !== dims.translateY && dims.maxTranslateY !== dims.translateY)) {
                affixType = 'VIEWPORT-UNBOTTOM';
            }
        }
        return affixType;
    }
    _getAffixTypeScrollingUp() {
        const dims = this.dimensions;
        const sidebarBottom = dims.sidebarHeight + dims.containerTop;
        const colliderTop = dims.viewportTop + dims.topSpacing;
        const colliderBottom = dims.viewportBottom - dims.bottomSpacing;
        let affixType = this.affixedType;
        if (colliderTop <= dims.translateY + dims.containerTop) {
            dims.translateY = colliderTop - dims.containerTop;
            affixType = 'VIEWPORT-TOP';
        }
        else if (dims.containerBottom <= colliderBottom) {
            dims.translateY = dims.containerBottom - sidebarBottom;
            affixType = 'CONTAINER-BOTTOM';
        }
        else if (!this.isSidebarFitsViewport()) {
            if (dims.containerTop <= colliderTop &&
                (0 !== dims.translateY && dims.maxTranslateY !== dims.translateY)) {
                affixType = 'VIEWPORT-UNBOTTOM';
            }
        }
        return affixType;
    }
    _getStyle(affixType) {
        if ('undefined' === typeof affixType)
            return;
        const style = { inner: {}, outer: {} };
        const dims = this.dimensions;
        switch (affixType) {
            case 'VIEWPORT-TOP':
                style.inner = {
                    position: 'fixed',
                    top: dims.topSpacing,
                    left: dims.sidebarLeft - dims.viewportLeft,
                    width: dims.sidebarWidth
                };
                break;
            case 'VIEWPORT-BOTTOM':
                style.inner = {
                    position: 'fixed',
                    top: 'auto',
                    left: dims.sidebarLeft,
                    bottom: dims.bottomSpacing,
                    width: dims.sidebarWidth
                };
                break;
            case 'CONTAINER-BOTTOM':
            case 'VIEWPORT-UNBOTTOM':
                const translate = this._getTranslate('0', dims.translateY + 'px');
                if (translate)
                    style.inner = { transform: translate };
                else
                    style.inner = { position: 'absolute', top: dims.translateY, width: dims.sidebarWidth };
                break;
        }
        switch (affixType) {
            case 'VIEWPORT-TOP':
            case 'VIEWPORT-BOTTOM':
            case 'VIEWPORT-UNBOTTOM':
            case 'CONTAINER-BOTTOM':
                style.outer = { height: dims.sidebarHeight, position: 'relative' };
                break;
        }
        style.outer = { height: '', position: '', ...style.outer };
        style.inner = {
            position: 'relative',
            top: '',
            left: '',
            bottom: '',
            width: '',
            transform: '',
            ...style.inner
        };
        return style;
    }
    stickyPosition(force = false) {
        if (this._breakpoint)
            return;
        force = this._reStyle || force || false;
        const offsetTop = this.options.topSpacing;
        const offsetBottom = this.options.bottomSpacing;
        const affixType = this.getAffixType();
        const style = this._getStyle(affixType);
        const innerEl = this.sidebarInner.nativeElement;
        if ((this.affixedType !== affixType || force) && affixType) {
            //const affixEvent = 'affix.' + affixType.toLowerCase().replace('viewport-', '') + StickySidebarDirective.EVENT_KEY;
            //StickySidebar.eventTrigger(this.sidebar, affixEvent);
            if ('STATIC' === affixType)
                this.renderer.removeClass(this.sidebarEl, this.options.stickyClass);
            else
                this.renderer.addClass(this.sidebarEl, this.options.stickyClass);
            Object.keys(style.outer).forEach(key => {
                const unit = 'number' === typeof style.outer[key] ? 'px' : '';
                this.sidebarEl.style[key] = style.outer[key] + unit;
            });
            Object.keys(style.inner).forEach(key => {
                const unit = 'number' === typeof style.inner[key] ? 'px' : '';
                innerEl.style[key] = style.inner[key] + unit;
            });
            //const affixedEvent = 'affixed.'+ affixType.toLowerCase().replace('viewport-', '') + EVENT_KEY;
            //StickySidebar.eventTrigger(this.sidebar, affixedEvent);
        }
        else {
            if (this._initialized)
                innerEl.style.left = style.inner['left'];
        }
        this.affixedType = affixType;
    }
    _widthBreakpoint() {
        if (window.innerWidth <= this.options.minWidth) {
            this._breakpoint = true;
            this.affixedType = 'STATIC';
            this.renderer.removeAttribute(this.sidebarEl, 'style');
            this.renderer.removeAttribute(this.sidebarInner.nativeElement, 'style');
            this.renderer.removeClass(this.sidebarEl, this.options.stickyClass);
        }
        else {
            this._breakpoint = false;
        }
    }
    updateSticky(event) {
        if (this._running)
            return;
        this._running = true;
        (eventType => {
            requestAnimationFrame(() => {
                switch (eventType) {
                    case 'scroll':
                        this._calcDimensionsWithScroll();
                        this.observeScrollDir();
                        this.stickyPosition();
                        break;
                    // When browser is resizing or there's no event, observe width
                    // breakpoint and re-calculate dimensions.
                    case 'resize':
                    default:
                        this._widthBreakpoint();
                        this.calcDimensions();
                        this.stickyPosition(true);
                        break;
                }
                this._running = false;
            });
        })(event.type);
    }
    _setSupportFeatures() {
        const support = this.support;
        support.transform = this.supportTransform();
        support.transform3d = this.supportTransform(true);
    }
    _getTranslate(y = '0', x = '0', z = '0') {
        if (this.support.transform3d)
            return 'translate3d(' + y + ', ' + x + ', ' + z + ')';
        else if (this.support.transform)
            return 'translate(' + y + ', ' + x + ')';
        else
            return false;
    }
    supportTransform(transform3d = false) {
        let result = null;
        const property = transform3d ? 'perspective' : 'transform', upper = property.charAt(0).toUpperCase() + property.slice(1), prefixes = ['Webkit', 'Moz', 'O', 'ms'], support = document.createElement('support'), style = support.style;
        (property + ' ' + prefixes.join(upper + ' ') + upper).split(' ').forEach(function (property, i) {
            if (style[property] !== undefined) {
                result = property;
                return false;
            }
        });
        return result;
    }
    getScrollTop() {
        return document.documentElement.scrollTop || document.body.scrollTop || document.documentElement.offsetTop * -1;
    }
}
StickySidebarDirective.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "15.2.9", ngImport: i0, type: StickySidebarDirective, deps: [{ token: i0.ElementRef }, { token: STICKY_SIDEBAR_OPTIONS, optional: true }, { token: i0.NgZone }, { token: i0.Renderer2 }, { token: PLATFORM_ID }], target: i0.ɵɵFactoryTarget.Directive });
StickySidebarDirective.ɵdir = i0.ɵɵngDeclareDirective({ minVersion: "14.0.0", version: "15.2.9", type: StickySidebarDirective, selector: "[wtStickySidebar]", queries: [{ propertyName: "sidebarInner", first: true, predicate: i0.forwardRef(function () { return StickySidebarInnerDirective; }), descendants: true, read: ElementRef, static: true }], ngImport: i0 });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "15.2.9", ngImport: i0, type: StickySidebarDirective, decorators: [{
            type: Directive,
            args: [{
                    selector: '[wtStickySidebar]'
                }]
        }], ctorParameters: function () { return [{ type: i0.ElementRef }, { type: undefined, decorators: [{
                    type: Optional
                }, {
                    type: Inject,
                    args: [STICKY_SIDEBAR_OPTIONS]
                }] }, { type: i0.NgZone }, { type: i0.Renderer2 }, { type: i1$7.Platform, decorators: [{
                    type: Inject,
                    args: [PLATFORM_ID]
                }] }]; }, propDecorators: { sidebarInner: [{
                type: ContentChild,
                args: [forwardRef(() => StickySidebarInnerDirective), { static: true, read: ElementRef }]
            }] } });
class StickySidebarInnerDirective {
    constructor() {
    }
}
StickySidebarInnerDirective.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "15.2.9", ngImport: i0, type: StickySidebarInnerDirective, deps: [], target: i0.ɵɵFactoryTarget.Directive });
StickySidebarInnerDirective.ɵdir = i0.ɵɵngDeclareDirective({ minVersion: "14.0.0", version: "15.2.9", type: StickySidebarInnerDirective, selector: "[wtStickySidebarInner]", ngImport: i0 });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "15.2.9", ngImport: i0, type: StickySidebarInnerDirective, decorators: [{
            type: Directive,
            args: [{
                    selector: '[wtStickySidebarInner]'
                }]
        }], ctorParameters: function () { return []; } });

class StickySidebarModule {
    static withOptions(options) {
        return {
            ngModule: StickySidebarModule,
            providers: [
                {
                    provide: STICKY_SIDEBAR_OPTIONS,
                    useValue: options
                }
            ]
        };
    }
}
StickySidebarModule.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "15.2.9", ngImport: i0, type: StickySidebarModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule });
StickySidebarModule.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "15.2.9", ngImport: i0, type: StickySidebarModule, declarations: [StickySidebarDirective, StickySidebarInnerDirective], imports: [CommonModule], exports: [StickySidebarDirective, StickySidebarInnerDirective] });
StickySidebarModule.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "15.2.9", ngImport: i0, type: StickySidebarModule, imports: [CommonModule] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "15.2.9", ngImport: i0, type: StickySidebarModule, decorators: [{
            type: NgModule,
            args: [{
                    declarations: [StickySidebarDirective, StickySidebarInnerDirective],
                    imports: [
                        CommonModule
                    ],
                    exports: [StickySidebarDirective, StickySidebarInnerDirective]
                }]
        }] });

class TagCloudComponent {
    constructor() {
        this.loaded = false;
        this.trackByFn = trackById;
    }
    ngOnInit() {
        /*this.tagsFacade.loadTags();
        this.getTags$ = this.tagsFacade.getTags$.pipe(
          filter(items => !!items),
          tap(items => {
            if (items.length) {
              this.loaded = true;
            }
          })
        );*/
    }
    ngOnDestroy() {
    }
}
TagCloudComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "15.2.9", ngImport: i0, type: TagCloudComponent, deps: [], target: i0.ɵɵFactoryTarget.Component });
TagCloudComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "15.2.9", type: TagCloudComponent, selector: "shared-tag-cloud", ngImport: i0, template: "<ng-container *ngIf=\"getTags$ | async; let tags;\">\n<aside *ngIf=\"loaded\" class=\"single-sidebar-widget tag_cloud_widget\">\n  <h4 class=\"widget_title\">\u0422\u0435\u0433\u0438</h4>\n  <ul class=\"tag-list list\">\n    <li *ngFor=\"let tag of tags; trackBy: trackByFn\"><a [routerLink]=\"['/tag/' + tag.slug + '.html']\">{{tag.name}}</a></li>\n  </ul>\n</aside>\n</ng-container>\n<shared-spinner *ngIf=\"!loaded\" [diameter]=\"30\"></shared-spinner>\n", styles: [".tag-list li:nth-child(3n) a{margin-right:0!important}\n"], dependencies: [{ kind: "directive", type: i1$3.NgForOf, selector: "[ngFor][ngForOf]", inputs: ["ngForOf", "ngForTrackBy", "ngForTemplate"] }, { kind: "directive", type: i1$3.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "component", type: SpinnerComponent, selector: "shared-spinner", inputs: ["overlay", "diameter", "color", "position"] }, { kind: "directive", type: i2.RouterLink, selector: "[routerLink]", inputs: ["target", "queryParams", "fragment", "queryParamsHandling", "state", "relativeTo", "preserveFragment", "skipLocationChange", "replaceUrl", "routerLink"] }, { kind: "pipe", type: i1$3.AsyncPipe, name: "async" }], changeDetection: i0.ChangeDetectionStrategy.OnPush });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "15.2.9", ngImport: i0, type: TagCloudComponent, decorators: [{
            type: Component,
            args: [{ selector: 'shared-tag-cloud', changeDetection: ChangeDetectionStrategy.OnPush, template: "<ng-container *ngIf=\"getTags$ | async; let tags;\">\n<aside *ngIf=\"loaded\" class=\"single-sidebar-widget tag_cloud_widget\">\n  <h4 class=\"widget_title\">\u0422\u0435\u0433\u0438</h4>\n  <ul class=\"tag-list list\">\n    <li *ngFor=\"let tag of tags; trackBy: trackByFn\"><a [routerLink]=\"['/tag/' + tag.slug + '.html']\">{{tag.name}}</a></li>\n  </ul>\n</aside>\n</ng-container>\n<shared-spinner *ngIf=\"!loaded\" [diameter]=\"30\"></shared-spinner>\n", styles: [".tag-list li:nth-child(3n) a{margin-right:0!important}\n"] }]
        }], ctorParameters: function () { return []; } });

class TagCloudModule {
}
TagCloudModule.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "15.2.9", ngImport: i0, type: TagCloudModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule });
TagCloudModule.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "15.2.9", ngImport: i0, type: TagCloudModule, declarations: [TagCloudComponent], imports: [CommonModule,
        SharedSpinnerModule,
        RouterModule], exports: [TagCloudComponent] });
TagCloudModule.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "15.2.9", ngImport: i0, type: TagCloudModule, imports: [CommonModule,
        SharedSpinnerModule,
        RouterModule] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "15.2.9", ngImport: i0, type: TagCloudModule, decorators: [{
            type: NgModule,
            args: [{
                    declarations: [TagCloudComponent],
                    imports: [
                        CommonModule,
                        SharedSpinnerModule,
                        RouterModule
                    ],
                    exports: [TagCloudComponent]
                }]
        }] });

class SafePipe {
    constructor(sanitizer) {
        this.sanitizer = sanitizer;
    }
    transform(value, type) {
        switch (type) {
            case 'html':
                return this.sanitizer.bypassSecurityTrustHtml(value);
            case 'style':
                return this.sanitizer.bypassSecurityTrustStyle(value);
            case 'script':
                return this.sanitizer.bypassSecurityTrustScript(value);
            case 'url':
                return this.sanitizer.bypassSecurityTrustUrl(value);
            case 'resourceUrl':
                return this.sanitizer.bypassSecurityTrustResourceUrl(value);
            default:
                throw new Error(`Invalid safe type specified: ${type}`);
        }
    }
}
SafePipe.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "15.2.9", ngImport: i0, type: SafePipe, deps: [{ token: i1$5.DomSanitizer }], target: i0.ɵɵFactoryTarget.Pipe });
SafePipe.ɵpipe = i0.ɵɵngDeclarePipe({ minVersion: "14.0.0", version: "15.2.9", ngImport: i0, type: SafePipe, name: "safe" });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "15.2.9", ngImport: i0, type: SafePipe, decorators: [{
            type: Pipe,
            args: [{
                    name: 'safe'
                }]
        }], ctorParameters: function () { return [{ type: i1$5.DomSanitizer }]; } });

class TextWithLinkMoreComponent {
    constructor() {
        this.height = 300;
    }
    ngOnInit() {
        /*this.tagsFacade.loadTags();
        this.getTags$ = this.tagsFacade.getTags$.pipe(
          filter(items => !!items),
          tap(items => {
            if (items.length) {
              this.loaded = true;
            }
          })
        );*/
    }
    ngOnDestroy() {
    }
    toggle(textBlock) {
        textBlock.classList.toggle('open');
    }
}
TextWithLinkMoreComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "15.2.9", ngImport: i0, type: TextWithLinkMoreComponent, deps: [], target: i0.ɵɵFactoryTarget.Component });
TextWithLinkMoreComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "15.2.9", type: TextWithLinkMoreComponent, selector: "shared-text-with-link-more", inputs: { text: "text", height: "height" }, ngImport: i0, template: "<div class=\"text-block\" #textBlock>\n  <div class=\"text-block-inner\" [innerHTML]=\"text | safe : 'html'\"></div>\n  <div class=\"text-right open-text\">\n    <a (click)=\"toggle(textBlock)\">\u041F\u043E\u0434\u0440\u043E\u0431\u043D\u0435\u0435</a>\n  </div>\n  <div class=\"text-right close-text\">\n    <a (click)=\"toggle(textBlock)\">\u0417\u0430\u043A\u0440\u044B\u0442\u044C</a>\n  </div>\n</div>\n", styles: [".text-block .text-block-inner{overflow:hidden;position:relative;height:200px;transition:height .3s linear 0s}.text-block .text-block-inner:after{content:\"\";text-align:right;position:absolute;bottom:0;right:0;left:0;height:50px;background:linear-gradient(to bottom,rgba(255,255,255,0),white 100%);pointer-events:none}.text-block .open-text{display:block}.text-block .close-text{display:none}.text-block.open .text-block-inner{height:auto}.text-block.open .text-block-inner:after{background:transparent}.text-block.open .open-text{display:none}.text-block.open .close-text{display:block}.text-right a{cursor:pointer;color:#007bff;font-size:14px}\n"], dependencies: [{ kind: "pipe", type: SafePipe, name: "safe" }], changeDetection: i0.ChangeDetectionStrategy.OnPush });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "15.2.9", ngImport: i0, type: TextWithLinkMoreComponent, decorators: [{
            type: Component,
            args: [{ selector: 'shared-text-with-link-more', changeDetection: ChangeDetectionStrategy.OnPush, template: "<div class=\"text-block\" #textBlock>\n  <div class=\"text-block-inner\" [innerHTML]=\"text | safe : 'html'\"></div>\n  <div class=\"text-right open-text\">\n    <a (click)=\"toggle(textBlock)\">\u041F\u043E\u0434\u0440\u043E\u0431\u043D\u0435\u0435</a>\n  </div>\n  <div class=\"text-right close-text\">\n    <a (click)=\"toggle(textBlock)\">\u0417\u0430\u043A\u0440\u044B\u0442\u044C</a>\n  </div>\n</div>\n", styles: [".text-block .text-block-inner{overflow:hidden;position:relative;height:200px;transition:height .3s linear 0s}.text-block .text-block-inner:after{content:\"\";text-align:right;position:absolute;bottom:0;right:0;left:0;height:50px;background:linear-gradient(to bottom,rgba(255,255,255,0),white 100%);pointer-events:none}.text-block .open-text{display:block}.text-block .close-text{display:none}.text-block.open .text-block-inner{height:auto}.text-block.open .text-block-inner:after{background:transparent}.text-block.open .open-text{display:none}.text-block.open .close-text{display:block}.text-right a{cursor:pointer;color:#007bff;font-size:14px}\n"] }]
        }], ctorParameters: function () { return []; }, propDecorators: { text: [{
                type: Input
            }], height: [{
                type: Input
            }] } });

class CountFormatPipe {
    transform(value, ...args) {
        const numValue = +value;
        if (numValue) {
            let dop = '';
            let newValue = 0;
            if (numValue >= 1000000) {
                newValue = Math.trunc(numValue / 1000000);
                dop = 'm';
            }
            else if (numValue >= 1000) {
                newValue = Math.trunc(numValue / 1000);
                dop = 'k';
            }
            else {
                newValue = numValue;
            }
            return `${newValue}${dop}`;
        }
        return 0;
    }
}
CountFormatPipe.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "15.2.9", ngImport: i0, type: CountFormatPipe, deps: [], target: i0.ɵɵFactoryTarget.Pipe });
CountFormatPipe.ɵpipe = i0.ɵɵngDeclarePipe({ minVersion: "14.0.0", version: "15.2.9", ngImport: i0, type: CountFormatPipe, name: "countFormatPipe" });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "15.2.9", ngImport: i0, type: CountFormatPipe, decorators: [{
            type: Pipe,
            args: [{
                    name: 'countFormatPipe'
                }]
        }] });

class DateFormatPipe {
    transform(value, ...args) {
        if (value) {
            return moment(value).format('DD MMM, YYYY');
        }
        return null;
    }
}
DateFormatPipe.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "15.2.9", ngImport: i0, type: DateFormatPipe, deps: [], target: i0.ɵɵFactoryTarget.Pipe });
DateFormatPipe.ɵpipe = i0.ɵɵngDeclarePipe({ minVersion: "14.0.0", version: "15.2.9", ngImport: i0, type: DateFormatPipe, name: "dateFormatPipe" });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "15.2.9", ngImport: i0, type: DateFormatPipe, decorators: [{
            type: Pipe,
            args: [{
                    name: 'dateFormatPipe'
                }]
        }] });

class PhonePipe {
    transform(number) {
        // +99897 412 70 53
        /*
            number = number.charAt(0) !== '+' ? "+" + number : "" + number;
    
            let newStr = "";
            let i = 0;
    
            for (; i < Math.floor(number.length / 2) - 1; i++) {
              newStr = newStr + number.substr(i * 2, 2) + "-";
            }
        */
        return `+${number[0]}${number[1]}${number[2]} ${number[3]}${number[4]} ${number[5]}${number[6]}${number[7]}-${number[8]}${number[9]}-${number[10]}${number[11]}`;
    }
}
PhonePipe.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "15.2.9", ngImport: i0, type: PhonePipe, deps: [], target: i0.ɵɵFactoryTarget.Pipe });
PhonePipe.ɵpipe = i0.ɵɵngDeclarePipe({ minVersion: "14.0.0", version: "15.2.9", ngImport: i0, type: PhonePipe, name: "phoneFormat" });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "15.2.9", ngImport: i0, type: PhonePipe, decorators: [{
            type: Pipe,
            args: [{
                    name: 'phoneFormat'
                }]
        }] });

class PipesModule {
}
PipesModule.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "15.2.9", ngImport: i0, type: PipesModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule });
PipesModule.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "15.2.9", ngImport: i0, type: PipesModule, declarations: [SafePipe,
        CountFormatPipe,
        DateFormatPipe,
        PhonePipe], imports: [CommonModule], exports: [SafePipe,
        CountFormatPipe,
        DateFormatPipe,
        PhonePipe] });
PipesModule.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "15.2.9", ngImport: i0, type: PipesModule, imports: [CommonModule] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "15.2.9", ngImport: i0, type: PipesModule, decorators: [{
            type: NgModule,
            args: [{
                    declarations: [
                        SafePipe,
                        CountFormatPipe,
                        DateFormatPipe,
                        PhonePipe
                    ],
                    imports: [
                        CommonModule,
                    ],
                    exports: [
                        SafePipe,
                        CountFormatPipe,
                        DateFormatPipe,
                        PhonePipe
                    ],
                }]
        }] });

class TextWithLinkMoreModule {
}
TextWithLinkMoreModule.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "15.2.9", ngImport: i0, type: TextWithLinkMoreModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule });
TextWithLinkMoreModule.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "15.2.9", ngImport: i0, type: TextWithLinkMoreModule, declarations: [TextWithLinkMoreComponent], imports: [CommonModule,
        PipesModule], exports: [TextWithLinkMoreComponent] });
TextWithLinkMoreModule.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "15.2.9", ngImport: i0, type: TextWithLinkMoreModule, imports: [CommonModule,
        PipesModule] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "15.2.9", ngImport: i0, type: TextWithLinkMoreModule, decorators: [{
            type: NgModule,
            args: [{
                    declarations: [TextWithLinkMoreComponent],
                    imports: [
                        CommonModule,
                        PipesModule
                    ],
                    exports: [TextWithLinkMoreComponent]
                }]
        }] });

class HeadersInterceptor {
    constructor(authenticationService, routerFacade, usersFacade, formErrorsFacade, formsFacade, filesFacade, publicationMessagesFacade, requestsFacade, notificationsFacade, staticDataFacade) {
        this.authenticationService = authenticationService;
        this.routerFacade = routerFacade;
        this.usersFacade = usersFacade;
        this.formErrorsFacade = formErrorsFacade;
        this.formsFacade = formsFacade;
        this.filesFacade = filesFacade;
        this.publicationMessagesFacade = publicationMessagesFacade;
        this.requestsFacade = requestsFacade;
        this.notificationsFacade = notificationsFacade;
        this.staticDataFacade = staticDataFacade;
        this.modelAdapter = BaseModelAdapter.createInstance();
    }
    intercept(request, next) {
        return next.handle(request).pipe(tap((response) => {
            try {
                this.handlePublicationMessagesAndFiles(response);
                this.updateStaticData(response);
            }
            catch (e) {
                console.error('[ headers.interceptor ][ intercept.tap ]', e);
            }
        }), catchError((errResponse) => {
            console.error('[ headers.interceptor ][ catchError ]', errResponse);
            try {
                const userInfo = this.authenticationService.loadAuthDataFromLocalStore();
                this.updateRequestData(request.urlWithParams, request.method, errResponse.error.formErrors);
                const currentHost = this.getDomainByUrl(window.location.host);
                const requestDomain = this.getDomainByUrl(request.url);
                if (currentHost === requestDomain) {
                    if (errResponse.status === 401) {
                        return this.handle401Error(errResponse, userInfo, request, next);
                    }
                    if (errResponse.status === 422 && errResponse.error) {
                        if (errResponse.error.formErrors) {
                            this.checkErrors(errResponse.error.formErrors);
                        }
                        if (errResponse.error.formId) {
                            this.formsFacade.updateForm({
                                formId: errResponse.error.formId,
                                loading: false,
                                hasError: true,
                                isComplete: true,
                                error: errResponse.error.error,
                                code: errResponse.error.code
                            });
                        }
                        if (errResponse.error.data?.publicationResult) {
                            const { errors, warnings } = errResponse.error.data.publicationResult;
                            if (errors || warnings) {
                                this.checkPublishErrors(errors, warnings);
                            }
                        }
                    }
                    if (errResponse.status === 403) {
                        this.sendForbiddenError();
                    }
                }
                const error = (errResponse.error && errResponse.error.message) || errResponse.statusText;
                return throwError(error);
            }
            catch (e) {
                console.error('[ headers.interceptor ][ intercept ][ catchError ]', e);
            }
        }));
    }
    updateRequestData(url, httpMethod, error) {
        const urlParams = url.split('api/');
        const urlParams2 = urlParams[1].split('/');
        const endPointUrl = urlParams2[0];
        const secondEndPointUrl = urlParams2[1];
        const itemIdOrSlug = +urlParams2[2];
        this.requestsFacade.updateRequestData(endPointUrl, httpMethod.toLowerCase(), itemIdOrSlug, RequestStatus.LOADED, secondEndPointUrl, error);
    }
    updateStaticData(response) {
        try {
            if (response.body?.meta?.autoAction === 'update-static-data' && response.body.meta?.staticDataType) {
                if (response.body?.data?.id) {
                    this.staticDataFacade.updateSuccess(response.body.meta.staticDataType, response.body?.data?.id, response.body?.data);
                }
            }
        }
        catch (e) {
            console.error('[ headers.interceptor ][ intercept ][ updateStaticData ]', e);
        }
    }
    handlePublicationMessagesAndFiles(response) {
        try {
            let allPublicationMessages = [];
            let allFiles = [];
            if (response.body?.data?.length) {
                // publicationMessages
                response.body.data.filter(item => !!item.publicationMessages)
                    .forEach(item => {
                    const { entity, itemId } = item.publicationMessages[0];
                    // @ts-ignore
                    const result = this.modelAdapter.convertItems(FormErrorModel, item.publicationMessages);
                    allPublicationMessages = [...allPublicationMessages, ...result];
                    this.publicationMessagesFacade.deletePublicationMessages(entity, itemId);
                });
                // files
                response.body.data.filter(item => !!item.files)
                    .forEach(item => {
                    // @ts-ignore
                    const files = this.modelAdapter.convertItems(FileModel, item.files);
                    allFiles = [...allFiles, ...files];
                });
            }
            else if (response.body?.data) {
                const item = response.body.data;
                const meta = response.body.meta;
                if (response.body.data?.publicationMessages && meta.staticDataType && meta.itemId) {
                    this.publicationMessagesFacade.deletePublicationMessages(meta.staticDataType, meta.itemId);
                }
                if (response.body.data?.publicationMessages?.length) {
                    // @ts-ignore
                    const result = this.modelAdapter.convertItems(FormErrorModel, item.publicationMessages);
                    allPublicationMessages = [...allPublicationMessages, ...result];
                }
                if (response.body.data?.files?.length) {
                    // @ts-ignore
                    const files = this.modelAdapter.convertItems(FileModel, item.files);
                    allFiles = [...allFiles, ...files];
                }
            }
            if (allPublicationMessages?.length) {
                this.checkPublicationMessages(allPublicationMessages);
            }
            if (allFiles?.length) {
                this.filesFacade.filesLoadSuccess(allFiles);
            }
        }
        catch (e) {
            console.error('[ headers.interceptor ][ intercept ][ handlePublicationMessagesAndFiles ]', e);
        }
    }
    getDomainByUrl(url, subdomain = false) {
        let newUrl = url.replace(/(https?:\/\/)?(www.)?/i, '');
        if (subdomain) {
            const urlParams = newUrl.split('.');
            newUrl = urlParams.slice(url.length - 2).join('.');
        }
        if (newUrl.indexOf('/') !== -1) {
            newUrl = newUrl.split('/')[0];
        }
        const urlParams = newUrl.split(':');
        return urlParams[0];
    }
    handle401Error(err, userInfo, request, next) {
        console.error('[ header.interceptor ][ handle401Error ]', userInfo);
        if (err.error.error === 'refresh-token-fail' ||
            (err.error.data &&
                (err.error.data.responseStatus || err.error.data.error) &&
                (err.error.data.responseStatus === MainConst.responseStatus.tokenNotFound ||
                    err.error.data.error === MainConst.responseStatus.tokenNotFound)) ||
            (err.error &&
                (err.error.responseStatus || err.error.error) &&
                (err.error.responseStatus === MainConst.responseStatus.tokenNotFound ||
                    err.error.error === MainConst.responseStatus.tokenNotFound))
            || !userInfo.token
            || !userInfo.refreshToken) {
            console.error('handle401Error ++');
            this.authenticationService.clearData();
            this.routerFacade.goTo(['/auth'], {
                queryParams: {
                    redirectTo: document.location.pathname
                }
            });
            return EMPTY; // this.goToAuth(next);
        }
        else {
            console.error('handle401Error --');
            this.usersFacade.refreshToken(userInfo.refreshToken);
            return this.reSendQuery(request, next);
        }
    }
    checkPublicationMessages(messages) {
        this.publicationMessagesFacade.savePublicationMessages(messages);
    }
    checkPublishErrors(errors, warnings) {
        let publishErrors = [];
        if (errors && Array.isArray(errors)) {
            publishErrors = [...errors];
        }
        if (warnings && Array.isArray(warnings)) {
            publishErrors = [...publishErrors, ...warnings];
        }
        if (publishErrors) {
            const { entity, itemId } = publishErrors[0];
            this.publicationMessagesFacade.deletePublicationMessages(entity, itemId);
            this.publicationMessagesFacade.savePublicationMessages(publishErrors);
            this.publicationMessagesFacade.publishPostFail();
        }
    }
    checkErrors(error) {
        let list = [];
        if (Array.isArray(error)) {
            list = error;
        }
        else if (typeof error === 'object') {
            list = Object.values(error);
        }
        list.forEach(errorItem => {
            const { formId, form_id, field, message, errorMessage, errorCode } = errorItem;
            const formError = {
                formId: formId || form_id,
                field,
                message: message || errorMessage,
                code: errorCode || error
            };
            if (formError.formId) {
                this.formErrorsFacade.saveError(formError);
            }
        });
    }
    reSendQuery(request, next) {
        return this.usersFacade.getUser$
            .pipe(filter(item => item && item.loaded), switchMap$1((data) => {
            const newRequest = request.clone({ headers: request.headers.set('Authorization', `JWT ${data.token}`) });
            return next.handle(newRequest);
        }));
    }
    sendForbiddenError() {
        this.notificationsFacade.showForbiddenError();
    }
}
HeadersInterceptor.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "15.2.9", ngImport: i0, type: HeadersInterceptor, deps: [{ token: AuthenticationService }, { token: RouterFacade }, { token: UsersFacade }, { token: FormErrorsFacade }, { token: FormsFacade }, { token: FilesFacade }, { token: PublicationMessagesFacade }, { token: RequestsFacade }, { token: NotificationsFacade }, { token: StaticDataFacade }], target: i0.ɵɵFactoryTarget.Injectable });
HeadersInterceptor.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "15.2.9", ngImport: i0, type: HeadersInterceptor });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "15.2.9", ngImport: i0, type: HeadersInterceptor, decorators: [{
            type: Injectable
        }], ctorParameters: function () { return [{ type: AuthenticationService }, { type: RouterFacade }, { type: UsersFacade }, { type: FormErrorsFacade }, { type: FormsFacade }, { type: FilesFacade }, { type: PublicationMessagesFacade }, { type: RequestsFacade }, { type: NotificationsFacade }, { type: StaticDataFacade }]; } });

class JwtInterceptor {
    constructor(authenticationService) {
        this.authenticationService = authenticationService;
    }
    intercept(request, next) {
        // add authorization header with jwt token if available
        const { token } = this.authenticationService.loadAuthDataFromLocalStore();
        if (token) {
            request = request.clone({
                setHeaders: {
                    Authorization: `JWT ${token}`
                }
            });
        }
        return next.handle(request);
    }
}
JwtInterceptor.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "15.2.9", ngImport: i0, type: JwtInterceptor, deps: [{ token: AuthenticationService }], target: i0.ɵɵFactoryTarget.Injectable });
JwtInterceptor.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "15.2.9", ngImport: i0, type: JwtInterceptor });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "15.2.9", ngImport: i0, type: JwtInterceptor, decorators: [{
            type: Injectable
        }], ctorParameters: function () { return [{ type: AuthenticationService }]; } });

/*
 * Public API Surface of wt-front-shared
 */

/**
 * Generated bundle index. Do not edit.
 */

export { AccessDeniedComponent, AccessDeniedModule, ActionsEndpointTypes, ActionsFacade, ActionsMetaStatus, ActionsModel, ActionsSendRequest, ActionsService, AsyncValidators, AsyncValidatorsMessages, AsyncValidatorsType, AuthEndpointTypes, AuthenticationService, AutoFormMainComponent, AutoFormModule, AutoFormService, AutoFormShowComponent, Back, BaseAPI, BaseAPIService, BaseAutoFormService, BaseErrors, BaseModelAdapter, BaseResponseFactory, BreadCrumbsComponent, BreadCrumbsModule, ButtonComponent, ButtonModule, CORE_CONFIG, CacheDataEndpointTypes, CacheDataFacade, CacheDataModel, CacheDataService, ChipsInputComponent, ChipsInputModule, ClearStaticData, CommonDialogComponent, CookiesService, CoreFacade, CoreLoadError, CoreLoaded, CountFormatPipe, CreateRequestListener, DateFormatPipe, DeleteComponent, DeleteRequest, DeleteRequestWaiter, DialogService, DialogsModule, EntitiesReportsRequest, Entity, EntityQueryFieldNames, EntitySortType, EntityType, FieldType, FileFieldNames, FileModel, FileUpdateModel, FilesDeleteRequest, FilesDeleteResponseFactory, FilesEndpointTypes, FilesFacade, FilesLoadRequest, FilesLoadResponseFactory, FilesService, FilesSortRequest, FilesSortResponseFactory, FilesUpdateRequest, FilesUpdateResponseFactory, FilesUploadComponent, FilesUploadModule, FormDeleteFileBaseEndpointTypes, FormDeleteFileFacade, FormDeleteFileRequest, FormDeleteFileService, FormErrorModel, FormErrorsFacade, FormFieldErrorComponent, FormFieldErrorModule, FormFieldPublishErrorComponent, FormFieldPublishErrorModule, FormValidationCheckRequest, FormValidationEndpointTypes, FormValidationFacade, FormValidationService, FormsFacade, Forward, GetCacheDataRequest, GetRequest, GlobalErrorMessages, GlobalEvent, Go, GoFail, HeaderComponent, HeaderModule, HeadersInterceptor, IFormFieldFormat, IconComponent, ImageComponent, ImageModule, InputTagsComponent, InputTagsModule, JwtInterceptor, LoadCore, LoadUsers, LoadUsersFail, LoadUsersSuccess, LoginSend, LoginSendCreateRequest, LoginSendCreateResponseFactory, LoginSendFail, LoginSendSuccess, MainConst, MainFacade, MapperRegistry, MapperUtil, MetaModel, NOTIFICATION_LONG_TIMEOUT, NOTIFICATION_TIMEOUT, NotificationAdd, NotificationAddFail, NotificationModel, NotificationShowingType, NotificationsEffects, NotificationsFacade, PaginationComponent, PaginationModule, PagingModel, PanelComponent, PanelHeaderComponent, PanelHeaderModule, PanelModule, PasswordRules, PatchRequest, PhonePipe, PipesModule, PostRequest, PublicationMessageFieldNames, PublicationMessagesFacade, PublishDataModel, PublishEndpointTypes, PublishErrors, PublishPostRequest, PublishResultModel, PublishService, PutRequest, QueryFieldsAdapter, ReducerService, RefreshToken, RefreshTokenFail, RefreshTokenSuccess, ReportsEndpointTypes, ReportsFacade, ReportsModel, ReportsService, Request, RequestMethods, RequestStatus, RequestsEffects, RequestsFacade, ResponseStatus, RouterEffects, RouterFacade, RouterService, STICKY_SIDEBAR_OPTIONS, SafePipe, SeoService, SequelizeUniqueConstraintError, SetLoaded, SetRouterQueryParams, SharedFormErrors, SharedIconModule, SharedReducer, SharedSpinnerModule, SiteHelperComponent, SiteHelperModule, SmartProgressBarComponent, SmartProgressBarModule, SocialAuthService, SpinnerComponent, StarRatingComponent, StarRatingModule, StaticDataComponentInputData, StaticDataCreate, StaticDataCreateFail, StaticDataCreateRequest, StaticDataCreateSuccess, StaticDataDelete, StaticDataDeleteFail, StaticDataDeleteRequest, StaticDataDeleteSuccess, StaticDataEffects, StaticDataEndpointTypes, StaticDataFacade, StaticDataGet, StaticDataGetFail, StaticDataGetList, StaticDataGetListCategories, StaticDataGetListCategoriesFail, StaticDataGetListCategoriesRequest, StaticDataGetListCategoriesSuccess, StaticDataGetListFail, StaticDataGetListRequest, StaticDataGetListSuccess, StaticDataGetRequest, StaticDataGetSubRouting, StaticDataGetSubRoutingFail, StaticDataGetSubRoutingSuccess, StaticDataGetSuccess, StaticDataLoadRevisions, StaticDataMetaStatus, StaticDataModel, StaticDataModule, StaticDataNewRevisions, StaticDataPartUpdate, StaticDataPatchUpdate, StaticDataPatchUpdateFail, StaticDataPatchUpdateSuccess, StaticDataService, StaticDataSubRoutingGetRequest, StaticDataUpdate, StaticDataUpdateFail, StaticDataUpdateRequest, StaticDataUpdateSuccess, StickySidebarDirective, StickySidebarInnerDirective, StickySidebarModule, StorageProvider, StorageService, TableMenuComponent, TableMenuModule, TagCloudComponent, TagCloudModule, TagEntitiesRequest, TagEntityModel, TagModel, TagsEndpointTypes, TagsFacade, TagsLoadRequest, TagsLoadResponseFactory, TagsService, TextWithLinkMoreComponent, TextWithLinkMoreModule, USERS_FEATURE_KEY, UiUnitIds, UiUnitsEffects, UiUnitsFacade, UnPublishPostRequest, UpdateRequestData, UserFieldNames, UserModel, UserRole, UserSectionRightModel, UsersEffects, UsersFacade, UsersService, ValidatorsType, VersionsModel, WebsocketMessageSubTypes, WebsocketMessageTypes, WebsocketService, WtFrontSharedModule, appearFromLeft, appearFromLeftHideToRight, appearFromLeftWithDelay, appearFromRight, appearFromRightWithDelay, appearOpacity, appearOpacity2, componentDestroyed, coreQuery, defaultStickySidebarOptions, entityScheme, expandCollapse, fileMapper, fileScheme, getAll, getAllUiUnits, getRequestInfo, getRouterLastRoute, getRouterLastRouteParams, getRouterQueryParams, getRouterRoot, getRouterUrl, getUIUnit, getUiUnitDataById, getUserAuthData, guid, hideToTopOpacity, initialState$b as initialState, mappet, notificationQuery, publicationMessageMapper, publicationMessageScheme, requestsQuery, sharedEffects, sharedFacades, staticDataQuery, trackById, uiUnitsQuery, untilComponentDestroyed, userMapper, userReducer, userScheme, usersQuery };
